var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _g2, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _g3, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _g4, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _g5, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _g6, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _g7, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _g8, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _g9, _path859, _g0, _path860, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApplication(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.073 64.167-29.08-1.21c-2.478-.103-4.498-2.26-4.498-4.795V6.514c0-2.535 2.02-4.68 4.499-4.769L50.074.728c2.664-.095 4.854 1.996 4.854 4.643v54.183c0 2.651-2.193 4.726-4.855 4.613Z",
    fill: "#6981CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m50.033 64.143-29.042-1.207c-2.476-.103-4.493-2.258-4.493-4.793V6.505c0-2.532 2.017-4.674 4.493-4.763L50.033.728c2.662-.095 4.85 1.992 4.85 4.637v54.17c0 2.646-2.191 4.718-4.85 4.608Z",
    fill: "#6A82CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.994 64.116-29.006-1.204c-2.473-.103-4.49-2.255-4.49-4.787V6.493c0-2.53 2.014-4.671 4.49-4.757L49.994.722c2.655-.092 4.843 1.992 4.843 4.634v54.159c0 2.641-2.184 4.713-4.843 4.6Z",
    fill: "#6B82CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m49.954 64.091-28.97-1.2c-2.472-.104-4.483-2.252-4.483-4.781V6.484c0-2.526 2.01-4.665 4.483-4.75L49.954.721c2.653-.092 4.837 1.99 4.837 4.628v54.146c0 2.636-2.181 4.705-4.837 4.595Z",
    fill: "#6C83CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m49.919 64.064-28.934-1.197c-2.47-.104-4.477-2.252-4.477-4.775V6.475c0-2.523 2.01-4.66 4.477-4.745L49.92.72c2.649-.092 4.83 1.986 4.83 4.622v54.134c-.003 2.633-2.181 4.699-4.83 4.589Z",
    fill: "#6D84CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m49.879 64.04-28.897-1.195c-2.467-.1-4.471-2.248-4.471-4.768V6.463c0-2.52 2.007-4.653 4.471-4.739L49.88.716c2.646-.092 4.824 1.983 4.824 4.616v54.122c0 2.633-2.178 4.695-4.824 4.586Z",
    fill: "#6E84CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.84 64.013-28.86-1.195c-2.465-.1-4.47-2.246-4.47-4.762V6.454c0-2.517 2.005-4.647 4.47-4.735L49.84.709c2.643-.09 4.817 1.985 4.817 4.611v54.11c0 2.632-2.174 4.692-4.818 4.583Z",
    fill: "#6F85CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m49.8 63.988-28.824-1.191c-2.46-.1-4.462-2.243-4.462-4.757V6.445c0-2.514 2.001-4.644 4.462-4.73L49.8.71c2.64-.091 4.812 1.98 4.812 4.604v54.097c0 2.627-2.172 4.684-4.812 4.577Z",
    fill: "#7086D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49.763 63.96-28.787-1.188c-2.458-.1-4.456-2.24-4.456-4.75V6.435c0-2.51 2.001-4.637 4.456-4.723L49.763.71c2.637-.091 4.806 1.977 4.806 4.598v54.085c-.003 2.62-2.172 4.677-4.806 4.568Z",
    fill: "#7186D1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M49.724 63.937 20.973 62.75c-2.455-.1-4.453-2.236-4.453-4.744V6.423c0-2.507 1.998-4.631 4.453-4.716L49.723.704c2.635-.091 4.8 1.975 4.8 4.595v54.073c-.003 2.618-2.168 4.671-4.8 4.565Z",
    fill: "#7287D1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M49.684 63.91 20.97 62.726c-2.452-.1-4.447-2.234-4.447-4.738V6.414c0-2.504 1.995-4.625 4.447-4.71l28.714-1c2.628-.091 4.794 1.972 4.794 4.589v54.06c0 2.615-2.166 4.666-4.794 4.556Z",
    fill: "#7388D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m49.644 63.884-28.678-1.18c-2.448-.1-4.44-2.23-4.44-4.734V6.404c0-2.504 1.992-4.62 4.44-4.704l28.678-1c2.625-.091 4.788 1.972 4.788 4.583v54.049c0 2.611-2.16 4.659-4.788 4.552Z",
    fill: "#7488D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.605 63.857 20.96 62.68c-2.445-.1-4.435-2.228-4.435-4.73V6.393c0-2.501 1.99-4.616 4.435-4.701L49.605.694c2.622-.091 4.778 1.969 4.778 4.577v54.036c.003 2.612-2.153 4.656-4.778 4.55Z",
    fill: "#7589D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.568 63.833 20.96 62.659c-2.442-.1-4.432-2.224-4.432-4.722V6.383c0-2.498 1.99-4.61 4.432-4.695L49.568.69c2.619-.091 4.773 1.966 4.773 4.571v54.024c0 2.609-2.154 4.653-4.773 4.547Z",
    fill: "#768AD3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m49.528 63.805-28.571-1.17c-2.44-.1-4.426-2.221-4.426-4.717V6.374c0-2.495 1.986-4.604 4.426-4.69L49.528.692c2.616-.091 4.767 1.963 4.767 4.565v54.012c0 2.602-2.15 4.644-4.767 4.537Z",
    fill: "#778AD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.49 63.777 20.955 62.61c-2.437-.1-4.42-2.218-4.42-4.71V6.36c0-2.492 1.983-4.598 4.42-4.683L49.49.685c2.612-.092 4.76 1.962 4.76 4.561v54c0 2.602-2.148 4.64-4.76 4.53Z",
    fill: "#788BD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m49.449 63.753-28.498-1.164c-2.434-.101-4.414-2.216-4.414-4.705V6.352c0-2.49 1.98-4.592 4.414-4.677l28.498-.99c2.61-.092 4.754 1.959 4.754 4.555v53.988c.003 2.596-2.144 4.631-4.754 4.525Z",
    fill: "#798CD5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m49.413 63.725-28.461-1.164c-2.43-.1-4.411-2.212-4.411-4.698V6.343c0-2.486 1.98-4.589 4.41-4.671L49.414.685c2.607-.092 4.749 1.956 4.749 4.549v53.975c0 2.59-2.145 4.623-4.749 4.516Z",
    fill: "#7A8CD6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m49.374 63.7-28.426-1.16c-2.427-.1-4.404-2.212-4.404-4.693V6.334c0-2.483 1.977-4.583 4.404-4.665L49.374.682c2.603-.092 4.742 1.953 4.742 4.543v53.963c0 2.587-2.142 4.62-4.742 4.513Z",
    fill: "#7B8DD6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m49.334 63.674-28.389-1.158c-2.424-.098-4.398-2.21-4.398-4.687V6.322c0-2.48 1.974-4.577 4.398-4.662l28.39-.984c2.597-.092 4.735 1.95 4.735 4.537v53.951c0 2.587-2.138 4.616-4.736 4.51Z",
    fill: "#7C8ED7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m49.294 63.65-28.352-1.155c-2.421-.098-4.395-2.206-4.395-4.68V6.312c0-2.477 1.97-4.57 4.395-4.656L49.294.673c2.595-.092 4.73 1.95 4.73 4.53v53.94c0 2.584-2.132 4.61-4.73 4.507Z",
    fill: "#7C8ED7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.255 63.622 20.939 62.47c-2.418-.097-4.39-2.203-4.39-4.677V6.303c0-2.473 1.969-4.564 4.39-4.649L49.255.673c2.591-.092 4.724 1.947 4.724 4.525v53.927c.003 2.58-2.13 4.604-4.724 4.497Z",
    fill: "#7D8FD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m49.218 63.598-28.28-1.149c-2.414-.097-4.382-2.2-4.382-4.671V6.292c0-2.471 1.968-4.562 4.383-4.644l28.28-.981c2.588-.089 4.717 1.944 4.717 4.522v53.914c0 2.578-2.13 4.598-4.718 4.495Z",
    fill: "#7E90D9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m49.178 63.57-28.242-1.145c-2.412-.098-4.377-2.197-4.377-4.665V6.283c0-2.469 1.965-4.556 4.377-4.638L49.178.667c2.586-.089 4.712 1.94 4.712 4.516v53.902c0 2.572-2.126 4.592-4.712 4.485Z",
    fill: "#7F91D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m49.139 63.546-28.206-1.143c-2.41-.097-4.374-2.194-4.374-4.659V6.274c0-2.466 1.961-4.55 4.374-4.632L49.139.664c2.582-.088 4.706 1.94 4.706 4.51v53.89c0 2.569-2.124 4.586-4.706 4.482Z",
    fill: "#8091DA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m49.1 63.518-28.17-1.14c-2.406-.097-4.367-2.19-4.367-4.653V6.261c0-2.462 1.958-4.544 4.367-4.629L49.1.657c2.58-.088 4.7 1.938 4.7 4.504v53.88c0 2.566-2.12 4.58-4.7 4.477Z",
    fill: "#8192DA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.064 63.494 20.93 62.357c-2.406-.097-4.362-2.188-4.362-4.647V6.252c0-2.46 1.96-4.537 4.362-4.623L49.064.654c2.576-.088 4.693 1.935 4.693 4.498v53.865c-.003 2.57-2.12 4.58-4.693 4.477Z",
    fill: "#8293DB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 63.466 20.927 62.33c-2.403-.098-4.356-2.185-4.356-4.641V6.242c0-2.455 1.956-4.534 4.356-4.616L49.024.654c2.57-.088 4.687 1.932 4.687 4.492v53.853c0 2.563-2.117 4.57-4.687 4.467Z",
    fill: "#8393DC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m48.984 63.443-28.06-1.134c-2.4-.097-4.353-2.181-4.353-4.634V6.23c0-2.453 1.953-4.528 4.353-4.61l28.06-.969c2.568-.088 4.682 1.929 4.682 4.489v53.841c0 2.556-2.114 4.565-4.682 4.46Z",
    fill: "#8494DC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m48.945 63.415-28.024-1.13c-2.397-.098-4.347-2.18-4.347-4.63V6.222c0-2.45 1.95-4.521 4.347-4.604L48.945.648c2.564-.088 4.675 1.93 4.675 4.483V58.96c0 2.553-2.108 4.558-4.675 4.455Z",
    fill: "#8595DD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.908 63.387 20.921 62.26c-2.394-.098-4.34-2.176-4.34-4.626V6.212c0-2.447 1.949-4.515 4.34-4.598L48.908.648c2.561-.088 4.67 1.926 4.67 4.476v53.818c-.004 2.547-2.109 4.549-4.67 4.445Z",
    fill: "#8695DD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m48.868 63.363-27.95-1.124c-2.391-.098-4.335-2.176-4.335-4.62V6.203c0-2.443 1.947-4.51 4.335-4.595l27.95-.966c2.558-.088 4.663 1.923 4.663 4.47V58.92c-.003 2.548-2.105 4.547-4.663 4.443Z",
    fill: "#8796DE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m48.829 63.336-27.915-1.121c-2.387-.095-4.331-2.173-4.331-4.614V6.191c0-2.44 1.944-4.506 4.332-4.589L48.829.64c2.555-.089 4.657 1.92 4.657 4.463v53.793c0 2.548-2.102 4.543-4.657 4.44Z",
    fill: "#8897DE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.79 63.312 20.91 62.193c-2.384-.094-4.325-2.17-4.325-4.607V6.182c0-2.437 1.94-4.5 4.325-4.583L48.79.637c2.552-.089 4.651 1.92 4.651 4.457v53.781c0 2.544-2.099 4.537-4.65 4.437Z",
    fill: "#8997DF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 63.284 20.91 62.17c-2.383-.095-4.32-2.167-4.32-4.601V6.173c0-2.434 1.937-4.494 4.32-4.577l27.84-.96c2.55-.088 4.645 1.917 4.645 4.452v53.769c0 2.538-2.096 4.53-4.645 4.427Z",
    fill: "#8A98E0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m48.714 63.26-27.805-1.112c-2.379-.095-4.316-2.164-4.316-4.595V6.16c0-2.431 1.937-4.488 4.316-4.57L48.714.63C51.26.542 53.35 2.544 53.35 5.079v53.757c0 2.535-2.093 4.525-4.636 4.424Z",
    fill: "#8B99E0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m48.674 63.233-27.768-1.11c-2.376-.094-4.31-2.16-4.31-4.588V6.151c0-2.428 1.934-4.482 4.31-4.564L48.674.63c2.54-.089 4.63 1.91 4.63 4.442v53.744c0 2.532-2.09 4.52-4.63 4.416Z",
    fill: "#8C99E1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m48.635 63.208-27.732-1.106c-2.373-.094-4.304-2.157-4.304-4.583V6.146c0-2.426 1.931-4.48 4.304-4.559L48.635.634C51.17.545 53.258 2.54 53.258 5.07v53.735c.003 2.52-2.087 4.504-4.623 4.403Z",
    fill: "#8D9AE1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.595 63.18 20.9 62.074c-2.37-.094-4.298-2.154-4.298-4.577V6.13c0-2.422 1.928-4.473 4.298-4.555L48.595.62c2.534-.088 4.617 1.907 4.617 4.43v53.723c.003 2.526-2.08 4.507-4.617 4.406Z",
    fill: "#8E9BE2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M48.558 63.156 20.9 62.053c-2.366-.095-4.294-2.151-4.294-4.57V6.12c0-2.42 1.928-4.467 4.294-4.55l27.66-.95c2.53-.088 4.61 1.904 4.61 4.424v53.71c0 2.52-2.08 4.501-4.61 4.4Z",
    fill: "#8F9BE2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m48.519 63.129-27.623-1.1c-2.363-.095-4.289-2.149-4.289-4.568V6.11c0-2.415 1.926-4.46 4.29-4.542l27.622-.95c2.527-.09 4.605 1.9 4.605 4.417v53.699c0 2.517-2.078 4.494-4.605 4.394Z",
    fill: "#909CE3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m50.033 63.19-30.56-1.215c-1.579-.064-2.868-1.439-2.868-3.06V4.66c0-1.618 1.286-2.989 2.868-3.04L50.033.566c1.698-.058 3.091 1.274 3.091 2.959v56.72c0 1.689-1.393 3.011-3.09 2.944Z",
    fill: "url(#a)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.53 4.79c.308-.07.6.152.6.456l-.146 28.734c0 2.706-.48 23.365-4.41 23.365V5.715l3.957-.926Z",
    fill: "#C2C2CE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m43.546 5.713 3.735-.896.22-.052c.31-.04.599.155.599.46l-.14 28.755c0 2.706-.481 23.365-4.411 23.365-.006 0-.006-51.626-.003-51.633Z",
    fill: "#C3C3CF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m43.522 5.71 3.729-.918c.003-.003.213-.049.219-.052.31-.04.6.159.596.46l-.137 28.78c0 2.706-.48 23.365-4.41 23.365-.003 0-.003-51.623.003-51.636Z",
    fill: "#C4C4D0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m43.497 5.707 3.723-.942c.006-.003.21-.049.22-.052.31-.036.596.159.596.464l-.134 28.8c0 2.706-.481 23.365-4.41 23.365-.004.003-.004-51.617.005-51.635Z",
    fill: "#C5C5D0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m43.473 5.705 3.717-.963.219-.052c.31-.037.596.161.596.466l-.128 28.825c0 2.706-.48 23.365-4.41 23.365-.006 0-.006-51.614.006-51.641Z",
    fill: "#C6C6D1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m43.449 5.7 3.71-.984c.013-.006.207-.049.22-.052.31-.036.596.165.596.47l-.125 28.85c0 2.705-.48 23.364-4.41 23.364-.007-.003-.007-51.614.009-51.648Z",
    fill: "#C7C7D2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m43.421 5.697 3.705-1.009c.012-.006.204-.048.219-.051.307-.034.596.164.593.472l-.119 28.87c0 2.706-.48 23.365-4.41 23.365-.003 0-.003-51.608.012-51.647Z",
    fill: "#C8C8D3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m43.398 5.695 3.698-1.03c.016-.006.201-.049.22-.052.307-.034.592.168.592.475l-.115 28.896c0 2.705-.48 23.364-4.41 23.364-.004-.003-.004-51.605.015-51.653Z",
    fill: "#C9C9D3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m43.373 5.692 3.693-1.055c.018-.009.2-.048.219-.051.307-.034.593.17.593.475l-.112 28.916c0 2.706-.481 23.365-4.411 23.365-.003.003-.003-51.595.018-51.65Z",
    fill: "#CACAD4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m43.349 5.689 3.687-1.076a2.85 2.85 0 0 1 .218-.051c.308-.03.594.173.59.478l-.106 28.94c0 2.707-.48 23.366-4.41 23.366-.004 0-.004-51.596.02-51.657Z",
    fill: "#CBCBD5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m43.325 5.686 3.68-1.097c.021-.01.195-.049.219-.052.307-.03.59.174.59.482l-.103 28.962c0 2.706-.48 23.365-4.41 23.365-.004 0-.004-51.593.023-51.66Z",
    fill: "#CCCCD6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m43.297 5.682 3.675-1.121a1.9 1.9 0 0 1 .219-.052c.307-.03.59.177.59.484l-.098 28.987c0 2.706-.48 23.365-4.41 23.365-.003 0-.003-51.587.024-51.663Z",
    fill: "#CDCDD7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m43.273 5.68 3.668-1.143a1.9 1.9 0 0 1 .22-.052c.306-.028.59.18.59.487l-.095 29.008c0 2.706-.48 23.365-4.41 23.365-.004 0-.004-51.583.027-51.666Z",
    fill: "#CECED7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m43.248 5.676 3.663-1.167c.03-.012.188-.048.219-.051.304-.028.59.18.587.49l-.088 29.032c0 2.706-.481 23.365-4.411 23.365-.003 0-.003-51.58.03-51.669Z",
    fill: "#CFCFD8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m43.224 5.673 3.656-1.188c.03-.015.186-.049.22-.052.303-.027.586.183.586.49l-.085 29.054c0 2.706-.48 23.365-4.41 23.365-.003.003-.003-51.571.033-51.669Z",
    fill: "#D0D0D9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m43.2 5.67 3.65-1.21c.033-.014.185-.048.219-.05.304-.025.587.185.587.493l-.082 29.078c0 2.706-.48 23.365-4.41 23.365-.004 0-.004-51.572.036-51.675Z",
    fill: "#D1D1DA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m43.175 5.667 3.644-1.234c.037-.016.183-.05.22-.052.303-.025.586.186.586.497l-.076 29.099c0 2.706-.48 23.365-4.41 23.365-.007.003-.007-51.566.036-51.675Z",
    fill: "#D2D2DB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m43.147 5.665 3.635-1.256c.04-.018.18-.049.22-.052.303-.024.586.19.583.5l-.073 29.124c0 2.706-.48 23.365-4.41 23.365.003 0 .003-51.566.045-51.681Z",
    fill: "#D2D2DB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m43.124 5.661 3.629-1.277a1.09 1.09 0 0 1 .219-.051c.304-.022.584.191.584.502l-.067 29.145c0 2.706-.48 23.365-4.41 23.365 0 0 0-51.559.045-51.684Z",
    fill: "#D3D3DC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m43.099 5.658 3.622-1.301c.043-.018.177-.049.22-.052.303-.021.583.195.583.506l-.064 29.17c0 2.705-.48 23.364-4.41 23.364 0 0 0-51.556.049-51.687Z",
    fill: "#D4D4DD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m43.074 5.655 3.617-1.322a.953.953 0 0 1 .219-.052c.304-.022.584.195.58.506l-.06 29.19c0 2.706-.48 23.365-4.41 23.365.003.003.003-51.55.054-51.687Z",
    fill: "#D5D5DE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m43.05 5.652 3.611-1.347a.953.953 0 0 1 .22-.052c.3-.018.58.198.58.509l-.054 29.215c0 2.706-.48 23.365-4.41 23.365 0 .003 0-51.547.054-51.69Z",
    fill: "#D6D6DE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m43.023 5.649 3.604-1.369a.954.954 0 0 1 .22-.051c.3-.019.58.2.58.512l-.052 29.24c0 2.705-.48 23.364-4.41 23.364.003 0 .003-51.544.058-51.696Z",
    fill: "#D7D7DF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m42.998 5.646 3.599-1.389a.817.817 0 0 1 .219-.052c.3-.018.58.201.58.515l-.045 29.261c0 2.706-.48 23.365-4.41 23.365 0 0 0-51.541.057-51.7Z",
    fill: "#D8D8E0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m42.974 5.643 3.592-1.414a.816.816 0 0 1 .22-.051c.3-.016.58.204.577.518l-.042 29.285c0 2.706-.48 23.365-4.41 23.365.002 0 .002-51.538.063-51.703Z",
    fill: "#D9D9E1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m42.95 5.64 3.586-1.436a.817.817 0 0 1 .219-.052c.301-.015.578.207.578.521l-.037 29.307c0 2.706-.48 23.365-4.41 23.365 0 0 0-51.532.064-51.706Z",
    fill: "#DADAE2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m42.925 5.637 3.58-1.46a.716.716 0 0 1 .22-.051c.3-.016.577.21.577.52l-.033 29.332c0 2.706-.48 23.365-4.41 23.365 0 .003 0-51.526.066-51.706Z",
    fill: "#DBDBE2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m42.898 5.634 3.574-1.481a.715.715 0 0 1 .22-.052c.3-.012.577.21.577.524l-.03 29.352c0 2.706-.48 23.365-4.41 23.365.002.003.002-51.522.07-51.708Z",
    fill: "#DCDCE3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m42.874 5.63 3.568-1.502a.716.716 0 0 1 .219-.051c.3-.013.575.213.575.527L47.21 33.98c0 2.705-.48 23.364-4.41 23.364.003 0 .003-51.522.073-51.714Z",
    fill: "#DDDDE4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.85 5.628 46.41 4.1a.637.637 0 0 1 .22-.052c.3-.012.574.217.574.53l-.021 29.398c0 2.706-.48 23.365-4.41 23.365.002.003.002-51.513.075-51.714Z",
    fill: "#DEDEE5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m42.825 5.624 3.556-1.548a.637.637 0 0 1 .219-.051c.301-.01.575.216.575.533L47.16 33.98c0 2.706-.481 23.365-4.411 23.365 0 0 0-51.513.076-51.72Z",
    fill: "#DFDFE5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m42.8 5.621 3.55-1.569c.07-.03.15-.049.22-.052.298-.009.574.22.574.537l-.012 29.443c0 2.706-.48 23.365-4.41 23.365 0 0 0-51.51.079-51.724Z",
    fill: "#E0E0E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.32 4.025c.368-.165.791.094.791.487l-.009 29.468c0 2.706-.48 23.365-4.41 23.365V5.838c0-.08.03-.159.081-.22l3.547-1.593Z",
    fill: "#E1E1E7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M13.816 4.76c-.606.021-1.086.5-1.086 1.084v31.391c0 6.832-2.662 13.416-7.459 18.444l37.019 1.645c4.343 0 4.678-20.713 4.678-23.425l.137-29.097c.003-.615-.526-1.109-1.162-1.087L13.816 4.76Z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m0 47.747 39.704.908c.566.012 1.02.323 1.022.704.019 2.038.17 7.925 2.72 7.99l-38.172-1.14c0 .003-4.252-.314-5.274-8.462Z",
    fill: "#D0D0DA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m0 47.747 39.05.905c.283.006 1.165.177 1.168.369.01 1.02.286 8.257 3.103 8.327L5.277 56.212c-.003 0-4.255-.317-5.277-8.465Z",
    fill: "#D1D1DA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m0 47.747 39.707.932s.405 8.59 3.486 8.666L5.277 56.21c-.003.003-4.255-.314-5.277-8.462Z",
    fill: "#D1D1D9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m0 47.714 39.707.932s-.24 8.633 2.841 8.709L5.274 56.212S1.022 55.86 0 47.714Z",
    fill: "url(#b)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m38.6 18.19-9.995.262c-.718.018-1.293-.564-1.284-1.304l.006-.698c.007-.74.594-1.359 1.311-1.383l10.023-.32c.745-.025 1.335.57 1.323 1.325l-.012.713c-.018.759-.633 1.384-1.372 1.405Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m38.595 18.171-9.995.265c-.709.019-1.28-.557-1.275-1.291l.006-.698c.006-.735.587-1.347 1.3-1.371l10.022-.32c.736-.025 1.323.563 1.31 1.313l-.011.713c-.013.75-.62 1.371-1.357 1.39Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m38.592 18.156-9.996.265c-.702.018-1.268-.555-1.262-1.28l.006-.7c.006-.729.581-1.335 1.287-1.357l10.022-.32c.73-.024 1.311.561 1.3 1.302l-.013.716c-.015.74-.617 1.352-1.344 1.374Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m38.585 18.137-9.995.265c-.697.019-1.256-.548-1.25-1.267l.006-.704c.006-.72.575-1.322 1.274-1.344l10.023-.32c.724-.024 1.299.555 1.287 1.29l-.012.715c-.016.738-.612 1.347-1.333 1.365Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "m38.582 18.122-9.995.266c-.69.018-1.244-.543-1.238-1.256l.006-.704c.006-.713.572-1.31 1.262-1.331l10.02-.317c.718-.021 1.286.548 1.274 1.277l-.012.719c-.012.725-.605 1.328-1.317 1.346Z",
    fill: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "m38.577 18.107-9.996.265c-.684.018-1.232-.54-1.226-1.243l.007-.707c.006-.707.565-1.298 1.25-1.32l10.02-.316a1.224 1.224 0 0 1 1.262 1.264l-.012.722a1.365 1.365 0 0 1-1.305 1.335Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m38.573 18.09-9.992.265c-.678.018-1.22-.534-1.214-1.231l.006-.71c.006-.701.56-1.286 1.238-1.308l10.02-.316a1.21 1.21 0 0 1 1.25 1.252l-.012.722c-.015.716-.596 1.307-1.296 1.326Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m38.567 18.073-9.992.265c-.673.018-1.208-.527-1.205-1.219l.006-.71c.006-.691.554-1.273 1.226-1.295l10.02-.317a1.198 1.198 0 0 1 1.238 1.24l-.013.726c-.012.704-.587 1.292-1.28 1.31Z",
    fill: "#F8F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m38.56 18.056-9.992.265c-.663.018-1.198-.524-1.192-1.207l.006-.713c.006-.685.55-1.261 1.217-1.283l10.02-.317c.69-.02 1.237.53 1.225 1.228l-.012.729c-.015.7-.58 1.28-1.271 1.298Z",
    fill: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m38.557 18.04-9.992.265c-.657.018-1.186-.518-1.18-1.194l.006-.716c.006-.68.544-1.25 1.204-1.268l10.02-.317a1.176 1.176 0 0 1 1.214 1.216l-.013.728c-.015.692-.577 1.268-1.259 1.286Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m38.552 18.023-9.992.265c-.651.018-1.174-.512-1.168-1.186l.006-.716c.006-.673.538-1.237 1.192-1.255l10.017-.317c.675-.021 1.213.518 1.201 1.207l-.012.731c-.012.686-.569 1.255-1.244 1.27Z",
    fill: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m38.548 18.007-9.992.265c-.645.019-1.162-.509-1.156-1.173l.007-.719c.006-.667.532-1.222 1.18-1.243l10.016-.317c.67-.021 1.202.512 1.19 1.194l-.013.735a1.288 1.288 0 0 1-1.232 1.258Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m38.543 17.992-9.992.265c-.639.018-1.15-.503-1.144-1.161l.006-.72c.006-.658.527-1.209 1.168-1.23l10.017-.317c.663-.022 1.19.509 1.177 1.182l-.012.734a1.273 1.273 0 0 1-1.22 1.247Z",
    fill: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m38.54 17.973-9.992.268c-.633.015-1.138-.496-1.132-1.148l.006-.723c.006-.652.523-1.197 1.156-1.219l10.017-.316a1.128 1.128 0 0 1 1.165 1.17l-.013.737c-.012.661-.553 1.216-1.207 1.231Z",
    fill: "#F3F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m38.534 17.959-9.993.268c-.626.015-1.125-.49-1.122-1.137l.006-.725c.006-.646.517-1.185 1.144-1.207l10.016-.316c.648-.022 1.165.496 1.153 1.157l-.012.74c-.01.656-.544 1.201-1.192 1.22Z",
    fill: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m38.531 17.94-9.99.268c-.617.016-1.112-.487-1.11-1.124l.007-.725c.006-.64.51-1.174 1.131-1.195l10.014-.317a1.104 1.104 0 0 1 1.14 1.146l-.012.74c-.012.65-.541 1.192-1.18 1.207Z",
    fill: "#F1EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m38.525 17.924-9.99.269c-.61.015-1.104-.482-1.097-1.113l.006-.728c.006-.634.505-1.16 1.119-1.179l10.014-.317c.635-.021 1.14.488 1.128 1.134l-.012.743a1.217 1.217 0 0 1-1.168 1.191Z",
    fill: "#F0EEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m38.521 17.909-9.989.268c-.605.015-1.092-.475-1.086-1.1l.006-.731c.006-.625.502-1.149 1.108-1.167l10.013-.317c.63-.021 1.129.481 1.117 1.121l-.013.744a1.21 1.21 0 0 1-1.156 1.182Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "m38.515 17.891-9.989.269c-.6.015-1.08-.473-1.074-1.088l.006-.732c.006-.618.496-1.136 1.095-1.154l10.014-.317a1.07 1.07 0 0 1 1.104 1.109l-.012.746a1.19 1.19 0 0 1-1.144 1.167Z",
    fill: "#EEECED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "m38.513 17.875-9.99.268c-.593.015-1.067-.466-1.061-1.076l.006-.734c.006-.612.49-1.124 1.083-1.143l10.013-.316a1.058 1.058 0 0 1 1.092 1.096l-.012.75a1.186 1.186 0 0 1-1.131 1.155Z",
    fill: "#EDEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "m38.506 17.857-9.989.268c-.587.015-1.055-.46-1.05-1.067l.007-.737c.006-.607.484-1.112 1.07-1.13l10.014-.318a1.05 1.05 0 0 1 1.083 1.085l-.012.75c-.015.622-.514 1.133-1.123 1.149Z",
    fill: "#ECEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "m38.503 17.843-9.99.268c-.577.015-1.042-.457-1.04-1.054l.007-.737c.006-.598.48-1.1 1.058-1.119l10.01-.317c.603-.018 1.08.46 1.071 1.073l-.012.752c-.009.61-.505 1.119-1.104 1.134Z",
    fill: "#EBE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "m38.497 17.828-9.99.268c-.571.015-1.03-.451-1.027-1.042l.006-.74c.006-.592.474-1.089 1.049-1.107l10.01-.317a1.027 1.027 0 0 1 1.059 1.06l-.012.756a1.148 1.148 0 0 1-1.095 1.122Z",
    fill: "#EBE8E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "m38.494 17.808-9.989.268c-.566.015-1.019-.445-1.016-1.03l.006-.743c.006-.585.469-1.076 1.038-1.094l10.01-.317a1.014 1.014 0 0 1 1.046 1.048l-.012.756c-.012.6-.499 1.097-1.083 1.112Z",
    fill: "#EAE7E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "m38.488 17.793-9.986.269c-.56.015-1.01-.442-1.004-1.018l.006-.744c.006-.579.462-1.063 1.025-1.078l10.01-.317a1.001 1.001 0 0 1 1.035 1.036l-.012.758c-.015.589-.493 1.08-1.074 1.094Z",
    fill: "#E9E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "m38.486 17.775-9.986.271c-.554.015-.998-.436-.992-1.005l.006-.747c.006-.573.456-1.048 1.013-1.066l10.01-.317a.988.988 0 0 1 1.022 1.024l-.012.761a1.11 1.11 0 0 1-1.061 1.079Z",
    fill: "#E8E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "m38.48 17.76-9.987.271c-.547.016-.985-.43-.98-.993l.007-.746c.006-.564.453-1.036 1-1.055l10.011-.316a.979.979 0 0 1 1.01 1.011l-.012.762a1.1 1.1 0 0 1-1.05 1.066Z",
    fill: "#E7E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "m38.476 17.74-9.986.272c-.542.015-.974-.423-.967-.981l.006-.75c.006-.557.447-1.023.988-1.042l10.008-.317a.966.966 0 0 1 .997 1l-.012.765c-.015.57-.477 1.042-1.034 1.054Z",
    fill: "#E6E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m38.47 17.727-9.986.27c-.533.016-.962-.42-.959-.968l.007-.753c.006-.551.44-1.012.976-1.03l10.007-.317a.953.953 0 0 1 .986.987l-.012.768a1.063 1.063 0 0 1-1.02 1.043Z",
    fill: "#E5E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m38.466 17.71-9.986.272c-.526.015-.949-.414-.946-.957l.006-.752c.006-.546.435-1 .965-1.018l10.007-.317a.942.942 0 0 1 .973.975l-.012.768a1.055 1.055 0 0 1-1.007 1.03Z",
    fill: "#E4E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m38.461 17.693-9.986.27c-.52.016-.937-.408-.934-.947l.006-.755c.003-.54.432-.988.952-1.006l10.008-.317a.93.93 0 0 1 .96.963l-.011.77a1.04 1.04 0 0 1-.995 1.022Z",
    fill: "#E3E0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m38.458 17.677-9.986.271c-.515.015-.928-.405-.922-.935l.006-.76c.003-.53.426-.974.94-.99l10.007-.313a.918.918 0 0 1 .95.95l-.016.771c-.009.543-.45.99-.98 1.006Z",
    fill: "#E3DFE0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m38.451 17.66-9.986.27a.893.893 0 0 1-.91-.923l.007-.759c.003-.524.42-.963.928-.978l10.007-.313a.908.908 0 0 1 .937.938l-.015.774c-.01.533-.441.978-.968.99Z",
    fill: "#E2DEDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m38.448 17.644-9.986.27c-.502.013-.904-.392-.898-.91l.007-.762c.003-.518.413-.95.915-.966l10.004-.314c.52-.015.934.4.925.927l-.015.777a.994.994 0 0 1-.952.978Z",
    fill: "#E1DDDE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m38.443 17.63-9.984.27c-.495.013-.89-.39-.885-.898l.006-.765c.003-.512.408-.939.904-.954l10.004-.314a.883.883 0 0 1 .913.914l-.016.777a.989.989 0 0 1-.942.97Z",
    fill: "#E0DCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m38.44 17.61-9.984.27c-.487.013-.879-.383-.876-.886l.006-.765c.003-.502.405-.926.891-.941l10.005-.314a.872.872 0 0 1 .9.902l-.015.78a.968.968 0 0 1-.928.954Z",
    fill: "#DFDCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m38.433 17.595-9.983.271c-.48.013-.867-.377-.864-.874l.006-.768c.003-.497.399-.914.88-.93l10.003-.313a.86.86 0 0 1 .889.89l-.015.783a.957.957 0 0 1-.916.941Z",
    fill: "#DEDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m38.428 17.577-9.983.274c-.475.012-.855-.375-.852-.862l.006-.771c.003-.49.392-.902.87-.917l10.004-.314a.847.847 0 0 1 .876.877l-.015.783a.945.945 0 0 1-.906.93Z",
    fill: "#DDDADB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m38.424 17.562-9.983.274c-.468.013-.842-.368-.84-.85l.007-.77c.003-.485.386-.89.857-.903L38.47 15a.835.835 0 0 1 .864.866l-.016.786a.935.935 0 0 1-.894.911Z",
    fill: "#DCD9DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m38.418 17.543-9.983.274a.81.81 0 0 1-.827-.838l.006-.774a.892.892 0 0 1 .845-.89l10.002-.314a.825.825 0 0 1 .851.854l-.015.789a.915.915 0 0 1-.88.899Z",
    fill: "#DBD8D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m38.415 17.528-9.983.274c-.457.013-.822-.356-.816-.828l.006-.774a.881.881 0 0 1 .834-.878l10.001-.314a.812.812 0 0 1 .84.841l-.015.79a.905.905 0 0 1-.867.89Z",
    fill: "#DBD7D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m38.41 17.513-9.984.274a.793.793 0 0 1-.806-.817l.006-.777a.868.868 0 0 1 .822-.865l10-.314a.8.8 0 0 1 .828.829l-.015.792a.887.887 0 0 1-.852.878Z",
    fill: "#DAD6D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m38.406 17.494-9.983.275c-.441.012-.797-.348-.794-.805l.006-.78a.855.855 0 0 1 .81-.853l10-.314c.46-.015.825.35.816.817l-.016.795a.876.876 0 0 1-.84.865Z",
    fill: "#D9D5D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m38.4 17.48-9.98.274c-.436.012-.785-.341-.782-.792l.006-.78a.842.842 0 0 1 .797-.841l10.001-.314a.777.777 0 0 1 .803.804l-.015.796a.865.865 0 0 1-.83.853Z",
    fill: "#D8D4D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m38.397 17.461-9.98.275c-.429.012-.773-.339-.77-.78l.007-.784a.834.834 0 0 1 .784-.828l10.002-.314c.444-.015.8.341.79.792l-.015.798a.857.857 0 0 1-.818.841Z",
    fill: "#D7D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m38.39 17.446-9.98.274c-.422.012-.76-.332-.757-.768l.006-.786c.004-.436.35-.801.773-.814l9.998-.313a.751.751 0 0 1 .779.78l-.015.798a.836.836 0 0 1-.803.829Z",
    fill: "#D6D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m38.387 17.431-9.98.274c-.416.012-.748-.326-.745-.755l.006-.787c.003-.43.344-.789.76-.801l9.999-.314a.742.742 0 0 1 .767.768l-.016.801a.83.83 0 0 1-.79.814Z",
    fill: "#D5D1D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m38.381 17.413-9.98.274a.718.718 0 0 1-.733-.744l.006-.789c.003-.423.338-.777.748-.79l9.999-.313a.73.73 0 0 1 .754.756l-.015.804a.81.81 0 0 1-.779.802Z",
    fill: "#D4D0D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m38.379 17.397-9.98.274a.71.71 0 0 1-.724-.731l.006-.792c.003-.418.334-.765.736-.777l9.998-.314a.718.718 0 0 1 .742.743l-.015.805a.799.799 0 0 1-.763.792Z",
    fill: "#D3CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m38.373 17.38-9.98.277a.698.698 0 0 1-.712-.72l.006-.792c.003-.408.328-.752.724-.764l9.998-.314c.41-.012.74.314.73.734l-.015.808a.78.78 0 0 1-.752.77Z",
    fill: "#D3CECF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m38.37 17.364-9.98.277a.69.69 0 0 1-.7-.71l.006-.795c.003-.402.322-.74.711-.752l9.999-.314a.695.695 0 0 1 .718.722l-.016.81a.774.774 0 0 1-.739.762Z",
    fill: "#D2CDCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m38.364 17.349-9.98.277a.676.676 0 0 1-.688-.698l.006-.795c.003-.396.317-.728.7-.74l9.995-.315a.682.682 0 0 1 .706.71l-.015.81a.754.754 0 0 1-.724.75Z",
    fill: "#D1CCCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m38.36 17.331-9.977.277a.664.664 0 0 1-.675-.685l.006-.799a.724.724 0 0 1 .69-.725l9.996-.314a.67.67 0 0 1 .693.698l-.015.814a.75.75 0 0 1-.718.734Z",
    fill: "#D0CBCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m38.354 17.314-9.977.278a.652.652 0 0 1-.663-.674l.006-.8a.715.715 0 0 1 .678-.714l9.996-.314a.66.66 0 0 1 .68.686l-.014.816a.739.739 0 0 1-.706.723Z",
    fill: "#CFCACB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m38.35 17.296-9.976.277a.64.64 0 0 1-.651-.66l.006-.802a.704.704 0 0 1 .666-.701l9.995-.314a.647.647 0 0 1 .67.674l-.016.816a.723.723 0 0 1-.693.71Z",
    fill: "#CEC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "m38.345 17.28-9.977.278a.63.63 0 0 1-.641-.65l.006-.804a.691.691 0 0 1 .654-.688l9.995-.314a.634.634 0 0 1 .657.661l-.015.82a.706.706 0 0 1-.679.698Z",
    fill: "#CDC8C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m38.342 17.264-9.977.277a.618.618 0 0 1-.63-.636l.006-.808a.678.678 0 0 1 .642-.676l9.996-.314a.624.624 0 0 1 .644.649l-.015.822a.695.695 0 0 1-.666.686Z",
    fill: "#CCC7C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m38.337 17.247-9.977.278a.607.607 0 0 1-.618-.625l.006-.807a.667.667 0 0 1 .63-.665l9.992-.31a.616.616 0 0 1 .636.636l-.015.823a.681.681 0 0 1-.654.67Z",
    fill: "#CBC6C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m38.333 17.233-9.977.277a.594.594 0 0 1-.605-.612l.006-.81a.657.657 0 0 1 .618-.653l9.992-.31c.35-.013.63.268.623.624l-.015.826a.675.675 0 0 1-.642.658Z",
    fill: "#CBC5C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m38.327 17.215-9.977.277a.58.58 0 0 1-.593-.6l.006-.814a.639.639 0 0 1 .605-.637l9.993-.31a.59.59 0 0 1 .61.612l-.014.829a.654.654 0 0 1-.63.643Z",
    fill: "#CAC4C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m38.324 17.199-9.977.277a.57.57 0 0 1-.581-.588l.006-.814a.626.626 0 0 1 .593-.624l9.992-.311a.582.582 0 0 1 .6.6l-.016.829a.646.646 0 0 1-.617.63Z",
    fill: "#C9C3C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m38.318 17.181-9.974.28a.558.558 0 0 1-.569-.578l.007-.817a.613.613 0 0 1 .58-.612l9.993-.311a.57.57 0 0 1 .587.588l-.016.832a.637.637 0 0 1-.608.618Z",
    fill: "#C8C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m38.315 17.166-9.974.28a.549.549 0 0 1-.56-.567l.006-.82a.602.602 0 0 1 .57-.6l9.991-.31c.323-.01.581.247.575.576l-.015.831a.622.622 0 0 1-.593.61Z",
    fill: "#C7C1C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m38.309 17.15-9.974.28a.538.538 0 0 1-.548-.554l.006-.82a.59.59 0 0 1 .557-.588l9.989-.31a.545.545 0 0 1 .563.563l-.016.835a.604.604 0 0 1-.577.594Z",
    fill: "#C6C0C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m38.305 17.132-9.974.28a.525.525 0 0 1-.535-.542l.006-.823a.578.578 0 0 1 .544-.576l9.99-.31c.31-.01.553.237.55.55l-.015.839a.59.59 0 0 1-.566.582Z",
    fill: "#C5BFC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m38.3 17.117-9.974.28a.512.512 0 0 1-.523-.53l.006-.822a.565.565 0 0 1 .532-.564l9.992-.314a.523.523 0 0 1 .539.54l-.016.837a.585.585 0 0 1-.556.573Z",
    fill: "#C4BEC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m38.297 17.099-9.974.28a.5.5 0 0 1-.511-.518l.006-.826a.554.554 0 0 1 .523-.551l9.989-.31a.51.51 0 0 1 .526.526l-.015.841a.572.572 0 0 1-.544.558Z",
    fill: "#C3BDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m38.29 17.083-9.974.28a.488.488 0 0 1-.499-.505l.006-.829a.536.536 0 0 1 .511-.536l9.99-.311a.5.5 0 0 1 .514.515l-.016.844a.558.558 0 0 1-.532.542Z",
    fill: "#C3BCBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m38.284 17.065-9.974.28a.477.477 0 0 1-.487-.493l.006-.83a.527.527 0 0 1 .5-.523l9.988-.311a.486.486 0 0 1 .502.502l-.015.845a.54.54 0 0 1-.52.53Z",
    fill: "#C2BBBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m38.282 17.05-9.974.28a.47.47 0 0 1-.478-.48l.006-.833a.514.514 0 0 1 .487-.512l9.986-.31c.274-.01.493.21.49.49l-.016.847a.522.522 0 0 1-.501.518Z",
    fill: "#C1BABC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m38.275 17.035-9.974.28a.457.457 0 0 1-.465-.47l.006-.834a.501.501 0 0 1 .475-.5l9.986-.31c.267-.01.48.207.477.478l-.015.85a.511.511 0 0 1-.49.506Z",
    fill: "#C0B9BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.272 17.016-9.971.28a.445.445 0 0 1-.453-.46l.006-.834a.49.49 0 0 1 .462-.488l9.986-.31a.451.451 0 0 1 .466.466l-.016.85a.502.502 0 0 1-.48.496Z",
    fill: "#BFB8BA"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m38.19 17.367-9.85.27a.728.728 0 0 1-.742-.749l.006-.801a.8.8 0 0 1 .754-.798l9.868-.311a.736.736 0 0 1 .76.765l-.015.816a.818.818 0 0 1-.782.808Z",
    fill: "#B0B1BD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m38.168 17.352-9.834.272a.725.725 0 0 1-.74-.747l.007-.792a.793.793 0 0 1 .751-.792l9.852-.311a.733.733 0 0 1 .758.761l-.015.808a.81.81 0 0 1-.78.801Z",
    fill: "#B1B2BE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m38.15 17.333-9.82.271a.722.722 0 0 1-.735-.743l.006-.783c.003-.424.338-.777.748-.79l9.837-.31a.73.73 0 0 1 .755.755l-.016.796a.808.808 0 0 1-.775.804Z",
    fill: "#B2B3BF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m38.129 17.319-9.804.271a.714.714 0 0 1-.73-.74l.006-.774c.003-.42.338-.774.745-.787l9.822-.307a.728.728 0 0 1 .751.752l-.012.786a.816.816 0 0 1-.778.799Z",
    fill: "#B3B4C0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m38.107 17.304-9.788.27a.713.713 0 0 1-.727-.737l.006-.764a.783.783 0 0 1 .742-.784l9.807-.307a.726.726 0 0 1 .748.75l-.012.776a.812.812 0 0 1-.776.796Z",
    fill: "#B4B5C1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m38.089 17.287-9.77.271a.708.708 0 0 1-.724-.734l.006-.753c.003-.417.335-.767.739-.78l9.789-.307c.42-.012.75.32.745.746l-.013.768a.813.813 0 0 1-.772.79Z",
    fill: "#B4B6C2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m38.068 17.27-9.755.271c-.402.012-.724-.317-.721-.731l.006-.743a.777.777 0 0 1 .736-.777l9.773-.308a.72.72 0 0 1 .742.743l-.012.759a.803.803 0 0 1-.77.786Z",
    fill: "#B5B7C3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m38.047 17.255-9.74.271c-.402.012-.721-.314-.718-.728l.006-.734c.003-.415.332-.762.733-.774l9.758-.308a.718.718 0 0 1 .74.74l-.013.75a.804.804 0 0 1-.767.783Z",
    fill: "#B6B8C3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m38.028 17.24-9.724.27c-.399.013-.718-.313-.715-.724l.006-.726a.774.774 0 0 1 .73-.77l9.743-.308a.713.713 0 0 1 .736.737l-.012.74a.803.803 0 0 1-.764.78Z",
    fill: "#B7B9C4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m38.007 17.224-9.71.271c-.398.013-.714-.31-.711-.722l.006-.716a.766.766 0 0 1 .727-.765l9.725-.304c.41-.013.739.317.73.734l-.013.728a.79.79 0 0 1-.754.774Z",
    fill: "#B8BAC5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m37.986 17.209-9.691.271c-.396.012-.712-.31-.709-.719l.006-.707a.763.763 0 0 1 .724-.762l9.71-.304a.704.704 0 0 1 .726.73l-.012.72a.789.789 0 0 1-.754.77Z",
    fill: "#B9BBC6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m37.968 17.19-9.676.271c-.393.012-.71-.308-.706-.716l.006-.698a.762.762 0 0 1 .72-.759l9.695-.304a.701.701 0 0 1 .724.728l-.012.71a.786.786 0 0 1-.752.768Z",
    fill: "#BABCC7"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m37.946 17.175-9.66.27c-.393.013-.706-.307-.703-.712l.006-.689a.759.759 0 0 1 .718-.756l9.679-.304a.699.699 0 0 1 .72.722l-.011.7a.785.785 0 0 1-.749.769Z",
    fill: "#BBBDC8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m37.925 17.16-9.645.27c-.39.013-.703-.304-.7-.71l.006-.679c.003-.402.323-.74.712-.753l9.66-.304a.696.696 0 0 1 .718.719l-.012.692a.772.772 0 0 1-.739.764Z",
    fill: "#BBBDC9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m37.907 17.145-9.63.271a.682.682 0 0 1-.697-.704l.006-.67c.003-.402.323-.738.709-.75l9.645-.304a.693.693 0 0 1 .715.716l-.012.682a.77.77 0 0 1-.736.759Z",
    fill: "#BCBECA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m37.885 17.127-9.615.27a.68.68 0 0 1-.694-.7l.006-.661c.003-.4.32-.735.706-.747l9.63-.301a.691.691 0 0 1 .712.713l-.012.67a.763.763 0 0 1-.733.756Z",
    fill: "#BDBFCB"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m37.867 17.111-9.596.268a.677.677 0 0 1-.69-.697l.005-.65a.744.744 0 0 1 .703-.74l9.615-.301a.686.686 0 0 1 .709.71l-.013.66a.768.768 0 0 1-.733.75Z",
    fill: "#BEC0CC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m37.845 17.096-9.581.268a.674.674 0 0 1-.688-.695l.006-.64a.739.739 0 0 1 .7-.737l9.597-.301a.685.685 0 0 1 .705.707l-.012.652a.762.762 0 0 1-.727.746Z",
    fill: "#BFC1CD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m37.824 17.08-9.566.269a.67.67 0 0 1-.685-.692l.006-.63a.738.738 0 0 1 .697-.735l9.582-.301a.68.68 0 0 1 .702.704l-.012.642a.757.757 0 0 1-.724.744Z",
    fill: "#C0C2CD"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m37.806 17.066-9.551.268a.667.667 0 0 1-.682-.689l.006-.622a.733.733 0 0 1 .694-.73l9.566-.302a.674.674 0 0 1 .697.7l-.012.634a.753.753 0 0 1-.718.74Z",
    fill: "#C1C3CE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m37.785 17.047-9.536.269a.666.666 0 0 1-.679-.686l.006-.612a.731.731 0 0 1 .69-.729l9.552-.301a.67.67 0 0 1 .694.697l-.013.625a.746.746 0 0 1-.714.738Z",
    fill: "#C1C4CF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m37.763 17.032-9.517.268a.66.66 0 0 1-.673-.682l.006-.604a.728.728 0 0 1 .688-.725l9.533-.298a.67.67 0 0 1 .69.694l-.009.616a.75.75 0 0 1-.718.731Z",
    fill: "#C2C5D0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m37.745 17.016-9.502.268a.657.657 0 0 1-.67-.68l.006-.594a.725.725 0 0 1 .685-.722l9.517-.298a.666.666 0 0 1 .688.691l-.01.604a.755.755 0 0 1-.714.73Z",
    fill: "#C3C6D1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m37.724 17.002-9.487.268a.656.656 0 0 1-.667-.677l.006-.585c.003-.384.308-.707.682-.716l9.502-.299a.664.664 0 0 1 .685.686l-.01.594a.752.752 0 0 1-.711.729Z",
    fill: "#C4C7D2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m37.703 16.982-9.473.268a.65.65 0 0 1-.663-.673l.006-.576a.713.713 0 0 1 .679-.713l9.487-.298a.66.66 0 0 1 .681.682l-.009.585a.74.74 0 0 1-.708.725Z",
    fill: "#C5C8D3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m43.184 22.12-14.615.293c-.715.015-1.29-.57-1.284-1.304l.006-.7c.006-.738.593-1.35 1.308-1.369l14.655-.372a1.294 1.294 0 0 1 1.336 1.338l-.015.722a1.432 1.432 0 0 1-1.39 1.393Z",
    fill: "#FEFEFE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m43.181 22.102-14.616.293c-.708.015-1.277-.564-1.271-1.292l.006-.704c.006-.731.587-1.338 1.299-1.356l14.655-.372a1.281 1.281 0 0 1 1.323 1.326l-.015.722a1.426 1.426 0 0 1-1.38 1.383Z",
    fill: "#FDFDFD"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m43.178 22.086-14.616.293c-.703.015-1.265-.561-1.26-1.283l.007-.707c.006-.725.58-1.326 1.287-1.344l14.655-.372a1.27 1.27 0 0 1 1.31 1.314l-.014.725a1.416 1.416 0 0 1-1.37 1.374Z",
    fill: "#FCFCFC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m43.172 22.068-14.616.293c-.697.015-1.253-.555-1.247-1.27l.006-.708c.006-.716.575-1.313 1.274-1.331l14.656-.372a1.257 1.257 0 0 1 1.298 1.301l-.015.728a1.398 1.398 0 0 1-1.356 1.36Z",
    fill: "#FBFBFB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "m43.168 22.053-14.616.293c-.69.015-1.244-.549-1.238-1.259l.007-.71c.006-.71.568-1.301 1.262-1.32l14.655-.371a1.248 1.248 0 0 1 1.287 1.289l-.015.728a1.385 1.385 0 0 1-1.342 1.35Z",
    fill: "#FBFAFA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "m43.166 22.035-14.619.293c-.684.012-1.232-.542-1.226-1.246l.006-.71c.006-.704.566-1.29 1.25-1.308l14.656-.371a1.236 1.236 0 0 1 1.274 1.276l-.015.732a1.369 1.369 0 0 1-1.326 1.334Z",
    fill: "#FAF9F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m43.16 22.02-14.62.292c-.674.013-1.219-.539-1.213-1.234l.006-.713c.006-.697.56-1.276 1.238-1.292l14.655-.371a1.224 1.224 0 0 1 1.263 1.264l-.015.731a1.355 1.355 0 0 1-1.314 1.323Z",
    fill: "#F9F8F8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m43.156 22.001-14.618.296c-.67.012-1.208-.534-1.202-1.222l.006-.713c.006-.689.554-1.265 1.226-1.28l14.655-.372a1.21 1.21 0 0 1 1.25 1.253l-.015.734a1.341 1.341 0 0 1-1.302 1.304Z",
    fill: "#F8F7F7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m43.15 21.986-14.619.295c-.663.013-1.195-.527-1.19-1.21l.007-.715c.006-.683.547-1.253 1.214-1.268l14.655-.372a1.2 1.2 0 0 1 1.238 1.24l-.015.738a1.328 1.328 0 0 1-1.29 1.292Z",
    fill: "#F7F6F6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m43.148 21.968-14.62.296c-.656.012-1.182-.524-1.176-1.198l.006-.719c.006-.676.544-1.24 1.201-1.255l14.655-.372a1.188 1.188 0 0 1 1.226 1.228l-.015.738a1.316 1.316 0 0 1-1.277 1.282Z",
    fill: "#F6F5F5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m43.144 21.953-14.619.295c-.65.012-1.17-.518-1.165-1.185l.006-.72c.007-.67.539-1.227 1.19-1.242l14.655-.372a1.176 1.176 0 0 1 1.214 1.216l-.015.74a1.309 1.309 0 0 1-1.266 1.268Z",
    fill: "#F5F4F4"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m43.138 21.934-14.619.296c-.645.012-1.159-.512-1.156-1.173l.006-.722c.006-.665.533-1.216 1.178-1.231l14.655-.372a1.163 1.163 0 0 1 1.201 1.204l-.015.74a1.287 1.287 0 0 1-1.25 1.258Z",
    fill: "#F4F3F3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m43.135 21.919-14.62.295c-.638.013-1.149-.505-1.143-1.16l.006-.723c.006-.655.526-1.203 1.165-1.219l14.655-.371a1.152 1.152 0 0 1 1.19 1.191l-.015.744a1.278 1.278 0 0 1-1.238 1.243Z",
    fill: "#F3F2F3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m43.132 21.9-14.619.296c-.63.012-1.137-.503-1.131-1.152l.006-.725c.006-.649.52-1.191 1.153-1.207l14.655-.371a1.14 1.14 0 0 1 1.177 1.179l-.015.746a1.267 1.267 0 0 1-1.226 1.235Z",
    fill: "#F3F1F2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m43.126 21.886-14.619.298c-.623.012-1.125-.496-1.12-1.14l.007-.727c.006-.643.517-1.177 1.14-1.195l14.656-.372a1.13 1.13 0 0 1 1.165 1.167l-.015.747a1.252 1.252 0 0 1-1.214 1.222Z",
    fill: "#F2F0F1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m43.123 21.867-14.62.299c-.617.012-1.113-.49-1.107-1.128l.007-.728c.006-.637.51-1.164 1.128-1.182l14.655-.369c.651-.015 1.168.5 1.153 1.155l-.015.75a1.24 1.24 0 0 1-1.201 1.203Z",
    fill: "#F1EFF0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m43.12 21.852-14.619.298c-.611.012-1.1-.487-1.095-1.115l.006-.731c.007-.631.505-1.152 1.12-1.167l14.655-.37a1.105 1.105 0 0 1 1.14 1.144l-.015.75a1.232 1.232 0 0 1-1.192 1.19Z",
    fill: "#F0EEEF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m43.114 21.833-14.619.299c-.605.012-1.089-.482-1.083-1.103l.006-.732c.006-.621.5-1.14 1.108-1.155l14.655-.368a1.094 1.094 0 0 1 1.128 1.13l-.015.753a1.218 1.218 0 0 1-1.18 1.176Z",
    fill: "#EFEDEE"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "m43.11 21.819-14.618.298c-.6.012-1.077-.475-1.074-1.09l.006-.735c.006-.616.496-1.128 1.095-1.143l14.655-.368a1.081 1.081 0 0 1 1.117 1.118l-.015.756a1.205 1.205 0 0 1-1.166 1.163Z",
    fill: "#EEECED"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M43.108 21.801 28.49 22.1c-.59.012-1.064-.473-1.061-1.079l.006-.737c.006-.61.49-1.115 1.083-1.13l14.655-.37a1.07 1.07 0 0 1 1.104 1.107l-.015.755a1.192 1.192 0 0 1-1.153 1.155Z",
    fill: "#EDEBEC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "m43.102 21.785-14.619.298c-.584.012-1.055-.466-1.05-1.066l.007-.738c.006-.603.483-1.103 1.07-1.118l14.656-.369a1.06 1.06 0 0 1 1.092 1.094l-.016.759a1.179 1.179 0 0 1-1.14 1.14Z",
    fill: "#ECEAEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "m43.098 21.766-14.618.299c-.578.012-1.044-.46-1.038-1.055l.006-.74c.007-.597.478-1.09 1.06-1.106l14.654-.369a1.048 1.048 0 0 1 1.08 1.082l-.015.759a1.166 1.166 0 0 1-1.129 1.13Z",
    fill: "#EBE9EA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "m43.095 21.751-14.622.302c-.572.012-1.03-.454-1.025-1.042l.006-.74c.006-.588.472-1.08 1.047-1.094l14.655-.369a1.035 1.035 0 0 1 1.068 1.07l-.016.761c-.015.6-.514 1.1-1.113 1.112Z",
    fill: "#EBE8E9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "m43.09 21.733-14.622.302c-.566.012-1.019-.451-1.013-1.03l.006-.744c.006-.582.469-1.066 1.034-1.081l14.656-.37a1.022 1.022 0 0 1 1.055 1.058l-.015.765a1.138 1.138 0 0 1-1.101 1.1Z",
    fill: "#EAE7E8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "m43.086 21.719-14.621.301c-.56.012-1.007-.445-1.001-1.02l.006-.747c.006-.576.462-1.054 1.022-1.07l14.655-.368a1.013 1.013 0 0 1 1.044 1.045l-.016.765a1.126 1.126 0 0 1-1.089 1.094Z",
    fill: "#E9E6E7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "m43.08 21.7-14.622.302c-.553.012-.994-.439-.991-1.009l.006-.746c.006-.57.456-1.042 1.01-1.058l14.655-.368a1 1 0 0 1 1.031 1.033l-.015.768A1.108 1.108 0 0 1 43.08 21.7Z",
    fill: "#E8E5E6"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "m43.077 21.685-14.622.301c-.544.012-.982-.436-.98-.996l.007-.75c.006-.563.45-1.03.997-1.042l14.656-.369a.987.987 0 0 1 1.019 1.021l-.016.768a1.097 1.097 0 0 1-1.061 1.067Z",
    fill: "#E7E4E5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "m43.074 21.666-14.621.302c-.539.012-.97-.43-.968-.985l.006-.75c.006-.554.448-1.017.986-1.029l14.655-.369a.976.976 0 0 1 1.007 1.009l-.015.77a1.083 1.083 0 0 1-1.05 1.052Z",
    fill: "#E6E3E4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m43.068 21.652-14.622.301c-.532.012-.96-.423-.955-.972l.006-.752c.006-.549.441-1.006.974-1.018l14.655-.369a.964.964 0 0 1 .995.997l-.016.774a1.072 1.072 0 0 1-1.037 1.039Z",
    fill: "#E5E2E3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m43.065 21.632-14.622.302c-.526.012-.949-.418-.943-.96l.006-.756c.006-.542.435-.993.961-1.005l14.656-.369a.952.952 0 0 1 .982.984l-.015.774a1.058 1.058 0 0 1-1.025 1.03Z",
    fill: "#E4E1E2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m43.062 21.617-14.621.305a.92.92 0 0 1-.931-.948l.006-.755c.003-.536.429-.981.952-.994l14.655-.368a.939.939 0 0 1 .97.972l-.015.777c-.018.545-.471 1-1.016 1.011Z",
    fill: "#E3E0E1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m43.056 21.599-14.622.305a.911.911 0 0 1-.921-.936l.006-.759c.003-.527.423-.968.94-.98l14.655-.37a.93.93 0 0 1 .958.96l-.015.78c-.015.543-.463.99-1 1Z",
    fill: "#E3DFE0"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m43.053 21.583-14.622.305a.899.899 0 0 1-.91-.923l.007-.759c.003-.521.42-.957.927-.969l14.653-.369a.918.918 0 0 1 .946.948l-.016.78a1.019 1.019 0 0 1-.985.987Z",
    fill: "#E2DEDF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m43.05 21.566-14.622.305a.89.89 0 0 1-.898-.911l.006-.762c.003-.515.414-.945.916-.957l14.652-.369a.905.905 0 0 1 .934.936l-.015.783c-.016.53-.45.966-.974.975Z",
    fill: "#E1DDDE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m43.044 21.55-14.622.305a.876.876 0 0 1-.885-.899l.006-.764c.003-.51.408-.933.904-.945l14.652-.369c.52-.012.93.4.922.923l-.019.784a.989.989 0 0 1-.958.965Z",
    fill: "#E0DCDD"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m43.04 21.533-14.621.305a.861.861 0 0 1-.873-.887l.006-.765a.934.934 0 0 1 .891-.932l14.652-.369a.885.885 0 0 1 .91.911l-.018.786a.977.977 0 0 1-.946.95Z",
    fill: "#DFDCDD"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m43.037 21.516-14.621.305a.85.85 0 0 1-.861-.878l.006-.767a.92.92 0 0 1 .879-.917l14.652-.366a.872.872 0 0 1 .897.899l-.018.789a.968.968 0 0 1-.934.935Z",
    fill: "#DEDBDC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m43.032 21.499-14.622.305a.838.838 0 0 1-.848-.866l.006-.768a.908.908 0 0 1 .867-.905l14.652-.365a.859.859 0 0 1 .885.886l-.018.79a.95.95 0 0 1-.922.923Z",
    fill: "#DDDADB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m43.029 21.483-14.625.308a.83.83 0 0 1-.84-.853l.007-.771a.895.895 0 0 1 .854-.893l14.652-.366a.846.846 0 0 1 .873.875l-.018.792a.93.93 0 0 1-.903.908Z",
    fill: "#DCD9DA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m43.023 21.465-14.625.308a.817.817 0 0 1-.828-.841l.006-.774a.881.881 0 0 1 .843-.88l14.652-.367a.837.837 0 0 1 .861.863l-.018.792a.915.915 0 0 1-.892.899Z",
    fill: "#DBD8D9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m43.02 21.45-14.626.308a.807.807 0 0 1-.815-.829l.006-.774a.87.87 0 0 1 .83-.868l14.653-.366a.824.824 0 0 1 .849.85l-.019.796a.905.905 0 0 1-.879.883Z",
    fill: "#DBD7D8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m43.017 21.432-14.625.308a.794.794 0 0 1-.803-.817l.006-.777a.86.86 0 0 1 .818-.856l14.652-.366a.811.811 0 0 1 .837.838l-.018.798a.894.894 0 0 1-.867.872Z",
    fill: "#DAD6D7"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m43.01 21.416-14.624.308a.782.782 0 0 1-.791-.804l.006-.777a.847.847 0 0 1 .806-.844l14.652-.366a.798.798 0 0 1 .824.826l-.018.798a.88.88 0 0 1-.855.86Z",
    fill: "#D9D5D6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m43.007 21.398-14.625.308a.767.767 0 0 1-.778-.793l.006-.78a.834.834 0 0 1 .794-.831l14.652-.366a.789.789 0 0 1 .812.813l-.018.802a.866.866 0 0 1-.843.847Z",
    fill: "#D8D4D5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m43.004 21.383-14.625.308a.756.756 0 0 1-.767-.78l.007-.783a.821.821 0 0 1 .784-.82l14.652-.365c.45-.013.81.347.8.801l-.018.801a.865.865 0 0 1-.833.838Z",
    fill: "#D7D3D4"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m42.998 21.365-14.624.31a.747.747 0 0 1-.758-.767l.006-.783a.81.81 0 0 1 .773-.808l14.652-.366a.763.763 0 0 1 .788.79l-.018.804a.84.84 0 0 1-.819.82Z",
    fill: "#D6D2D3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m42.995 21.35-14.625.31a.736.736 0 0 1-.745-.756l.006-.786a.794.794 0 0 1 .76-.792l14.653-.366a.75.75 0 0 1 .775.777l-.018.808a.832.832 0 0 1-.806.804Z",
    fill: "#D5D1D2"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m42.992 21.33-14.625.312a.726.726 0 0 1-.733-.747l.006-.786a.781.781 0 0 1 .748-.78l14.652-.366a.74.74 0 0 1 .764.765l-.018.807a.82.82 0 0 1-.794.796Z",
    fill: "#D4D0D1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m42.986 21.315-14.624.311a.713.713 0 0 1-.721-.734l.006-.79a.768.768 0 0 1 .736-.767l14.652-.366a.731.731 0 0 1 .751.753l-.018.81a.807.807 0 0 1-.782.783Z",
    fill: "#D3CFD0"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m42.983 21.298-14.625.31a.7.7 0 0 1-.709-.722l.006-.792a.757.757 0 0 1 .724-.756l14.653-.365c.416-.01.745.32.736.74l-.019.81a.79.79 0 0 1-.766.775Z",
    fill: "#D3CECF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m42.98 21.282-14.625.311c-.39.01-.7-.31-.697-.71l.006-.792a.744.744 0 0 1 .712-.744l14.652-.365c.41-.01.733.314.724.728l-.018.813a.78.78 0 0 1-.754.76Z",
    fill: "#D2CDCE"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m42.973 21.264-14.624.31a.674.674 0 0 1-.685-.697l.006-.796a.733.733 0 0 1 .7-.73l14.652-.366c.401-.01.72.31.712.716l-.018.816a.763.763 0 0 1-.743.747Z",
    fill: "#D1CCCD"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m42.971 21.25-14.625.31a.665.665 0 0 1-.675-.686l.006-.795a.72.72 0 0 1 .687-.719l14.653-.366a.679.679 0 0 1 .7.704l-.019.817a.751.751 0 0 1-.727.734Z",
    fill: "#D0CBCC"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m42.965 21.23-14.625.314a.654.654 0 0 1-.663-.673l.006-.798a.707.707 0 0 1 .675-.707L43.01 19c.39-.009.697.299.688.692l-.019.82a.731.731 0 0 1-.714.719Z",
    fill: "#CFCACB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m42.961 21.215-14.624.314a.645.645 0 0 1-.651-.661l.006-.802a.696.696 0 0 1 .663-.694l14.652-.366c.38-.01.684.296.675.677l-.018.82a.728.728 0 0 1-.703.712Z",
    fill: "#CEC9CA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "m42.959 21.197-14.628.314a.632.632 0 0 1-.639-.65l.006-.8a.685.685 0 0 1 .651-.683l14.653-.366c.374-.01.672.29.663.664l-.018.823a.705.705 0 0 1-.688.698Z",
    fill: "#CDC8C9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m42.953 21.182-14.628.314a.619.619 0 0 1-.627-.637l.006-.805a.667.667 0 0 1 .64-.667l14.651-.362a.63.63 0 0 1 .651.652l-.018.825a.695.695 0 0 1-.675.68Z",
    fill: "#CCC7C8"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m42.95 21.163-14.629.314a.608.608 0 0 1-.614-.624l.006-.805a.656.656 0 0 1 .627-.655l14.652-.363a.617.617 0 0 1 .639.64l-.019.826a.682.682 0 0 1-.663.667Z",
    fill: "#CBC6C7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m42.946 21.149-14.628.314a.598.598 0 0 1-.605-.613l.006-.807a.646.646 0 0 1 .614-.643l14.653-.363a.608.608 0 0 1 .626.628l-.018.829a.669.669 0 0 1-.648.655Z",
    fill: "#CBC5C6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m42.94 21.13-14.627.313a.585.585 0 0 1-.593-.603l.006-.807a.633.633 0 0 1 .605-.631l14.652-.363a.595.595 0 0 1 .615.616l-.018.829a.657.657 0 0 1-.64.646Z",
    fill: "#CAC4C6"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m42.937 21.114-14.627.314a.574.574 0 0 1-.581-.591l.006-.81a.622.622 0 0 1 .593-.62l14.652-.362c.34-.009.611.262.602.603l-.018.832a.648.648 0 0 1-.627.634Z",
    fill: "#C9C3C5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m42.934 21.097-14.628.316a.563.563 0 0 1-.569-.579l.006-.813a.609.609 0 0 1 .581-.606l14.653-.363a.57.57 0 0 1 .59.591l-.019.835a.634.634 0 0 1-.614.619Z",
    fill: "#C8C2C4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m42.929 21.081-14.628.317a.55.55 0 0 1-.557-.567l.006-.813a.596.596 0 0 1 .57-.595l14.651-.362a.56.56 0 0 1 .578.579l-.018.835a.621.621 0 0 1-.602.606Z",
    fill: "#C7C1C3"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m42.925 21.064-14.628.317a.537.537 0 0 1-.544-.555l.006-.817a.585.585 0 0 1 .557-.582l14.652-.362c.32-.01.572.246.566.566l-.019.838a.608.608 0 0 1-.59.595Z",
    fill: "#C6C0C2"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m42.922 21.048-14.628.317a.526.526 0 0 1-.532-.542l.006-.817a.572.572 0 0 1 .544-.57l14.652-.363c.314-.009.56.241.554.555l-.018.838a.602.602 0 0 1-.578.582Z",
    fill: "#C5BFC1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m42.916 21.03-14.628.316a.517.517 0 0 1-.523-.53l.006-.82a.556.556 0 0 1 .532-.554l14.652-.363a.525.525 0 0 1 .542.543l-.019.84a.577.577 0 0 1-.562.567Z",
    fill: "#C4BEC0"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m42.913 21.014-14.627.317a.503.503 0 0 1-.512-.518l.006-.823a.543.543 0 0 1 .52-.542l14.653-.363a.515.515 0 0 1 .53.53l-.02.844a.57.57 0 0 1-.55.555Z",
    fill: "#C3BDBF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m42.91 20.995-14.628.317a.492.492 0 0 1-.499-.506l.006-.822a.532.532 0 0 1 .508-.53l14.65-.363a.502.502 0 0 1 .517.518l-.019.844a.552.552 0 0 1-.535.542Z",
    fill: "#C3BCBE"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m42.904 20.98-14.628.317a.48.48 0 0 1-.487-.494l.006-.826a.52.52 0 0 1 .496-.518l14.65-.362a.49.49 0 0 1 .504.506l-.018.847a.539.539 0 0 1-.523.53Z",
    fill: "#C2BBBD"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m42.901 20.962-14.628.32a.467.467 0 0 1-.474-.481l.006-.826c.003-.274.219-.5.484-.506l14.649-.362a.478.478 0 0 1 .492.493l-.018.847a.528.528 0 0 1-.51.515Z",
    fill: "#C1BABC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m42.895 20.947-14.628.32a.455.455 0 0 1-.462-.473l.006-.828a.495.495 0 0 1 .471-.494l14.65-.363c.27-.006.486.21.48.482l-.018.85a.513.513 0 0 1-.5.506Z",
    fill: "#C0B9BB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m42.892 20.928-14.628.32a.444.444 0 0 1-.45-.46l.006-.832a.482.482 0 0 1 .459-.481l14.65-.363a.454.454 0 0 1 .468.47l-.019.853a.502.502 0 0 1-.486.494Z",
    fill: "#BFB8BA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m42.806 21.28-14.506.308a.73.73 0 0 1-.74-.753l.007-.795a.788.788 0 0 1 .754-.786l14.534-.366a.745.745 0 0 1 .766.77l-.018.817a.822.822 0 0 1-.797.805Z",
    fill: "#B0B1BD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m42.788 21.262-14.491.307a.726.726 0 0 1-.736-.746l.006-.786a.785.785 0 0 1 .751-.784l14.518-.362a.739.739 0 0 1 .764.765l-.018.807a.82.82 0 0 1-.794.799Z",
    fill: "#B1B2BE"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m42.767 21.246-14.476.308a.723.723 0 0 1-.733-.743l.006-.777c.003-.42.337-.771.745-.78l14.5-.363a.738.738 0 0 1 .76.762l-.018.795c0 .433-.356.79-.785.798Z",
    fill: "#B2B3BF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m42.748 21.228-14.457.308a.72.72 0 0 1-.73-.74l.006-.765c.003-.418.334-.768.742-.777l14.485-.363a.734.734 0 0 1 .757.759l-.015.786a.816.816 0 0 1-.788.792Z",
    fill: "#B3B4C0"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m42.727 21.21-14.442.307a.712.712 0 0 1-.724-.737l.006-.756a.776.776 0 0 1 .739-.774l14.47-.362a.73.73 0 0 1 .754.755l-.015.774a.818.818 0 0 1-.788.793Z",
    fill: "#B4B5C1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m42.706 21.192-14.428.307a.713.713 0 0 1-.72-.734l.006-.747a.768.768 0 0 1 .736-.768l14.454-.362a.727.727 0 0 1 .749.752l-.016.765a.808.808 0 0 1-.781.787Z",
    fill: "#B4B6C2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m42.687 21.177-14.411.31a.708.708 0 0 1-.718-.73l.006-.735a.767.767 0 0 1 .733-.765l14.44-.362c.419-.01.753.323.744.746l-.015.756a.808.808 0 0 1-.779.78Z",
    fill: "#B5B7C3"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m42.666 21.158-14.396.31a.706.706 0 0 1-.715-.728l.006-.725a.762.762 0 0 1 .73-.762l14.424-.362a.72.72 0 0 1 .742.743l-.015.744a.805.805 0 0 1-.776.78Z",
    fill: "#B6B8C3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m42.645 21.14-14.382.31a.702.702 0 0 1-.711-.722l.006-.716a.76.76 0 0 1 .727-.759l14.406-.362c.416-.01.748.32.739.74l-.015.735a.794.794 0 0 1-.77.774Z",
    fill: "#B7B9C4"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m42.627 21.124-14.367.31a.699.699 0 0 1-.708-.718l.006-.704a.757.757 0 0 1 .72-.756l14.391-.36c.414-.009.746.32.737.738l-.016.722a.788.788 0 0 1-.763.768Z",
    fill: "#B8BAC5"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "m42.606 21.106-14.352.31a.696.696 0 0 1-.705-.715l.006-.695a.75.75 0 0 1 .718-.75l14.375-.36c.414-.009.74.318.733.735l-.015.713a.784.784 0 0 1-.76.762Z",
    fill: "#B9BBC6"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m42.587 21.089-14.336.31a.692.692 0 0 1-.702-.713l.006-.685a.748.748 0 0 1 .715-.747l14.36-.36c.41-.008.736.318.727.732l-.015.7a.78.78 0 0 1-.755.763Z",
    fill: "#BABCC7"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m42.566 21.072-14.32.311a.685.685 0 0 1-.697-.71l.006-.673a.744.744 0 0 1 .712-.744l14.345-.36a.702.702 0 0 1 .724.726l-.015.692a.782.782 0 0 1-.755.758Z",
    fill: "#BBBDC8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m42.545 21.055-14.303.31a.685.685 0 0 1-.693-.706l.006-.664c.003-.4.32-.732.709-.74l14.326-.36a.7.7 0 0 1 .721.722l-.015.68a.777.777 0 0 1-.751.758Z",
    fill: "#BBBDC9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m42.526 21.037-14.287.31a.68.68 0 0 1-.69-.7l.006-.655a.74.74 0 0 1 .706-.738l14.311-.36c.405-.008.727.312.718.72l-.015.67a.778.778 0 0 1-.748.753Z",
    fill: "#BCBECA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m42.505 21.018-14.272.311a.678.678 0 0 1-.687-.698l.006-.642a.736.736 0 0 1 .7-.735l14.296-.36c.401-.008.72.312.715.717l-.015.661a.763.763 0 0 1-.743.747Z",
    fill: "#BDBFCB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m42.483 21.003-14.257.31a.675.675 0 0 1-.684-.694l.006-.634a.73.73 0 0 1 .697-.728l14.28-.356a.687.687 0 0 1 .71.713l-.013.649a.761.761 0 0 1-.739.74Z",
    fill: "#BEC0CC"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "m42.465 20.985-14.242.31a.672.672 0 0 1-.681-.691l.006-.622a.727.727 0 0 1 .694-.725l14.265-.356a.685.685 0 0 1 .706.707l-.012.64a.764.764 0 0 1-.736.737Z",
    fill: "#BFC1CD"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m42.444 20.966-14.227.31a.668.668 0 0 1-.678-.688l.006-.613a.723.723 0 0 1 .69-.722l14.251-.356a.681.681 0 0 1 .703.704l-.012.627a.757.757 0 0 1-.733.738Z",
    fill: "#C0C2CD"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "m42.425 20.95-14.21.311a.665.665 0 0 1-.676-.685l.006-.604a.72.72 0 0 1 .688-.719l14.232-.356a.678.678 0 0 1 .7.7l-.012.62a.756.756 0 0 1-.727.733Z",
    fill: "#C1C3CE"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "m42.404 20.932-14.196.31a.66.66 0 0 1-.669-.682l.006-.59a.721.721 0 0 1 .685-.717l14.217-.356a.677.677 0 0 1 .696.698l-.012.606a.755.755 0 0 1-.727.731Z",
    fill: "#C1C4CF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m42.383 20.915-14.18.31a.657.657 0 0 1-.667-.676l.006-.582a.711.711 0 0 1 .682-.71l14.202-.356c.389-.01.7.301.693.694l-.012.598a.75.75 0 0 1-.724.722Z",
    fill: "#C2C5D0"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m42.365 20.9-14.166.31a.652.652 0 0 1-.663-.673l.006-.573a.71.71 0 0 1 .675-.707l14.187-.356c.39-.01.697.298.688.691l-.012.588a.74.74 0 0 1-.715.72Z",
    fill: "#C3C6D1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "m42.343 20.881-14.147.311a.65.65 0 0 1-.66-.67l.006-.561a.706.706 0 0 1 .672-.704l14.172-.356a.664.664 0 0 1 .684.685l-.012.576a.74.74 0 0 1-.715.72Z",
    fill: "#C4C7D2"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m42.322 20.863-14.132.31a.648.648 0 0 1-.657-.667l.006-.551a.703.703 0 0 1 .67-.701l14.156-.353a.66.66 0 0 1 .681.682l-.012.567a.738.738 0 0 1-.712.713Z",
    fill: "#C5C8D3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M24.35 23.84a31.369 31.369 0 0 1-6.023.107c-.797-.067-1.555-.823-1.646-1.627a28.668 28.668 0 0 1 .003-5.978c.091-.82.855-1.624 1.658-1.734a31.534 31.534 0 0 1 6.068-.201c.822.058 1.6.822 1.688 1.648a28.951 28.951 0 0 1-.045 6.073c-.104.82-.888 1.615-1.704 1.712Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.018,
    d: "M24.337 23.831a31.273 31.273 0 0 1-6.013.107c-.797-.067-1.552-.823-1.643-1.627a28.61 28.61 0 0 1 .003-5.972c.091-.817.855-1.621 1.655-1.731a31.44 31.44 0 0 1 6.06-.201c.82.058 1.596.822 1.684 1.645a28.865 28.865 0 0 1-.045 6.064c-.104.823-.886 1.618-1.7 1.715Z",
    fill: "#FDFEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "M24.325 23.822a31.18 31.18 0 0 1-6.004.107c-.797-.067-1.552-.823-1.64-1.624a28.552 28.552 0 0 1 .003-5.966c.091-.817.852-1.618 1.655-1.728a31.329 31.329 0 0 1 6.05-.201c.818.058 1.594.82 1.682 1.645a28.799 28.799 0 0 1-.046 6.058c-.103.82-.885 1.611-1.7 1.709Z",
    fill: "#FCFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.037,
    d: "M24.313 23.816a31.085 31.085 0 0 1-5.995.107c-.794-.067-1.549-.82-1.637-1.624a28.494 28.494 0 0 1 .003-5.96c.091-.817.852-1.618 1.652-1.728a31.235 31.235 0 0 1 6.04-.201c.819.058 1.595.82 1.68 1.642.198 2.035.182 4.02-.046 6.052-.103.822-.882 1.614-1.697 1.712Z",
    fill: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.046,
    d: "M24.304 23.807a30.999 30.999 0 0 1-5.987.106c-.794-.067-1.545-.82-1.636-1.62-.207-1.99-.204-3.94.003-5.952.091-.813.849-1.615 1.649-1.724a30.905 30.905 0 0 1 6.032-.198c.815.057 1.59.82 1.676 1.639a28.69 28.69 0 0 1-.046 6.045c-.1.814-.882 1.606-1.691 1.704Z",
    fill: "#FAFCFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.055,
    d: "M24.291 23.797a30.897 30.897 0 0 1-5.977.107c-.79-.067-1.542-.82-1.633-1.62a28.768 28.768 0 0 1 .003-5.946c.091-.813.848-1.615 1.645-1.721 1.99-.262 4.006-.33 6.023-.198.815.057 1.588.82 1.676 1.639.198 2.03.183 4.01-.045 6.04-.104.813-.883 1.602-1.692 1.7Z",
    fill: "#F9FBFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.064,
    d: "M24.28 23.791a31.05 31.05 0 0 1-5.969.107c-.79-.067-1.542-.82-1.63-1.618a28.709 28.709 0 0 1 .003-5.939c.091-.813.845-1.612 1.642-1.721 1.987-.262 4-.33 6.014-.198.815.057 1.585.816 1.673 1.636a28.547 28.547 0 0 1-.046 6.03c-.1.817-.879 1.606-1.688 1.703Z",
    fill: "#F8FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.073,
    d: "M24.267 23.782c-1.995.229-3.99.262-5.962.107-.79-.067-1.539-.817-1.627-1.615a28.65 28.65 0 0 1 .003-5.933c.091-.81.845-1.609 1.642-1.719a31.112 31.112 0 0 1 6.005-.198c.812.058 1.582.817 1.67 1.637.197 2.026.182 4-.046 6.024-.1.81-.876 1.6-1.685 1.697Z",
    fill: "#F7FAF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "M24.255 23.774a30.888 30.888 0 0 1-5.953.107c-.787-.067-1.536-.817-1.627-1.615a28.585 28.585 0 0 1 .003-5.927c.091-.81.846-1.609 1.64-1.718 1.98-.26 3.99-.327 5.995-.199.812.058 1.582.817 1.667 1.634a28.431 28.431 0 0 1-.046 6.018c-.094.816-.87 1.605-1.679 1.7Z",
    fill: "#F6F9F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.092,
    d: "M24.246 23.767c-1.99.228-3.979.262-5.944.106-.788-.067-1.533-.816-1.624-1.612a28.533 28.533 0 0 1 .003-5.92c.091-.81.842-1.606 1.636-1.716a30.924 30.924 0 0 1 5.987-.198c.809.058 1.578.814 1.663 1.63.198 2.02.18 3.992-.045 6.012-.098.814-.87 1.6-1.676 1.698Z",
    fill: "#F5F8F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.101,
    d: "M24.234 23.757a30.697 30.697 0 0 1-5.935.107c-.785-.067-1.533-.814-1.621-1.612a28.445 28.445 0 0 1 .003-5.911c.091-.81.842-1.606 1.633-1.713a30.83 30.83 0 0 1 5.977-.198c.81.058 1.576.814 1.661 1.63a28.69 28.69 0 0 1-.045 6.003c-.098.81-.87 1.597-1.673 1.694Z",
    fill: "#F4F8F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M24.221 23.748a30.61 30.61 0 0 1-5.925.107c-.785-.067-1.53-.814-1.618-1.609a28.387 28.387 0 0 1 .003-5.905c.091-.808.84-1.603 1.63-1.713a30.736 30.736 0 0 1 5.968-.198c.81.058 1.573.814 1.661 1.627.195 2.018.18 3.983-.046 5.997-.097.814-.87 1.6-1.673 1.694Z",
    fill: "#F3F7F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.119,
    d: "M24.21 23.743c-1.98.225-3.964.262-5.917.107-.785-.068-1.527-.814-1.615-1.606a28.328 28.328 0 0 1 .003-5.9c.088-.807.84-1.6 1.63-1.709a30.643 30.643 0 0 1 5.96-.198c.805.055 1.569.81 1.657 1.627.194 2.014.18 3.98-.046 5.99-.1.805-.87 1.591-1.673 1.689Z",
    fill: "#F2F6F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.128,
    d: "M24.2 23.734a30.662 30.662 0 0 1-5.907.106c-.782-.067-1.524-.81-1.615-1.605a28.27 28.27 0 0 1 .003-5.893c.088-.808.84-1.6 1.627-1.707a30.55 30.55 0 0 1 5.95-.198c.806.055 1.57.81 1.655 1.624.194 2.011.18 3.974-.046 5.985-.097.807-.867 1.59-1.667 1.688Z",
    fill: "#F1F6F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.138,
    d: "M24.189 23.724a30.568 30.568 0 0 1-5.898.107c-.782-.067-1.524-.81-1.612-1.603-.204-1.968-.201-3.897.003-5.887.088-.804.836-1.596 1.624-1.706a30.464 30.464 0 0 1 5.94-.195c.804.055 1.567.81 1.652 1.62.195 2.009.18 3.971-.045 5.98-.098.807-.864 1.59-1.664 1.684Z",
    fill: "#F0F5F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.147,
    d: "M24.175 23.715a30.474 30.474 0 0 1-5.888.107c-.782-.067-1.521-.81-1.61-1.603-.2-1.965-.2-3.894.004-5.88.088-.805.836-1.597 1.62-1.704a30.37 30.37 0 0 1 5.932-.195c.803.055 1.564.81 1.649 1.62.195 2.009.18 3.965-.046 5.97-.094.807-.864 1.59-1.66 1.685Z",
    fill: "#EFF4F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.156,
    d: "M24.163 23.71c-1.968.225-3.939.261-5.88.106-.778-.067-1.517-.81-1.606-1.6-.2-1.962-.2-3.888.004-5.875.088-.804.833-1.593 1.618-1.7a30.52 30.52 0 0 1 5.922-.195c.803.055 1.56.808 1.646 1.618.194 2.005.18 3.961-.046 5.963-.094.804-.86 1.585-1.658 1.682Z",
    fill: "#EEF4F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.165,
    d: "M24.151 23.7a30.534 30.534 0 0 1-5.87.107c-.78-.067-1.518-.808-1.604-1.6-.2-1.96-.2-3.885.004-5.866.088-.801.833-1.593 1.618-1.7a30.426 30.426 0 0 1 5.913-.195c.8.055 1.56.808 1.646 1.618.194 2.002.179 3.955-.046 5.957-.1.804-.864 1.584-1.66 1.679Z",
    fill: "#EDF3F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.174,
    d: "M24.142 23.69a30.43 30.43 0 0 1-5.861.107c-.776-.067-1.515-.807-1.604-1.596-.2-1.96-.2-3.88.004-5.86.088-.801.833-1.59 1.615-1.697a30.332 30.332 0 0 1 5.904-.195c.8.055 1.557.807 1.642 1.615.195 1.999.18 3.952-.045 5.95-.098.802-.861 1.582-1.655 1.677Z",
    fill: "#ECF2F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.183,
    d: "M24.13 23.685c-1.959.226-3.92.26-5.855.107-.776-.067-1.512-.807-1.6-1.594-.201-1.956-.201-3.875.003-5.853.088-.801.83-1.587 1.612-1.697a30.255 30.255 0 0 1 5.898-.195c.797.055 1.554.804 1.64 1.612.194 1.999.179 3.946-.046 5.941-.098.805-.858 1.582-1.652 1.68Z",
    fill: "#EBF2F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.193,
    d: "M24.118 23.676a30.27 30.27 0 0 1-5.846.107c-.776-.067-1.51-.805-1.597-1.594-.201-1.953-.201-3.87.003-5.847.088-.801.83-1.587 1.609-1.694a30.162 30.162 0 0 1 5.889-.195c.797.055 1.55.804 1.636 1.612.192 1.996.18 3.943-.046 5.935-.094.805-.854 1.582-1.648 1.676Z",
    fill: "#EAF1EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.202,
    d: "M24.106 23.667a29.943 29.943 0 0 1-5.838.104c-.772-.067-1.508-.805-1.593-1.59-.201-1.954-.201-3.867.003-5.842.088-.798.827-1.584 1.606-1.691a30.068 30.068 0 0 1 5.88-.195c.796.055 1.548.804 1.633 1.609a28.41 28.41 0 0 1-.046 5.93c-.094.804-.855 1.58-1.645 1.675Z",
    fill: "#E9F0EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.211,
    d: "M24.096 23.66c-1.95.226-3.902.26-5.828.104-.772-.067-1.505-.804-1.59-1.59-.201-1.95-.201-3.864.003-5.835.088-.799.827-1.585 1.606-1.691a30.21 30.21 0 0 1 5.87-.195c.794.054 1.549.804 1.63 1.608.192 1.99.177 3.934-.045 5.924-.097.804-.858 1.581-1.646 1.676Z",
    fill: "#E8F0ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M24.084 23.651a29.75 29.75 0 0 1-5.819.104c-.772-.067-1.502-.801-1.59-1.587-.201-1.948-.201-3.858.003-5.83.088-.798.824-1.58 1.603-1.688 1.937-.255 3.9-.32 5.861-.195.794.055 1.545.802 1.63 1.606.192 1.99.177 3.93-.045 5.918-.097.804-.855 1.578-1.643 1.672Z",
    fill: "#E7EFED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.229,
    d: "M24.072 23.642a29.9 29.9 0 0 1-5.81.104c-.77-.067-1.5-.802-1.588-1.585-.2-1.944-.197-3.854.003-5.82.089-.795.825-1.578 1.6-1.685a29.796 29.796 0 0 1 5.853-.192c.79.055 1.542.802 1.627 1.603a28.417 28.417 0 0 1-.042 5.908c-.098.799-.855 1.573-1.643 1.667Z",
    fill: "#E6EEEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.238,
    d: "M24.06 23.636a29.803 29.803 0 0 1-5.8.104c-.77-.067-1.5-.802-1.585-1.585a28.341 28.341 0 0 1 .003-5.814c.088-.795.825-1.578 1.597-1.685a29.705 29.705 0 0 1 5.844-.192c.79.055 1.539.802 1.624 1.603a28.358 28.358 0 0 1-.043 5.902c-.097.799-.851 1.573-1.64 1.667Z",
    fill: "#E5EEEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.248,
    d: "M24.049 23.627c-1.941.223-3.879.26-5.792.104-.767-.067-1.497-.802-1.582-1.582a28.28 28.28 0 0 1 .003-5.807c.088-.796.822-1.576 1.594-1.682a29.844 29.844 0 0 1 5.834-.192c.791.055 1.536.798 1.622 1.6.191 1.98.176 3.915-.043 5.895-.097.796-.849 1.57-1.636 1.664Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.257,
    d: "M24.04 23.618a29.616 29.616 0 0 1-5.783.104c-.767-.068-1.494-.799-1.582-1.582a28.223 28.223 0 0 1 .003-5.802c.088-.795.822-1.575 1.594-1.678a29.75 29.75 0 0 1 5.825-.192c.788.055 1.536.798 1.618 1.6.192 1.98.177 3.912-.042 5.89-.097.795-.852 1.566-1.634 1.66Z",
    fill: "#E3EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.266,
    d: "M24.027 23.612a29.766 29.766 0 0 1-5.773.103c-.767-.067-1.49-.798-1.579-1.578a28.163 28.163 0 0 1 .003-5.796c.088-.792.819-1.572 1.591-1.679 1.923-.252 3.87-.32 5.816-.192.788.055 1.533.799 1.618 1.597a28.154 28.154 0 0 1-.042 5.881c-.1.798-.852 1.57-1.634 1.664Z",
    fill: "#E2ECE9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.275,
    d: "M24.015 23.602a29.68 29.68 0 0 1-5.764.104c-.764-.064-1.49-.799-1.576-1.579a28.104 28.104 0 0 1 .003-5.789c.088-.792.819-1.57 1.588-1.676a29.798 29.798 0 0 1 5.807-.192c.785.055 1.53.795 1.615 1.594a28.095 28.095 0 0 1-.043 5.875c-.097.798-.848 1.569-1.63 1.663Z",
    fill: "#E1EBE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.284,
    d: "M24.003 23.593a29.614 29.614 0 0 1-5.758.104c-.764-.064-1.488-.796-1.573-1.576a28.052 28.052 0 0 1 .003-5.783c.089-.792.819-1.57 1.585-1.676a29.705 29.705 0 0 1 5.798-.192c.785.055 1.527.795 1.612 1.594a28.039 28.039 0 0 1-.043 5.868c-.094.799-.842 1.567-1.624 1.661Z",
    fill: "#E0EBE7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.294,
    d: "M23.994 23.587a29.512 29.512 0 0 1-5.75.103c-.76-.064-1.484-.795-1.569-1.572a27.956 27.956 0 0 1 .003-5.774c.088-.79.816-1.566 1.582-1.673a29.62 29.62 0 0 1 5.788-.192c.785.055 1.528.795 1.61 1.59a28.185 28.185 0 0 1-.043 5.863c-.094.792-.843 1.56-1.621 1.655Z",
    fill: "#DFEAE7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.303,
    d: "M23.982 23.578a29.427 29.427 0 0 1-5.74.103c-.76-.064-1.482-.795-1.57-1.572a27.905 27.905 0 0 1 .003-5.768c.089-.79.816-1.567 1.582-1.67a29.526 29.526 0 0 1 5.78-.192c.781.055 1.523.795 1.605 1.59a28.128 28.128 0 0 1-.042 5.857c-.094.79-.843 1.557-1.618 1.652Z",
    fill: "#DEE9E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.312,
    d: "M23.97 23.568c-1.92.223-3.836.256-5.731.104-.76-.064-1.482-.795-1.567-1.57a27.847 27.847 0 0 1 .003-5.761c.089-.79.813-1.563 1.579-1.67a29.434 29.434 0 0 1 5.77-.192c.782.055 1.521.792 1.603 1.588a28.038 28.038 0 0 1-.042 5.847c-.095.795-.84 1.56-1.616 1.654Z",
    fill: "#DDE9E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.321,
    d: "M23.957 23.563a29.245 29.245 0 0 1-5.721.104c-.758-.064-1.479-.793-1.564-1.57a27.998 27.998 0 0 1 .003-5.755c.088-.786.812-1.563 1.576-1.667a29.11 29.11 0 0 1 5.76-.189c.78.055 1.519.792 1.604 1.584a28.203 28.203 0 0 1-.043 5.842c-.094.792-.84 1.557-1.615 1.651Z",
    fill: "#DCE8E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M23.945 23.553a29.136 29.136 0 0 1-5.712.104c-.758-.064-1.476-.792-1.56-1.566a27.938 27.938 0 0 1 .002-5.75c.085-.786.812-1.56 1.573-1.664 1.9-.25 3.83-.317 5.752-.189.779.055 1.515.793 1.6 1.585a28.135 28.135 0 0 1-.043 5.835c-.094.786-.836 1.55-1.612 1.645Z",
    fill: "#DBE7E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M23.936 23.545c-1.91.222-3.82.256-5.704.103-.757-.064-1.472-.792-1.557-1.563a28.098 28.098 0 0 1 .003-5.744c.085-.786.81-1.557 1.57-1.663a29.403 29.403 0 0 1 5.742-.19c.78.056 1.515.79 1.597 1.582.189 1.96.174 3.87-.042 5.83-.095.789-.837 1.55-1.61 1.645Z",
    fill: "#DAE7E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.349,
    d: "M23.924 23.538c-1.908.22-3.815.256-5.695.104-.754-.064-1.472-.79-1.557-1.563a28.009 28.009 0 0 1 .003-5.735c.085-.786.81-1.557 1.57-1.66a29.301 29.301 0 0 1 5.733-.19c.776.056 1.512.79 1.594 1.582a27.982 27.982 0 0 1-.042 5.82c-.095.786-.834 1.548-1.606 1.642Z",
    fill: "#D9E6E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.358,
    d: "M23.911 23.53c-1.904.218-3.808.255-5.685.103-.754-.064-1.469-.79-1.554-1.56a27.95 27.95 0 0 1 .003-5.729c.085-.783.806-1.554 1.566-1.658a29.217 29.217 0 0 1 5.725-.188c.776.055 1.509.789 1.591 1.578.189 1.953.173 3.86-.043 5.814-.09.783-.833 1.545-1.603 1.64Z",
    fill: "#D8E5E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.367,
    d: "M23.9 23.52c-1.902.22-3.803.253-5.677.104-.751-.064-1.466-.79-1.551-1.56a27.89 27.89 0 0 1 .003-5.723c.085-.783.806-1.554 1.563-1.657a29.116 29.116 0 0 1 5.716-.19c.773.056 1.506.787 1.588 1.576a27.865 27.865 0 0 1-.043 5.808c-.091.789-.83 1.55-1.6 1.642Z",
    fill: "#D7E5E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.376,
    d: "M23.89 23.514c-1.898.22-3.796.253-5.667.103-.751-.064-1.463-.786-1.548-1.557a27.832 27.832 0 0 1 .003-5.716c.085-.783.803-1.55 1.56-1.655 1.886-.25 3.8-.313 5.71-.188.772.054 1.505.786 1.588 1.575.188 1.95.173 3.851-.043 5.802-.097.78-.836 1.541-1.603 1.636Z",
    fill: "#D6E4E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.385,
    d: "M23.878 23.505c-1.895.22-3.79.253-5.658.103-.751-.064-1.463-.786-1.545-1.557a27.772 27.772 0 0 1 .003-5.71c.085-.78.803-1.548 1.557-1.655a28.96 28.96 0 0 1 5.7-.188c.773.055 1.503.786 1.585 1.572a27.75 27.75 0 0 1-.042 5.795c-.098.787-.834 1.545-1.6 1.64Z",
    fill: "#D5E3DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.395,
    d: "M23.866 23.495c-1.892.22-3.784.253-5.652.104-.748-.064-1.46-.786-1.545-1.554a27.713 27.713 0 0 1 .003-5.704c.085-.78.803-1.548 1.558-1.652 1.88-.25 3.787-.313 5.69-.188.77.054 1.5.786 1.582 1.572a27.882 27.882 0 0 1-.042 5.786c-.095.786-.828 1.545-1.594 1.636Z",
    fill: "#D4E3DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.404,
    d: "M23.854 23.486c-1.89.22-3.778.253-5.643.104-.748-.064-1.457-.787-1.542-1.552a27.654 27.654 0 0 1 .003-5.698c.085-.78.8-1.544 1.554-1.648a28.77 28.77 0 0 1 5.683-.186c.769.055 1.496.783 1.578 1.57.186 1.944.174 3.839-.042 5.78-.092.78-.825 1.538-1.591 1.63Z",
    fill: "#D3E2DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.413,
    d: "M23.841 23.48c-1.886.22-3.771.254-5.633.104-.745-.064-1.454-.783-1.54-1.55a27.784 27.784 0 0 1 .004-5.69c.085-.777.8-1.544 1.551-1.648 1.874-.25 3.775-.31 5.673-.186.767.055 1.494.783 1.576 1.566a27.758 27.758 0 0 1-.043 5.774c-.091.78-.824 1.536-1.588 1.63Z",
    fill: "#D2E1DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.422,
    d: "M23.832 23.47c-1.883.22-3.766.254-5.624.104-.745-.064-1.454-.783-1.536-1.548a27.724 27.724 0 0 1 .003-5.682c.085-.777.797-1.542 1.548-1.646 1.87-.247 3.769-.31 5.664-.186.766.055 1.493.784 1.572 1.567.186 1.938.174 3.83-.042 5.768-.091.777-.824 1.532-1.585 1.624Z",
    fill: "#D1E1DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M23.82 23.462c-1.88.219-3.76.253-5.615.103-.745-.064-1.451-.783-1.536-1.548a27.88 27.88 0 0 1 .003-5.676c.085-.777.797-1.54 1.545-1.643a28.721 28.721 0 0 1 5.655-.186c.766.055 1.49.78 1.572 1.564a27.81 27.81 0 0 1-.042 5.758c-.092.78-.822 1.536-1.582 1.628Z",
    fill: "#D0E0DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M23.808 23.456c-1.877.22-3.754.253-5.606.104-.742-.064-1.448-.78-1.533-1.545a27.82 27.82 0 0 1 .003-5.67c.085-.777.797-1.54 1.545-1.643a28.637 28.637 0 0 1 5.646-.186c.763.055 1.487.78 1.57 1.563.185 1.935.17 3.821-.043 5.753-.092.777-.822 1.53-1.582 1.624Z",
    fill: "#CFDFDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M23.796 23.447c-1.874.22-3.748.253-5.597.104-.742-.064-1.445-.78-1.53-1.542a27.76 27.76 0 0 1 .003-5.665c.085-.774.794-1.535 1.542-1.639 1.865-.247 3.75-.31 5.636-.186.764.055 1.485.78 1.567 1.56.185 1.932.17 3.818-.043 5.747-.091.777-.818 1.53-1.578 1.621Z",
    fill: "#CEDFDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.459,
    d: "M23.787 23.438c-1.87.216-3.741.253-5.587.104-.743-.064-1.445-.78-1.527-1.542a27.7 27.7 0 0 1 .003-5.659c.085-.774.794-1.535 1.539-1.639a28.453 28.453 0 0 1 5.627-.186c.76.055 1.481.78 1.564 1.557a27.65 27.65 0 0 1-.043 5.741c-.094.78-.821 1.533-1.576 1.624Z",
    fill: "#CDDED9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.468,
    d: "M23.774 23.431c-1.867.217-3.735.25-5.578.104-.74-.064-1.442-.777-1.524-1.539a27.634 27.634 0 0 1 .003-5.652c.085-.774.79-1.533 1.536-1.636a28.597 28.597 0 0 1 5.618-.186c.76.055 1.481.777 1.56 1.557.186 1.926.17 3.809-.042 5.734-.091.774-.819 1.524-1.573 1.618Z",
    fill: "#CCDDD8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.477,
    d: "M23.762 23.423a28.64 28.64 0 0 1-5.57.104c-.739-.064-1.438-.777-1.523-1.54a27.551 27.551 0 0 1 .003-5.642c.085-.771.79-1.53 1.533-1.633a28.505 28.505 0 0 1 5.609-.186c.757.055 1.478.777 1.56 1.554.186 1.925.17 3.802-.042 5.725-.092.777-.816 1.527-1.57 1.618Z",
    fill: "#CBDDD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "M23.75 23.414c-1.862.216-3.723.25-5.56.103-.737-.064-1.436-.776-1.521-1.535a27.492 27.492 0 0 1 .003-5.637c.085-.771.79-1.53 1.533-1.633a28.413 28.413 0 0 1 5.6-.186c.757.055 1.475.777 1.557 1.554.183 1.922.17 3.8-.04 5.719-.094.774-.818 1.524-1.572 1.615Z",
    fill: "#CADCD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.495,
    d: "M23.738 23.408c-1.859.216-3.717.25-5.551.103-.736-.064-1.436-.777-1.518-1.532a27.433 27.433 0 0 1 .003-5.631c.085-.771.788-1.527 1.53-1.63 1.85-.247 3.72-.308 5.59-.183.758.054 1.473.774 1.555 1.55a27.81 27.81 0 0 1-.04 5.714c-.094.768-.815 1.514-1.57 1.609Z",
    fill: "#C9DBD6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    d: "M23.729 23.398c-1.856.216-3.711.25-5.546.104-.736-.064-1.432-.774-1.514-1.533a27.587 27.587 0 0 1 .003-5.625c.085-.771.787-1.527 1.527-1.627a28.22 28.22 0 0 1 5.581-.183c.755.055 1.472.774 1.551 1.548.183 1.916.17 3.79-.039 5.707-.091.768-.812 1.517-1.564 1.609Z",
    fill: "#C9DBD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "M23.716 23.389a28.28 28.28 0 0 1-5.536.103c-.733-.064-1.43-.774-1.511-1.53a27.528 27.528 0 0 1 .003-5.618c.085-.768.784-1.524 1.523-1.627a28.137 28.137 0 0 1 5.573-.183c.754.055 1.47.774 1.548 1.548.183 1.916.17 3.784-.04 5.698-.09.77-.811 1.517-1.56 1.609Z",
    fill: "#C8DAD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.523,
    d: "M23.704 23.383c-1.85.216-3.699.25-5.527.1-.733-.064-1.426-.774-1.511-1.53a27.691 27.691 0 0 1 .003-5.612c.085-.768.784-1.524 1.523-1.624a28.044 28.044 0 0 1 5.564-.183c.751.055 1.466.77 1.545 1.545.183 1.913.17 3.781-.04 5.692-.088.774-.809 1.52-1.557 1.612Z",
    fill: "#C7D9D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.532,
    d: "M23.693 23.374a27.87 27.87 0 0 1-5.518.1c-.73-.064-1.426-.77-1.509-1.526a27.63 27.63 0 0 1 .003-5.607c.086-.768.785-1.52 1.521-1.62a28.195 28.195 0 0 1 5.555-.184c.751.055 1.463.771 1.545 1.545.182 1.91.17 3.776-.04 5.686-.09.768-.809 1.515-1.557 1.606Z",
    fill: "#C6D9D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.541,
    d: "M23.683 23.365c-1.844.216-3.69.25-5.509.1-.73-.064-1.424-.77-1.506-1.526a27.54 27.54 0 0 1 .003-5.598c.083-.765.782-1.517 1.518-1.62a28.103 28.103 0 0 1 5.545-.184c.752.055 1.46.771 1.543 1.542a27.696 27.696 0 0 1-.04 5.68c-.094.77-.809 1.514-1.554 1.606Z",
    fill: "#C5D8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M23.67 23.358c-1.84.217-3.683.25-5.499.101-.73-.064-1.42-.77-1.503-1.523a27.48 27.48 0 0 1 .003-5.592c.083-.765.782-1.517 1.515-1.618a28.004 28.004 0 0 1 5.536-.183c.748.055 1.46.771 1.54 1.542a27.637 27.637 0 0 1-.04 5.674c-.091.765-.806 1.508-1.551 1.6Z",
    fill: "#C4D7D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M23.659 23.35a27.6 27.6 0 0 1-5.49.1c-.728-.064-1.418-.768-1.503-1.52-.19-1.868-.19-3.7.003-5.586.082-.765.778-1.514 1.511-1.618a27.934 27.934 0 0 1 5.53-.183c.748.055 1.457.768 1.536 1.54a27.547 27.547 0 0 1-.04 5.664c-.09.768-.802 1.51-1.547 1.602Z",
    fill: "#C3D7D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M23.646 23.34a27.5 27.5 0 0 1-5.48.1c-.728-.063-1.418-.767-1.5-1.52a27.362 27.362 0 0 1 .003-5.579c.082-.762.778-1.514 1.511-1.615a27.842 27.842 0 0 1 5.521-.183c.745.055 1.454.768 1.533 1.536a27.49 27.49 0 0 1-.04 5.659c-.09.77-.805 1.51-1.548 1.602Z",
    fill: "#C2D6D0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.578,
    d: "M23.634 23.334a27.873 27.873 0 0 1-5.472.1c-.727-.064-1.414-.767-1.496-1.517a27.303 27.303 0 0 1 .003-5.573c.082-.762.775-1.511 1.508-1.612a27.759 27.759 0 0 1 5.512-.183c.745.055 1.45.768 1.53 1.536a27.43 27.43 0 0 1-.04 5.652c-.09.765-.803 1.506-1.545 1.597Z",
    fill: "#C1D5CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.587,
    d: "M23.625 23.325a27.78 27.78 0 0 1-5.463.1c-.724-.064-1.412-.767-1.494-1.517a27.243 27.243 0 0 1 .003-5.567c.083-.762.776-1.508 1.506-1.612a27.436 27.436 0 0 1 5.503-.18c.745.055 1.448.765 1.53 1.533.18 1.898.167 3.748-.04 5.646-.094.765-.806 1.505-1.545 1.597Z",
    fill: "#C0D5CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.596,
    d: "M23.614 23.316a27.688 27.688 0 0 1-5.454.1c-.724-.064-1.412-.765-1.49-1.514a27.368 27.368 0 0 1 .002-5.558c.082-.762.776-1.509 1.503-1.609a27.801 27.801 0 0 1 5.493-.18c.742.055 1.448.765 1.527 1.533.18 1.895.168 3.745-.04 5.637-.094.762-.802 1.5-1.541 1.59Z",
    fill: "#BFD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.606,
    d: "M23.6 23.31a27.602 27.602 0 0 1-5.444.1c-.721-.063-1.409-.764-1.49-1.51a27.308 27.308 0 0 1 .002-5.552c.082-.76.773-1.506 1.5-1.606a27.71 27.71 0 0 1 5.484-.18c.742.055 1.445.765 1.524 1.53.18 1.892.168 3.738-.04 5.63-.09.76-.796 1.497-1.535 1.588Z",
    fill: "#BED3CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M23.59 23.301a27.538 27.538 0 0 1-5.44.1c-.72-.063-1.405-.764-1.487-1.51a27.473 27.473 0 0 1 .003-5.546c.082-.759.773-1.506 1.5-1.606 1.81-.24 3.644-.302 5.475-.18.74.055 1.442.765 1.52 1.527.18 1.889.168 3.735-.039 5.625-.088.761-.797 1.499-1.533 1.59Z",
    fill: "#BDD3CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.624,
    d: "M23.58 23.292a27.438 27.438 0 0 1-5.43.1c-.72-.064-1.402-.761-1.484-1.508a27.413 27.413 0 0 1 .003-5.54c.082-.758.77-1.502 1.497-1.602a27.526 27.526 0 0 1 5.466-.18c.739.055 1.438.762 1.518 1.527.18 1.889.167 3.73-.04 5.618-.091.76-.797 1.493-1.53 1.585Z",
    fill: "#BCD2CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.633,
    d: "M23.568 23.283a27.353 27.353 0 0 1-5.42.1c-.718-.064-1.403-.761-1.482-1.508a27.354 27.354 0 0 1 .003-5.534c.082-.755.77-1.499 1.494-1.6a27.434 27.434 0 0 1 5.457-.179c.739.055 1.438.762 1.514 1.524.18 1.886.168 3.726-.04 5.612-.087.759-.793 1.496-1.526 1.585Z",
    fill: "#BBD1CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.642,
    d: "M23.556 23.276c-1.81.214-3.623.247-5.412.101-.717-.06-1.399-.762-1.478-1.505a27.294 27.294 0 0 1 .003-5.528c.082-.755.77-1.499 1.49-1.6 1.801-.24 3.626-.3 5.448-.179.736.055 1.436.762 1.515 1.524.18 1.883.168 3.723-.04 5.603-.09.759-.793 1.493-1.526 1.584Z",
    fill: "#BAD1CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M23.544 23.267a27.163 27.163 0 0 1-5.402.1c-.718-.06-1.397-.76-1.479-1.504a27.234 27.234 0 0 1 .003-5.522c.082-.755.767-1.496 1.488-1.596a27.25 27.25 0 0 1 5.438-.18c.736.055 1.433.759 1.512 1.52a27.11 27.11 0 0 1-.04 5.598c-.085.762-.787 1.496-1.52 1.584Z",
    fill: "#B9D0C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M23.532 23.258c-1.804.213-3.611.247-5.393.1-.715-.06-1.394-.758-1.476-1.502a27.144 27.144 0 0 1 .003-5.512c.082-.756.767-1.496 1.488-1.597a27.393 27.393 0 0 1 5.43-.18c.732.052 1.429.76 1.508 1.518a27.26 27.26 0 0 1-.04 5.591c-.088.759-.787 1.493-1.52 1.582Z",
    fill: "#B8CFC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M23.522 23.253c-1.8.213-3.604.246-5.384.1-.715-.06-1.393-.759-1.472-1.5a27.084 27.084 0 0 1 .003-5.505c.082-.753.764-1.493 1.485-1.594a27.069 27.069 0 0 1 5.42-.176c.733.051 1.427.758 1.506 1.517a27.21 27.21 0 0 1-.04 5.585c-.091.75-.79 1.481-1.518 1.573Z",
    fill: "#B7CFC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.679,
    d: "M23.51 23.244a27.122 27.122 0 0 1-5.375.1c-.712-.06-1.39-.759-1.469-1.499a27.023 27.023 0 0 1 .003-5.5c.082-.753.764-1.49 1.482-1.59a27.202 27.202 0 0 1 5.41-.177c.734.052 1.427.755 1.503 1.514.18 1.874.165 3.705-.04 5.576-.087.756-.787 1.487-1.514 1.576Z",
    fill: "#B6CEC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.688,
    d: "M23.498 23.235c-1.795.21-3.593.243-5.366.1-.712-.06-1.387-.756-1.466-1.496a27.18 27.18 0 0 1 .003-5.494c.082-.753.764-1.49 1.478-1.59a27.11 27.11 0 0 1 5.402-.177c.73.052 1.424.755 1.503 1.514.177 1.871.164 3.7-.04 5.57-.09.753-.787 1.484-1.514 1.573Z",
    fill: "#B5CDC6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.697,
    d: "M23.486 23.227c-1.792.21-3.587.244-5.357.1-.712-.06-1.384-.755-1.466-1.495a27.12 27.12 0 0 1 .003-5.488c.082-.75.76-1.487 1.475-1.588a27.02 27.02 0 0 1 5.393-.176c.73.052 1.42.755 1.5 1.511.176 1.871.164 3.696-.04 5.564-.085.753-.781 1.48-1.508 1.572Z",
    fill: "#B4CDC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.706,
    d: "M23.476 23.219c-1.788.21-3.58.244-5.347.1-.709-.06-1.384-.755-1.463-1.492a27.288 27.288 0 0 1 .003-5.482c.082-.75.76-1.487 1.475-1.585a26.928 26.928 0 0 1 5.384-.176c.727.051 1.418.755 1.497 1.508.176 1.868.164 3.69-.04 5.558-.091.752-.785 1.48-1.509 1.569Z",
    fill: "#B3CCC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.716,
    d: "M23.464 23.21c-1.785.21-3.574.244-5.338.1-.709-.06-1.381-.752-1.46-1.49a27.227 27.227 0 0 1 .003-5.475c.082-.75.757-1.484 1.472-1.585a26.837 26.837 0 0 1 5.375-.176c.727.051 1.414.752 1.493 1.508a27.096 27.096 0 0 1-.04 5.552c-.087.75-.78 1.478-1.505 1.566Z",
    fill: "#B2CBC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.725,
    d: "M23.452 23.203c-1.782.21-3.568.244-5.332.101-.706-.06-1.378-.753-1.457-1.49a27.137 27.137 0 0 1 .003-5.466c.082-.747.757-1.484 1.47-1.582a26.746 26.746 0 0 1 5.365-.177c.727.052 1.414.753 1.49 1.506.177 1.861.165 3.68-.04 5.542-.085.75-.778 1.475-1.499 1.566Z",
    fill: "#B1CBC3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.734,
    d: "M23.44 23.194c-1.78.21-3.562.244-5.323.1-.706-.06-1.375-.752-1.457-1.486a27.069 27.069 0 0 1 .003-5.46c.082-.747.754-1.482 1.466-1.582a26.894 26.894 0 0 1 5.357-.177c.724.052 1.411.753 1.487 1.505a27.166 27.166 0 0 1-.036 5.537c-.082.75-.776 1.475-1.497 1.563Z",
    fill: "#B0CAC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.743,
    d: "M23.428 23.185c-1.777.21-3.556.244-5.314.1-.706-.06-1.375-.752-1.454-1.487a27.008 27.008 0 0 1 .003-5.454c.082-.746.754-1.478 1.463-1.578a26.817 26.817 0 0 1 5.348-.177c.723.052 1.408.75 1.487 1.502a27.1 27.1 0 0 1-.037 5.53c-.085.75-.775 1.476-1.496 1.564Z",
    fill: "#AFC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.752,
    d: "M23.419 23.178c-1.777.21-3.55.244-5.305.101-.703-.06-1.372-.75-1.451-1.484a26.956 26.956 0 0 1 .003-5.448c.079-.747.754-1.478 1.463-1.575a26.734 26.734 0 0 1 5.341-.177c.721.052 1.406.75 1.485 1.5a27.041 27.041 0 0 1-.037 5.523c-.094.747-.781 1.47-1.5 1.56Z",
    fill: "#AEC9C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    d: "M23.407 23.17a26.56 26.56 0 0 1-5.296.1c-.703-.06-1.369-.75-1.448-1.484a26.895 26.895 0 0 1 .003-5.442c.079-.743.751-1.475 1.46-1.575a26.421 26.421 0 0 1 5.332-.174c.721.052 1.405.75 1.482 1.5a26.953 26.953 0 0 1-.037 5.515c-.091.746-.779 1.471-1.496 1.56Z",
    fill: "#ADC8C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.771,
    d: "M23.394 23.16c-1.77.21-3.54.244-5.286.101-.703-.06-1.366-.75-1.445-1.48a26.835 26.835 0 0 1 .003-5.437c.079-.743.751-1.474 1.457-1.572a26.56 26.56 0 0 1 5.323-.174c.72.052 1.402.75 1.478 1.496.177 1.853.162 3.66-.036 5.51-.091.746-.779 1.468-1.494 1.557Z",
    fill: "#ACC8BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M23.382 23.154c-1.767.21-3.534.24-5.277.1-.7-.06-1.366-.746-1.445-1.477a26.738 26.738 0 0 1 .003-5.427c.08-.743.748-1.472 1.454-1.57a26.461 26.461 0 0 1 5.314-.173c.718.052 1.4.747 1.475 1.496.177 1.85.161 3.654-.036 5.503-.085.738-.773 1.457-1.488 1.548Z",
    fill: "#ABC7BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.789,
    d: "M23.373 23.146c-1.764.21-3.529.24-5.268.1-.7-.06-1.363-.746-1.442-1.477-.183-1.813-.18-3.59.003-5.42.079-.741.748-1.47 1.45-1.57a26.377 26.377 0 0 1 5.306-.174c.717.052 1.396.747 1.472 1.493.173 1.847.16 3.65-.037 5.497-.088.74-.772 1.463-1.484 1.551Z",
    fill: "#AAC6BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.798,
    d: "M23.36 23.137c-1.76.21-3.522.24-5.259.1-.696-.06-1.36-.746-1.438-1.475-.18-1.81-.18-3.586.003-5.414.079-.74.748-1.469 1.45-1.566a26.501 26.501 0 0 1 5.296-.174c.715.052 1.393.746 1.472 1.49a27.153 27.153 0 0 1-.036 5.49c-.091.741-.776 1.46-1.488 1.549Z",
    fill: "#A9C6BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.807,
    d: "M23.35 23.13a26.57 26.57 0 0 1-5.25.1c-.697-.061-1.357-.744-1.437-1.475-.179-1.807-.179-3.58.004-5.408.079-.74.745-1.466 1.447-1.564 1.75-.234 3.52-.292 5.287-.173.715.052 1.393.743 1.47 1.49a27.06 27.06 0 0 1-.037 5.481c-.092.74-.773 1.46-1.485 1.548Z",
    fill: "#A8C5BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.817,
    d: "M23.337 23.12a26.47 26.47 0 0 1-5.24.1c-.697-.06-1.357-.743-1.434-1.471a26.95 26.95 0 0 1 .004-5.402c.079-.738.745-1.466 1.444-1.564a26.335 26.335 0 0 1 5.278-.173c.715.052 1.39.743 1.466 1.487.173 1.84.161 3.635-.037 5.475-.09.74-.77 1.46-1.48 1.548Z",
    fill: "#A7C4BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M23.324 23.112c-1.752.207-3.504.24-5.232.1-.693-.06-1.353-.743-1.432-1.468-.18-1.804-.18-3.571.003-5.397.079-.737.742-1.462 1.441-1.56a26.245 26.245 0 0 1 5.269-.173c.712.051 1.387.743 1.463 1.487a26.942 26.942 0 0 1-.037 5.47c-.085.736-.766 1.452-1.475 1.54Z",
    fill: "#A6C4BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.835,
    d: "M23.315 23.105c-1.749.207-3.498.24-5.226.097-.693-.06-1.35-.743-1.43-1.468-.179-1.801-.179-3.568.004-5.39.079-.738.742-1.46 1.438-1.56a26.153 26.153 0 0 1 5.26-.174c.711.052 1.384.74 1.46 1.484a26.881 26.881 0 0 1-.037 5.463c-.085.744-.763 1.46-1.469 1.548Z",
    fill: "#A5C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.844,
    d: "M23.303 23.096c-1.746.208-3.492.241-5.217.098-.69-.06-1.347-.74-1.426-1.466-.18-1.797-.18-3.565.003-5.38.079-.738.742-1.46 1.438-1.558a26.049 26.049 0 0 1 5.25-.173c.71.051 1.384.74 1.46 1.48a26.785 26.785 0 0 1-.036 5.455c-.088.74-.766 1.456-1.472 1.544Z",
    fill: "#A4C2B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.853,
    d: "M23.29 23.088c-1.742.207-3.485.24-5.207.097-.69-.06-1.347-.74-1.423-1.465-.18-1.798-.18-3.56.003-5.375.079-.735.739-1.457 1.435-1.554a25.971 25.971 0 0 1 5.241-.171c.71.052 1.381.74 1.457 1.48.174 1.832.162 3.62-.036 5.449-.088.737-.764 1.45-1.47 1.539Z",
    fill: "#A3C2B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.862,
    d: "M23.279 23.078c-1.74.207-3.48.241-5.199.098-.69-.061-1.344-.74-1.423-1.463a26.61 26.61 0 0 1 .003-5.369c.079-.734.739-1.456 1.432-1.554 1.731-.231 3.483-.29 5.232-.17.709.051 1.378.74 1.454 1.477a26.674 26.674 0 0 1-.036 5.442c-.082.74-.758 1.454-1.463 1.54Z",
    fill: "#A2C1B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.872,
    d: "M23.27 23.072c-1.738.207-3.474.24-5.19.098-.687-.061-1.341-.738-1.42-1.463-.18-1.792-.18-3.55.003-5.363.079-.734.736-1.453 1.43-1.55a26.011 26.011 0 0 1 5.222-.171c.706.051 1.375.737 1.45 1.477.174 1.826.162 3.611-.036 5.436-.085.735-.757 1.448-1.46 1.536Z",
    fill: "#A1C0B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.881,
    d: "M23.258 23.063a25.862 25.862 0 0 1-5.18.097c-.688-.06-1.338-.737-1.418-1.46a26.718 26.718 0 0 1 .003-5.356c.08-.731.737-1.453 1.427-1.548 1.725-.231 3.47-.29 5.214-.17.705.051 1.372.737 1.448 1.474a26.77 26.77 0 0 1-.037 5.43c-.082.734-.757 1.444-1.457 1.533Z",
    fill: "#A0C0B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M23.245 23.054c-1.731.207-3.462.237-5.171.097-.688-.06-1.339-.737-1.415-1.456a26.888 26.888 0 0 1 .003-5.351c.08-.731.733-1.45 1.427-1.548a25.824 25.824 0 0 1 5.204-.17c.703.051 1.372.737 1.445 1.471.17 1.822.158 3.602-.036 5.42-.086.738-.758 1.451-1.457 1.537Z",
    fill: "#9FBFB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.899,
    d: "M23.233 23.048a25.673 25.673 0 0 1-5.162.098c-.685-.061-1.336-.738-1.412-1.457a26.827 26.827 0 0 1 .003-5.344c.08-.731.733-1.447 1.424-1.545a25.733 25.733 0 0 1 5.195-.17c.703.051 1.369.734 1.445 1.471.17 1.82.158 3.596-.037 5.415-.088.734-.757 1.444-1.456 1.532Z",
    fill: "#9EBEB4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.908,
    d: "M23.221 23.039c-1.724.207-3.449.238-5.152.098-.685-.061-1.333-.735-1.412-1.454a26.729 26.729 0 0 1 .003-5.335c.08-.732.733-1.448 1.42-1.542a25.65 25.65 0 0 1 5.187-.17c.703.051 1.366.734 1.442 1.468.17 1.816.158 3.592-.037 5.409-.082.73-.75 1.438-1.45 1.526Z",
    fill: "#9DBEB4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "M23.211 23.029a25.493 25.493 0 0 1-5.143.098c-.682-.061-1.33-.735-1.409-1.454a26.675 26.675 0 0 1 .003-5.33c.08-.727.73-1.444 1.418-1.541a25.56 25.56 0 0 1 5.177-.17c.7.051 1.363.734 1.439 1.468.17 1.816.158 3.586-.037 5.402-.085.732-.751 1.442-1.448 1.527Z",
    fill: "#9CBDB3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.927,
    d: "M23.2 23.024a25.639 25.639 0 0 1-5.135.098c-.682-.061-1.33-.735-1.406-1.45a26.614 26.614 0 0 1 .003-5.324c.08-.728.73-1.444 1.415-1.539a25.69 25.69 0 0 1 5.168-.17c.7.052 1.36.731 1.435 1.465.17 1.813.159 3.584-.036 5.394-.082.731-.751 1.438-1.445 1.526Z",
    fill: "#9BBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.936,
    d: "M23.187 23.015a25.533 25.533 0 0 1-5.126.098c-.68-.061-1.326-.732-1.402-1.448a26.554 26.554 0 0 1 .003-5.317c.08-.728.727-1.441 1.415-1.539a25.622 25.622 0 0 1 5.162-.17c.696.052 1.36.731 1.432 1.462.17 1.81.159 3.578-.036 5.388-.088.734-.755 1.44-1.448 1.526Z",
    fill: "#9ABCB1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.945,
    d: "M23.176 23.005a25.476 25.476 0 0 1-5.12.098c-.678-.061-1.323-.731-1.399-1.448a26.486 26.486 0 0 1 .003-5.31c.08-.726.727-1.439 1.412-1.536a25.537 25.537 0 0 1 5.152-.168c.697.052 1.357.732 1.43 1.463.17 1.807.158 3.574-.036 5.38-.082.73-.749 1.436-1.442 1.521Z",
    fill: "#99BBB1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    d: "M23.167 23c-1.71.203-3.42.237-5.11.097-.679-.061-1.32-.732-1.4-1.445a26.426 26.426 0 0 1 .003-5.305c.08-.725.727-1.438 1.409-1.532 1.7-.229 3.422-.287 5.143-.168.697.052 1.354.731 1.43 1.46.17 1.806.158 3.568-.037 5.375-.085.725-.748 1.429-1.438 1.517Z",
    fill: "#98BAB0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.963,
    d: "M23.154 22.99a25.289 25.289 0 0 1-5.102.098c-.678-.061-1.32-.729-1.396-1.445a26.357 26.357 0 0 1 .003-5.299c.076-.725.724-1.435 1.406-1.532a25.365 25.365 0 0 1 5.134-.168c.694.052 1.35.728 1.427 1.46.17 1.803.158 3.565-.037 5.369-.085.728-.745 1.432-1.435 1.517Z",
    fill: "#97BAAF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.973,
    d: "M23.141 22.98a25.212 25.212 0 0 1-5.092.098c-.675-.06-1.317-.728-1.393-1.441a26.504 26.504 0 0 1 .003-5.29c.076-.722.724-1.435 1.402-1.53a25.276 25.276 0 0 1 5.126-.167c.693.052 1.35.728 1.423 1.457.17 1.8.159 3.559-.036 5.36-.082.725-.742 1.428-1.433 1.514Z",
    fill: "#96B9AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    d: "M23.13 22.975c-1.7.204-3.4.238-5.083.098-.675-.061-1.314-.728-1.39-1.438a26.668 26.668 0 0 1 .003-5.284c.076-.722.72-1.432 1.402-1.527a25.186 25.186 0 0 1 5.117-.167c.69.052 1.347.728 1.42 1.453a26.47 26.47 0 0 1-.036 5.354c-.086.722-.746 1.423-1.433 1.511Z",
    fill: "#95B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.991,
    d: "M23.118 22.966a25.249 25.249 0 0 1-5.074.097c-.672-.06-1.311-.728-1.387-1.438a26.607 26.607 0 0 1 .003-5.277c.076-.722.72-1.43 1.4-1.527 1.687-.228 3.4-.283 5.106-.168.69.052 1.345.726 1.418 1.454.167 1.798.158 3.55-.034 5.348-.085.725-.745 1.426-1.432 1.51Z",
    fill: "#94B8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.109 22.957a25.16 25.16 0 0 1-5.065.097c-.672-.058-1.311-.725-1.387-1.435a26.546 26.546 0 0 1 .003-5.271c.076-.723.72-1.43 1.396-1.524a25.216 25.216 0 0 1 5.098-.168c.69.052 1.342.726 1.415 1.45a26.79 26.79 0 0 1-.034 5.342c-.085.723-.742 1.423-1.426 1.509Z",
    fill: "#93B7AC"
  }))), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M23.054 23.113a26.234 26.234 0 0 1-5.308.1c-.706-.064-1.372-.764-1.454-1.511a28.169 28.169 0 0 1 0-5.549c.08-.758.755-1.505 1.463-1.605a26.103 26.103 0 0 1 5.345-.177c.724.055 1.408.765 1.484 1.53.176 1.889.164 3.735-.037 5.624-.085.759-.775 1.496-1.493 1.588Z",
    fill: "#79BCA4"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M23.039 23.103a26.144 26.144 0 0 1-5.299.1c-.702-.063-1.369-.764-1.45-1.51a28.123 28.123 0 0 1 0-5.543c.078-.759.75-1.502 1.46-1.603 1.764-.24 3.549-.298 5.334-.177.721.055 1.406.762 1.482 1.527.176 1.89.164 3.733-.037 5.619-.085.762-.772 1.496-1.49 1.587Z",
    fill: "#7ABDA5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M23.027 23.095c-1.77.213-3.541.247-5.287.1-.703-.063-1.369-.761-1.448-1.508a28.046 28.046 0 0 1 0-5.536c.08-.759.752-1.502 1.457-1.603a26.108 26.108 0 0 1 5.323-.177c.721.055 1.402.762 1.479 1.524a27.918 27.918 0 0 1-.037 5.613c-.085.761-.773 1.496-1.487 1.587Z",
    fill: "#7ABEA6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M23.012 23.085a25.938 25.938 0 0 1-5.278.1c-.7-.063-1.366-.761-1.445-1.505a28 28 0 0 1 0-5.53c.08-.756.748-1.5 1.454-1.6a26.027 26.027 0 0 1 5.314-.177c.718.055 1.4.762 1.475 1.524a27.85 27.85 0 0 1-.036 5.606c-.082.756-.77 1.49-1.484 1.582Z",
    fill: "#7BBEA7"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M23 23.076a25.835 25.835 0 0 1-5.269.1c-.7-.06-1.363-.761-1.442-1.505a27.938 27.938 0 0 1 0-5.524c.08-.756.748-1.496 1.451-1.597a25.915 25.915 0 0 1 5.302-.177c.718.055 1.396.762 1.472 1.52a27.797 27.797 0 0 1-.036 5.601c-.083.756-.767 1.49-1.479 1.582Z",
    fill: "#7CBFA8"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M22.987 23.065a25.72 25.72 0 0 1-5.256.1c-.697-.06-1.36-.758-1.439-1.502a27.862 27.862 0 0 1 0-5.518c.08-.756.745-1.496 1.448-1.597a26.034 26.034 0 0 1 5.293-.176c.714.055 1.393.758 1.469 1.52.173 1.88.161 3.715-.037 5.595-.085.755-.766 1.49-1.478 1.578Z",
    fill: "#7CC0A9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M22.972 23.056a25.852 25.852 0 0 1-5.247.1c-.697-.06-1.357-.758-1.436-1.502a28.045 28.045 0 0 1 0-5.512c.08-.753.745-1.493 1.445-1.594a25.943 25.943 0 0 1 5.283-.176c.715.055 1.39.758 1.47 1.517a28.09 28.09 0 0 1-.037 5.585c-.085.76-.766 1.494-1.478 1.582Z",
    fill: "#7DC1AA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M22.96 23.046a25.759 25.759 0 0 1-5.238.1c-.694-.06-1.354-.758-1.433-1.499-.18-1.84-.18-3.644 0-5.506.079-.752.742-1.493 1.442-1.593a25.605 25.605 0 0 1 5.271-.174c.712.055 1.387.759 1.466 1.517a28.031 28.031 0 0 1-.036 5.58c-.082.755-.764 1.486-1.473 1.575Z",
    fill: "#7DC1AB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M22.944 23.037c-1.749.21-3.498.243-5.226.1-.693-.06-1.35-.759-1.43-1.499a28.154 28.154 0 0 1 0-5.5c.08-.753.743-1.49 1.44-1.59a25.509 25.509 0 0 1 5.262-.174c.712.055 1.387.759 1.463 1.514a27.967 27.967 0 0 1-.037 5.573c-.085.756-.763 1.487-1.472 1.576Z",
    fill: "#7EC2AC"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M22.932 23.028c-1.746.21-3.492.244-5.216.1-.694-.06-1.351-.755-1.427-1.496a28.091 28.091 0 0 1 0-5.493c.079-.753.739-1.49 1.439-1.588a25.616 25.616 0 0 1 5.25-.174c.708.055 1.384.756 1.46 1.515.173 1.87.161 3.699-.037 5.567-.085.75-.763 1.48-1.469 1.569Z",
    fill: "#7FC3AD"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22.92 23.018c-1.743.21-3.486.244-5.205.1-.69-.06-1.347-.755-1.423-1.496a28.044 28.044 0 0 1 0-5.487c.079-.75.739-1.487 1.435-1.588a25.528 25.528 0 0 1 5.241-.174c.71.055 1.381.756 1.457 1.512a27.848 27.848 0 0 1-.036 5.56c-.088.753-.767 1.482-1.47 1.573Z",
    fill: "#7FC4AE"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22.905 23.01c-1.737.21-3.477.243-5.196.1-.69-.06-1.344-.755-1.42-1.493a27.967 27.967 0 0 1 0-5.481c.079-.75.739-1.487 1.433-1.585a25.439 25.439 0 0 1 5.231-.174c.706.055 1.378.756 1.454 1.509.174 1.867.162 3.69-.036 5.555-.088.75-.76 1.477-1.466 1.569Z",
    fill: "#80C5AF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22.893 23c-1.734.21-3.471.244-5.187.1-.687-.06-1.34-.755-1.42-1.493a27.906 27.906 0 0 1 0-5.475c.08-.75.736-1.484 1.43-1.585a25.322 25.322 0 0 1 5.22-.174c.705.055 1.374.753 1.45 1.509a27.726 27.726 0 0 1-.036 5.548c-.082.753-.755 1.478-1.457 1.57Z",
    fill: "#81C5B0"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M22.88 22.988c-1.73.21-3.464.243-5.174.1-.687-.06-1.338-.753-1.417-1.49-.18-1.828-.18-3.62 0-5.47.079-.746.736-1.48 1.426-1.58a25.226 25.226 0 0 1 5.211-.175c.706.055 1.372.753 1.448 1.506.173 1.862.161 3.68-.037 5.542-.085.753-.757 1.478-1.457 1.567Z",
    fill: "#81C6B1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M22.865 22.979c-1.727.21-3.458.243-5.165.1-.684-.06-1.335-.752-1.414-1.49a27.782 27.782 0 0 1 0-5.463c.08-.747.733-1.481 1.423-1.579a25.326 25.326 0 0 1 5.199-.173c.702.055 1.369.752 1.445 1.505.17 1.862.16 3.678-.037 5.537-.079.75-.751 1.474-1.45 1.563Z",
    fill: "#82C7B2"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 22.97c-1.725.21-3.45.244-5.153.098-.684-.06-1.332-.753-1.411-1.487a28.189 28.189 0 0 1 0-5.457c.079-.747.733-1.478 1.42-1.578a25.244 25.244 0 0 1 5.19-.174c.702.052 1.365.752 1.441 1.502.17 1.859.158 3.672-.036 5.53-.085.753-.755 1.478-1.451 1.567Z",
    fill: "#82C8B3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M22.838 22.961c-1.722.21-3.444.244-5.144.098-.681-.061-1.33-.75-1.408-1.484a28.142 28.142 0 0 1 0-5.451c.079-.747.73-1.478 1.417-1.576a25.119 25.119 0 0 1 5.177-.17c.7.051 1.363.75 1.439 1.502a28.17 28.17 0 0 1-.034 5.524c-.082.744-.75 1.469-1.447 1.557Z",
    fill: "#83C8B4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M22.825 22.951c-1.718.21-3.437.24-5.134.098-.681-.061-1.33-.75-1.405-1.484a28.08 28.08 0 0 1 0-5.445c.079-.744.73-1.475 1.414-1.576a25.03 25.03 0 0 1 5.168-.17c.7.051 1.36.75 1.436 1.499.17 1.855.158 3.662-.034 5.518-.082.75-.751 1.472-1.445 1.56Z",
    fill: "#84C9B5"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M22.813 22.943c-1.712.21-3.428.24-5.122.097-.681-.06-1.326-.75-1.402-1.48a28 28 0 0 1 0-5.44c.079-.743.726-1.474 1.41-1.572a24.944 24.944 0 0 1 5.16-.17c.696.051 1.356.75 1.432 1.499.17 1.852.159 3.66-.033 5.512-.088.743-.751 1.465-1.445 1.554Z",
    fill: "#84CAB6"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M22.798 22.934c-1.71.21-3.422.24-5.113.097-.678-.06-1.323-.75-1.4-1.48a27.954 27.954 0 0 1 0-5.434c.077-.743.728-1.471 1.409-1.569a24.832 24.832 0 0 1 5.147-.17c.696.051 1.356.75 1.43 1.496.17 1.85.157 3.656-.034 5.506-.082.743-.745 1.465-1.439 1.554Z",
    fill: "#85CBB7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M22.786 22.924a24.67 24.67 0 0 1-5.104.098c-.678-.06-1.32-.746-1.396-1.478a27.891 27.891 0 0 1 0-5.427c.076-.743.724-1.471 1.405-1.569 1.7-.235 3.419-.292 5.137-.17.694.051 1.354.746 1.427 1.493a27.9 27.9 0 0 1-.033 5.496c-.082.747-.746 1.47-1.436 1.557Z",
    fill: "#86CCB8"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M22.774 22.915c-1.704.208-3.41.241-5.092.098-.676-.061-1.317-.747-1.393-1.478a27.814 27.814 0 0 1 0-5.42c.076-.741.723-1.47 1.402-1.567a24.622 24.622 0 0 1 5.125-.17c.694.051 1.35.746 1.424 1.493a27.83 27.83 0 0 1-.034 5.49c-.085.744-.745 1.466-1.432 1.554Z",
    fill: "#86CCB9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M22.759 22.902c-1.7.207-3.401.241-5.083.098-.675-.061-1.314-.747-1.39-1.475a27.767 27.767 0 0 1 0-5.415c.076-.74.72-1.468 1.399-1.566a24.535 24.535 0 0 1 5.116-.17c.69.051 1.348.746 1.42 1.49a27.76 27.76 0 0 1-.033 5.484c-.082.75-.742 1.466-1.43 1.554Z",
    fill: "#87CDBA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22.747 22.894c-1.697.207-3.394.24-5.07.097-.673-.06-1.311-.746-1.387-1.474a27.704 27.704 0 0 1 0-5.409c.076-.74.72-1.466 1.399-1.563a24.63 24.63 0 0 1 5.104-.17c.69.051 1.344.746 1.417 1.49.168 1.84.159 3.637-.033 5.478-.085.746-.745 1.462-1.43 1.55Z",
    fill: "#88CEBB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M22.73 22.884c-1.693.207-3.388.24-5.06.097-.673-.06-1.312-.743-1.388-1.471a28.117 28.117 0 0 1 0-5.403c.076-.737.718-1.462 1.396-1.56a24.752 24.752 0 0 1 5.095-.17c.688.051 1.342.743 1.415 1.486.167 1.84.158 3.636-.034 5.473-.079.743-.736 1.46-1.423 1.548Z",
    fill: "#88CFBC"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M22.719 22.876a24.39 24.39 0 0 1-5.053.097c-.669-.06-1.308-.743-1.384-1.471a28.055 28.055 0 0 1 0-5.397c.076-.737.718-1.462 1.393-1.56a24.468 24.468 0 0 1 5.086-.167c.688.051 1.339.743 1.412 1.487.167 1.837.155 3.629-.034 5.466-.082.74-.736 1.457-1.42 1.545Z",
    fill: "#89CFBC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M22.707 22.866a24.27 24.27 0 0 1-5.04.097c-.669-.06-1.305-.743-1.38-1.469a27.992 27.992 0 0 1 0-5.39c.075-.737.714-1.46 1.39-1.557 1.678-.231 3.379-.29 5.073-.167.684.051 1.335.743 1.408 1.483a27.993 27.993 0 0 1-.033 5.46c-.082.738-.736 1.454-1.418 1.543Z",
    fill: "#89D0BD"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 22.857c-1.682.207-3.367.24-5.03.097-.667-.06-1.303-.74-1.379-1.466a27.929 27.929 0 0 1 0-5.384c.076-.737.715-1.46 1.387-1.557 1.676-.231 3.37-.29 5.065-.167.684.051 1.332.74 1.405 1.483a27.929 27.929 0 0 1-.033 5.455c-.08.734-.733 1.45-1.415 1.538Z",
    fill: "#8AD1BE"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M22.68 22.847c-1.679.208-3.361.238-5.019.098-.666-.061-1.299-.74-1.375-1.466a27.865 27.865 0 0 1 0-5.378c.076-.734.712-1.456 1.384-1.554a24.142 24.142 0 0 1 5.053-.167c.684.051 1.329.74 1.405 1.48a27.868 27.868 0 0 1-.034 5.449c-.085.737-.736 1.45-1.414 1.538Z",
    fill: "#8BD2BF"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M22.664 22.84a24.189 24.189 0 0 1-5.01.097c-.666-.061-1.296-.74-1.372-1.463a27.803 27.803 0 0 1 0-5.372c.076-.734.712-1.457 1.381-1.55a24.049 24.049 0 0 1 5.044-.168c.68.051 1.326.74 1.402 1.477a27.807 27.807 0 0 1-.034 5.442c-.082.735-.733 1.448-1.411 1.536Z",
    fill: "#8BD2C0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M22.653 22.83a24.097 24.097 0 0 1-5 .097c-.664-.06-1.294-.74-1.37-1.462a27.74 27.74 0 0 1 0-5.366c.076-.735.71-1.454 1.378-1.551a24.172 24.172 0 0 1 5.034-.168c.682.052 1.327.74 1.4 1.478.167 1.825.155 3.61-.034 5.436-.082.734-.733 1.447-1.408 1.536Z",
    fill: "#8CD3C1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M22.64 22.817c-1.67.208-3.34.238-4.988.098-.663-.06-1.29-.737-1.366-1.46a27.677 27.677 0 0 1 0-5.36c.076-.734.709-1.453 1.375-1.547a24.055 24.055 0 0 1 5.022-.168c.678.052 1.323.738 1.396 1.475a27.682 27.682 0 0 1-.033 5.43c-.082.734-.73 1.447-1.405 1.532Z",
    fill: "#8DD4C2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M22.625 22.808a23.904 23.904 0 0 1-4.98.098c-.66-.061-1.289-.737-1.362-1.46a27.86 27.86 0 0 1 0-5.353c.076-.732.706-1.45 1.372-1.548a23.963 23.963 0 0 1 5.013-.168c.678.052 1.32.738 1.393 1.475a27.862 27.862 0 0 1-.034 5.424c-.082.734-.726 1.447-1.402 1.532Z",
    fill: "#8DD5C3"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M22.613 22.8c-1.66.206-3.325.237-4.97.097-.66-.061-1.287-.738-1.36-1.457a28.05 28.05 0 0 1 0-5.347c.076-.732.706-1.448 1.369-1.545a23.86 23.86 0 0 1 5-.168c.676.052 1.318.738 1.39 1.472.165 1.819.156 3.596-.033 5.415-.079.737-.724 1.447-1.396 1.532Z",
    fill: "#8ED6C4"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 22.79a23.91 23.91 0 0 1-4.957.098c-.657-.061-1.284-.737-1.357-1.457a27.97 27.97 0 0 1 0-5.341c.076-.731.706-1.447 1.366-1.542a23.759 23.759 0 0 1 4.991-.164c.675.051 1.314.737 1.387 1.471a27.696 27.696 0 0 1-.033 5.409c-.082.731-.727 1.441-1.396 1.527Z",
    fill: "#8FD6C5"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M22.586 22.781a23.808 23.808 0 0 1-4.95.098c-.656-.061-1.28-.735-1.353-1.454a27.923 27.923 0 0 1 0-5.335c.076-.728.703-1.444 1.363-1.542a23.65 23.65 0 0 1 4.98-.164c.671.051 1.31.734 1.383 1.468.164 1.816.152 3.59-.033 5.403-.08.731-.721 1.438-1.39 1.526Z",
    fill: "#8FD7C6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M22.573 22.772a23.71 23.71 0 0 1-4.936.098c-.657-.061-1.278-.735-1.354-1.454a27.86 27.86 0 0 1 0-5.33c.076-.727.703-1.443 1.363-1.538a23.565 23.565 0 0 1 4.97-.164c.672.051 1.308.734 1.38 1.468a27.816 27.816 0 0 1-.032 5.397c-.083.728-.724 1.435-1.39 1.523Z",
    fill: "#90D8C7"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.558 22.763a23.618 23.618 0 0 1-4.927.097c-.654-.06-1.275-.734-1.35-1.45-.171-1.78-.171-3.526 0-5.323.075-.729.699-1.442 1.359-1.54a23.686 23.686 0 0 1 4.96-.164c.67.052 1.306.735 1.379 1.466.164 1.813.152 3.58-.034 5.39-.079.728-.718 1.435-1.387 1.524Z",
    fill: "#90D9C8"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M22.546 22.753a23.517 23.517 0 0 1-4.918.098c-.654-.06-1.272-.731-1.348-1.45-.17-1.777-.17-3.52 0-5.317.073-.729.7-1.442 1.357-1.536a23.57 23.57 0 0 1 4.949-.165c.669.052 1.302.732 1.375 1.466.164 1.81.152 3.577-.034 5.384-.076.728-.715 1.432-1.38 1.52Z",
    fill: "#91D9C9"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M22.534 22.744a23.624 23.624 0 0 1-4.906.098c-.651-.061-1.272-.732-1.345-1.448a27.669 27.669 0 0 1 0-5.31c.073-.726.697-1.439 1.354-1.533a23.477 23.477 0 0 1 4.94-.165c.666.052 1.298.732 1.371 1.463a27.629 27.629 0 0 1-.033 5.378c-.082.725-.718 1.429-1.381 1.517Z",
    fill: "#92DACA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M22.519 22.732c-1.637.204-3.28.235-4.897.098-.651-.061-1.269-.732-1.342-1.445a27.605 27.605 0 0 1 0-5.305c.073-.725.697-1.438 1.35-1.532a23.376 23.376 0 0 1 4.928-.165c.666.052 1.3.732 1.37 1.46a27.558 27.558 0 0 1-.034 5.372c-.076.728-.712 1.432-1.375 1.517Z",
    fill: "#92DBCB"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M22.506 22.723a23.23 23.23 0 0 1-4.888.095c-.648-.061-1.265-.732-1.338-1.445a28.033 28.033 0 0 1 0-5.299c.073-.725.693-1.435 1.347-1.53a23.282 23.282 0 0 1 4.919-.164c.666.052 1.296.732 1.366 1.46a27.74 27.74 0 0 1-.034 5.366c-.076.728-.712 1.432-1.372 1.517Z",
    fill: "#93DCCC"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 22.714c-1.63.204-3.264.235-4.876.095-.648-.062-1.262-.729-1.335-1.442a27.97 27.97 0 0 1 0-5.293c.073-.722.693-1.432 1.344-1.53a23.19 23.19 0 0 1 4.91-.164c.663.052 1.292.729 1.362 1.457.162 1.8.152 3.559-.033 5.36-.08.728-.712 1.432-1.372 1.517Z",
    fill: "#94DDCD"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22.479 22.704a23.032 23.032 0 0 1-4.867.095c-.645-.061-1.26-.729-1.332-1.441a27.906 27.906 0 0 1 0-5.287c.073-.722.69-1.432 1.341-1.527a23.081 23.081 0 0 1 4.897-.161c.663.052 1.29.728 1.36 1.456a27.615 27.615 0 0 1-.033 5.354c-.076.725-.71 1.426-1.366 1.511Z",
    fill: "#94DDCE"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M22.467 22.696a22.91 22.91 0 0 1-4.855.094c-.645-.06-1.256-.728-1.33-1.438a27.842 27.842 0 0 1 0-5.28c.074-.723.691-1.43 1.34-1.527a23.195 23.195 0 0 1 4.887-.162c.66.052 1.287.729 1.357 1.454a27.8 27.8 0 0 1-.03 5.347c-.083.726-.712 1.426-1.37 1.512Z",
    fill: "#95DECF"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M22.451 22.687a22.832 22.832 0 0 1-4.845.094c-.642-.06-1.253-.728-1.326-1.438a27.777 27.777 0 0 1 0-5.275c.073-.722.687-1.429 1.335-1.523a23.08 23.08 0 0 1 4.876-.162c.66.052 1.284.729 1.354 1.454a27.729 27.729 0 0 1-.03 5.341c-.08.723-.707 1.423-1.364 1.509Z",
    fill: "#95DFD0"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M22.44 22.677a22.945 22.945 0 0 1-4.837.095c-.642-.061-1.25-.725-1.323-1.435a27.712 27.712 0 0 1 0-5.269c.073-.719.687-1.426 1.332-1.52 1.61-.226 3.24-.28 4.867-.162.657.052 1.28.726 1.35 1.45.162 1.792.15 3.544-.03 5.336-.08.72-.706 1.42-1.36 1.505Z",
    fill: "#96E0D1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M22.427 22.668c-1.612.201-3.23.235-4.824.095-.642-.061-1.25-.725-1.32-1.435a27.65 27.65 0 0 1 0-5.263c.073-.719.684-1.426 1.329-1.52a22.879 22.879 0 0 1 4.855-.162c.657.052 1.277.726 1.347 1.45.161 1.792.15 3.538-.03 5.327-.08.722-.706 1.42-1.357 1.508Z",
    fill: "#97E0D2"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22.412 22.656a22.74 22.74 0 0 1-4.815.095c-.639-.061-1.247-.726-1.32-1.433a27.586 27.586 0 0 1 0-5.256c.073-.719.684-1.423 1.326-1.517a22.793 22.793 0 0 1 4.846-.162c.654.052 1.274.726 1.344 1.448.161 1.788.15 3.534-.03 5.32-.073.722-.7 1.42-1.35 1.505Z",
    fill: "#97E1D3"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 22.647a22.636 22.636 0 0 1-4.803.095c-.639-.058-1.244-.723-1.317-1.433a27.52 27.52 0 0 1 0-5.25c.073-.719.681-1.423 1.323-1.517 1.6-.226 3.218-.28 4.836-.162.654.052 1.272.723 1.342 1.445a27.702 27.702 0 0 1-.03 5.314c-.08.728-.703 1.423-1.351 1.508Z",
    fill: "#98E2D4"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.015,
    d: "m19.787 21.302-1.409-1.39c-.34-.335-.346-.902-.018-1.264a.833.833 0 0 1 1.214-.055l.28.277a.24.24 0 0 0 .337-.006l1.886-1.908c.35-.353.9-.353 1.229 0 .328.354.31.927-.04 1.28L20.222 21.3a.31.31 0 0 1-.435.003Z",
    fill: "#FEFEFE"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "m19.786 21.296-1.405-1.387c-.337-.335-.347-.899-.018-1.264.328-.366.873-.39 1.21-.055l.28.274a.24.24 0 0 0 .338-.006l1.883-1.904c.35-.354.9-.354 1.229 0 .328.353.31.926-.04 1.28l-3.042 3.055a.307.307 0 0 1-.435.007Z",
    fill: "#FDFEFE"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.045,
    d: "m19.783 21.29-1.402-1.387c-.337-.335-.347-.898-.018-1.264.328-.366.87-.39 1.21-.055l.28.274a.24.24 0 0 0 .338-.006l1.883-1.904c.35-.354.897-.354 1.226 0 .328.353.31.926-.04 1.276l-3.036 3.054c-.127.128-.319.134-.44.012Z",
    fill: "#FCFDFD"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.061,
    d: "m19.783 21.287-1.402-1.384a.92.92 0 0 1-.018-1.261.835.835 0 0 1 1.21-.055l.28.274c.095.091.24.088.335-.006l1.88-1.901c.35-.354.897-.354 1.226 0 .328.353.31.923-.04 1.276l-3.033 3.05a.31.31 0 0 1-.438.006Z",
    fill: "#FBFDFC"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.076,
    d: "m19.78 21.28-1.399-1.384c-.337-.332-.347-.896-.018-1.261.328-.363.87-.387 1.207-.055l.28.274c.095.091.24.088.335-.006l1.877-1.898c.346-.354.897-.354 1.222 0 .329.353.31.923-.04 1.273l-3.029 3.047a.305.305 0 0 1-.435.01Z",
    fill: "#FAFCFC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.091,
    d: "m19.777 21.274-1.399-1.38c-.337-.332-.347-.896-.018-1.259.328-.362.867-.387 1.207-.055l.28.275c.095.091.24.088.335-.006l1.874-1.896c.346-.35.894-.353 1.223 0 .328.35.31.924-.04 1.274l-3.027 3.044a.31.31 0 0 1-.435.003Z",
    fill: "#F9FCFB"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.106,
    d: "m19.777 21.271-1.396-1.38c-.337-.332-.347-.896-.018-1.258.328-.363.867-.387 1.204-.055l.28.274c.095.091.24.088.335-.006l1.874-1.895c.346-.35.894-.354 1.22 0 .325.35.306.92-.04 1.27l-3.024 3.041a.305.305 0 0 1-.435.01Z",
    fill: "#F8FBFA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.121,
    d: "m19.774 21.265-1.396-1.377c-.338-.333-.344-.893-.018-1.256a.828.828 0 0 1 1.204-.055l.277.275c.094.091.24.088.335-.006l1.87-1.893c.347-.35.895-.35 1.22 0 .326.35.307.92-.04 1.27l-3.02 3.039a.306.306 0 0 1-.432.003Z",
    fill: "#F7FAFA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.136,
    d: "m19.771 21.259-1.393-1.377c-.338-.333-.344-.893-.018-1.256.325-.362.864-.387 1.201-.055l.277.275c.091.091.24.088.335-.006l1.867-1.89c.347-.35.892-.35 1.217 0 .325.35.307.92-.04 1.268l-3.014 3.032a.301.301 0 0 1-.432.009Z",
    fill: "#F6FAF9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.151,
    d: "m19.771 21.256-1.393-1.375c-.335-.332-.344-.892-.018-1.252.325-.363.864-.387 1.201-.055l.277.274c.091.092.24.089.334-.006l1.868-1.889c.347-.35.891-.35 1.217 0 .325.35.307.917-.04 1.268l-3.011 3.029a.31.31 0 0 1-.435.006Z",
    fill: "#F5F9F8"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m19.769 21.25-1.39-1.375c-.335-.332-.344-.89-.018-1.252.325-.36.863-.384 1.198-.055l.277.274c.091.092.24.089.334-.006l1.865-1.886c.347-.35.891-.35 1.214 0 .325.35.307.918-.04 1.265l-3.008 3.026a.301.301 0 0 1-.432.009Z",
    fill: "#F4F9F8"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.182,
    d: "m19.769 21.244-1.39-1.372a.912.912 0 0 1-.018-1.249.826.826 0 0 1 1.198-.055l.277.271c.091.092.24.089.331-.006l1.862-1.883c.347-.35.888-.35 1.214 0 .325.35.307.918-.04 1.265l-3.005 3.023a.3.3 0 0 1-.43.006Z",
    fill: "#F3F8F7"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.197,
    d: "m19.766 21.24-1.387-1.37c-.335-.33-.344-.89-.018-1.25.325-.36.86-.384 1.195-.055l.277.271c.091.092.24.089.331-.006l1.859-1.88c.344-.35.888-.35 1.21 0 .326.348.308.914-.04 1.262l-3.001 3.02a.299.299 0 0 1-.426.009Z",
    fill: "#F2F8F7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.212,
    d: "m19.762 21.235-1.387-1.368c-.335-.329-.344-.887-.018-1.246.325-.36.86-.384 1.195-.055l.277.271a.232.232 0 0 0 .331-.006l1.859-1.88c.344-.347.888-.35 1.21 0 .326.348.308.914-.039 1.262l-3 3.016a.3.3 0 0 1-.428.006Z",
    fill: "#F1F7F6"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.227,
    d: "m19.763 21.228-1.384-1.368c-.335-.329-.344-.886-.018-1.246.325-.36.857-.384 1.195-.055l.277.271a.232.232 0 0 0 .331-.006l1.856-1.877c.343-.347.885-.35 1.21 0 .323.348.308.911-.04 1.259l-2.995 3.013a.301.301 0 0 1-.432.01Z",
    fill: "#F0F6F5"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.242,
    d: "m19.76 21.226-1.384-1.365c-.335-.33-.341-.887-.018-1.243a.819.819 0 0 1 1.192-.055l.277.27a.232.232 0 0 0 .331-.005l1.853-1.874c.343-.348.885-.348 1.207 0 .323.347.304.911-.04 1.258l-2.99 3.008a.306.306 0 0 1-.428.006Z",
    fill: "#EFF6F5"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.258,
    d: "m19.756 21.219-1.38-1.362c-.332-.33-.341-.884-.019-1.243a.819.819 0 0 1 1.193-.055l.273.271a.232.232 0 0 0 .332-.006l1.852-1.874c.344-.347.886-.347 1.208 0 .322.347.304.911-.04 1.258l-2.986 3.005a.31.31 0 0 1-.433.006Z",
    fill: "#EEF5F4"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.273,
    d: "m19.756 21.213-1.38-1.362a.906.906 0 0 1-.019-1.24.818.818 0 0 1 1.19-.055l.273.271a.232.232 0 0 0 .332-.006l1.85-1.871c.343-.347.882-.347 1.204 0 .322.347.304.908-.04 1.255l-2.984 3.002a.296.296 0 0 1-.425.006Z",
    fill: "#EDF5F3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.288,
    d: "m19.753 21.21-1.377-1.36a.906.906 0 0 1-.019-1.24.818.818 0 0 1 1.19-.051l.273.27a.232.232 0 0 0 .332-.005l1.846-1.868c.344-.348.882-.348 1.205 0 .322.347.304.908-.04 1.255l-2.98 2.998a.311.311 0 0 1-.43 0Z",
    fill: "#ECF4F3"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.303,
    d: "m19.753 21.203-1.377-1.359a.902.902 0 0 1-.019-1.237c.323-.356.855-.38 1.187-.052l.273.272a.228.228 0 0 0 .329-.006l1.843-1.865a.823.823 0 0 1 1.202 0c.322.347.304.908-.04 1.252l-2.978 2.995a.3.3 0 0 1-.42 0Z",
    fill: "#EBF3F2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.318,
    d: "m19.75 21.198-1.374-1.356c-.332-.326-.341-.88-.019-1.237.323-.356.852-.38 1.187-.052l.273.272a.228.228 0 0 0 .329-.006l1.843-1.865c.34-.345.88-.348 1.202 0 .322.344.304.905-.04 1.252l-2.975 2.992a.302.302 0 0 1-.425 0Z",
    fill: "#EAF3F1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "m19.747 21.195-1.371-1.356c-.332-.326-.341-.88-.019-1.237.323-.356.852-.38 1.184-.052l.273.269a.228.228 0 0 0 .329-.006l1.84-1.862c.34-.345.88-.348 1.199 0 .322.344.304.905-.04 1.25l-2.969 2.988a.302.302 0 0 1-.426.006Z",
    fill: "#E9F2F1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.348,
    d: "m19.747 21.189-1.372-1.353c-.331-.326-.337-.877-.018-1.234.323-.357.852-.38 1.183-.052l.274.268a.234.234 0 0 0 .329-.006l1.837-1.858a.824.824 0 0 1 1.198 0c.32.344.305.904-.04 1.249l-2.965 2.983a.305.305 0 0 1-.426.003Z",
    fill: "#E8F2F0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.364,
    d: "m19.744 21.183-1.369-1.353c-.331-.326-.337-.877-.018-1.234.32-.356.849-.38 1.18-.052l.274.268a.234.234 0 0 0 .329-.006l1.837-1.858c.34-.345.876-.345 1.195 0 .32.344.301.902-.04 1.246l-2.962 2.98a.3.3 0 0 1-.426.01Z",
    fill: "#E7F1EF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.379,
    d: "m19.741 21.18-1.369-1.35c-.328-.326-.337-.878-.018-1.231a.81.81 0 0 1 1.18-.052l.274.268a.234.234 0 0 0 .329-.006l1.834-1.855c.34-.345.876-.345 1.195 0 .32.344.301.901-.04 1.246l-2.959 2.977a.305.305 0 0 1-.426.003Z",
    fill: "#E6F1EF"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.394,
    d: "m19.741 21.174-1.366-1.35c-.328-.326-.337-.875-.018-1.231.32-.354.849-.378 1.177-.052l.274.268a.234.234 0 0 0 .328-.006l1.832-1.852c.34-.345.873-.345 1.192 0 .32.344.301.902-.04 1.243l-2.956 2.974a.298.298 0 0 1-.423.006Z",
    fill: "#E5F0EE"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.409,
    d: "m19.738 21.168-1.366-1.347a.897.897 0 0 1-.018-1.228c.32-.354.846-.378 1.177-.052l.27.268a.234.234 0 0 0 .33-.006l1.828-1.85c.34-.344.872-.344 1.192 0 .32.345.301.9-.04 1.244l-2.953 2.97a.3.3 0 0 1-.42 0Z",
    fill: "#E4EFED"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.424,
    d: "m19.738 21.165-1.363-1.347a.897.897 0 0 1-.018-1.228c.32-.354.846-.378 1.177-.052l.27.268a.23.23 0 0 0 .326-.006l1.828-1.85c.338-.344.873-.344 1.19 0 .32.342.3.9-.04 1.24l-2.95 2.969a.297.297 0 0 1-.42.006Z",
    fill: "#E3EFED"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "m19.735 21.158-1.363-1.343c-.328-.323-.337-.872-.018-1.225.32-.354.846-.378 1.174-.052l.27.268a.23.23 0 0 0 .326-.006l1.825-1.847c.338-.34.87-.344 1.19 0 .32.342.3.9-.04 1.24l-2.944 2.965a.3.3 0 0 1-.42 0Z",
    fill: "#E2EEEC"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.455,
    d: "m19.732 21.152-1.36-1.343c-.328-.323-.337-.872-.018-1.225.32-.354.843-.378 1.174-.052l.27.268a.23.23 0 0 0 .326-.006l1.822-1.843c.338-.342.87-.345 1.19 0 .32.34.3.895-.04 1.237l-2.941 2.958a.298.298 0 0 1-.423.006Z",
    fill: "#E1EEEB"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "m19.732 21.15-1.36-1.34c-.328-.324-.334-.872-.018-1.223.32-.353.842-.377 1.171-.051l.27.265a.23.23 0 0 0 .326-.006l1.822-1.844c.338-.341.87-.341 1.186 0 .317.341.302.896-.04 1.237l-2.937 2.956a.3.3 0 0 1-.42.006Z",
    fill: "#E0EDEB"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.485,
    d: "m19.729 21.143-1.357-1.34c-.328-.323-.334-.869-.018-1.222a.804.804 0 0 1 1.171-.052l.27.265a.23.23 0 0 0 .326-.006l1.82-1.84a.815.815 0 0 1 1.185 0 .897.897 0 0 1-.04 1.233l-2.934 2.953a.296.296 0 0 1-.423.01Z",
    fill: "#DFEDEA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.726 21.138 18.369 19.8c-.325-.323-.334-.868-.018-1.219a.803.803 0 0 1 1.168-.051l.27.265a.23.23 0 0 0 .326-.006l1.816-1.838c.338-.341.867-.341 1.183 0 .317.341.298.893-.04 1.234l-2.932 2.95a.293.293 0 0 1-.416.003Z",
    fill: "#DFECEA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.515,
    d: "m19.726 21.135-1.354-1.338a.892.892 0 0 1-.018-1.219.803.803 0 0 1 1.168-.051l.27.265a.23.23 0 0 0 .326-.006l1.813-1.835c.337-.341.867-.341 1.183 0 .316.341.298.893-.04 1.231l-2.929 2.947a.3.3 0 0 1-.42.006Z",
    fill: "#DEEBE9"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "m19.723 21.129-1.354-1.335a.888.888 0 0 1-.018-1.216c.316-.35.84-.374 1.165-.051l.27.265a.23.23 0 0 0 .326-.006l1.813-1.835a.808.808 0 0 1 1.18 0c.316.341.298.89-.04 1.231l-2.923 2.944a.303.303 0 0 1-.42.003Z",
    fill: "#DDEBE8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.545,
    d: "m19.723 21.122-1.351-1.335a.888.888 0 0 1-.018-1.216c.316-.35.836-.375 1.165-.052l.267.266a.227.227 0 0 0 .323-.006l1.81-1.832c.334-.338.863-.341 1.18 0 .316.338.298.89-.04 1.228l-2.92 2.94a.29.29 0 0 1-.416.007Z",
    fill: "#DCEAE8"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "m19.72 21.116-1.35-1.332c-.326-.32-.335-.865-.02-1.213.317-.35.837-.375 1.163-.052l.267.266a.227.227 0 0 0 .323-.007l1.807-1.828c.334-.338.863-.341 1.177 0 .316.338.298.89-.04 1.228l-2.917 2.934a.286.286 0 0 1-.41.004Z",
    fill: "#DBEAE7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.576,
    d: "m19.717 21.113-1.348-1.331c-.325-.32-.334-.863-.018-1.213.316-.35.836-.375 1.162-.052l.267.265a.227.227 0 0 0 .323-.006l1.807-1.828a.81.81 0 0 1 1.177 0c.316.338.298.887-.04 1.225l-2.914 2.931a.293.293 0 0 1-.416.01Z",
    fill: "#DAE9E6"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.591,
    d: "m19.717 21.106-1.344-1.328c-.326-.32-.332-.863-.018-1.21a.799.799 0 0 1 1.162-.052l.267.265a.226.226 0 0 0 .323-.006l1.803-1.825c.335-.338.861-.338 1.174 0 .314.338.299.887-.04 1.225l-2.91 2.928a.293.293 0 0 1-.417.003Z",
    fill: "#D9E9E6"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.606,
    d: "m19.713 21.101-1.344-1.328c-.326-.32-.332-.863-.018-1.21a.795.795 0 0 1 1.159-.052l.267.265a.226.226 0 0 0 .323-.006l1.8-1.822c.335-.338.861-.338 1.175 0a.888.888 0 0 1-.04 1.222l-2.908 2.925a.287.287 0 0 1-.414.006Z",
    fill: "#D8E8E5"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.621,
    d: "m19.714 21.098-1.341-1.325c-.323-.32-.332-.86-.019-1.21a.797.797 0 0 1 1.16-.052l.267.262a.227.227 0 0 0 .322-.006l1.798-1.819c.335-.338.858-.338 1.171 0 .314.338.295.884-.04 1.222l-2.904 2.922a.292.292 0 0 1-.414.006Z",
    fill: "#D7E7E4"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.636,
    d: "M19.711 21.092 18.37 19.77a.882.882 0 0 1-.018-1.207c.313-.347.83-.372 1.155-.052l.268.262a.227.227 0 0 0 .322-.006l1.798-1.819c.335-.338.858-.338 1.171 0 .314.338.295.884-.04 1.219l-2.898 2.919a.296.296 0 0 1-.417.006Z",
    fill: "#D6E7E4"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "m19.707 21.085-1.338-1.322a.882.882 0 0 1-.018-1.207c.313-.347.83-.372 1.155-.052l.268.262a.227.227 0 0 0 .322-.006l1.795-1.816c.332-.338.858-.338 1.168 0 .313.335.295.884-.04 1.219l-2.895 2.916a.29.29 0 0 1-.417.006Z",
    fill: "#D5E6E3"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m19.708 21.082-1.338-1.32a.879.879 0 0 1-.018-1.203c.313-.348.83-.372 1.152-.052l.268.262a.223.223 0 0 0 .32-.006l1.79-1.813c.332-.335.856-.338 1.169 0 .313.335.295.88-.04 1.216l-2.892 2.91a.289.289 0 0 1-.41.006Z",
    fill: "#D4E6E2"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.682,
    d: "m19.705 21.076-1.335-1.32c-.323-.317-.332-.856-.018-1.203.313-.348.83-.372 1.152-.052l.268.262a.223.223 0 0 0 .32-.006l1.79-1.813c.332-.335.856-.338 1.169 0 .313.335.295.88-.04 1.216l-2.89 2.907a.294.294 0 0 1-.416.009Z",
    fill: "#D3E5E2"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.697,
    d: "m19.701 21.07-1.335-1.317c-.323-.317-.332-.856-.018-1.2a.79.79 0 0 1 1.15-.052l.264.262a.223.223 0 0 0 .32-.006l1.788-1.81c.331-.335.855-.335 1.165 0 .313.335.295.88-.04 1.216l-2.886 2.903a.283.283 0 0 1-.408.003Z",
    fill: "#D2E5E1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.712,
    d: "m19.702 21.066-1.333-1.316c-.322-.317-.328-.853-.018-1.2a.79.79 0 0 1 1.15-.052l.265.262a.223.223 0 0 0 .32-.006l1.785-1.807a.8.8 0 0 1 1.165 0c.31.335.295.877-.037 1.212l-2.883 2.901a.293.293 0 0 1-.414.006Z",
    fill: "#D1E4E0"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    d: "m19.698 21.061-1.332-1.313c-.323-.317-.329-.853-.019-1.198.31-.344.828-.368 1.147-.052l.265.263a.223.223 0 0 0 .32-.006l1.782-1.804c.331-.336.851-.336 1.162 0 .31.335.295.877-.037 1.212l-2.878 2.898a.294.294 0 0 1-.41 0Z",
    fill: "#D0E3E0"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.742,
    d: "m19.699 21.055-1.33-1.313c-.319-.317-.328-.853-.018-1.198a.788.788 0 0 1 1.147-.051l.264.262a.223.223 0 0 0 .32-.006l1.782-1.804c.332-.335.852-.335 1.162 0a.881.881 0 0 1-.036 1.21l-2.875 2.894a.296.296 0 0 1-.416.006Z",
    fill: "#CFE3DF"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.758,
    d: "m19.696 21.052-1.33-1.31a.873.873 0 0 1-.018-1.195.788.788 0 0 1 1.147-.052l.265.262a.223.223 0 0 0 .319-.006l1.78-1.8a.793.793 0 0 1 1.158 0c.31.335.292.874-.036 1.21l-2.872 2.89a.298.298 0 0 1-.413 0Z",
    fill: "#CEE2DE"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.773,
    d: "m19.693 21.046-1.327-1.31a.873.873 0 0 1-.018-1.195c.31-.344.825-.369 1.144-.052l.264.26a.223.223 0 0 0 .32-.007l1.776-1.797c.329-.333.849-.336 1.16 0 .31.332.291.874-.037 1.206l-2.869 2.886a.29.29 0 0 1-.413.009Z",
    fill: "#CDE2DE"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.788,
    d: "m19.693 21.04-1.327-1.307a.87.87 0 0 1-.018-1.192c.31-.344.822-.369 1.144-.052l.264.26a.222.222 0 0 0 .317-.007l1.776-1.797c.329-.333.849-.336 1.156 0 .31.332.292.874-.036 1.206l-2.866 2.883a.289.289 0 0 1-.41.006Z",
    fill: "#CCE1DD"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.803,
    d: "m19.69 21.037-1.324-1.308c-.319-.313-.328-.847-.018-1.191a.784.784 0 0 1 1.14-.052l.265.26a.225.225 0 0 0 .317-.007l1.773-1.795a.795.795 0 0 1 1.156 0c.31.332.292.872-.036 1.204l-2.863 2.88a.29.29 0 0 1-.41.009Z",
    fill: "#CBE0DC"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.818,
    d: "m19.686 21.03-1.323-1.304c-.32-.314-.325-.847-.018-1.188a.784.784 0 0 1 1.14-.052l.265.26a.225.225 0 0 0 .317-.007l1.77-1.792c.329-.332.846-.332 1.153 0 .31.332.292.872-.037 1.204l-2.859 2.876a.288.288 0 0 1-.408.003Z",
    fill: "#CAE0DC"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m19.686 21.024-1.32-1.304c-.32-.314-.325-.847-.018-1.188.31-.341.818-.366 1.138-.052l.261.26a.225.225 0 0 0 .317-.007l1.767-1.789a.792.792 0 0 1 1.153 0c.307.332.292.869-.037 1.201l-2.853 2.873a.285.285 0 0 1-.408.006Z",
    fill: "#C9DFDB"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.849,
    d: "m19.683 21.021-1.32-1.3c-.32-.315-.325-.845-.018-1.186a.783.783 0 0 1 1.138-.052l.261.26a.225.225 0 0 0 .317-.007l1.767-1.789c.328-.332.843-.332 1.15 0 .307.332.292.869-.037 1.2l-2.85 2.871a.294.294 0 0 1-.408.003Z",
    fill: "#C8DFDB"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "m19.683 21.015-1.317-1.3a.868.868 0 0 1-.018-1.186c.307-.341.818-.366 1.134-.052l.262.26a.225.225 0 0 0 .316-.007l1.765-1.786c.328-.332.842-.332 1.15 0a.872.872 0 0 1-.037 1.198l-2.847 2.867a.285.285 0 0 1-.408.006Z",
    fill: "#C7DEDA"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.879,
    d: "m19.68 21.01-1.314-1.299a.868.868 0 0 1-.018-1.185.78.78 0 0 1 1.134-.052l.262.259a.225.225 0 0 0 .316-.006l1.762-1.783a.784.784 0 0 1 1.146 0c.308.33.29.866-.036 1.198l-2.844 2.861a.285.285 0 0 1-.408.006Z",
    fill: "#C6DED9"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.894,
    d: "m19.677 21.006-1.314-1.298a.864.864 0 0 1-.018-1.182c.307-.342.815-.366 1.132-.052l.261.259a.225.225 0 0 0 .316-.006l1.762-1.783c.325-.329.84-.332 1.146 0 .308.33.29.866-.036 1.195l-2.841 2.858a.288.288 0 0 1-.408.009Z",
    fill: "#C5DDD9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.909,
    d: "m19.677 21-1.31-1.294a.864.864 0 0 1-.02-1.183.778.778 0 0 1 1.132-.051l.262.256a.221.221 0 0 0 .313-.006l1.758-1.78a.79.79 0 0 1 1.147 0c.307.33.29.866-.036 1.195l-2.838 2.855a.288.288 0 0 1-.408.009Z",
    fill: "#C4DCD8"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.924,
    d: "m19.674 20.995-1.31-1.295c-.317-.311-.326-.841-.02-1.18a.778.778 0 0 1 1.133-.051l.261.256a.221.221 0 0 0 .313-.006l1.756-1.777a.786.786 0 0 1 1.143 0c.307.33.29.862-.036 1.192l-2.832 2.852a.283.283 0 0 1-.408.009Z",
    fill: "#C3DCD7"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    d: "M19.671 20.99 18.363 19.7c-.316-.311-.322-.838-.018-1.18a.775.775 0 0 1 1.128-.051l.262.256a.221.221 0 0 0 .313-.006l1.752-1.774a.786.786 0 0 1 1.144 0c.307.33.289.862-.037 1.192l-2.828 2.849a.29.29 0 0 1-.408.006Z",
    fill: "#C2DBD7"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    d: "m19.671 20.986-1.308-1.292c-.316-.311-.322-.838-.018-1.177.307-.338.812-.362 1.128-.051l.262.256a.221.221 0 0 0 .313-.007l1.752-1.773c.326-.329.837-.329 1.14 0a.867.867 0 0 1-.036 1.189l-2.825 2.845a.288.288 0 0 1-.408.01Z",
    fill: "#C1DBD6"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "m19.668 20.98-1.305-1.29c-.316-.31-.322-.837-.018-1.176.307-.338.809-.362 1.125-.051l.259.256a.221.221 0 0 0 .313-.007l1.75-1.77c.324-.329.832-.329 1.14 0 .304.33.289.86-.037 1.189l-2.822 2.842a.282.282 0 0 1-.405.007Z",
    fill: "#C0DAD5"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    d: "m19.669 20.975-1.305-1.286a.859.859 0 0 1-.018-1.173.774.774 0 0 1 1.125-.052l.259.256a.221.221 0 0 0 .313-.006l1.746-1.767a.779.779 0 0 1 1.137 0c.305.33.29.86-.036 1.185l-2.82 2.837a.283.283 0 0 1-.401.006Z",
    fill: "#BFDAD5"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m19.665 20.97-1.302-1.287a.858.858 0 0 1-.018-1.173c.304-.338.809-.362 1.122-.052l.259.256a.221.221 0 0 0 .313-.006l1.746-1.767c.322-.326.833-.33 1.137 0 .305.326.29.86-.036 1.185l-2.817 2.834a.284.284 0 0 1-.404.01Z",
    fill: "#BED9D4"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m19.595 20.906-1.301-1.286a.859.859 0 0 1-.019-1.173c.305-.338.81-.363 1.123-.052l.258.256a.221.221 0 0 0 .314-.006l1.742-1.767c.323-.326.834-.33 1.138 0 .304.325.29.859-.036 1.185L20 20.897a.28.28 0 0 1-.405.009Z",
    fill: "#BED9D4"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m19.593 20.903-1.302-1.282a.855.855 0 0 1-.019-1.17.773.773 0 0 1 1.123-.052l.258.256a.217.217 0 0 0 .31-.006l1.743-1.765c.323-.326.83-.329 1.135 0 .304.326.286.857-.036 1.183l-2.811 2.83a.283.283 0 0 1-.401.006Z",
    fill: "#BFD9D5"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "m19.59 20.896-1.3-1.283c-.313-.307-.322-.831-.018-1.17a.77.77 0 0 1 1.12-.051l.258.256a.217.217 0 0 0 .31-.006l1.74-1.762a.78.78 0 0 1 1.135 0c.304.326.286.857-.037 1.183l-2.807 2.827a.278.278 0 0 1-.402.006Z",
    fill: "#C0DAD5"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "m19.59 20.893-1.3-1.28c-.313-.308-.322-.832-.018-1.167a.77.77 0 0 1 1.12-.052l.258.256a.217.217 0 0 0 .31-.006l1.737-1.758c.323-.326.83-.326 1.132 0 .304.326.286.856-.037 1.18l-2.804 2.824a.282.282 0 0 1-.399.003Z",
    fill: "#C1DAD6"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "m19.586 20.89-1.296-1.28c-.313-.307-.319-.831-.018-1.167.304-.335.803-.36 1.117-.051l.258.253a.217.217 0 0 0 .31-.007l1.737-1.758a.777.777 0 0 1 1.132 0c.304.326.286.853-.037 1.18l-2.801 2.821a.28.28 0 0 1-.402.01Z",
    fill: "#C2DBD6"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "m19.586 20.885-1.296-1.277c-.313-.308-.319-.829-.018-1.164.304-.335.803-.36 1.117-.052l.258.253a.218.218 0 0 0 .31-.006l1.734-1.755c.323-.326.828-.326 1.129 0 .3.326.285.853-.037 1.18l-2.798 2.818a.282.282 0 0 1-.399.003Z",
    fill: "#C3DBD7"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m19.583 20.882-1.293-1.277c-.313-.308-.319-.829-.018-1.164.304-.335.803-.36 1.117-.052l.258.253a.217.217 0 0 0 .31-.006l1.731-1.752c.323-.326.827-.326 1.129 0a.857.857 0 0 1-.037 1.176l-2.795 2.816a.283.283 0 0 1-.402.006Z",
    fill: "#C4DCD7"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m19.58 20.875-1.293-1.274a.853.853 0 0 1-.018-1.164.765.765 0 0 1 1.113-.052l.259.253a.217.217 0 0 0 .31-.006l1.731-1.752a.77.77 0 0 1 1.125 0 .857.857 0 0 1-.036 1.176l-2.792 2.813a.28.28 0 0 1-.399.006Z",
    fill: "#C5DCD8"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M19.58 20.872 18.29 19.6a.85.85 0 0 1-.018-1.161.764.764 0 0 1 1.113-.049l.256.253a.217.217 0 0 0 .31-.006l1.728-1.75c.32-.322.824-.325 1.125 0 .301.324.286.851-.036 1.174l-2.787 2.81a.289.289 0 0 1-.401.002Z",
    fill: "#C6DDD9"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "m19.577 20.866-1.29-1.27a.85.85 0 0 1-.018-1.161.76.76 0 0 1 1.11-.049l.256.253a.214.214 0 0 0 .307-.006l1.725-1.746c.32-.323.824-.326 1.125 0 .301.323.286.85-.036 1.173l-2.784 2.803a.279.279 0 0 1-.395.003Z",
    fill: "#C7DDD9"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m19.574 20.863-1.287-1.27a.846.846 0 0 1-.018-1.158.76.76 0 0 1 1.11-.05l.256.254a.214.214 0 0 0 .307-.006l1.722-1.746a.771.771 0 0 1 1.122 0c.301.323.283.847-.036 1.17l-2.78 2.8a.281.281 0 0 1-.396.006Z",
    fill: "#C8DEDA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "m19.575 20.857-1.287-1.267c-.31-.305-.316-.823-.018-1.158a.757.757 0 0 1 1.107-.05l.256.254a.214.214 0 0 0 .307-.006l1.721-1.743a.771.771 0 0 1 1.123 0c.301.323.283.847-.037 1.17l-2.777 2.797a.279.279 0 0 1-.395.003Z",
    fill: "#C9DEDA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "m19.572 20.854-1.284-1.268c-.31-.304-.316-.822-.018-1.154.301-.333.797-.357 1.107-.05l.256.254a.214.214 0 0 0 .307-.006l1.718-1.74c.32-.323.822-.323 1.12 0 .3.323.283.847-.037 1.167l-2.774 2.794a.284.284 0 0 1-.395.003Z",
    fill: "#CADEDB"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "m19.572 20.848-1.284-1.265c-.31-.304-.316-.822-.018-1.154.301-.332.794-.357 1.104-.05l.256.254a.214.214 0 0 0 .307-.006l1.715-1.74c.32-.323.819-.323 1.12 0a.852.852 0 0 1-.037 1.167l-2.77 2.79a.275.275 0 0 1-.393.004Z",
    fill: "#CBDFDB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "m19.569 20.845-1.28-1.265c-.311-.304-.317-.82-.02-1.151.302-.332.795-.357 1.105-.05l.256.25a.214.214 0 0 0 .307-.005l1.715-1.737c.32-.323.819-.323 1.117 0a.848.848 0 0 1-.037 1.164l-2.768 2.788a.282.282 0 0 1-.395.006Z",
    fill: "#CCDFDC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m19.566 20.839-1.28-1.262a.844.844 0 0 1-.02-1.152.759.759 0 0 1 1.105-.048l.256.25a.216.216 0 0 0 .307-.006l1.712-1.734a.764.764 0 0 1 1.116 0c.299.32.283.84-.036 1.164l-2.765 2.785a.279.279 0 0 1-.395.003Z",
    fill: "#CDE0DC"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "m19.566 20.837-1.278-1.262a.84.84 0 0 1-.018-1.149.755.755 0 0 1 1.1-.048l.256.25a.216.216 0 0 0 .308-.007l1.71-1.73c.315-.32.814-.323 1.112 0 .298.32.283.84-.036 1.16l-2.762 2.782a.28.28 0 0 1-.392.004Z",
    fill: "#CEE0DD"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "m19.563 20.83-1.275-1.259a.84.84 0 0 1-.018-1.149.755.755 0 0 1 1.1-.048l.256.25a.22.22 0 0 0 .308-.007l1.71-1.73c.315-.32.814-.323 1.112 0 .298.32.283.84-.036 1.16l-2.756 2.776c-.119.113-.292.116-.401.006Z",
    fill: "#CFE1DE"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "m19.563 20.826-1.275-1.258a.836.836 0 0 1-.018-1.146.752.752 0 0 1 1.098-.049l.252.25c.085.082.22.08.304-.006l1.707-1.728c.316-.32.815-.32 1.11 0a.84.84 0 0 1-.036 1.158l-2.753 2.773a.274.274 0 0 1-.39.006Z",
    fill: "#D0E1DE"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m19.56 20.82-1.272-1.255c-.307-.302-.314-.817-.018-1.146.298-.33.79-.354 1.098-.049l.252.25c.085.082.22.08.304-.006l1.704-1.725a.762.762 0 0 1 1.11 0c.298.32.28.838-.037 1.158l-2.75 2.77a.275.275 0 0 1-.392.003Z",
    fill: "#D1E2DF"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "m19.556 20.817-1.271-1.255c-.307-.302-.313-.814-.018-1.146.298-.329.787-.353 1.095-.049l.252.25c.085.082.22.08.304-.006l1.704-1.725a.762.762 0 0 1 1.11 0c.298.32.28.838-.037 1.155l-2.746 2.767a.275.275 0 0 1-.393.01Z",
    fill: "#D2E2DF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "m19.556 20.81-1.268-1.251c-.307-.302-.314-.814-.018-1.143.298-.33.787-.354 1.095-.049l.252.25c.085.082.22.08.304-.006l1.7-1.722c.317-.32.813-.32 1.108 0 .295.32.28.835-.037 1.155l-2.743 2.764a.275.275 0 0 1-.393.003Z",
    fill: "#D3E3E0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m19.553 20.808-1.268-1.253c-.307-.301-.313-.813-.018-1.142.298-.33.787-.35 1.092-.049l.252.25c.085.082.22.08.304-.006l1.698-1.719a.758.758 0 0 1 1.107 0c.295.32.28.835-.037 1.155l-2.74 2.76a.277.277 0 0 1-.39.004Z",
    fill: "#D4E3E0"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m19.55 20.802-1.265-1.25a.835.835 0 0 1-.018-1.14.75.75 0 0 1 1.091-.048l.253.25c.085.082.219.08.304-.006l1.694-1.719c.314-.317.81-.32 1.104 0 .296.317.28.835-.036 1.152l-2.738 2.758a.272.272 0 0 1-.389.003Z",
    fill: "#D5E3E1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "m19.55 20.8-1.265-1.25a.835.835 0 0 1-.018-1.14.75.75 0 0 1 1.091-.048l.253.247c.085.082.219.08.304-.006l1.694-1.716c.314-.317.81-.32 1.104 0 .296.317.28.832-.036 1.152l-2.735 2.755a.278.278 0 0 1-.392.006Z",
    fill: "#D6E4E2"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "m19.547 20.793-1.262-1.246a.83.83 0 0 1-.018-1.137.746.746 0 0 1 1.088-.048l.253.247c.085.082.216.079.304-.007l1.691-1.712a.756.756 0 0 1 1.101 0c.296.317.28.832-.036 1.149l-2.729 2.751a.275.275 0 0 1-.392.003Z",
    fill: "#D7E4E2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "m19.547 20.79-1.262-1.246a.83.83 0 0 1-.018-1.137.746.746 0 0 1 1.088-.048l.253.246c.085.083.216.08.301-.006l1.688-1.709a.756.756 0 0 1 1.101 0c.295.317.28.832-.036 1.149l-2.726 2.745a.274.274 0 0 1-.389.006Z",
    fill: "#D8E5E3"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "m19.544 20.784-1.26-1.243c-.304-.299-.31-.808-.018-1.134.295-.326.782-.35 1.086-.048l.253.246c.085.083.216.08.3-.006l1.689-1.709c.313-.317.806-.317 1.098 0 .295.317.277.829-.036 1.146l-2.723 2.742a.27.27 0 0 1-.39.006Z",
    fill: "#D9E5E3"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "m19.54 20.781-1.258-1.243c-.305-.299-.31-.808-.019-1.134.295-.326.782-.35 1.086-.048l.25.246c.085.083.216.08.3-.006l1.686-1.706a.753.753 0 0 1 1.098 0c.295.317.277.829-.036 1.146l-2.72 2.739a.27.27 0 0 1-.386.006Z",
    fill: "#DAE6E4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m19.54 20.778-1.255-1.24c-.305-.299-.31-.805-.019-1.13a.744.744 0 0 1 1.083-.05l.25.247c.082.082.216.08.3-.006l1.683-1.703a.753.753 0 0 1 1.098 0c.295.317.277.829-.037 1.142l-2.716 2.737a.273.273 0 0 1-.386.003Z",
    fill: "#DBE6E4"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m19.538 20.772-1.256-1.24c-.305-.299-.31-.805-.019-1.13a.744.744 0 0 1 1.083-.05l.25.247c.082.083.216.08.3-.006l1.683-1.703a.75.75 0 0 1 1.095 0 .834.834 0 0 1-.037 1.143l-2.713 2.733a.27.27 0 0 1-.386.006Z",
    fill: "#DCE7E5"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m19.535 20.768-1.253-1.237a.825.825 0 0 1-.019-1.127c.295-.326.779-.347 1.08-.049l.25.247c.082.082.215.08.3-.006l1.68-1.7a.752.752 0 0 1 1.095 0c.292.314.277.825-.037 1.14l-2.71 2.73a.279.279 0 0 1-.386.003Z",
    fill: "#DDE7E5"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m19.535 20.762-1.253-1.237a.825.825 0 0 1-.019-1.127.74.74 0 0 1 1.08-.049l.25.247c.082.082.215.08.3-.006l1.677-1.697c.31-.314.8-.317 1.092 0 .292.314.276.825-.037 1.14l-2.707 2.726a.27.27 0 0 1-.383.003Z",
    fill: "#DEE8E6"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "m19.532 20.76-1.25-1.235a.825.825 0 0 1-.019-1.127.74.74 0 0 1 1.08-.049l.25.247c.082.082.215.08.3-.006l1.677-1.697a.751.751 0 0 1 1.092 0 .826.826 0 0 1-.037 1.136l-2.701 2.724a.284.284 0 0 1-.392.006Z",
    fill: "#DEE8E7"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m19.532 20.753-1.25-1.234a.821.821 0 0 1-.019-1.124c.292-.323.776-.347 1.077-.049l.25.244c.082.082.215.08.297-.006l1.674-1.694a.747.747 0 0 1 1.088 0c.293.313.277.822-.036 1.136l-2.698 2.721a.267.267 0 0 1-.383.006Z",
    fill: "#DFE8E7"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "m19.528 20.75-1.247-1.23c-.3-.296-.307-.8-.018-1.125.292-.323.773-.348 1.077-.049l.25.244c.081.082.215.079.297-.006l1.67-1.691a.747.747 0 0 1 1.09 0 .822.822 0 0 1-.037 1.133l-2.695 2.715a.273.273 0 0 1-.387.01Z",
    fill: "#E0E9E8"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "m19.526 20.744-1.248-1.23c-.3-.296-.307-.8-.018-1.122a.739.739 0 0 1 1.074-.049l.25.244c.081.082.212.08.297-.006l1.667-1.691c.31-.314.797-.314 1.086 0 .292.313.274.82-.036 1.133l-2.692 2.712a.26.26 0 0 1-.38.01Z",
    fill: "#E1E9E8"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "m19.525 20.741-1.244-1.228c-.3-.296-.307-.798-.018-1.121a.739.739 0 0 1 1.074-.049l.246.244c.082.082.213.079.298-.006l1.667-1.688c.31-.314.794-.314 1.086 0 .292.313.274.82-.036 1.133l-2.69 2.709a.272.272 0 0 1-.383.006Z",
    fill: "#E2EAE9"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m19.522 20.735-1.244-1.228c-.3-.296-.307-.795-.018-1.118a.735.735 0 0 1 1.07-.049l.247.244c.082.082.213.079.298-.006l1.664-1.685a.74.74 0 0 1 1.083 0c.289.31.274.82-.037 1.13L19.9 20.73a.26.26 0 0 1-.378.006Z",
    fill: "#E3EAE9"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "m19.52 20.732-1.242-1.225a.82.82 0 0 1-.018-1.119.735.735 0 0 1 1.07-.048l.247.243c.082.083.213.08.298-.006l1.661-1.682c.307-.31.794-.314 1.083 0 .289.311.274.817-.034 1.13l-2.683 2.704a.275.275 0 0 1-.383.003Z",
    fill: "#E4EBEA"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52 20.726 18.277 19.5a.816.816 0 0 1-.018-1.116.732.732 0 0 1 1.068-.048l.246.244c.082.082.213.079.298-.007l1.66-1.682a.743.743 0 0 1 1.084 0c.289.311.274.817-.034 1.128l-2.68 2.7a.267.267 0 0 1-.383.006Z",
    fill: "#E5EBEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "m19.516 20.723-1.238-1.222a.816.816 0 0 1-.018-1.115.732.732 0 0 1 1.068-.049l.246.244c.082.082.213.08.298-.006l1.658-1.679a.742.742 0 0 1 1.08 0c.289.311.274.817-.034 1.128l-2.674 2.696a.279.279 0 0 1-.386.003Z",
    fill: "#E6ECEB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m19.516 20.717-1.238-1.222a.812.812 0 0 1-.018-1.112.734.734 0 0 1 1.068-.049l.246.244c.082.082.213.08.295-.006l1.655-1.676a.742.742 0 0 1 1.08 0c.289.311.273.814-.034 1.124l-2.67 2.691a.267.267 0 0 1-.384.006Z",
    fill: "#E7ECEC"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m19.513 20.714-1.235-1.219c-.298-.292-.304-.792-.018-1.112a.733.733 0 0 1 1.064-.049l.247.244c.082.082.213.08.295-.006l1.655-1.676a.738.738 0 0 1 1.076 0c.29.311.274.814-.033 1.124l-2.668 2.691a.275.275 0 0 1-.383.003Z",
    fill: "#E8ECEC"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m19.51 20.707-1.235-1.219c-.298-.292-.304-.789-.018-1.109a.733.733 0 0 1 1.064-.049l.247.241c.082.082.213.08.295-.006l1.652-1.673a.738.738 0 0 1 1.076 0 .816.816 0 0 1-.033 1.122l-2.665 2.684a.264.264 0 0 1-.383.01Z",
    fill: "#E9EDED"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m19.51 20.705-1.231-1.216c-.299-.292-.305-.789-.016-1.109a.73.73 0 0 1 1.062-.049l.246.241c.082.08.213.08.295-.006l1.65-1.67c.306-.31.787-.31 1.073 0 .289.311.27.81-.034 1.121L19.894 20.7a.272.272 0 0 1-.383.006Z",
    fill: "#EAEDED"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m19.508 20.698-1.232-1.216c-.298-.292-.305-.789-.015-1.109a.73.73 0 0 1 1.061-.049l.246.241c.083.08.213.08.295-.006l1.646-1.67a.735.735 0 0 1 1.074 0c.286.308.27.81-.034 1.119l-2.658 2.678a.262.262 0 0 1-.383.012Z",
    fill: "#EBEEEE"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "m19.507 20.696-1.229-1.213a.807.807 0 0 1-.015-1.106c.29-.32.764-.341 1.059-.049l.243.24c.082.08.213.08.295-.005l1.646-1.667c.304-.308.785-.31 1.07 0 .286.308.271.81-.033 1.118l-2.655 2.676a.269.269 0 0 1-.38.006Z",
    fill: "#ECEEEE"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "m19.504 20.69-1.229-1.213a.808.808 0 0 1-.015-1.106.726.726 0 0 1 1.059-.049l.243.24a.21.21 0 0 0 .295-.005l1.643-1.664a.736.736 0 0 1 1.07 0c.286.308.271.807-.033 1.115l-2.652 2.672a.26.26 0 0 1-.38.01Z",
    fill: "#EDEFEF"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m19.501 20.686-1.226-1.21a.804.804 0 0 1-.015-1.102c.286-.317.76-.342 1.056-.05l.243.241a.21.21 0 0 0 .295-.006l1.64-1.66a.733.733 0 0 1 1.067 0c.286.307.271.807-.033 1.115l-2.65 2.67a.268.268 0 0 1-.377.002Z",
    fill: "#EEEFF0"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "m19.501 20.68-1.226-1.21a.804.804 0 0 1-.015-1.102.728.728 0 0 1 1.056-.05l.243.242c.082.079.21.076.292-.006l1.64-1.661a.733.733 0 0 1 1.067 0 .81.81 0 0 1-.033 1.112l-2.643 2.666c-.11.113-.277.116-.38.01Z",
    fill: "#EFF0F0"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "m19.498 20.677-1.223-1.206a.803.803 0 0 1-.015-1.1.727.727 0 0 1 1.056-.05l.243.241c.082.08.21.077.292-.006l1.637-1.657a.733.733 0 0 1 1.067 0 .81.81 0 0 1-.033 1.112l-2.64 2.663a.275.275 0 0 1-.384.003Z",
    fill: "#F0F0F1"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "m19.495 20.674-1.223-1.206c-.295-.29-.3-.784-.015-1.1a.724.724 0 0 1 1.053-.05l.243.241c.082.08.21.077.292-.006l1.633-1.654c.305-.308.78-.308 1.065 0a.806.806 0 0 1-.033 1.109l-2.638 2.66a.268.268 0 0 1-.377.006Z",
    fill: "#F1F1F1"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m19.495 20.668-1.22-1.204c-.295-.29-.3-.783-.015-1.096a.724.724 0 0 1 1.053-.05l.243.241c.082.08.21.077.292-.006L21.48 16.9a.73.73 0 0 1 1.065 0 .806.806 0 0 1-.034 1.109l-2.634 2.654c-.112.107-.28.11-.383.006Z",
    fill: "#F2F1F2"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m19.492 20.665-1.217-1.204c-.295-.29-.3-.78-.015-1.097a.72.72 0 0 1 1.05-.048l.243.237c.082.08.21.076.292-.006l1.63-1.651c.301-.305.779-.308 1.062 0 .283.304.268.801-.034 1.109l-2.63 2.65a.272.272 0 0 1-.38.01Z",
    fill: "#F3F1F2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m19.492 20.659-1.217-1.2a.798.798 0 0 1-.015-1.095.72.72 0 0 1 1.05-.049l.243.238c.082.08.21.076.292-.006l1.627-1.648a.728.728 0 0 1 1.062 0c.283.304.267.801-.034 1.106l-2.628 2.648c-.112.106-.277.11-.38.006Z",
    fill: "#F4F2F3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "m19.489 20.656-1.214-1.201a.798.798 0 0 1-.015-1.094c.286-.317.754-.338 1.046-.049l.244.238c.082.08.21.076.292-.006l1.627-1.649a.727.727 0 0 1 1.059 0c.283.305.267.802-.034 1.107l-2.625 2.644a.272.272 0 0 1-.38.01Z",
    fill: "#F5F2F3"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "m19.486 20.65-1.214-1.198a.798.798 0 0 1-.015-1.094.722.722 0 0 1 1.046-.049l.24.238c.083.08.21.076.293-.006l1.624-1.646a.727.727 0 0 1 1.059 0c.283.305.267.799-.034 1.104l-2.622 2.641a.263.263 0 0 1-.377.01Z",
    fill: "#F6F3F4"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m19.486 20.647-1.21-1.197a.794.794 0 0 1-.016-1.091.718.718 0 0 1 1.043-.049l.24.238c.08.08.21.076.29-.006l1.62-1.643a.723.723 0 0 1 1.056 0c.283.305.268.799-.033 1.104L19.86 20.64a.267.267 0 0 1-.374.006Z",
    fill: "#F7F3F5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m19.483 20.64-1.21-1.194a.797.797 0 0 1-.016-1.09.718.718 0 0 1 1.043-.05l.24.238c.08.08.207.076.29-.006l1.618-1.643a.724.724 0 0 1 1.055 0 .8.8 0 0 1-.033 1.1l-2.613 2.636a.259.259 0 0 1-.374.01Z",
    fill: "#F8F4F5"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m19.48 20.638-1.208-1.194c-.292-.287-.298-.774-.015-1.088a.716.716 0 0 1 1.043-.046l.24.238c.08.079.207.076.29-.006l1.618-1.64c.3-.304.772-.304 1.052 0a.8.8 0 0 1-.033 1.1l-2.61 2.633a.273.273 0 0 1-.377.003Z",
    fill: "#F9F4F6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m19.48 20.632-1.208-1.191c-.292-.287-.298-.774-.015-1.088a.712.712 0 0 1 1.04-.046l.24.238c.08.079.207.076.29-.006l1.615-1.637a.72.72 0 0 1 1.052 0c.283.302.268.796-.033 1.097l-2.607 2.63a.264.264 0 0 1-.374.003Z",
    fill: "#FAF5F6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m19.477 20.628-1.205-1.192c-.292-.286-.298-.774-.015-1.084a.712.712 0 0 1 1.04-.046l.24.238c.08.079.207.076.29-.007l1.612-1.633a.723.723 0 0 1 1.052 0c.283.302.268.795-.033 1.097l-2.604 2.624a.274.274 0 0 1-.377.003Z",
    fill: "#FBF5F7"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "m19.477 20.623-1.205-1.189a.793.793 0 0 1-.015-1.085c.283-.313.745-.335 1.037-.045l.24.238c.08.079.207.076.29-.007l1.611-1.633c.299-.302.77-.305 1.05 0 .28.302.264.792-.034 1.094l-2.6 2.62a.261.261 0 0 1-.374.007Z",
    fill: "#FCF6F7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m19.474 20.62-1.201-1.189a.79.79 0 0 1-.015-1.082.711.711 0 0 1 1.037-.045l.24.234c.08.08.207.076.29-.006l1.608-1.63a.722.722 0 0 1 1.05 0c.28.302.264.792-.034 1.094l-2.597 2.617a.27.27 0 0 1-.378.006Z",
    fill: "#FDF6F8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m35.786 29.464-7.289.043a.934.934 0 0 1-.936-.954l.003-.5a.977.977 0 0 1 .955-.972l7.31-.079a.95.95 0 0 1 .963.972l-.009.509c-.009.54-.456.978-.997.981Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m35.783 29.453-7.288.042a.926.926 0 0 1-.928-.944l.003-.503a.967.967 0 0 1 .947-.963l7.306-.08a.94.94 0 0 1 .955.964l-.01.512a.993.993 0 0 1-.985.972Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m35.78 29.443-7.288.043a.92.92 0 0 1-.922-.936l.003-.502a.958.958 0 0 1 .94-.954l7.307-.08a.929.929 0 0 1 .946.954l-.01.512a.983.983 0 0 1-.976.963Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m35.777 29.43-7.288.044a.911.911 0 0 1-.913-.927l.003-.503a.946.946 0 0 1 .931-.944l7.306-.08a.92.92 0 0 1 .937.945l-.009.515a.975.975 0 0 1-.967.95Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "m35.773 29.419-7.288.042a.902.902 0 0 1-.903-.92l.003-.506a.943.943 0 0 1 .922-.938l7.306-.08a.915.915 0 0 1 .93.936l-.008.515a.972.972 0 0 1-.962.95Z",
    fill: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "m35.77 29.406-7.288.043a.894.894 0 0 1-.894-.911l.003-.506a.935.935 0 0 1 .912-.93l7.307-.079a.906.906 0 0 1 .921.927l-.009.518a.963.963 0 0 1-.952.938Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m35.768 29.394-7.288.043a.883.883 0 0 1-.885-.902l.003-.51a.924.924 0 0 1 .903-.92l7.307-.079a.898.898 0 0 1 .912.918l-.009.518a.954.954 0 0 1-.943.932Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m35.762 29.382-7.285.042a.873.873 0 0 1-.876-.893l.003-.508a.916.916 0 0 1 .894-.912l7.306-.079a.888.888 0 0 1 .904.908l-.01.521a.944.944 0 0 1-.936.92Z",
    fill: "#F8F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m35.758 29.37-7.285.042a.87.87 0 0 1-.87-.884l.004-.512a.906.906 0 0 1 .885-.902l7.306-.079a.88.88 0 0 1 .894.9l-.009.52a.935.935 0 0 1-.925.914Z",
    fill: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m35.755 29.358-7.285.043a.86.86 0 0 1-.86-.875l.002-.512a.896.896 0 0 1 .877-.893l7.303-.079a.869.869 0 0 1 .885.89l-.01.524a.92.92 0 0 1-.912.902Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m35.752 29.346-7.285.042a.85.85 0 0 1-.852-.865l.003-.515a.889.889 0 0 1 .87-.884l7.303-.079a.862.862 0 0 1 .877.884l-.01.524a.914.914 0 0 1-.906.893Z",
    fill: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m35.75 29.333-7.285.043a.84.84 0 0 1-.843-.86l.003-.514a.88.88 0 0 1 .861-.875l7.303-.08a.854.854 0 0 1 .867.875l-.009.528a.905.905 0 0 1-.897.883Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m35.746 29.324-7.285.042a.831.831 0 0 1-.833-.85l.003-.518a.868.868 0 0 1 .852-.865l7.303-.08a.842.842 0 0 1 .858.866l-.01.527a.9.9 0 0 1-.888.878Z",
    fill: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m35.743 29.311-7.285.043a.828.828 0 0 1-.827-.84l.003-.519a.858.858 0 0 1 .843-.856l7.303-.08a.834.834 0 0 1 .848.857l-.009.527a.885.885 0 0 1-.876.868Z",
    fill: "#F3F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m35.74 29.3-7.285.043a.816.816 0 0 1-.818-.832l.003-.521a.85.85 0 0 1 .833-.847l7.303-.08a.83.83 0 0 1 .843.848l-.01.53a.88.88 0 0 1-.869.86Z",
    fill: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m35.737 29.288-7.285.042a.808.808 0 0 1-.81-.822l.004-.521a.842.842 0 0 1 .824-.838l7.303-.08a.82.82 0 0 1 .834.838l-.01.53a.873.873 0 0 1-.86.85Z",
    fill: "#F1EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m35.734 29.275-7.285.046a.799.799 0 0 1-.8-.814l.003-.52a.835.835 0 0 1 .816-.832l7.303-.08a.81.81 0 0 1 .824.83l-.009.532a.862.862 0 0 1-.852.838Z",
    fill: "#F0EEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m35.728 29.264-7.285.046a.787.787 0 0 1-.79-.805l.003-.524a.828.828 0 0 1 .809-.823l7.3-.079a.8.8 0 0 1 .815.82l-.01.533a.849.849 0 0 1-.842.832Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "m35.725 29.25-7.285.046a.782.782 0 0 1-.785-.798l.003-.524a.818.818 0 0 1 .8-.814l7.3-.079a.792.792 0 0 1 .807.81l-.01.537a.836.836 0 0 1-.83.823Z",
    fill: "#EEECED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "m35.722 29.24-7.285.045a.775.775 0 0 1-.776-.79l.003-.526a.808.808 0 0 1 .791-.805l7.3-.079a.782.782 0 0 1 .797.801l-.009.537a.827.827 0 0 1-.821.816Z",
    fill: "#EDEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "m35.719 29.226-7.286.046a.767.767 0 0 1-.766-.78l.003-.528a.799.799 0 0 1 .782-.795l7.3-.08a.773.773 0 0 1 .788.793l-.01.54a.819.819 0 0 1-.811.804Z",
    fill: "#ECEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "m35.716 29.215-7.282.045a.755.755 0 0 1-.757-.77l.003-.53a.789.789 0 0 1 .772-.787l7.3-.08a.765.765 0 0 1 .78.787l-.01.54a.81.81 0 0 1-.806.795Z",
    fill: "#EBE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "m35.713 29.202-7.282.046a.747.747 0 0 1-.748-.762l.003-.53a.781.781 0 0 1 .763-.777l7.3-.08a.757.757 0 0 1 .77.778l-.01.542a.803.803 0 0 1-.796.783Z",
    fill: "#EBE8E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "m35.71 29.194-7.282.046a.74.74 0 0 1-.742-.753l.006-.533a.77.77 0 0 1 .754-.768l7.3-.08a.75.75 0 0 1 .764.768l-.01.543a.803.803 0 0 1-.79.777Z",
    fill: "#EAE7E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "m35.706 29.18-7.282.046a.732.732 0 0 1-.733-.743l.007-.534a.762.762 0 0 1 .745-.758l7.3-.08a.742.742 0 0 1 .754.76l-.009.545a.795.795 0 0 1-.782.764Z",
    fill: "#E9E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "m35.703 29.168-7.282.046a.721.721 0 0 1-.724-.738l.006-.536a.752.752 0 0 1 .74-.75l7.297-.079a.735.735 0 0 1 .745.75l-.01.545a.786.786 0 0 1-.772.762Z",
    fill: "#E8E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "m35.698 29.156-7.282.045a.714.714 0 0 1-.715-.728l.006-.536a.743.743 0 0 1 .73-.74l7.297-.08a.725.725 0 0 1 .737.74l-.01.546a.772.772 0 0 1-.763.753Z",
    fill: "#E7E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "m35.695 29.143-7.282.046a.706.706 0 0 1-.706-.719l.006-.54a.74.74 0 0 1 .721-.734l7.297-.079a.717.717 0 0 1 .727.732l-.009.548a.765.765 0 0 1-.754.747Z",
    fill: "#E6E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m35.691 29.132-7.282.046a.694.694 0 0 1-.696-.71l.006-.54a.73.73 0 0 1 .712-.725l7.297-.079a.707.707 0 0 1 .718.722l-.01.549a.753.753 0 0 1-.745.737Z",
    fill: "#E5E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m35.688 29.12-7.282.045a.689.689 0 0 1-.69-.7l.006-.54a.72.72 0 0 1 .703-.716l7.297-.08a.698.698 0 0 1 .709.714l-.01.551a.74.74 0 0 1-.733.726Z",
    fill: "#E4E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m35.685 29.107-7.282.046a.679.679 0 0 1-.681-.692l.006-.542a.71.71 0 0 1 .693-.707l7.297-.08a.688.688 0 0 1 .7.705l-.009.551a.733.733 0 0 1-.724.72Z",
    fill: "#E3E0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m35.683 29.095-7.282.046a.671.671 0 0 1-.672-.683l.006-.542a.7.7 0 0 1 .684-.698l7.297-.08c.39-.002.7.308.69.695l-.008.555a.72.72 0 0 1-.715.707Z",
    fill: "#E3DFE0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m35.68 29.084-7.282.048a.66.66 0 0 1-.664-.676l.006-.546a.694.694 0 0 1 .679-.688l7.297-.08a.67.67 0 0 1 .681.69l-.009.554a.716.716 0 0 1-.709.698Z",
    fill: "#E2DEDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m35.676 29.071-7.279.049a.652.652 0 0 1-.654-.667l.006-.546a.682.682 0 0 1 .67-.68l7.297-.079a.664.664 0 0 1 .675.68l-.01.558a.715.715 0 0 1-.705.685Z",
    fill: "#E1DDDE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m35.673 29.062-7.279.048a.645.645 0 0 1-.648-.658l.006-.548a.674.674 0 0 1 .66-.67l7.294-.08a.656.656 0 0 1 .667.67l-.01.558a.702.702 0 0 1-.69.68Z",
    fill: "#E0DCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m35.67 29.05-7.278.049a.637.637 0 0 1-.639-.65l.006-.548a.664.664 0 0 1 .651-.66l7.294-.077a.648.648 0 0 1 .657.661l-.009.561a.693.693 0 0 1-.681.664Z",
    fill: "#DFDCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m35.664 29.038-7.279.049a.628.628 0 0 1-.63-.64l.007-.552a.654.654 0 0 1 .642-.652l7.294-.076a.638.638 0 0 1 .648.652l-.01.56a.68.68 0 0 1-.672.659Z",
    fill: "#DEDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m35.661 29.026-7.279.048a.618.618 0 0 1-.62-.63l.006-.552a.647.647 0 0 1 .633-.643l7.294-.076a.629.629 0 0 1 .638.643l-.009.564a.672.672 0 0 1-.663.646Z",
    fill: "#DDDADB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m35.658 29.013-7.279.05a.61.61 0 0 1-.611-.622l.006-.555a.641.641 0 0 1 .623-.637l7.294-.076a.62.62 0 0 1 .63.634l-.01.563a.663.663 0 0 1-.653.643Z",
    fill: "#DCD9DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m35.655 29.001-7.28.049a.606.606 0 0 1-.605-.616l.007-.554a.634.634 0 0 1 .614-.628l7.294-.076a.611.611 0 0 1 .62.625l-.008.563a.65.65 0 0 1-.642.637Z",
    fill: "#DBD8D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m35.653 28.99-7.28.048a.594.594 0 0 1-.596-.606l.006-.558a.62.62 0 0 1 .609-.618l7.294-.076a.601.601 0 0 1 .611.615l-.009.567a.644.644 0 0 1-.635.628Z",
    fill: "#DBD7D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m35.65 28.977-7.28.049a.584.584 0 0 1-.587-.597l.006-.558a.613.613 0 0 1 .6-.61l7.294-.075a.593.593 0 0 1 .602.606l-.01.567a.634.634 0 0 1-.626.618Z",
    fill: "#DAD6D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m35.646 28.964-7.279.049a.576.576 0 0 1-.578-.589l.006-.557a.603.603 0 0 1 .59-.6l7.291-.076c.335-.004.6.265.593.597l-.009.57a.621.621 0 0 1-.614.606Z",
    fill: "#D9D5D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m35.643 28.953-7.28.048a.567.567 0 0 1-.568-.579l.006-.56a.593.593 0 0 1 .581-.591l7.291-.077a.58.58 0 0 1 .587.591l-.009.57a.614.614 0 0 1-.608.598Z",
    fill: "#D8D4D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m35.64 28.943-7.28.049a.557.557 0 0 1-.56-.57l.007-.56a.586.586 0 0 1 .572-.583l7.29-.076a.568.568 0 0 1 .579.582l-.01.573a.61.61 0 0 1-.599.585Z",
    fill: "#D7D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m35.633 28.93-7.279.05a.552.552 0 0 1-.553-.564l.006-.564a.576.576 0 0 1 .563-.573l7.29-.076a.56.56 0 0 1 .57.573l-.01.573a.593.593 0 0 1-.587.582Z",
    fill: "#D6D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m35.631 28.918-7.276.05a.543.543 0 0 1-.544-.555l.006-.564a.566.566 0 0 1 .553-.564l7.291-.076a.552.552 0 0 1 .56.564l-.01.576a.589.589 0 0 1-.58.57Z",
    fill: "#D5D1D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m35.628 28.906-7.276.049a.533.533 0 0 1-.536-.546l.007-.566a.557.557 0 0 1 .547-.555l7.291-.076a.54.54 0 0 1 .55.555l-.008.575a.583.583 0 0 1-.575.564Z",
    fill: "#D4D0D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m35.624 28.895-7.276.048a.523.523 0 0 1-.526-.536l.006-.567a.549.549 0 0 1 .539-.545l7.29-.076a.532.532 0 0 1 .542.545l-.009.58a.574.574 0 0 1-.566.55Z",
    fill: "#D3CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m35.621 28.882-7.276.052a.515.515 0 0 1-.517-.527l.006-.57a.542.542 0 0 1 .53-.536l7.29-.076a.525.525 0 0 1 .533.536l-.01.579a.569.569 0 0 1-.556.542Z",
    fill: "#D3CECF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m35.619 28.87-7.276.052a.512.512 0 0 1-.511-.518l.006-.57a.532.532 0 0 1 .52-.53l7.288-.076a.515.515 0 0 1 .523.527l-.009.582a.547.547 0 0 1-.541.533Z",
    fill: "#D2CDCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m35.616 28.859-7.276.051a.499.499 0 0 1-.502-.509l.006-.572a.524.524 0 0 1 .511-.521l7.288-.076a.505.505 0 0 1 .514.518l-.009.581a.538.538 0 0 1-.532.528Z",
    fill: "#D1CCCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m35.612 28.845-7.276.052a.491.491 0 0 1-.492-.503l.006-.572a.515.515 0 0 1 .502-.512l7.288-.077a.5.5 0 0 1 .508.51l-.01.581a.534.534 0 0 1-.526.521Z",
    fill: "#D0CBCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m35.61 28.834-7.277.052a.482.482 0 0 1-.483-.494l.006-.576a.505.505 0 0 1 .492-.502l7.289-.077a.492.492 0 0 1 .498.5l-.009.585a.526.526 0 0 1-.517.512Z",
    fill: "#CFCACB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m35.603 28.822-7.276.051a.472.472 0 0 1-.474-.484l.006-.576a.497.497 0 0 1 .483-.494l7.288-.076a.483.483 0 0 1 .49.494l-.009.585a.512.512 0 0 1-.508.5Z",
    fill: "#CEC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "m35.6 28.812-7.276.052a.467.467 0 0 1-.469-.476l.007-.575a.488.488 0 0 1 .477-.485l7.288-.076a.473.473 0 0 1 .48.485l-.008.588a.505.505 0 0 1-.5.487Z",
    fill: "#CDC8C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m35.598 28.8-7.276.052a.457.457 0 0 1-.46-.467l.006-.579a.48.48 0 0 1 .469-.475l7.288-.076a.465.465 0 0 1 .471.475l-.009.588a.498.498 0 0 1-.49.482Z",
    fill: "#CCC7C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m35.594 28.787-7.276.052a.45.45 0 0 1-.45-.457l.006-.579a.468.468 0 0 1 .46-.466l7.288-.076a.456.456 0 0 1 .462.466l-.01.591a.488.488 0 0 1-.48.47Z",
    fill: "#CBC6C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m35.591 28.776-7.276.052a.437.437 0 0 1-.44-.448l.005-.582a.46.46 0 0 1 .45-.457l7.285-.076a.444.444 0 0 1 .454.457l-.01.59a.474.474 0 0 1-.468.464Z",
    fill: "#CBC5C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m35.588 28.764-7.273.052a.43.43 0 0 1-.432-.442l.006-.582a.45.45 0 0 1 .441-.448l7.285-.076c.25-.003.45.198.444.447l-.009.595a.469.469 0 0 1-.462.454Z",
    fill: "#CAC4C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m35.585 28.751-7.272.052a.425.425 0 0 1-.426-.433l.006-.585a.44.44 0 0 1 .432-.438l7.285-.077a.427.427 0 0 1 .435.44l-.01.593a.457.457 0 0 1-.45.448Z",
    fill: "#C9C3C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m35.582 28.74-7.273.05a.417.417 0 0 1-.416-.423l.006-.585a.436.436 0 0 1 .422-.432l7.285-.077a.417.417 0 0 1 .426.43l-.009.597a.445.445 0 0 1-.44.44Z",
    fill: "#C8C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m35.579 28.727-7.273.052a.404.404 0 0 1-.408-.415l.007-.588a.427.427 0 0 1 .416-.423l7.285-.077a.413.413 0 0 1 .42.42l-.01.598a.445.445 0 0 1-.437.433Z",
    fill: "#C7C1C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m35.576 28.714-7.273.052a.396.396 0 0 1-.399-.405l.006-.588a.417.417 0 0 1 .408-.415l7.285-.076a.404.404 0 0 1 .41.412l-.008.6a.44.44 0 0 1-.43.42Z",
    fill: "#C6C0C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m35.57 28.703-7.273.052a.386.386 0 0 1-.39-.396l.006-.591a.408.408 0 0 1 .399-.406l7.285-.076a.396.396 0 0 1 .401.402l-.009.6a.426.426 0 0 1-.42.415Z",
    fill: "#C5BFC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m35.567 28.69-7.273.055a.38.38 0 0 1-.38-.387l.006-.59a.4.4 0 0 1 .39-.397l7.285-.076a.387.387 0 0 1 .392.396l-.01.6c-.008.22-.188.4-.41.4Z",
    fill: "#C4BEC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m35.564 28.681-7.273.055a.376.376 0 0 1-.374-.38l.006-.592a.392.392 0 0 1 .38-.387l7.282-.076a.377.377 0 0 1 .383.387l-.009.603a.4.4 0 0 1-.395.39Z",
    fill: "#C3BDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m35.56 28.669-7.272.055a.366.366 0 0 1-.365-.372l.006-.594a.38.38 0 0 1 .371-.378l7.282-.076a.37.37 0 0 1 .374.378l-.009.603a.393.393 0 0 1-.386.384Z",
    fill: "#C3BCBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m35.557 28.656-7.272.055a.356.356 0 0 1-.356-.362l.006-.595a.373.373 0 0 1 .362-.368l7.282-.076a.358.358 0 0 1 .365.368l-.01.607a.384.384 0 0 1-.377.371Z",
    fill: "#C2BBBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m35.554 28.644-7.273.055a.345.345 0 0 1-.346-.354l.006-.597a.36.36 0 0 1 .353-.36l7.281-.076a.35.35 0 0 1 .356.36l-.009.607a.373.373 0 0 1-.368.365Z",
    fill: "#C1BABC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m35.552 28.633-7.273.055a.337.337 0 0 1-.337-.345l.006-.597a.352.352 0 0 1 .346-.35l7.282-.077a.342.342 0 0 1 .347.35l-.01.61a.37.37 0 0 1-.361.354Z",
    fill: "#C0B9BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.549 28.62-7.27.055a.331.331 0 0 1-.332-.335l.006-.6a.344.344 0 0 1 .338-.341l7.282-.077a.33.33 0 0 1 .338.342l-.01.609a.358.358 0 0 1-.352.347Z",
    fill: "#BFB8BA"
  }))), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m35.488 28.87-7.182.049a.539.539 0 0 1-.541-.549l.006-.576a.563.563 0 0 1 .55-.56l7.197-.077a.548.548 0 0 1 .557.558l-.01.585a.589.589 0 0 1-.577.57Z",
    fill: "#B0B1BD"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "m35.473 28.858-7.173.048a.536.536 0 0 1-.538-.548l.006-.567a.562.562 0 0 1 .547-.558l7.185-.076c.31-.003.56.247.554.558l-.01.579a.58.58 0 0 1-.571.564Z",
    fill: "#B1B2BE"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "m35.457 28.845-7.16.05a.533.533 0 0 1-.535-.546l.006-.561a.557.557 0 0 1 .547-.555l7.173-.076a.54.54 0 0 1 .55.555l-.009.573a.577.577 0 0 1-.572.56Z",
    fill: "#B2B3BF"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "m35.442 28.833-7.148.049a.53.53 0 0 1-.532-.542l.006-.555a.558.558 0 0 1 .544-.555l7.16-.076a.539.539 0 0 1 .548.552l-.009.564a.575.575 0 0 1-.569.563Z",
    fill: "#B3B4C0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "m35.43 28.82-7.136.053a.533.533 0 0 1-.532-.54l.006-.548a.555.555 0 0 1 .541-.552l7.148-.076a.536.536 0 0 1 .545.549l-.01.557a.568.568 0 0 1-.562.558Z",
    fill: "#B4B5C1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m35.415 28.812-7.124.052a.527.527 0 0 1-.53-.54l.007-.542a.552.552 0 0 1 .538-.549l7.14-.076a.537.537 0 0 1 .544.546l-.01.551a.578.578 0 0 1-.565.558Z",
    fill: "#B4B6C2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m35.4 28.8-7.115.052a.525.525 0 0 1-.526-.536l.006-.533a.549.549 0 0 1 .535-.546l7.127-.076a.534.534 0 0 1 .542.546l-.01.542a.567.567 0 0 1-.56.552Z",
    fill: "#B5B7C3"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m35.385 28.788-7.103.052a.522.522 0 0 1-.523-.533l.006-.527a.544.544 0 0 1 .535-.543l7.115-.076a.53.53 0 0 1 .538.542l-.009.537a.57.57 0 0 1-.56.548Z",
    fill: "#B6B8C3"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m35.37 28.775-7.091.052a.521.521 0 0 1-.523-.53l.003-.521a.545.545 0 0 1 .532-.543l7.103-.076a.526.526 0 0 1 .535.54l-.009.53c0 .301-.25.545-.55.548Z",
    fill: "#B7B9C4"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "m35.354 28.763-7.078.052a.518.518 0 0 1-.52-.527l.003-.515a.542.542 0 0 1 .53-.54l7.09-.076a.525.525 0 0 1 .532.537l-.01.524a.549.549 0 0 1-.547.545Z",
    fill: "#B8BAC5"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "m35.342 28.75-7.066.053a.516.516 0 0 1-.517-.527l.003-.506a.539.539 0 0 1 .526-.537l7.081-.076a.526.526 0 0 1 .533.534l-.01.514a.56.56 0 0 1-.55.546Z",
    fill: "#B9BBC6"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "m35.327 28.743-7.057.051a.512.512 0 0 1-.514-.524l.003-.5a.536.536 0 0 1 .526-.533l7.07-.076a.521.521 0 0 1 .529.533l-.01.51a.558.558 0 0 1-.547.539Z",
    fill: "#BABCC7"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "m35.312 28.73-7.045.052a.509.509 0 0 1-.511-.52l.003-.495a.535.535 0 0 1 .523-.53l7.057-.076a.518.518 0 0 1 .526.53l-.009.503a.553.553 0 0 1-.544.536Z",
    fill: "#BBBDC8"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m35.296 28.717-7.033.052a.51.51 0 0 1-.511-.518l.003-.487a.532.532 0 0 1 .52-.53l7.045-.077a.513.513 0 0 1 .523.527l-.009.497a.547.547 0 0 1-.538.536Z",
    fill: "#BBBDC9"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "m35.28 28.705-7.02.052a.505.505 0 0 1-.508-.515l.003-.481a.531.531 0 0 1 .517-.528l7.033-.076a.512.512 0 0 1 .52.524l-.01.488a.54.54 0 0 1-.535.536Z",
    fill: "#BCBECA"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m35.265 28.693-7.011.052a.502.502 0 0 1-.505-.515l.003-.473a.528.528 0 0 1 .514-.524l7.02-.076a.513.513 0 0 1 .52.521l-.008.482c0 .295-.24.53-.533.533Z",
    fill: "#BDBFCB"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m35.25 28.68-7 .053a.5.5 0 0 1-.5-.512l.002-.466a.523.523 0 0 1 .514-.522l7.011-.076a.51.51 0 0 1 .517.521l-.009.476a.539.539 0 0 1-.535.527Z",
    fill: "#BEC0CC"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "m35.238 28.67-6.987.051a.5.5 0 0 1-.502-.509l.003-.46a.522.522 0 0 1 .511-.518l7-.073a.505.505 0 0 1 .513.518l-.009.47a.534.534 0 0 1-.53.52Z",
    fill: "#BFC1CD"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "m35.223 28.66-6.975.052a.497.497 0 0 1-.499-.506l.003-.454a.521.521 0 0 1 .508-.518l6.987-.073a.504.504 0 0 1 .511.515l-.01.46a.534.534 0 0 1-.525.524Z",
    fill: "#C0C2CD"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "m35.208 28.648-6.963.052a.493.493 0 0 1-.496-.506l.003-.445a.518.518 0 0 1 .505-.515l6.975-.073a.499.499 0 0 1 .508.512l-.01.454a.529.529 0 0 1-.522.521Z",
    fill: "#C1C3CE"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "m35.192 28.636-6.953.052a.491.491 0 0 1-.493-.503l.003-.439a.515.515 0 0 1 .502-.512l6.963-.073a.5.5 0 0 1 .508.509l-.01.448a.528.528 0 0 1-.52.518Z",
    fill: "#C1C4CF"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "m35.177 28.624-6.941.052a.493.493 0 0 1-.493-.5l.003-.433a.512.512 0 0 1 .502-.509l6.95-.073a.5.5 0 0 1 .505.509l-.006.442a.525.525 0 0 1-.52.512Z",
    fill: "#C2C5D0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m35.162 28.612-6.93.051a.486.486 0 0 1-.489-.496l.003-.427a.509.509 0 0 1 .5-.506l6.94-.073a.494.494 0 0 1 .502.506l-.006.433a.524.524 0 0 1-.52.512Z",
    fill: "#C3C6D1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m35.147 28.599-6.917.051a.484.484 0 0 1-.487-.493l.003-.42a.508.508 0 0 1 .496-.507l6.93-.073a.49.49 0 0 1 .498.503l-.006.427a.522.522 0 0 1-.517.512Z",
    fill: "#C4C7D2"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "m35.135 28.59-6.908.052a.482.482 0 0 1-.484-.494l.003-.41a.505.505 0 0 1 .493-.504l6.917-.073a.488.488 0 0 1 .496.5l-.006.42a.52.52 0 0 1-.511.51Z",
    fill: "#C5C8D3"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m39.132 32.357-10.658-.006a.94.94 0 0 1-.937-.957l.003-.502a.967.967 0 0 1 .955-.963l10.686-.052a.958.958 0 0 1 .973.981l-.012.518c-.009.543-.462.981-1.01.981Z",
    fill: "#FEFEFE"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m39.13 32.345-10.658-.006a.932.932 0 0 1-.928-.948l.003-.506a.959.959 0 0 1 .946-.953l10.686-.052a.95.95 0 0 1 .964.972l-.012.518a1 1 0 0 1-1.001.975Z",
    fill: "#FDFDFD"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m39.127 32.334-10.659-.007a.923.923 0 0 1-.918-.938l.003-.506a.95.95 0 0 1 .937-.944l10.686-.052a.942.942 0 0 1 .955.963l-.013.52a.99.99 0 0 1-.991.963Z",
    fill: "#FCFCFC"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m39.124 32.32-10.659-.006a.913.913 0 0 1-.91-.93l.004-.508a.94.94 0 0 1 .927-.936l10.686-.051a.93.93 0 0 1 .946.953l-.012.521a.981.981 0 0 1-.982.957Z",
    fill: "#FBFBFB"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "m39.12 32.309-10.658-.006a.908.908 0 0 1-.903-.92l.003-.51a.93.93 0 0 1 .918-.926l10.686-.052c.53-.003.949.421.94.945l-.012.524a.973.973 0 0 1-.974.945Z",
    fill: "#FBFAFA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "M39.117 32.296 28.46 32.29a.898.898 0 0 1-.895-.91l.003-.51a.919.919 0 0 1 .913-.917l10.686-.049a.919.919 0 0 1 .93.936l-.012.524a.968.968 0 0 1-.967.932Z",
    fill: "#FAF9F9"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m39.114 32.285-10.658-.003a.89.89 0 0 1-.886-.902l.003-.512a.915.915 0 0 1 .904-.911l10.686-.049c.52-.003.93.412.921.926l-.012.525a.958.958 0 0 1-.958.926Z",
    fill: "#F9F8F8"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m39.112 32.272-10.659-.003a.88.88 0 0 1-.876-.896l.003-.512a.908.908 0 0 1 .895-.902l10.685-.049a.9.9 0 0 1 .913.917l-.012.527a.95.95 0 0 1-.95.918Z",
    fill: "#F8F7F7"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m39.108 32.26-10.658-.003a.87.87 0 0 1-.867-.886l.003-.515a.896.896 0 0 1 .885-.893l10.686-.049a.892.892 0 0 1 .903.908l-.012.527a.94.94 0 0 1-.94.911Z",
    fill: "#F7F6F6"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m39.105 32.247-10.658-.003a.862.862 0 0 1-.858-.878l.003-.515a.888.888 0 0 1 .876-.883l10.686-.049c.505-.003.906.4.894.899l-.012.53a.93.93 0 0 1-.93.899Z",
    fill: "#F6F5F5"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m39.102 32.236-10.658-.003a.856.856 0 0 1-.852-.869l.003-.518a.878.878 0 0 1 .867-.874l10.686-.05a.87.87 0 0 1 .885.89l-.013.53a.919.919 0 0 1-.918.894Z",
    fill: "#F5F4F4"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "M39.099 32.223 28.44 32.22a.847.847 0 0 1-.842-.86l.003-.517a.87.87 0 0 1 .858-.866l10.685-.048a.863.863 0 0 1 .876.88l-.012.534a.907.907 0 0 1-.91.88Z",
    fill: "#F4F3F3"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m39.096 32.21-10.658-.002a.837.837 0 0 1-.833-.85l.003-.518a.858.858 0 0 1 .851-.857l10.686-.048c.49-.003.879.39.867.871l-.012.533a.904.904 0 0 1-.904.872Z",
    fill: "#F3F2F3"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m39.093 32.2-10.658-.004a.827.827 0 0 1-.825-.84l.003-.522a.85.85 0 0 1 .843-.847l10.686-.048a.843.843 0 0 1 .857.862l-.012.533a.897.897 0 0 1-.894.865Z",
    fill: "#F3F1F2"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m39.09 32.187-10.659-.003a.816.816 0 0 1-.815-.835l.003-.52a.847.847 0 0 1 .834-.842l10.686-.048c.48-.004.86.38.848.853l-.012.536a.885.885 0 0 1-.885.86Z",
    fill: "#F2F0F1"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m39.087 32.174-10.659-.003a.813.813 0 0 1-.809-.826l.003-.524a.835.835 0 0 1 .825-.832l10.685-.049a.826.826 0 0 1 .84.848l-.012.536a.873.873 0 0 1-.873.85Z",
    fill: "#F1EFF0"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m39.083 32.163-10.658-.004a.803.803 0 0 1-.8-.816l.003-.524a.827.827 0 0 1 .815-.823l10.686-.049a.817.817 0 0 1 .83.838l-.012.54a.858.858 0 0 1-.864.838Z",
    fill: "#F0EEEF"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M39.081 32.15H28.423a.795.795 0 0 1-.791-.807l.003-.527a.817.817 0 0 1 .806-.814l10.686-.049a.807.807 0 0 1 .821.829l-.012.54a.85.85 0 0 1-.855.828Z",
    fill: "#EFEDEE"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "M39.078 32.14H28.419a.786.786 0 0 1-.781-.798l.003-.527a.81.81 0 0 1 .797-.804l10.685-.05a.803.803 0 0 1 .816.82l-.013.543a.851.851 0 0 1-.848.817Z",
    fill: "#EEECED"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M39.075 32.128H28.416a.774.774 0 0 1-.772-.789l.003-.527a.8.8 0 0 1 .788-.796l10.685-.048a.794.794 0 0 1 .806.81l-.012.543a.84.84 0 0 1-.84.807Z",
    fill: "#EDEBEC"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "M39.072 32.117H28.41a.77.77 0 0 1-.766-.78l.003-.53a.789.789 0 0 1 .781-.787l10.686-.048a.784.784 0 0 1 .797.801l-.012.543a.828.828 0 0 1-.828.8Z",
    fill: "#ECEAEB"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "M39.07 32.104H28.407a.759.759 0 0 1-.758-.77l.003-.53a.781.781 0 0 1 .773-.778l10.686-.048a.776.776 0 0 1 .788.792l-.013.545a.82.82 0 0 1-.818.79Z",
    fill: "#EBE9EA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "M39.066 32.092H28.404a.752.752 0 0 1-.748-.765l.006-.533a.77.77 0 0 1 .764-.768l10.686-.048a.766.766 0 0 1 .778.783l-.012.545a.813.813 0 0 1-.812.786Z",
    fill: "#EBE8E9"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M39.063 32.08H28.4a.742.742 0 0 1-.739-.756l.006-.533a.766.766 0 0 1 .755-.762l10.685-.049a.757.757 0 0 1 .77.774l-.012.549a.806.806 0 0 1-.803.777Z",
    fill: "#EAE7E8"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "M39.06 32.068H28.397a.734.734 0 0 1-.73-.747l.006-.536a.756.756 0 0 1 .745-.753l10.686-.049a.749.749 0 0 1 .76.765l-.012.549a.798.798 0 0 1-.794.77Z",
    fill: "#E9E6E7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "M39.056 32.055H28.395a.727.727 0 0 1-.724-.737l.006-.537a.747.747 0 0 1 .736-.743l10.686-.049a.741.741 0 0 1 .751.756l-.012.552a.781.781 0 0 1-.782.758Z",
    fill: "#E8E5E6"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M39.053 32.044H28.392a.717.717 0 0 1-.715-.728l.006-.537a.739.739 0 0 1 .727-.734l10.686-.049a.73.73 0 0 1 .742.747l-.012.551a.773.773 0 0 1-.773.75Z",
    fill: "#E7E4E5"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M39.05 32.031H28.39a.71.71 0 0 1-.706-.719l.006-.539a.73.73 0 0 1 .72-.725l10.686-.049a.722.722 0 0 1 .733.737l-.012.552a.769.769 0 0 1-.766.743Z",
    fill: "#E6E3E4"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m39.047 32.019-10.661.003c-.39 0-.7-.317-.697-.71l.007-.54a.72.72 0 0 1 .711-.715l10.686-.05a.714.714 0 0 1 .724.73l-.012.554a.758.758 0 0 1-.758.728Z",
    fill: "#E5E2E3"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m39.044 32.007-10.661.003a.69.69 0 0 1-.688-.704l.006-.543a.708.708 0 0 1 .703-.706l10.686-.05a.702.702 0 0 1 .715.72l-.013.555a.751.751 0 0 1-.748.725Z",
    fill: "#E4E1E2"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m39.041 31.995-10.661.003a.68.68 0 0 1-.679-.694l.006-.543a.7.7 0 0 1 .694-.698l10.686-.048a.694.694 0 0 1 .705.71l-.012.557a.741.741 0 0 1-.739.713Z",
    fill: "#E3E0E1"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m39.039 31.982-10.662.003a.676.676 0 0 1-.672-.686l.006-.542a.693.693 0 0 1 .685-.689l10.685-.048a.686.686 0 0 1 .697.7l-.012.558a.727.727 0 0 1-.727.704Z",
    fill: "#E3DFE0"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m39.035 31.97-10.66.003a.666.666 0 0 1-.664-.677l.006-.545a.686.686 0 0 1 .675-.683l10.686-.048a.68.68 0 0 1 .69.694l-.012.56a.724.724 0 0 1-.72.696Z",
    fill: "#E2DEDF"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m39.032 31.957-10.661.003a.656.656 0 0 1-.654-.667l.006-.545a.678.678 0 0 1 .666-.674l10.683-.049a.672.672 0 0 1 .681.686l-.012.56a.71.71 0 0 1-.709.686Z",
    fill: "#E1DDDE"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m39.029 31.946-10.662.003a.648.648 0 0 1-.644-.658l.006-.549a.668.668 0 0 1 .657-.664l10.683-.046a.664.664 0 0 1 .672.677l-.013.563a.699.699 0 0 1-.7.674Z",
    fill: "#E0DCDD"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m39.026 31.933-10.662.003a.637.637 0 0 1-.636-.649l.007-.548a.661.661 0 0 1 .65-.655l10.683-.046a.653.653 0 0 1 .663.667l-.012.564a.696.696 0 0 1-.693.664Z",
    fill: "#DFDCDD"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m39.023 31.921-10.66.003a.632.632 0 0 1-.63-.643l.005-.551a.647.647 0 0 1 .642-.646l10.683-.046a.645.645 0 0 1 .654.658l-.012.564a.683.683 0 0 1-.681.661Z",
    fill: "#DEDBDC"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m39.02 31.91-10.661.003a.623.623 0 0 1-.62-.634l.005-.552a.64.64 0 0 1 .633-.636l10.683-.046c.365-.003.65.29.645.649l-.012.567a.672.672 0 0 1-.673.649Z",
    fill: "#DDDADB"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m39.017 31.897-10.661.003a.615.615 0 0 1-.612-.624l.006-.552a.631.631 0 0 1 .624-.628l10.683-.045a.624.624 0 0 1 .635.64l-.012.566a.663.663 0 0 1-.663.64Z",
    fill: "#DCD9DA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m39.014 31.885-10.662.006a.605.605 0 0 1-.602-.615l.006-.555a.62.62 0 0 1 .614-.619l10.683-.045a.616.616 0 0 1 .627.63l-.012.57a.654.654 0 0 1-.654.628Z",
    fill: "#DBD8D9"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m39.01 31.872-10.661.007a.595.595 0 0 1-.593-.607l.006-.554a.612.612 0 0 1 .605-.61l10.683-.046a.606.606 0 0 1 .617.622l-.012.57a.644.644 0 0 1-.645.618Z",
    fill: "#DBD7D8"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m39.008 31.86-10.661.006a.592.592 0 0 1-.587-.597l.006-.557c.003-.333.27-.6.596-.604l10.683-.046a.598.598 0 0 1 .608.613l-.012.573a.63.63 0 0 1-.633.612Z",
    fill: "#DAD6D7"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m39.005 31.849-10.661.006a.58.58 0 0 1-.578-.588l.006-.558a.598.598 0 0 1 .59-.594l10.683-.046a.588.588 0 0 1 .599.604l-.012.573a.625.625 0 0 1-.627.603Z",
    fill: "#D9D5D6"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m39.002 31.837-10.665.006a.57.57 0 0 1-.568-.58l.006-.56a.59.59 0 0 1 .58-.585l10.683-.046c.335 0 .6.265.59.594l-.012.573a.614.614 0 0 1-.614.598Z",
    fill: "#D8D4D5"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m38.999 31.824-10.665.006a.562.562 0 0 1-.56-.572l.006-.561a.58.58 0 0 1 .572-.576l10.683-.046c.329 0 .59.262.581.585l-.012.576a.604.604 0 0 1-.605.588Z",
    fill: "#D7D3D4"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m38.995 31.812-10.664.006a.554.554 0 0 1-.55-.564l.005-.56a.57.57 0 0 1 .563-.567l10.683-.046c.322 0 .58.256.575.576l-.013.576a.599.599 0 0 1-.599.579Z",
    fill: "#D6D2D3"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m38.993 31.803-10.664.006a.546.546 0 0 1-.545-.554l.006-.564a.559.559 0 0 1 .554-.557l10.683-.046c.319 0 .571.253.565.567l-.012.579a.59.59 0 0 1-.587.57Z",
    fill: "#D5D1D2"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m38.99 31.791-10.665.006a.537.537 0 0 1-.535-.545l.006-.564a.55.55 0 0 1 .545-.548l10.682-.046a.55.55 0 0 1 .557.557l-.012.58a.579.579 0 0 1-.578.56Z",
    fill: "#D4D0D1"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m38.987 31.779-10.665.006a.529.529 0 0 1-.526-.537l.006-.566a.541.541 0 0 1 .535-.54l10.683-.045a.54.54 0 0 1 .548.551l-.013.582a.568.568 0 0 1-.568.549Z",
    fill: "#D3CFD0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m38.983 31.766-10.664.006a.519.519 0 0 1-.517-.527l.006-.566a.536.536 0 0 1 .526-.534l10.683-.045c.304 0 .544.24.538.542l-.012.582a.56.56 0 0 1-.56.542Z",
    fill: "#D3CECF"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m38.98 31.754-10.664.01a.51.51 0 0 1-.508-.519l.006-.57a.529.529 0 0 1 .52-.524l10.683-.046c.298 0 .535.238.529.534l-.012.582a.556.556 0 0 1-.554.533Z",
    fill: "#D2CDCE"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m38.978 31.742-10.665.009a.5.5 0 0 1-.498-.512l.006-.57a.52.52 0 0 1 .51-.515l10.683-.046c.292 0 .526.232.52.524l-.012.585a.546.546 0 0 1-.544.525Z",
    fill: "#D1CCCD"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m38.975 31.73-10.665.008a.497.497 0 0 1-.493-.502l.006-.57a.511.511 0 0 1 .502-.506l10.683-.046c.289 0 .517.229.511.515l-.012.585a.532.532 0 0 1-.532.515Z",
    fill: "#D0CBCC"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m38.971 31.718-10.664.009a.483.483 0 0 1-.484-.494l.006-.573a.498.498 0 0 1 .493-.496l10.683-.046c.283 0 .508.226.502.506l-.012.588a.524.524 0 0 1-.524.506Z",
    fill: "#CFCACB"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m38.968 31.705-10.664.01a.476.476 0 0 1-.475-.485l.006-.573a.49.49 0 0 1 .484-.487l10.683-.046c.276 0 .498.223.492.497l-.012.588a.514.514 0 0 1-.514.496Z",
    fill: "#CEC9CA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "m38.965 31.693-10.665.01a.468.468 0 0 1-.465-.476l.006-.576a.482.482 0 0 1 .475-.478l10.682-.046c.274 0 .49.216.484.488l-.012.59a.505.505 0 0 1-.505.488Z",
    fill: "#CDC8C9"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m38.962 31.68-10.664.01a.458.458 0 0 1-.456-.466l.006-.576a.47.47 0 0 1 .465-.47l10.683-.045c.268 0 .48.213.474.478l-.012.591a.497.497 0 0 1-.495.479Z",
    fill: "#CCC7C8"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m38.96 31.668-10.665.01a.453.453 0 0 1-.45-.457l.006-.58a.463.463 0 0 1 .46-.46l10.682-.045a.46.46 0 0 1 .465.469l-.012.591a.487.487 0 0 1-.487.472Z",
    fill: "#CBC6C7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m38.956 31.657-10.664.01a.441.441 0 0 1-.441-.449l.006-.579a.458.458 0 0 1 .45-.454l10.683-.045a.45.45 0 0 1 .456.46l-.012.594a.478.478 0 0 1-.478.463Z",
    fill: "#CBC5C6"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m38.953 31.644-10.665.009a.434.434 0 0 1-.431-.442l.006-.579a.448.448 0 0 1 .44-.445l10.683-.045c.253 0 .454.2.45.45l-.012.595a.475.475 0 0 1-.471.457Z",
    fill: "#CAC4C6"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m38.95 31.633-10.664.009a.423.423 0 0 1-.423-.433l.006-.582a.439.439 0 0 1 .432-.436l10.683-.046c.25 0 .444.199.441.442l-.012.598a.463.463 0 0 1-.462.448Z",
    fill: "#C9C3C5"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m38.947 31.62-10.664.012a.415.415 0 0 1-.414-.423l.006-.582a.429.429 0 0 1 .423-.427l10.683-.046c.243 0 .435.192.432.433l-.012.597a.455.455 0 0 1-.454.436Z",
    fill: "#C8C2C4"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m38.944 31.608-10.664.012a.411.411 0 0 1-.408-.415l.006-.585a.421.421 0 0 1 .414-.417l10.682-.046c.238 0 .426.19.423.424l-.012.6a.443.443 0 0 1-.44.427Z",
    fill: "#C7C1C3"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m38.94 31.595-10.664.012a.402.402 0 0 1-.398-.405l.006-.585a.41.41 0 0 1 .405-.408l10.682-.046c.235 0 .417.186.414.415l-.012.6a.431.431 0 0 1-.432.417Z",
    fill: "#C6C0C2"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m38.938 31.583-10.665.012a.39.39 0 0 1-.39-.396l.007-.588c.003-.22.18-.4.395-.4l10.683-.042a.4.4 0 0 1 .405.405l-.013.6a.423.423 0 0 1-.422.409Z",
    fill: "#C5BFC1"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m38.934 31.571-10.664.012a.38.38 0 0 1-.38-.386l.006-.588a.392.392 0 0 1 .39-.39l10.682-.043c.222 0 .398.177.395.399l-.012.603a.417.417 0 0 1-.417.393Z",
    fill: "#C4BEC0"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m38.932 31.558-10.667.012a.373.373 0 0 1-.371-.38l.006-.589c.003-.21.17-.38.38-.38l10.683-.043a.38.38 0 0 1 .386.39l-.012.603a.403.403 0 0 1-.405.387Z",
    fill: "#C3BDBF"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m38.929 31.546-10.665.012a.366.366 0 0 1-.365-.372l.006-.59a.38.38 0 0 1 .372-.376l10.682-.042c.213 0 .383.17.377.38l-.012.607a.396.396 0 0 1-.395.38Z",
    fill: "#C3BCBE"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m38.926 31.534-10.668.013a.358.358 0 0 1-.356-.363l.006-.591a.37.37 0 0 1 .362-.366l10.683-.042c.207 0 .374.164.368.371l-.012.607a.38.38 0 0 1-.383.371Z",
    fill: "#C2BBBD"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m38.922 31.523-10.667.012a.35.35 0 0 1-.347-.353l.006-.594a.36.36 0 0 1 .353-.357l10.683-.043c.204 0 .365.162.359.363l-.012.61a.372.372 0 0 1-.375.362Z",
    fill: "#C1BABC"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m38.92 31.51-10.668.013a.339.339 0 0 1-.338-.345l.006-.594a.348.348 0 0 1 .344-.347l10.683-.043c.197 0 .355.159.35.354l-.013.61a.364.364 0 0 1-.365.353Z",
    fill: "#C0B9BB"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "m38.917 31.498-10.668.012a.329.329 0 0 1-.328-.335l.006-.597a.34.34 0 0 1 .335-.338l10.682-.043c.192 0 .347.153.341.345l-.012.609a.353.353 0 0 1-.356.347Z",
    fill: "#BFB8BA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "m38.856 31.745-10.576.01a.54.54 0 0 1-.539-.549l.006-.57a.56.56 0 0 1 .55-.554l10.598-.046c.317 0 .566.25.56.564l-.012.585a.587.587 0 0 1-.587.56Z",
    fill: "#B0B1BD"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "m38.84 31.734-10.563.01a.538.538 0 0 1-.536-.549l.006-.564a.554.554 0 0 1 .548-.551l10.585-.046a.55.55 0 0 1 .557.56l-.012.58a.586.586 0 0 1-.584.56Z",
    fill: "#B1B2BE"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "m38.829 31.722-10.555.01a.539.539 0 0 1-.536-.546l.006-.558a.55.55 0 0 1 .545-.548l10.573-.046c.313 0 .56.25.554.558l-.012.57a.576.576 0 0 1-.575.56Z",
    fill: "#B2B3BF"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "m38.813 31.709-10.542.01a.535.535 0 0 1-.533-.543l.006-.549a.548.548 0 0 1 .542-.545l10.56-.046c.311 0 .56.247.551.555l-.012.563a.572.572 0 0 1-.572.555Z",
    fill: "#B3B4C0"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "m38.798 31.695-10.53.009a.53.53 0 0 1-.53-.54l.006-.542a.544.544 0 0 1 .539-.542l10.549-.046c.31 0 .556.247.55.552l-.012.554a.572.572 0 0 1-.572.555Z",
    fill: "#B4B5C1"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "m38.783 31.683-10.518.009a.529.529 0 0 1-.527-.537l.006-.533a.546.546 0 0 1 .536-.542l10.54-.046a.54.54 0 0 1 .547.552l-.012.548a.573.573 0 0 1-.572.549Z",
    fill: "#B4B6C2"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "m38.768 31.67-10.51.01a.524.524 0 0 1-.523-.534l.006-.527a.543.543 0 0 1 .536-.54l10.527-.045c.308 0 .55.244.545.549l-.012.542a.57.57 0 0 1-.57.545Z",
    fill: "#B5B7C3"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "m38.753 31.657-10.497.01a.521.521 0 0 1-.52-.534l.002-.52a.54.54 0 0 1 .533-.537l10.515-.046c.304 0 .548.244.542.546l-.013.533a.56.56 0 0 1-.562.548Z",
    fill: "#B6B8C3"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "m38.74 31.646-10.485.01a.524.524 0 0 1-.52-.531l.003-.512a.537.537 0 0 1 .53-.533l10.503-.046c.304 0 .544.24.538.543l-.012.527a.556.556 0 0 1-.556.542Z",
    fill: "#B7B9C4"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "m38.725 31.634-10.475.009a.517.517 0 0 1-.517-.527l.002-.506a.531.531 0 0 1 .527-.53l10.494-.046a.53.53 0 0 1 .535.54l-.012.517a.556.556 0 0 1-.554.543Z",
    fill: "#B8BAC5"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m38.71 31.619-10.463.009a.516.516 0 0 1-.514-.524l.002-.497a.53.53 0 0 1 .524-.527l10.482-.046c.3 0 .538.238.532.537l-.012.511a.548.548 0 0 1-.55.537Z",
    fill: "#B9BBC6"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "m38.695 31.607-10.451.012a.513.513 0 0 1-.511-.521l.002-.491a.532.532 0 0 1 .52-.527l10.47-.046c.298 0 .539.238.533.533l-.01.503a.555.555 0 0 1-.553.537Z",
    fill: "#BABCC7"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "m38.68 31.594-10.44.012a.51.51 0 0 1-.507-.518l.002-.484a.529.529 0 0 1 .52-.524l10.458-.046c.298 0 .536.238.53.533l-.01.497a.556.556 0 0 1-.553.53Z",
    fill: "#BBBDC8"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "m38.664 31.582-10.43.012a.511.511 0 0 1-.508-.518l.003-.475a.526.526 0 0 1 .517-.521l10.448-.046a.52.52 0 0 1 .526.53l-.009.488a.546.546 0 0 1-.547.53Z",
    fill: "#BBBDC9"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "m38.653 31.57-10.419.012a.508.508 0 0 1-.505-.515l.004-.47a.52.52 0 0 1 .514-.517l10.436-.046c.295 0 .53.235.523.527l-.009.482a.551.551 0 0 1-.544.527Z",
    fill: "#BCBECA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "m38.636 31.554-10.406.012a.503.503 0 0 1-.502-.512l.004-.463a.517.517 0 0 1 .51-.515l10.425-.046c.292 0 .526.235.52.524l-.01.473a.542.542 0 0 1-.54.527Z",
    fill: "#BDBFCB"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "m38.621 31.543-10.397.012a.502.502 0 0 1-.498-.51l.003-.453a.514.514 0 0 1 .508-.512l10.412-.046a.51.51 0 0 1 .517.521l-.01.466a.534.534 0 0 1-.535.521Z",
    fill: "#BEC0CC"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "m38.606 31.53-10.385.012a.496.496 0 0 1-.495-.505l.003-.448a.51.51 0 0 1 .505-.51l10.4-.045c.288 0 .52.232.514.518l-.01.457a.533.533 0 0 1-.532.521Z",
    fill: "#BFC1CD"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "m38.59 31.518-10.372.012a.493.493 0 0 1-.492-.503l.003-.438a.513.513 0 0 1 .505-.51l10.39-.045c.29 0 .517.229.511.515l-.009.451a.535.535 0 0 1-.535.518Z",
    fill: "#C0C2CD"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "m38.576 31.505-10.36.012a.497.497 0 0 1-.493-.502l.003-.433a.51.51 0 0 1 .502-.506l10.378-.046c.286 0 .517.229.511.512l-.009.442a.533.533 0 0 1-.532.521Z",
    fill: "#C1C3CE"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m38.563 31.49-10.35.012a.49.49 0 0 1-.49-.5l.003-.426a.504.504 0 0 1 .499-.503l10.366-.046c.286 0 .514.229.508.512l-.01.436a.528.528 0 0 1-.526.515Z",
    fill: "#C1C4CF"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "m38.548 31.478-10.339.012a.489.489 0 0 1-.486-.497l.003-.417a.503.503 0 0 1 .495-.5l10.355-.046c.286 0 .51.226.505.51l-.01.429a.525.525 0 0 1-.523.509Z",
    fill: "#C2C5D0"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "m38.533 31.466-10.327.015a.483.483 0 0 1-.483-.493l.003-.411a.498.498 0 0 1 .492-.497l10.345-.046c.283 0 .508.226.502.506l-.009.42a.524.524 0 0 1-.523.506Z",
    fill: "#C3C6D1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "m38.518 31.453-10.318.015a.482.482 0 0 1-.48-.49l.003-.402a.496.496 0 0 1 .49-.494l10.332-.046c.283 0 .505.223.5.503l-.01.414a.515.515 0 0 1-.517.5Z",
    fill: "#C4C7D2"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "m38.503 31.442-10.306.015a.479.479 0 0 1-.477-.487l.003-.396a.498.498 0 0 1 .486-.494l10.321-.046a.49.49 0 0 1 .496.5l-.01.405a.513.513 0 0 1-.513.503Z",
    fill: "#C5C8D3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.015,
    d: "M25.389 33.313c-1.47.134-2.939.13-4.39-.013-.58-.06-1.134-.612-1.198-1.19a20.198 20.198 0 0 1 .003-4.288c.067-.585.624-1.152 1.208-1.219a23.268 23.268 0 0 1 4.42-.055c.599.052 1.164.613 1.228 1.207a20.229 20.229 0 0 1-.033 4.354c-.073.585-.642 1.146-1.238 1.204Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M25.373 33.304a23.077 23.077 0 0 1-4.377-.012c-.58-.06-1.131-.612-1.195-1.191a20.31 20.31 0 0 1 .003-4.278c.067-.585.62-1.149 1.204-1.216a23.173 23.173 0 0 1 4.411-.055c.596.052 1.162.613 1.226 1.204a20.145 20.145 0 0 1-.034 4.345c-.073.588-.641 1.145-1.238 1.203Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.045,
    d: "M25.361 33.292a22.974 22.974 0 0 1-4.368-.012c-.578-.06-1.128-.612-1.192-1.188-.15-1.43-.15-2.831.003-4.272.067-.582.62-1.146 1.201-1.213a23.045 23.045 0 0 1 4.399-.055c.596.052 1.159.613 1.223 1.2.143 1.46.133 2.883-.034 4.337-.073.59-.642 1.145-1.232 1.203Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.061,
    d: "M25.346 33.283c-1.46.134-2.917.13-4.356-.012-.578-.061-1.125-.61-1.19-1.186-.148-1.429-.148-2.824.004-4.262.067-.582.617-1.146 1.198-1.21a22.95 22.95 0 0 1 4.39-.055c.593.052 1.155.61 1.22 1.2.142 1.46.133 2.88-.034 4.33-.073.582-.642 1.137-1.232 1.195Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.076,
    d: "M25.334 33.274c-1.454.134-2.911.13-4.347-.013-.575-.06-1.122-.609-1.186-1.182a20.11 20.11 0 0 1 .003-4.256c.067-.582.617-1.143 1.195-1.21a22.826 22.826 0 0 1 4.377-.055c.594.052 1.153.61 1.217 1.198a20.11 20.11 0 0 1-.033 4.32c-.073.585-.64 1.14-1.226 1.198Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.091,
    d: "M25.319 33.261c-1.451.134-2.905.131-4.335-.012-.575-.061-1.12-.61-1.183-1.183-.15-1.422-.15-2.815.003-4.247.067-.579.614-1.14 1.195-1.207a22.487 22.487 0 0 1 4.368-.051c.59.051 1.15.609 1.214 1.194.143 1.453.13 2.867-.034 4.311-.076.586-.641 1.14-1.228 1.195Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.106,
    d: "M25.306 33.251a22.53 22.53 0 0 1-4.325-.012c-.572-.06-1.116-.606-1.18-1.179-.15-1.42-.15-2.81.003-4.242.067-.578.614-1.14 1.192-1.203a22.854 22.854 0 0 1 4.356-.052c.59.052 1.15.607 1.21 1.195a20.17 20.17 0 0 1-.033 4.305c-.076.579-.639 1.13-1.223 1.188Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.121,
    d: "M25.291 33.243c-1.445.134-2.89.128-4.313-.012-.572-.061-1.113-.606-1.18-1.176a19.888 19.888 0 0 1 .003-4.233c.067-.578.611-1.136 1.19-1.203a22.759 22.759 0 0 1 4.346-.052c.587.052 1.147.606 1.208 1.191.142 1.448.13 2.859-.034 4.297-.073.579-.636 1.13-1.22 1.188Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.136,
    d: "M25.279 33.234a22.559 22.559 0 0 1-4.304-.012c-.569-.058-1.11-.604-1.177-1.176a20.03 20.03 0 0 1 .003-4.227c.064-.575.611-1.133 1.186-1.2a22.631 22.631 0 0 1 4.335-.052c.587.052 1.143.603 1.204 1.188.143 1.445.131 2.852-.033 4.29-.073.58-.633 1.131-1.214 1.189Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.151,
    d: "M25.265 33.22a22.431 22.431 0 0 1-4.292-.011c-.57-.058-1.11-.604-1.174-1.174a20.15 20.15 0 0 1 .003-4.217c.064-.576.608-1.133 1.183-1.197a22.5 22.5 0 0 1 4.322-.052c.584.052 1.14.603 1.202 1.185.143 1.442.13 2.846-.034 4.281-.07.58-.63 1.13-1.21 1.186Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "M25.249 33.212a22.337 22.337 0 0 1-4.283-.012c-.57-.058-1.107-.603-1.171-1.17a20.092 20.092 0 0 1 .003-4.21c.064-.577.608-1.131 1.18-1.195a22.405 22.405 0 0 1 4.313-.052c.584.052 1.138.603 1.199 1.185.143 1.438.13 2.84-.034 4.272-.07.576-.627 1.124-1.207 1.182Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.182,
    d: "M25.237 33.203c-1.43.134-2.859.128-4.27-.01-.566-.057-1.104-.6-1.168-1.166a20.006 20.006 0 0 1 .003-4.202c.064-.573.605-1.127 1.177-1.194a22.276 22.276 0 0 1 4.3-.052c.582.052 1.135.6 1.196 1.182.14 1.435.131 2.837-.033 4.266-.07.573-.627 1.118-1.205 1.176Z",
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.197,
    d: "M25.222 33.194a22.627 22.627 0 0 1-4.261-.01c-.566-.057-1.101-.6-1.165-1.166a19.905 19.905 0 0 1 .003-4.193c.064-.573.605-1.124 1.174-1.191a22.182 22.182 0 0 1 4.292-.052c.58.052 1.131.6 1.192 1.179.14 1.435.13 2.83-.033 4.257-.07.572-.624 1.118-1.202 1.176Z",
    fill: "#F2F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.212,
    d: "M25.21 33.182a22.497 22.497 0 0 1-4.25-.01c-.562-.057-1.098-.6-1.161-1.163a19.862 19.862 0 0 1 .003-4.187c.064-.573.602-1.124 1.17-1.188a22.06 22.06 0 0 1 4.28-.052c.578.052 1.129.6 1.19 1.176.14 1.432.13 2.825-.034 4.247-.07.576-.623 1.122-1.198 1.177Z",
    fill: "#F1F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.227,
    d: "M25.194 33.173c-1.42.131-2.838.128-4.24-.01-.563-.057-1.095-.596-1.16-1.16a19.776 19.776 0 0 1 .004-4.178c.064-.57.602-1.121 1.168-1.185a22.21 22.21 0 0 1 4.27-.052c.578.052 1.126.598 1.187 1.176.14 1.43.13 2.819-.03 4.242-.074.567-.624 1.109-1.2 1.167Z",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.242,
    d: "M25.183 33.163a22.265 22.265 0 0 1-4.229-.01c-.56-.057-1.091-.596-1.155-1.16a19.718 19.718 0 0 1 .003-4.172c.064-.57.599-1.118 1.165-1.185a22.087 22.087 0 0 1 4.258-.052c.575.052 1.122.598 1.183 1.174.14 1.425.128 2.815-.03 4.232-.073.573-.624 1.115-1.195 1.173Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.258,
    d: "M25.167 33.154a22.177 22.177 0 0 1-4.219-.009c-.56-.058-1.088-.594-1.152-1.158a19.618 19.618 0 0 1 .003-4.162c.064-.57.599-1.118 1.162-1.182a22.224 22.224 0 0 1 4.249-.052c.575.052 1.12.594 1.18 1.17.14 1.423.128 2.81-.03 4.224-.07.57-.62 1.112-1.193 1.17Z",
    fill: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.273,
    d: "M25.155 33.142a22.042 22.042 0 0 1-4.207-.009c-.556-.058-1.086-.594-1.15-1.155a19.774 19.774 0 0 1 .004-4.156c.063-.567.596-1.115 1.158-1.179 1.4-.152 2.82-.17 4.238-.052.575.052 1.116.594 1.177 1.17.14 1.42.128 2.803-.03 4.217-.074.567-.621 1.11-1.19 1.164Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.288,
    d: "M25.14 33.133c-1.406.131-2.81.128-4.198-.01-.557-.057-1.083-.593-1.147-1.151a19.897 19.897 0 0 1 .003-4.147c.064-.567.597-1.112 1.156-1.176a21.99 21.99 0 0 1 4.225-.052c.572.052 1.114.594 1.174 1.167.14 1.417.128 2.797-.03 4.208-.067.564-.614 1.106-1.183 1.161Z",
    fill: "#ECEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.303,
    d: "M25.125 33.123a21.827 21.827 0 0 1-4.186-.01c-.554-.057-1.083-.59-1.144-1.151a19.839 19.839 0 0 1 .003-4.14c.064-.565.594-1.113 1.153-1.177a21.891 21.891 0 0 1 4.216-.052c.572.052 1.11.591 1.171 1.164.14 1.414.128 2.794-.03 4.202-.07.567-.615 1.106-1.183 1.164Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.318,
    d: "M25.112 33.112c-1.399.13-2.795.128-4.176-.01-.554-.057-1.08-.59-1.14-1.148a19.753 19.753 0 0 1 .002-4.132c.064-.564.594-1.11 1.15-1.173 1.39-.152 2.799-.17 4.204-.052.569.052 1.107.591 1.168 1.161a19.91 19.91 0 0 1-.03 4.193c-.067.566-.612 1.106-1.178 1.16Z",
    fill: "#EAEBED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M25.097 33.102c-1.393.131-2.79.128-4.164-.009-.55-.058-1.077-.59-1.138-1.146a19.694 19.694 0 0 1 .003-4.125c.064-.564.59-1.106 1.147-1.17a21.659 21.659 0 0 1 4.195-.052c.569.052 1.104.591 1.165 1.16.137 1.412.128 2.783-.03 4.184-.07.564-.612 1.104-1.178 1.158Z",
    fill: "#E9EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.348,
    d: "M25.085 33.093c-1.39.131-2.78.128-4.155-.009-.55-.058-1.074-.588-1.135-1.146a19.607 19.607 0 0 1 .003-4.116c.064-.56.59-1.106 1.144-1.17a21.533 21.533 0 0 1 4.183-.052c.565.052 1.1.588 1.162 1.158a19.773 19.773 0 0 1-.031 4.177c-.067.567-.608 1.103-1.171 1.158Z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.364,
    d: "M25.07 33.084a21.378 21.378 0 0 1-4.143-.009c-.55-.058-1.07-.588-1.132-1.142a19.52 19.52 0 0 1 .003-4.108c.064-.56.587-1.103 1.141-1.167a21.683 21.683 0 0 1 4.173-.052c.566.052 1.098.589 1.16 1.155a19.68 19.68 0 0 1-.031 4.169c-.07.563-.608 1.097-1.171 1.154Z",
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.379,
    d: "M25.058 33.072a21.533 21.533 0 0 1-4.134-.009c-.548-.058-1.068-.585-1.129-1.14a19.462 19.462 0 0 1 .003-4.1c.064-.561.587-1.1 1.138-1.165a21.56 21.56 0 0 1 4.161-.052c.563.052 1.098.589 1.156 1.152a19.6 19.6 0 0 1-.03 4.16c-.067.566-.606 1.1-1.165 1.154Z",
    fill: "#E6E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.394,
    d: "M25.042 33.063c-1.38.131-2.759.125-4.121-.01-.548-.057-1.065-.584-1.126-1.136a19.572 19.572 0 0 1 .003-4.092c.064-.558.584-1.1 1.135-1.16a21.463 21.463 0 0 1 4.152-.053c.563.052 1.095.585 1.153 1.152.137 1.399.124 2.76-.03 4.153-.07.558-.606 1.091-1.166 1.146Z",
    fill: "#E5E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.409,
    d: "M25.03 33.053a21.32 21.32 0 0 1-4.113-.009c-.544-.058-1.061-.585-1.122-1.136-.14-1.368-.14-2.71.003-4.086.064-.558.584-1.097 1.132-1.161a21.348 21.348 0 0 1 4.14-.05c.56.053 1.091.586 1.15 1.15a19.657 19.657 0 0 1-.031 4.144c-.067.56-.602 1.094-1.16 1.148Z",
    fill: "#E4E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.424,
    d: "M25.015 33.045a21.436 21.436 0 0 1-4.1-.01c-.545-.057-1.06-.581-1.123-1.133-.14-1.365-.14-2.702.003-4.077.06-.557.581-1.093 1.129-1.157 1.365-.15 2.75-.168 4.13-.05.56.053 1.09.583 1.147 1.147a19.6 19.6 0 0 1-.03 4.137c-.067.555-.6 1.085-1.156 1.143Z",
    fill: "#E3E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M25.003 33.033a21.341 21.341 0 0 1-4.092-.01c-.541-.057-1.055-.581-1.119-1.13-.14-1.362-.14-2.696.003-4.07.06-.555.581-1.091 1.126-1.155 1.362-.15 2.74-.168 4.118-.05.557.053 1.086.583 1.144 1.147.137 1.389.125 2.745-.03 4.128-.064.555-.597 1.085-1.15 1.14Z",
    fill: "#E2E3E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.455,
    d: "M24.987 33.023a21.206 21.206 0 0 1-4.079-.01c-.541-.057-1.055-.581-1.116-1.13-.14-1.362-.14-2.694.003-4.062.06-.554.578-1.09 1.122-1.152a21.006 21.006 0 0 1 4.107-.048c.556.052 1.083.582 1.14 1.142.134 1.387.125 2.74-.03 4.12-.064.555-.593 1.085-1.147 1.14Z",
    fill: "#E1E2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M24.972 33.013a21.112 21.112 0 0 1-4.07-.009c-.538-.058-1.052-.579-1.113-1.127-.14-1.36-.14-2.688.003-4.056.061-.554.578-1.088 1.12-1.152a20.91 20.91 0 0 1 4.097-.048c.553.052 1.08.579 1.137 1.14a19.57 19.57 0 0 1-.03 4.113c-.06.554-.59 1.085-1.144 1.14Z",
    fill: "#E0E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.485,
    d: "M24.96 33.002c-1.36.128-2.716.125-4.058-.01-.538-.057-1.05-.578-1.11-1.124a19.34 19.34 0 0 1 .003-4.046c.06-.552.575-1.085 1.12-1.149 1.35-.15 2.719-.164 4.085-.049.553.05 1.076.58 1.134 1.137.134 1.383.125 2.73-.03 4.104-.067.555-.593 1.082-1.144 1.137Z",
    fill: "#DFE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.945 32.993c-1.354.128-2.71.125-4.049-.009-.535-.058-1.046-.578-1.107-1.12-.14-1.354-.14-2.68.003-4.041.061-.552.575-1.085 1.116-1.146a20.938 20.938 0 0 1 4.076-.049c.551.049 1.074.58 1.132 1.137.134 1.38.125 2.724-.03 4.095-.064.555-.59 1.079-1.141 1.133Z",
    fill: "#DFDFE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.515,
    d: "M24.933 32.984c-1.351.128-2.705.125-4.037-.009-.535-.055-1.043-.576-1.104-1.121-.14-1.35-.137-2.672.003-4.031.06-.552.572-1.082 1.113-1.146a20.813 20.813 0 0 1 4.064-.049c.55.049 1.07.576 1.128 1.134a19.34 19.34 0 0 1-.03 4.089c-.067.555-.59 1.079-1.137 1.133Z",
    fill: "#DEDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M24.917 32.975a20.674 20.674 0 0 1-4.027-.01c-.535-.054-1.04-.575-1.101-1.117a19.534 19.534 0 0 1 .003-4.022c.06-.549.572-1.08 1.11-1.143a20.704 20.704 0 0 1 4.055-.049c.547.049 1.067.576 1.125 1.13a19.253 19.253 0 0 1-.03 4.08c-.064.552-.59 1.076-1.135 1.131Z",
    fill: "#DDDDE1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.545,
    d: "M24.905 32.962a20.556 20.556 0 0 1-4.015-.01c-.532-.054-1.037-.572-1.098-1.114a19.482 19.482 0 0 1 .003-4.017c.06-.548.569-1.078 1.107-1.14a20.822 20.822 0 0 1 4.043-.048c.547.049 1.064.573 1.122 1.128a19.172 19.172 0 0 1-.03 4.07c-.067.555-.59 1.08-1.132 1.13Z",
    fill: "#DCDCE0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M24.89 32.954c-1.342.127-2.68.124-4.006-.01-.532-.054-1.034-.572-1.095-1.115a19.387 19.387 0 0 1 .003-4.007c.06-.548.569-1.075 1.104-1.136a20.726 20.726 0 0 1 4.033-.049c.545.049 1.062.573 1.12 1.127a19.316 19.316 0 0 1-.03 4.065c-.064.549-.588 1.07-1.13 1.125Z",
    fill: "#DBDBDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.576,
    d: "M24.878 32.944a20.333 20.333 0 0 1-3.994-.009c-.53-.055-1.031-.573-1.092-1.112-.137-1.34-.137-2.65.003-4 .06-.546.565-1.073 1.1-1.137a20.604 20.604 0 0 1 4.022-.049c.545.049 1.059.573 1.116 1.124.131 1.366.122 2.697-.027 4.056-.07.551-.59 1.073-1.128 1.127Z",
    fill: "#DADADE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.591,
    d: "M24.862 32.935a20.216 20.216 0 0 1-3.981-.01c-.53-.054-1.028-.569-1.09-1.108a19.247 19.247 0 0 1 .004-3.992c.06-.545.565-1.072 1.098-1.133a20.49 20.49 0 0 1 4.009-.05c.541.05 1.055.57 1.113 1.122.131 1.362.122 2.69-.027 4.05-.067.545-.587 1.066-1.126 1.121Z",
    fill: "#D9D9DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.606,
    d: "M24.847 32.923c-1.329.128-2.658.125-3.972-.006-.526-.055-1.028-.57-1.086-1.106a19.182 19.182 0 0 1 .003-3.986c.06-.542.563-1.07 1.095-1.13a20.387 20.387 0 0 1 4-.05c.541.05 1.052.57 1.11 1.122.13 1.362.122 2.688-.027 4.04-.067.543-.584 1.064-1.123 1.116Z",
    fill: "#D8D8DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.621,
    d: "M24.835 32.913a20.233 20.233 0 0 1-3.96-.006c-.527-.055-1.026-.57-1.083-1.106a19.1 19.1 0 0 1 .003-3.976c.06-.543.563-1.067 1.092-1.128a20.499 20.499 0 0 1 3.988-.049c.538.05 1.049.57 1.107 1.119a19.41 19.41 0 0 1-.028 4.031c-.067.542-.584 1.06-1.119 1.115Z",
    fill: "#D7D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.636,
    d: "M24.82 32.904a20.383 20.383 0 0 1-3.951-.006c-.524-.055-1.022-.567-1.08-1.103a19.035 19.035 0 0 1 .003-3.97c.06-.543.56-1.064 1.089-1.128a20.4 20.4 0 0 1 3.978-.049c.539.05 1.047.567 1.105 1.116.13 1.356.121 2.675-.028 4.025-.067.542-.58 1.06-1.116 1.115Z",
    fill: "#D6D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M24.808 32.896c-1.32.125-2.638.121-3.94-.006-.523-.055-1.019-.567-1.076-1.1a19.155 19.155 0 0 1 .003-3.962c.06-.539.56-1.063 1.085-1.124a20.287 20.287 0 0 1 3.967-.049c.535.049 1.046.567 1.101 1.112.13 1.353.122 2.67-.027 4.017-.067.539-.581 1.057-1.113 1.112Z",
    fill: "#D5D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M24.793 32.884a20.402 20.402 0 0 1-3.93-.007c-.52-.054-1.016-.563-1.073-1.1a19.306 19.306 0 0 1 .003-3.955c.06-.539.556-1.06 1.082-1.12a20.193 20.193 0 0 1 3.958-.05c.535.05 1.043.567 1.098 1.113.13 1.35.121 2.663-.028 4.006-.066.546-.577 1.06-1.11 1.113Z",
    fill: "#D4D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.682,
    d: "M24.78 32.874a20.276 20.276 0 0 1-3.917-.006c-.52-.055-1.013-.564-1.07-1.097a19.218 19.218 0 0 1 .002-3.946c.061-.54.557-1.057 1.08-1.118a20.07 20.07 0 0 1 3.945-.049c.533.049 1.04.564 1.096 1.11a19.12 19.12 0 0 1-.028 4c-.067.54-.578 1.051-1.107 1.106Z",
    fill: "#D3D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.697,
    d: "M24.766 32.865a20.182 20.182 0 0 1-3.909-.006c-.517-.055-1.01-.564-1.067-1.094a19.128 19.128 0 0 1 .003-3.937c.06-.536.553-1.057 1.076-1.118a20.218 20.218 0 0 1 3.936-.049c.533.049 1.038.564 1.092 1.106.131 1.344.122 2.654-.027 3.992-.067.54-.575 1.051-1.104 1.106Z",
    fill: "#D2D2D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.712,
    d: "M24.754 32.852c-1.305.125-2.61.122-3.897-.006-.517-.055-1.007-.56-1.067-1.094a19.07 19.07 0 0 1 .003-3.93c.057-.537.553-1.055 1.073-1.116a19.858 19.858 0 0 1 3.924-.045c.53.048 1.034.56 1.09 1.103.127 1.34.118 2.648-.028 3.985-.064.54-.572 1.052-1.098 1.103Z",
    fill: "#D1D1D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    d: "M24.738 32.844a19.955 19.955 0 0 1-3.887-.006c-.517-.055-1.004-.56-1.064-1.091-.134-1.313-.134-2.6.003-3.922.057-.536.55-1.05 1.07-1.112a19.732 19.732 0 0 1 3.912-.046c.53.05 1.031.561 1.086 1.104a19.308 19.308 0 0 1-.027 3.976c-.061.533-.566 1.045-1.093 1.097Z",
    fill: "#D0D0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.742,
    d: "M24.723 32.834a19.839 19.839 0 0 1-3.875-.006c-.514-.054-1-.56-1.061-1.087a18.93 18.93 0 0 1 .003-3.916c.057-.533.55-1.051 1.067-1.112a19.87 19.87 0 0 1 3.903-.046c.526.049 1.028.56 1.083 1.1a19.217 19.217 0 0 1-.028 3.968c-.06.536-.566 1.045-1.092 1.1Z",
    fill: "#CFCFD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.758,
    d: "M24.711 32.825a19.737 19.737 0 0 1-3.866-.006c-.514-.055-1-.558-1.058-1.085a18.84 18.84 0 0 1 .003-3.906c.057-.533.547-1.048 1.064-1.11a19.756 19.756 0 0 1 3.89-.045c.527.049 1.026.558 1.08 1.097a19.152 19.152 0 0 1-.027 3.961c-.06.53-.563 1.04-1.086 1.094Z",
    fill: "#CECFD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.773,
    d: "M24.696 32.813a19.63 19.63 0 0 1-3.854-.006c-.511-.055-.998-.558-1.056-1.085a18.992 18.992 0 0 1 .003-3.9c.058-.533.548-1.045 1.062-1.106a19.661 19.661 0 0 1 3.881-.046c.524.049 1.022.558 1.077 1.097a19.072 19.072 0 0 1-.027 3.952c-.061.533-.563 1.042-1.086 1.094Z",
    fill: "#CDCED3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.788,
    d: "M24.683 32.804a19.53 19.53 0 0 1-3.844-.006c-.511-.055-.995-.555-1.053-1.082-.13-1.304-.13-2.581.003-3.891.058-.53.548-1.045 1.059-1.103a19.526 19.526 0 0 1 3.869-.046c.523.049 1.019.558 1.074 1.094.127 1.329.118 2.62-.028 3.943-.06.53-.56 1.039-1.08 1.09Z",
    fill: "#CCCDD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.803,
    d: "M24.668 32.794a19.398 19.398 0 0 1-3.832-.006c-.508-.054-.992-.554-1.05-1.078-.13-1.301-.13-2.575.003-3.885.058-.53.545-1.042 1.056-1.103a19.434 19.434 0 0 1 3.86-.046c.523.049 1.016.555 1.07 1.09a18.918 18.918 0 0 1-.027 3.938c-.06.53-.56 1.036-1.08 1.09Z",
    fill: "#CBCCD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.818,
    d: "M24.656 32.785a19.315 19.315 0 0 1-3.823-.006c-.508-.055-.989-.554-1.047-1.079-.13-1.297-.13-2.568.003-3.875.058-.53.545-1.04 1.053-1.1a19.316 19.316 0 0 1 3.848-.046c.52.049 1.012.555 1.067 1.088a18.837 18.837 0 0 1-.027 3.927c-.061.534-.557 1.036-1.074 1.091Z",
    fill: "#CACBD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "M24.64 32.774a19.2 19.2 0 0 1-3.81-.006c-.505-.055-.986-.552-1.044-1.076-.13-1.295-.13-2.562.003-3.866.058-.528.542-1.04 1.05-1.097a19.226 19.226 0 0 1 3.838-.046c.52.049 1.01.551 1.065 1.088a18.75 18.75 0 0 1-.027 3.918c-.061.53-.557 1.033-1.074 1.085Z",
    fill: "#C9CAD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.849,
    d: "M24.629 32.764a19.328 19.328 0 0 1-3.803-.006c-.505-.055-.982-.552-1.04-1.073-.13-1.292-.13-2.56.003-3.86.058-.528.542-1.037 1.047-1.095a19.345 19.345 0 0 1 3.826-.045c.517.049 1.007.551 1.062 1.085a18.9 18.9 0 0 1-.028 3.912c-.06.527-.553 1.03-1.067 1.082Z",
    fill: "#C8C9CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "M24.613 32.755a19.206 19.206 0 0 1-3.79-.006c-.502-.055-.979-.551-1.037-1.07-.13-1.291-.13-2.553.003-3.85.058-.528.539-1.034 1.044-1.095 1.262-.14 2.54-.158 3.814-.045.517.049 1.004.551 1.059 1.081a19.02 19.02 0 0 1-.028 3.904c-.058.527-.55 1.03-1.065 1.081Z",
    fill: "#C7C8CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.879,
    d: "M24.601 32.745c-1.265.122-2.53.122-3.78-.006-.503-.055-.977-.548-1.035-1.07-.13-1.288-.13-2.547.003-3.845.058-.524.539-1.03 1.044-1.09 1.259-.141 2.533-.156 3.805-.047.514.05 1 .549 1.055 1.08a18.96 18.96 0 0 1-.027 3.896c-.064.527-.554 1.027-1.065 1.082Z",
    fill: "#C6C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.894,
    d: "M24.586 32.735a18.997 18.997 0 0 1-3.769-.006c-.498-.055-.976-.549-1.03-1.067a18.59 18.59 0 0 1 .002-3.836c.058-.524.536-1.03 1.04-1.088a19.231 19.231 0 0 1 3.794-.046c.514.05.997.549 1.052 1.079a18.88 18.88 0 0 1-.027 3.888c-.061.524-.55 1.024-1.062 1.076Z",
    fill: "#C5C6CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.909,
    d: "M24.571 32.724a19.128 19.128 0 0 1-3.76-.006c-.498-.052-.973-.548-1.027-1.063a18.958 18.958 0 0 1 0-3.83c.057-.521.535-1.027 1.037-1.085 1.25-.14 2.518-.155 3.784-.046.51.05.994.549 1.05 1.076a18.783 18.783 0 0 1-.028 3.879c-.058.524-.545 1.024-1.056 1.075Z",
    fill: "#C4C5CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.924,
    d: "M24.559 32.715c-1.253.122-2.51.12-3.748-.006-.498-.052-.97-.545-1.025-1.063a19.103 19.103 0 0 1 0-3.821c.058-.521.533-1.024 1.034-1.085a19.016 19.016 0 0 1 3.772-.046c.511.05.995.546 1.047 1.073a18.943 18.943 0 0 1-.025 3.873c-.06.524-.547 1.023-1.055 1.075Z",
    fill: "#C3C4CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    d: "M24.544 32.703c-1.25.122-2.5.119-3.739-.006-.495-.052-.967-.545-1.022-1.06a19.042 19.042 0 0 1 0-3.815c.058-.521.533-1.024 1.031-1.082a18.92 18.92 0 0 1 3.763-.046c.508.05.992.546 1.043 1.07a18.847 18.847 0 0 1-.024 3.864c-.06.527-.544 1.023-1.052 1.075Z",
    fill: "#C2C3C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    d: "M24.531 32.694a18.79 18.79 0 0 1-3.726-.006c-.496-.052-.964-.543-1.019-1.058a18.952 18.952 0 0 1 0-3.805c.058-.518.53-1.021 1.028-1.08a18.802 18.802 0 0 1 3.75-.045c.509.049.99.546 1.044 1.07a18.757 18.757 0 0 1-.024 3.854c-.064.521-.548 1.018-1.053 1.07Z",
    fill: "#C1C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M24.516 32.685a18.705 18.705 0 0 1-3.717-.007c-.492-.051-.96-.542-1.016-1.054a18.891 18.891 0 0 1 0-3.8c.058-.518.53-1.017 1.025-1.078a18.711 18.711 0 0 1 3.742-.046c.505.049.985.543 1.04 1.067a18.708 18.708 0 0 1-.024 3.848c-.064.521-.545 1.018-1.05 1.07Z",
    fill: "#C0C1C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    d: "M24.504 32.676a18.583 18.583 0 0 1-3.705-.006c-.493-.052-.958-.542-1.013-1.054a18.8 18.8 0 0 1 0-3.79c.055-.519.526-1.018 1.022-1.076a18.59 18.59 0 0 1 3.73-.046c.504.046.982.543 1.037 1.063a18.83 18.83 0 0 1-.025 3.84c-.064.524-.544 1.017-1.046 1.07Z",
    fill: "#BFC0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.489 32.664a18.492 18.492 0 0 1-3.696-.006c-.49-.052-.955-.54-1.01-1.052a18.71 18.71 0 0 1 0-3.781c.055-.515.526-1.015 1.02-1.073a18.936 18.936 0 0 1 3.716-.045c.502.045.98.539 1.035 1.063a18.74 18.74 0 0 1-.025 3.83c-.06.521-.541 1.012-1.04 1.064Z",
    fill: "#BEBFC6"
  }))), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M24.45 32.773a19.335 19.335 0 0 1-3.872-.006c-.514-.055-1-.57-1.059-1.106a19.806 19.806 0 0 1 0-3.983c.058-.542.55-1.07 1.068-1.13a19.609 19.609 0 0 1 3.9-.049c.526.049 1.028.57 1.082 1.118a19.871 19.871 0 0 1-.027 4.035c-.064.548-.569 1.07-1.092 1.12Z",
    fill: "#B3B5BC"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M24.434 32.764a19.23 19.23 0 0 1-3.86-.006c-.511-.055-.998-.567-1.056-1.104a19.746 19.746 0 0 1 0-3.976c.058-.542.548-1.066 1.065-1.127a19.49 19.49 0 0 1 3.887-.049c.527.049 1.025.567 1.08 1.115a19.811 19.811 0 0 1-.027 4.028c-.064.546-.566 1.064-1.09 1.119Z",
    fill: "#B4B6BD"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42 32.755a19.125 19.125 0 0 1-3.851-.007c-.511-.054-.995-.566-1.053-1.103a19.656 19.656 0 0 1 0-3.967c.058-.542.548-1.063 1.062-1.127 1.28-.146 2.58-.162 3.875-.049.523.049 1.022.567 1.077 1.115a19.75 19.75 0 0 1-.027 4.022c-.061.543-.56 1.06-1.083 1.116Z",
    fill: "#B5B7BE"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M24.407 32.742c-1.284.128-2.57.125-3.84-.006-.507-.055-.99-.566-1.049-1.1a19.596 19.596 0 0 1 0-3.96c.058-.54.545-1.064 1.059-1.125a19.275 19.275 0 0 1 3.866-.049c.523.049 1.019.567 1.074 1.112.128 1.353.118 2.67-.028 4.016-.067.543-.562 1.058-1.082 1.112Z",
    fill: "#B6B8BF"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M24.392 32.733c-1.28.125-2.561.125-3.827-.006-.508-.055-.988-.564-1.046-1.1-.13-1.325-.13-2.62 0-3.955.058-.54.545-1.06 1.056-1.121a19.154 19.154 0 0 1 3.853-.049c.52.049 1.016.567 1.071 1.112.128 1.35.119 2.666-.027 4.01-.064.54-.563 1.054-1.08 1.11Z",
    fill: "#B7B9C0"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M24.377 32.721a19.013 19.013 0 0 1-3.818-.006c-.505-.055-.988-.564-1.043-1.097a19.92 19.92 0 0 1 0-3.949c.058-.54.542-1.06 1.053-1.121a19.037 19.037 0 0 1 3.841-.049c.52.049 1.013.564 1.068 1.11.128 1.346.119 2.66-.027 4-.061.545-.557 1.06-1.074 1.112Z",
    fill: "#B8BAC1"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M24.362 32.712a18.907 18.907 0 0 1-3.806-.006c-.505-.055-.985-.564-1.04-1.094-.13-1.32-.13-2.614 0-3.943.058-.54.542-1.057 1.05-1.118a18.917 18.917 0 0 1 3.83-.049c.516.049 1.009.564 1.064 1.106a19.698 19.698 0 0 1-.025 3.995c-.063.542-.556 1.054-1.073 1.109Z",
    fill: "#B8BAC2"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M24.35 32.703c-1.27.125-2.54.125-3.794-.006-.505-.055-.982-.56-1.037-1.094-.13-1.32-.13-2.608 0-3.937.058-.536.538-1.057 1.046-1.118a18.824 18.824 0 0 1 3.82-.045c.518.048 1.008.563 1.062 1.106.125 1.343.119 2.65-.024 3.988-.067.54-.56 1.051-1.074 1.106Z",
    fill: "#B9BBC3"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M24.334 32.691a18.696 18.696 0 0 1-3.784-.006c-.502-.055-.98-.56-1.034-1.09a19.736 19.736 0 0 1 0-3.932c.058-.536.539-1.054 1.043-1.115a18.708 18.708 0 0 1 3.809-.045c.514.048 1.004.56 1.058 1.102.125 1.341.119 2.648-.024 3.983-.064.54-.557 1.051-1.068 1.103Z",
    fill: "#BABCC4"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M24.319 32.682a18.563 18.563 0 0 1-3.772-.006c-.502-.055-.976-.56-1.03-1.091-.132-1.313-.132-2.6 0-3.925.057-.536.534-1.05 1.04-1.112a18.588 18.588 0 0 1 3.796-.045c.513.048 1 .56 1.055 1.102a19.962 19.962 0 0 1-.024 3.977c-.064.533-.554 1.045-1.065 1.1Z",
    fill: "#BBBDC5"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M24.304 32.67c-1.26.124-2.519.121-3.76-.007-.499-.054-.973-.56-1.028-1.087a19.584 19.584 0 0 1 0-3.916c.058-.533.535-1.051 1.037-1.112a18.722 18.722 0 0 1 3.787-.046c.511.049.998.56 1.053 1.1a19.867 19.867 0 0 1-.025 3.968c-.066.536-.553 1.048-1.064 1.1Z",
    fill: "#BCBEC6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M24.292 32.66c-1.254.125-2.51.122-3.75-.006-.5-.055-.971-.557-1.026-1.088-.13-1.31-.13-2.593 0-3.909.058-.533.532-1.048 1.034-1.11a18.6 18.6 0 0 1 3.775-.045c.511.049.995.558 1.05 1.097a19.814 19.814 0 0 1-.025 3.961c-.064.537-.55 1.046-1.058 1.1Z",
    fill: "#BDBFC7"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M24.276 32.651c-1.25.125-2.503.122-3.738-.006-.496-.055-.968-.558-1.022-1.085a19.933 19.933 0 0 1 0-3.903c.058-.533.532-1.048 1.03-1.106a18.469 18.469 0 0 1 3.764-.046c.508.049.991.558 1.046 1.097.125 1.332.115 2.63-.024 3.955-.064.53-.551 1.04-1.056 1.094Z",
    fill: "#BEC0C8"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M24.26 32.639a18.346 18.346 0 0 1-3.725-.006c-.496-.055-.965-.558-1.02-1.082a19.87 19.87 0 0 1 0-3.897c.058-.533.53-1.045 1.029-1.106a18.39 18.39 0 0 1 3.753-.046c.508.049.989.558 1.044 1.094a19.695 19.695 0 0 1-.025 3.95c-.066.532-.55 1.041-1.055 1.093Z",
    fill: "#BFC1C9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M24.246 32.63a18.475 18.475 0 0 1-3.717-.003c-.493-.055-.961-.555-1.016-1.082a19.809 19.809 0 0 1 0-3.891c.058-.53.53-1.045 1.025-1.103a18.261 18.261 0 0 1 3.741-.046c.505.049.986.555 1.04 1.094.125 1.329.116 2.62-.024 3.94-.064.53-.544 1.036-1.05 1.09Z",
    fill: "#C0C2CA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M24.234 32.618a18.361 18.361 0 0 1-3.705-.003c-.493-.055-.958-.555-1.016-1.079a19.747 19.747 0 0 1 0-3.885c.055-.53.526-1.042 1.022-1.103a18.157 18.157 0 0 1 3.729-.046c.505.049.983.555 1.037 1.091a19.542 19.542 0 0 1-.024 3.934c-.06.533-.542 1.039-1.043 1.09Z",
    fill: "#C1C3CB"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M24.218 32.608a18.234 18.234 0 0 1-3.692-.002c-.49-.055-.955-.555-1.013-1.08a19.685 19.685 0 0 1 0-3.878c.055-.53.523-1.04 1.019-1.1a18.038 18.038 0 0 1 3.717-.046c.502.049.98.555 1.034 1.088a19.704 19.704 0 0 1-.024 3.928c-.061.533-.542 1.036-1.04 1.09Z",
    fill: "#C2C4CC"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M24.203 32.596a18.145 18.145 0 0 1-3.683-.003c-.49-.055-.952-.551-1.01-1.075a19.578 19.578 0 0 1 0-3.87c.055-.527.523-1.04 1.016-1.097a17.934 17.934 0 0 1 3.708-.046c.502.049.976.555 1.03 1.088.123 1.32.117 2.605-.023 3.922-.061.527-.539 1.03-1.038 1.081Z",
    fill: "#C2C4CC"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M24.188 32.587a18.025 18.025 0 0 1-3.671-.003c-.487-.055-.95-.552-1.007-1.073a19.516 19.516 0 0 1 0-3.863c.055-.527.52-1.036 1.013-1.097a17.819 17.819 0 0 1 3.695-.046c.5.049.974.552 1.029 1.085.121 1.32.112 2.602-.025 3.915-.06.524-.535 1.03-1.034 1.082Z",
    fill: "#C3C5CD"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M24.176 32.578a17.936 17.936 0 0 1-3.662-.003c-.487-.055-.946-.552-1.004-1.073a19.455 19.455 0 0 1 0-3.857c.055-.527.52-1.036 1.01-1.094 1.22-.14 2.454-.159 3.683-.046.5.049.97.552 1.022 1.082.122 1.316.113 2.599-.024 3.906-.055.527-.53 1.03-1.025 1.085Z",
    fill: "#C4C6CE"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M24.16 32.566c-1.22.124-2.442.121-3.65-.004-.483-.054-.943-.548-1-1.069a19.873 19.873 0 0 1 0-3.851c.054-.525.517-1.033 1.006-1.094a18.056 18.056 0 0 1 3.675-.046c.496.049.967.551 1.019 1.082a19.655 19.655 0 0 1-.024 3.9c-.058.527-.533 1.03-1.026 1.082Z",
    fill: "#C5C7CF"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M24.145 32.556a17.92 17.92 0 0 1-3.638-.003c-.483-.051-.943-.548-.998-1.07a19.81 19.81 0 0 1 0-3.845c.055-.524.518-1.03 1.004-1.09 1.211-.14 2.44-.156 3.663-.046.495.049.964.548 1.016 1.079a19.6 19.6 0 0 1-.025 3.894c-.058.527-.529 1.027-1.022 1.081Z",
    fill: "#C6C8D0"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M24.13 32.544a17.83 17.83 0 0 1-3.629-.003c-.48-.052-.94-.548-.994-1.066a19.748 19.748 0 0 1 0-3.84c.054-.524.514-1.03 1-1.087 1.208-.14 2.43-.156 3.65-.046.493.049.962.548 1.013 1.079a19.54 19.54 0 0 1-.024 3.888c-.052.524-.523 1.023-1.016 1.075Z",
    fill: "#C7C9D1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M24.118 32.535c-1.21.122-2.421.122-3.617-.003-.48-.052-.937-.548-.992-1.063a19.685 19.685 0 0 1 0-3.834c.055-.524.515-1.026.998-1.087a17.73 17.73 0 0 1 3.641-.046c.493.049.958.548 1.01 1.076.122 1.307.113 2.58-.024 3.881-.058.525-.526 1.024-1.016 1.076Z",
    fill: "#C8CAD2"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M24.103 32.526a17.6 17.6 0 0 1-3.605-.003c-.477-.052-.934-.546-.989-1.064a19.623 19.623 0 0 1 0-3.827c.055-.52.512-1.027.995-1.084a17.612 17.612 0 0 1 3.629-.046c.49.049.955.545 1.007 1.073a19.614 19.614 0 0 1-.024 3.872c-.058.527-.527 1.024-1.013 1.079Z",
    fill: "#C9CBD3"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M24.087 32.514a17.505 17.505 0 0 1-3.595-.003c-.477-.052-.93-.546-.985-1.06a19.529 19.529 0 0 1 0-3.819c.054-.52.51-1.023.991-1.084 1.196-.14 2.41-.156 3.617-.046.49.049.952.545 1.004 1.073a19.552 19.552 0 0 1-.025 3.866c-.054.524-.52 1.021-1.007 1.073Z",
    fill: "#CACCD4"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M24.072 32.505a17.387 17.387 0 0 1-3.583-.003c-.474-.052-.928-.546-.982-1.06a19.467 19.467 0 0 1 0-3.813c.054-.52.508-1.024.988-1.081 1.193-.14 2.4-.156 3.605-.046.486.049.949.545 1 1.07a19.484 19.484 0 0 1-.024 3.86c-.052.524-.517 1.02-1.004 1.073Z",
    fill: "#CBCDD5"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M24.06 32.492c-1.195.122-2.39.122-3.571-.003-.474-.051-.925-.542-.98-1.057a19.405 19.405 0 0 1 0-3.806c.055-.518.508-1.02.986-1.078a17.29 17.29 0 0 1 3.595-.046c.487.049.946.542.998 1.07a19.43 19.43 0 0 1-.024 3.854c-.058.518-.52 1.015-1.004 1.066Z",
    fill: "#CCCED6"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M24.045 32.483c-1.19.122-2.382.122-3.562-.003-.472-.051-.922-.542-.977-1.054a19.818 19.818 0 0 1 0-3.8c.055-.518.505-1.017.983-1.078a17.173 17.173 0 0 1 3.583-.046c.484.049.943.542.995 1.066.118 1.295.11 2.557-.025 3.849-.054.518-.517 1.014-.997 1.066Z",
    fill: "#CCCED7"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M24.03 32.472a17.058 17.058 0 0 1-3.55-.003c-.47-.052-.918-.543-.973-1.055a19.753 19.753 0 0 1 0-3.793c.055-.518.505-1.018.98-1.076a16.852 16.852 0 0 1 3.57-.043c.484.05.94.543.992 1.064.119 1.292.11 2.553-.024 3.84-.055.52-.514 1.014-.995 1.066Z",
    fill: "#CDCFD8"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M24.015 32.462c-1.183.122-2.37.122-3.537-.003-.469-.052-.916-.54-.97-1.051a19.691 19.691 0 0 1 0-3.788c.054-.518.501-1.014.976-1.072a17.173 17.173 0 0 1 3.562-.043c.48.046.936.543.988 1.064.119 1.291.11 2.547-.024 3.833-.055.515-.514 1.008-.995 1.06Z",
    fill: "#CED0D9"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M24.002 32.453c-1.18.122-2.36.119-3.528-.003-.469-.052-.913-.54-.968-1.051a19.628 19.628 0 0 1 0-3.782c.055-.515.502-1.014.974-1.072a17.058 17.058 0 0 1 3.55-.043c.48.046.933.54.985 1.06.119 1.29.11 2.545-.024 3.828-.055.518-.511 1.011-.989 1.063Z",
    fill: "#CFD1DA"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M23.988 32.44a16.95 16.95 0 0 1-3.517-.002c-.465-.052-.909-.54-.964-1.049a19.533 19.533 0 0 1 0-3.772c.055-.515.5-1.011.97-1.07a16.945 16.945 0 0 1 3.538-.042c.478.046.93.54.983 1.06.115 1.286.11 2.539-.022 3.822-.057.511-.514 1.002-.988 1.054Z",
    fill: "#D0D2DB"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M23.973 32.432a16.833 16.833 0 0 1-3.505-.003c-.465-.052-.906-.537-.96-1.046a19.47 19.47 0 0 1 0-3.766c.051-.515.498-1.011.966-1.07a16.856 16.856 0 0 1 3.529-.042c.478.046.928.54.98 1.057.115 1.283.109 2.536-.022 3.815-.06.512-.514 1.003-.988 1.055Z",
    fill: "#D1D3DC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m35.788 38.76-7.289.044a.934.934 0 0 1-.936-.954l.003-.5a.977.977 0 0 1 .955-.972l7.31-.08a.95.95 0 0 1 .963.973l-.009.509c-.009.54-.456.978-.997.98Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m35.785 38.752-7.288.043a.926.926 0 0 1-.928-.944l.003-.503a.967.967 0 0 1 .946-.963l7.307-.08a.94.94 0 0 1 .955.964l-.01.512a.995.995 0 0 1-.985.971Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m35.782 38.74-7.288.043a.92.92 0 0 1-.922-.936l.003-.503a.958.958 0 0 1 .94-.953l7.307-.08a.928.928 0 0 1 .945.954l-.009.512a.983.983 0 0 1-.976.963Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m35.779 38.728-7.288.042a.911.911 0 0 1-.913-.926l.003-.503a.946.946 0 0 1 .931-.944l7.306-.08a.92.92 0 0 1 .937.945l-.009.515a.975.975 0 0 1-.967.95Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "m35.776 38.716-7.289.042a.902.902 0 0 1-.903-.92l.003-.506a.943.943 0 0 1 .922-.938l7.306-.08a.915.915 0 0 1 .93.936l-.008.515a.972.972 0 0 1-.962.95Z",
    fill: "#FBFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "m35.772 38.703-7.288.043a.894.894 0 0 1-.894-.911l.003-.506a.935.935 0 0 1 .912-.93l7.307-.079a.906.906 0 0 1 .921.927l-.009.518a.963.963 0 0 1-.952.938Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m35.769 38.692-7.288.042a.883.883 0 0 1-.885-.901l.003-.51a.924.924 0 0 1 .903-.92l7.307-.079a.898.898 0 0 1 .912.918l-.01.518a.954.954 0 0 1-.942.932Z",
    fill: "#F9F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m35.764 38.68-7.288.042a.873.873 0 0 1-.876-.893l.003-.509a.916.916 0 0 1 .894-.91l7.306-.08a.888.888 0 0 1 .904.908l-.01.521a.94.94 0 0 1-.933.92Z",
    fill: "#F8F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m35.76 38.667-7.285.043a.87.87 0 0 1-.87-.884l.003-.512a.906.906 0 0 1 .886-.902l7.306-.079a.88.88 0 0 1 .894.899l-.009.521a.935.935 0 0 1-.925.914Z",
    fill: "#F7F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m35.757 38.655-7.285.042a.86.86 0 0 1-.86-.874l.002-.512a.896.896 0 0 1 .876-.893l7.304-.08a.869.869 0 0 1 .885.89l-.01.525a.92.92 0 0 1-.912.902Z",
    fill: "#F6F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m35.754 38.642-7.285.043a.85.85 0 0 1-.852-.865l.003-.515a.889.889 0 0 1 .87-.884l7.304-.08a.861.861 0 0 1 .876.884l-.01.525a.915.915 0 0 1-.906.892Z",
    fill: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m35.75 38.63-7.284.043a.839.839 0 0 1-.843-.86l.003-.515a.88.88 0 0 1 .861-.874l7.303-.08a.854.854 0 0 1 .867.875l-.009.527a.903.903 0 0 1-.897.884Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m35.748 38.62-7.285.043a.831.831 0 0 1-.833-.85l.003-.518a.867.867 0 0 1 .852-.865l7.303-.08a.842.842 0 0 1 .858.866l-.01.527a.9.9 0 0 1-.888.878Z",
    fill: "#F3F2F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m35.745 38.608-7.285.043a.828.828 0 0 1-.827-.841l.003-.518a.858.858 0 0 1 .842-.856l7.304-.08a.834.834 0 0 1 .848.857l-.009.527a.885.885 0 0 1-.876.868Z",
    fill: "#F3F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m35.742 38.597-7.285.043a.816.816 0 0 1-.818-.832l.003-.521a.85.85 0 0 1 .833-.847l7.303-.08a.83.83 0 0 1 .843.848l-.01.53a.88.88 0 0 1-.869.859Z",
    fill: "#F2F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m35.739 38.586-7.285.042a.808.808 0 0 1-.81-.822l.004-.522a.842.842 0 0 1 .824-.837l7.303-.08a.819.819 0 0 1 .834.838l-.01.53a.872.872 0 0 1-.86.85Z",
    fill: "#F1EFF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m35.736 38.572-7.285.046a.799.799 0 0 1-.8-.814l.003-.52a.835.835 0 0 1 .816-.833l7.303-.079a.81.81 0 0 1 .824.829l-.009.533a.862.862 0 0 1-.852.838Z",
    fill: "#F0EEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "m35.73 38.56-7.285.046a.787.787 0 0 1-.79-.804l.002-.524a.828.828 0 0 1 .81-.823l7.3-.079a.8.8 0 0 1 .815.82l-.01.533a.849.849 0 0 1-.842.832Z",
    fill: "#EFEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "m35.727 38.547-7.285.046a.782.782 0 0 1-.785-.798l.003-.524a.818.818 0 0 1 .8-.814l7.3-.079a.792.792 0 0 1 .807.81l-.01.537a.836.836 0 0 1-.83.822Z",
    fill: "#EEECED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "m35.724 38.536-7.285.046a.775.775 0 0 1-.776-.79l.003-.526a.808.808 0 0 1 .791-.805l7.3-.08a.782.782 0 0 1 .797.802l-.009.537a.827.827 0 0 1-.821.816Z",
    fill: "#EDEBEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "m35.72 38.524-7.284.045a.767.767 0 0 1-.767-.78l.003-.527a.799.799 0 0 1 .782-.795l7.3-.08a.772.772 0 0 1 .788.793l-.01.54a.819.819 0 0 1-.811.804Z",
    fill: "#ECEAEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "m35.718 38.511-7.282.046a.755.755 0 0 1-.757-.77l.003-.53a.789.789 0 0 1 .772-.787l7.3-.08a.765.765 0 0 1 .78.787l-.01.54a.81.81 0 0 1-.806.794Z",
    fill: "#EBE9EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "m35.715 38.502-7.282.046a.747.747 0 0 1-.748-.762l.003-.53a.781.781 0 0 1 .763-.777l7.3-.08a.757.757 0 0 1 .77.777l-.01.543a.808.808 0 0 1-.796.783Z",
    fill: "#EBE8E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "m35.712 38.49-7.282.046a.74.74 0 0 1-.742-.752l.006-.533a.77.77 0 0 1 .754-.768l7.3-.08a.75.75 0 0 1 .764.768l-.01.543a.803.803 0 0 1-.79.777Z",
    fill: "#EAE7E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "m35.708 38.478-7.282.046a.732.732 0 0 1-.733-.744l.006-.533a.762.762 0 0 1 .746-.758l7.3-.08a.742.742 0 0 1 .754.759l-.009.545a.795.795 0 0 1-.782.765Z",
    fill: "#E9E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "m35.705 38.466-7.282.046a.722.722 0 0 1-.724-.738l.006-.536a.753.753 0 0 1 .74-.75l7.297-.079a.735.735 0 0 1 .745.75l-.01.545a.786.786 0 0 1-.772.762Z",
    fill: "#E8E5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "m35.699 38.453-7.282.046a.714.714 0 0 1-.715-.728l.006-.536a.743.743 0 0 1 .73-.74l7.298-.08a.725.725 0 0 1 .736.74l-.01.546a.772.772 0 0 1-.763.752Z",
    fill: "#E7E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "m35.697 38.441-7.282.046a.706.706 0 0 1-.706-.719l.006-.54a.74.74 0 0 1 .721-.734l7.297-.079a.717.717 0 0 1 .727.731l-.009.549a.765.765 0 0 1-.754.746Z",
    fill: "#E6E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m35.694 38.429-7.283.046a.694.694 0 0 1-.696-.71l.006-.54a.73.73 0 0 1 .712-.725l7.297-.08a.707.707 0 0 1 .718.723l-.01.548a.753.753 0 0 1-.745.738Z",
    fill: "#E5E2E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m35.69 38.416-7.282.046a.689.689 0 0 1-.69-.7l.006-.54a.72.72 0 0 1 .703-.716l7.297-.08a.698.698 0 0 1 .709.714l-.01.551a.74.74 0 0 1-.733.725Z",
    fill: "#E4E1E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m35.687 38.405-7.282.046a.68.68 0 0 1-.681-.692l.006-.542a.71.71 0 0 1 .693-.707l7.298-.08a.688.688 0 0 1 .7.705l-.01.551a.733.733 0 0 1-.724.72Z",
    fill: "#E3E0E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m35.685 38.393-7.282.045a.671.671 0 0 1-.672-.682l.006-.542a.7.7 0 0 1 .684-.698l7.297-.08c.39-.002.7.308.69.695l-.008.555a.72.72 0 0 1-.715.707Z",
    fill: "#E3DFE0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m35.681 38.38-7.281.05a.66.66 0 0 1-.664-.677l.006-.546a.693.693 0 0 1 .679-.688l7.297-.08a.67.67 0 0 1 .681.69l-.009.554a.716.716 0 0 1-.709.697Z",
    fill: "#E2DEDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m35.678 38.371-7.279.049a.653.653 0 0 1-.654-.668l.006-.545a.682.682 0 0 1 .67-.68l7.297-.079a.664.664 0 0 1 .675.68l-.01.557a.72.72 0 0 1-.705.686Z",
    fill: "#E1DDDE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m35.675 38.359-7.279.048a.645.645 0 0 1-.648-.658l.006-.548a.674.674 0 0 1 .66-.67l7.294-.08a.656.656 0 0 1 .666.67l-.009.558a.702.702 0 0 1-.69.68Z",
    fill: "#E0DCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m35.673 38.347-7.28.049a.637.637 0 0 1-.638-.65l.006-.548a.664.664 0 0 1 .65-.66l7.295-.077a.648.648 0 0 1 .657.661l-.009.56a.694.694 0 0 1-.681.665Z",
    fill: "#DFDCDD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m35.666 38.335-7.278.048a.628.628 0 0 1-.63-.64l.006-.55a.654.654 0 0 1 .642-.653l7.294-.076a.638.638 0 0 1 .648.652l-.01.56a.68.68 0 0 1-.672.659Z",
    fill: "#DEDBDC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m35.663 38.322-7.279.05a.618.618 0 0 1-.62-.632l.006-.551a.647.647 0 0 1 .633-.643l7.294-.076a.629.629 0 0 1 .638.643l-.009.563a.672.672 0 0 1-.663.646Z",
    fill: "#DDDADB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m35.66 38.31-7.279.049a.61.61 0 0 1-.611-.622l.006-.554a.642.642 0 0 1 .623-.637l7.294-.076a.62.62 0 0 1 .63.633l-.01.564a.663.663 0 0 1-.653.643Z",
    fill: "#DCD9DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m35.657 38.298-7.28.049a.605.605 0 0 1-.604-.616l.006-.555a.634.634 0 0 1 .614-.627l7.294-.076a.611.611 0 0 1 .62.624l-.009.564a.65.65 0 0 1-.641.637Z",
    fill: "#DBD8D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m35.654 38.286-7.28.05a.594.594 0 0 1-.596-.607l.006-.558a.62.62 0 0 1 .609-.618l7.294-.076a.601.601 0 0 1 .611.615l-.009.567a.642.642 0 0 1-.636.627Z",
    fill: "#DBD7D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m35.651 38.274-7.279.049a.584.584 0 0 1-.587-.597l.006-.558a.613.613 0 0 1 .6-.61l7.294-.076a.594.594 0 0 1 .602.607l-.01.567a.634.634 0 0 1-.626.618Z",
    fill: "#DAD6D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m35.648 38.262-7.279.048a.576.576 0 0 1-.578-.588l.006-.557a.603.603 0 0 1 .59-.6l7.291-.077c.335-.003.6.265.594.598l-.01.57a.62.62 0 0 1-.614.606Z",
    fill: "#D9D5D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m35.645 38.25-7.28.048a.567.567 0 0 1-.568-.579l.006-.56a.593.593 0 0 1 .581-.592l7.291-.076a.58.58 0 0 1 .587.591l-.009.57a.614.614 0 0 1-.608.597Z",
    fill: "#D8D4D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m35.641 38.24-7.279.049a.557.557 0 0 1-.56-.57l.007-.56a.586.586 0 0 1 .572-.583l7.29-.076a.568.568 0 0 1 .579.582l-.01.573a.61.61 0 0 1-.599.585Z",
    fill: "#D7D3D4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m35.635 38.228-7.279.048a.552.552 0 0 1-.553-.563l.006-.564a.576.576 0 0 1 .563-.573l7.29-.076a.56.56 0 0 1 .57.573l-.01.573a.593.593 0 0 1-.587.582Z",
    fill: "#D6D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m35.633 38.215-7.276.049a.543.543 0 0 1-.544-.555l.006-.563a.566.566 0 0 1 .553-.564l7.291-.076a.552.552 0 0 1 .56.564l-.01.575a.59.59 0 0 1-.58.57Z",
    fill: "#D5D1D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m35.63 38.204-7.276.049a.533.533 0 0 1-.536-.546l.006-.566a.557.557 0 0 1 .548-.555l7.291-.076a.54.54 0 0 1 .55.554l-.008.576a.583.583 0 0 1-.575.564Z",
    fill: "#D4D0D1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m35.626 38.191-7.275.05a.523.523 0 0 1-.527-.537l.006-.567a.55.55 0 0 1 .539-.545l7.29-.076a.532.532 0 0 1 .542.545l-.009.579a.574.574 0 0 1-.566.551Z",
    fill: "#D3CFD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m35.623 38.18-7.276.05a.515.515 0 0 1-.517-.526l.006-.57a.541.541 0 0 1 .53-.536l7.29-.076a.525.525 0 0 1 .533.536l-.01.579a.569.569 0 0 1-.556.542Z",
    fill: "#D3CECF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m35.62 38.167-7.275.052a.512.512 0 0 1-.511-.518l.006-.57a.532.532 0 0 1 .52-.53l7.288-.077a.515.515 0 0 1 .523.528l-.009.582a.545.545 0 0 1-.541.533Z",
    fill: "#D2CDCE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m35.618 38.156-7.276.051a.498.498 0 0 1-.502-.509l.006-.572a.525.525 0 0 1 .511-.521l7.288-.077a.505.505 0 0 1 .514.518l-.009.582a.538.538 0 0 1-.532.528Z",
    fill: "#D1CCCD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m35.614 38.142-7.275.052a.491.491 0 0 1-.493-.503l.006-.573a.515.515 0 0 1 .502-.512l7.288-.076a.5.5 0 0 1 .508.51l-.01.581a.534.534 0 0 1-.526.521Z",
    fill: "#D0CBCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m35.611 38.13-7.276.053a.482.482 0 0 1-.483-.494l.006-.576a.505.505 0 0 1 .492-.503l7.288-.076a.492.492 0 0 1 .5.5l-.01.585a.526.526 0 0 1-.517.512Z",
    fill: "#CFCACB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m35.605 38.121-7.276.052a.472.472 0 0 1-.474-.484l.006-.576a.497.497 0 0 1 .483-.494l7.288-.076a.483.483 0 0 1 .49.494l-.01.585a.514.514 0 0 1-.507.5Z",
    fill: "#CEC9CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "m35.602 38.109-7.276.052a.467.467 0 0 1-.469-.476l.006-.576a.488.488 0 0 1 .478-.484l7.288-.076a.473.473 0 0 1 .48.484l-.008.588a.505.505 0 0 1-.5.488Z",
    fill: "#CDC8C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m35.6 38.097-7.276.051a.457.457 0 0 1-.46-.466l.006-.579a.48.48 0 0 1 .469-.475l7.288-.076a.465.465 0 0 1 .471.475l-.009.588a.498.498 0 0 1-.49.482Z",
    fill: "#CCC7C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m35.596 38.084-7.276.052a.449.449 0 0 1-.45-.457l.006-.579a.469.469 0 0 1 .46-.466l7.288-.076a.456.456 0 0 1 .462.466l-.01.591a.488.488 0 0 1-.48.47Z",
    fill: "#CBC6C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m35.593 38.073-7.276.052a.438.438 0 0 1-.441-.448l.006-.582a.46.46 0 0 1 .45-.457l7.285-.076a.444.444 0 0 1 .454.457l-.01.59a.474.474 0 0 1-.468.464Z",
    fill: "#CBC5C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m35.59 38.06-7.273.052a.43.43 0 0 1-.432-.441l.006-.582a.449.449 0 0 1 .44-.448l7.286-.076c.25-.004.45.198.444.447l-.01.595a.469.469 0 0 1-.461.454Z",
    fill: "#CAC4C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m35.587 38.048-7.273.052a.425.425 0 0 1-.425-.433l.006-.585a.44.44 0 0 1 .432-.438l7.285-.077a.427.427 0 0 1 .435.44l-.01.593a.455.455 0 0 1-.45.448Z",
    fill: "#C9C3C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m35.584 38.036-7.273.052a.417.417 0 0 1-.416-.424l.006-.585a.436.436 0 0 1 .422-.432l7.285-.077a.417.417 0 0 1 .426.43l-.009.597a.445.445 0 0 1-.44.439Z",
    fill: "#C8C2C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m35.58 38.024-7.272.051a.404.404 0 0 1-.408-.414l.007-.588a.427.427 0 0 1 .416-.423l7.285-.077a.413.413 0 0 1 .42.42l-.01.598a.445.445 0 0 1-.437.433Z",
    fill: "#C7C1C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m35.578 38.011-7.273.052a.396.396 0 0 1-.399-.405l.006-.588a.417.417 0 0 1 .408-.415l7.285-.076a.404.404 0 0 1 .41.411l-.008.6a.44.44 0 0 1-.43.421Z",
    fill: "#C6C0C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m35.571 38-7.272.052a.386.386 0 0 1-.39-.396l.006-.591a.408.408 0 0 1 .399-.406l7.285-.076a.396.396 0 0 1 .401.402l-.009.6a.426.426 0 0 1-.42.415Z",
    fill: "#C5BFC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m35.57 37.99-7.274.054a.38.38 0 0 1-.38-.387l.006-.59a.4.4 0 0 1 .39-.397l7.284-.076a.387.387 0 0 1 .393.396l-.01.6a.42.42 0 0 1-.41.4Z",
    fill: "#C4BEC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m35.566 37.979-7.273.055a.376.376 0 0 1-.374-.381l.006-.591a.392.392 0 0 1 .38-.387l7.282-.076a.377.377 0 0 1 .383.387l-.009.603a.4.4 0 0 1-.395.39Z",
    fill: "#C3BDBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m35.563 37.966-7.273.055a.366.366 0 0 1-.365-.372l.006-.594a.38.38 0 0 1 .371-.378l7.282-.076a.37.37 0 0 1 .374.377l-.009.604a.393.393 0 0 1-.386.384Z",
    fill: "#C3BCBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m35.56 37.953-7.273.055a.356.356 0 0 1-.356-.363l.006-.594a.372.372 0 0 1 .362-.368l7.282-.077a.358.358 0 0 1 .365.37l-.01.605a.384.384 0 0 1-.377.372Z",
    fill: "#C2BBBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m35.556 37.942-7.273.055a.344.344 0 0 1-.346-.354l.006-.597a.36.36 0 0 1 .352-.36l7.282-.076a.35.35 0 0 1 .356.36l-.009.606a.373.373 0 0 1-.368.366Z",
    fill: "#C1BABC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m35.554 37.93-7.273.054a.337.337 0 0 1-.338-.344l.006-.597a.352.352 0 0 1 .347-.35l7.282-.077a.342.342 0 0 1 .347.35l-.01.61a.368.368 0 0 1-.361.353Z",
    fill: "#C0B9BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.55 37.917-7.27.055a.331.331 0 0 1-.33-.335l.005-.6a.344.344 0 0 1 .338-.342l7.282-.076a.33.33 0 0 1 .338.342l-.01.609a.358.358 0 0 1-.352.347Z",
    fill: "#BFB8BA"
  }))), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "m35.49 38.168-7.182.048a.539.539 0 0 1-.541-.548l.006-.576a.563.563 0 0 1 .55-.56l7.197-.077a.548.548 0 0 1 .557.558l-.01.585a.589.589 0 0 1-.577.57Z",
    fill: "#B0B1BD"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "m35.475 38.155-7.173.05a.536.536 0 0 1-.538-.55l.006-.566a.562.562 0 0 1 .547-.558l7.185-.076c.31-.003.56.247.554.558l-.01.579a.58.58 0 0 1-.571.563Z",
    fill: "#B1B2BE"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "m35.46 38.143-7.16.049a.533.533 0 0 1-.536-.545l.006-.561a.557.557 0 0 1 .547-.555l7.173-.076a.54.54 0 0 1 .55.555l-.009.573a.575.575 0 0 1-.572.56Z",
    fill: "#B2B3BF"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "m35.444 38.131-7.148.049a.53.53 0 0 1-.532-.542l.006-.555a.558.558 0 0 1 .544-.555l7.16-.076a.539.539 0 0 1 .548.552l-.009.563a.575.575 0 0 1-.569.564Z",
    fill: "#B3B4C0"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m35.432 38.123-7.136.052a.533.533 0 0 1-.532-.54l.006-.548a.555.555 0 0 1 .541-.552l7.148-.076a.536.536 0 0 1 .545.548l-.01.558a.573.573 0 0 1-.562.558Z",
    fill: "#B4B5C1"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "m35.417 38.11-7.124.051a.527.527 0 0 1-.53-.539l.007-.542a.552.552 0 0 1 .538-.549l7.14-.076a.537.537 0 0 1 .544.546l-.01.551a.578.578 0 0 1-.565.558Z",
    fill: "#B4B6C2"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m35.402 38.098-7.115.052a.525.525 0 0 1-.526-.536l.006-.533a.548.548 0 0 1 .535-.546l7.127-.076a.534.534 0 0 1 .541.545l-.009.543a.567.567 0 0 1-.56.551Z",
    fill: "#B5B7C3"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "m35.386 38.086-7.102.052a.522.522 0 0 1-.523-.533l.006-.527a.544.544 0 0 1 .535-.543l7.115-.076a.531.531 0 0 1 .538.542l-.009.537a.57.57 0 0 1-.56.548Z",
    fill: "#B6B8C3"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m35.371 38.073-7.09.052a.521.521 0 0 1-.523-.53l.003-.521a.545.545 0 0 1 .532-.543l7.103-.076a.526.526 0 0 1 .535.54l-.01.53c0 .301-.248.545-.55.548Z",
    fill: "#B7B9C4"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "m35.356 38.06-7.078.053a.518.518 0 0 1-.52-.527l.003-.515a.542.542 0 0 1 .53-.54l7.09-.076a.525.525 0 0 1 .532.536l-.01.525a.549.549 0 0 1-.547.545Z",
    fill: "#B8BAC5"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m35.344 38.049-7.066.051a.515.515 0 0 1-.517-.527l.003-.505a.539.539 0 0 1 .526-.537l7.081-.076a.526.526 0 0 1 .533.533l-.01.515a.56.56 0 0 1-.55.546Z",
    fill: "#B9BBC6"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m35.329 38.04-7.057.052a.512.512 0 0 1-.514-.524l.003-.5a.536.536 0 0 1 .526-.533l7.07-.076a.521.521 0 0 1 .528.533l-.009.51a.556.556 0 0 1-.547.538Z",
    fill: "#BABCC7"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "m35.314 38.028-7.045.052a.509.509 0 0 1-.511-.521l.003-.494a.535.535 0 0 1 .523-.53l7.057-.076a.518.518 0 0 1 .526.53l-.009.503a.553.553 0 0 1-.544.536Z",
    fill: "#BBBDC8"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m35.297 38.015-7.032.052a.51.51 0 0 1-.511-.518l.003-.487a.532.532 0 0 1 .52-.53l7.045-.077a.513.513 0 0 1 .523.527l-.01.497a.545.545 0 0 1-.538.536Z",
    fill: "#BBBDC9"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "m35.282 38.003-7.02.052a.505.505 0 0 1-.508-.515l.003-.482a.531.531 0 0 1 .517-.527l7.033-.076a.512.512 0 0 1 .52.524l-.01.488a.54.54 0 0 1-.535.536Z",
    fill: "#BCBECA"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m35.267 37.99-7.011.053a.502.502 0 0 1-.505-.515l.003-.473a.528.528 0 0 1 .514-.524l7.02-.076a.513.513 0 0 1 .52.521l-.008.482c0 .295-.24.533-.533.533Z",
    fill: "#BDBFCB"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "m35.252 37.979-7 .051a.5.5 0 0 1-.501-.511l.003-.467a.523.523 0 0 1 .514-.52l7.011-.077a.51.51 0 0 1 .517.521l-.009.476a.539.539 0 0 1-.535.527Z",
    fill: "#BEC0CC"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "m35.24 37.97-6.987.051a.5.5 0 0 1-.502-.509l.003-.46a.522.522 0 0 1 .511-.518l7-.073a.505.505 0 0 1 .513.518l-.009.47a.539.539 0 0 1-.53.52Z",
    fill: "#BFC1CD"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "m35.225 37.958-6.975.052a.497.497 0 0 1-.499-.506l.003-.454a.521.521 0 0 1 .508-.518l6.987-.073a.504.504 0 0 1 .511.515l-.01.46a.534.534 0 0 1-.525.524Z",
    fill: "#C0C2CD"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "m35.21 37.946-6.963.052a.493.493 0 0 1-.496-.506l.003-.445a.518.518 0 0 1 .505-.515l6.975-.073a.499.499 0 0 1 .508.512l-.01.454a.529.529 0 0 1-.523.521Z",
    fill: "#C1C3CE"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "m35.194 37.934-6.953.052a.491.491 0 0 1-.493-.503l.003-.439a.515.515 0 0 1 .502-.512l6.963-.073a.5.5 0 0 1 .508.509l-.01.448a.528.528 0 0 1-.52.518Z",
    fill: "#C1C4CF"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "m35.18 37.922-6.942.051a.493.493 0 0 1-.493-.5l.003-.432a.512.512 0 0 1 .502-.509l6.95-.073a.5.5 0 0 1 .505.509l-.006.442a.524.524 0 0 1-.52.512Z",
    fill: "#C2C5D0"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "m35.164 37.91-6.93.051a.486.486 0 0 1-.489-.496l.003-.427a.509.509 0 0 1 .499-.506l6.941-.073a.494.494 0 0 1 .502.506l-.006.432a.525.525 0 0 1-.52.512Z",
    fill: "#C3C6D1"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "m35.149 37.896-6.917.052a.484.484 0 0 1-.487-.493l.003-.421a.508.508 0 0 1 .496-.506l6.93-.073a.49.49 0 0 1 .498.503l-.006.427a.522.522 0 0 1-.517.511Z",
    fill: "#C4C7D2"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "m35.137 37.888-6.908.052a.482.482 0 0 1-.484-.494l.003-.411a.505.505 0 0 1 .493-.503l6.917-.073a.488.488 0 0 1 .496.5l-.006.42a.52.52 0 0 1-.511.51Z",
    fill: "#C5C8D3"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "m39.134 41.655-10.658-.006a.94.94 0 0 1-.937-.957l.003-.502a.967.967 0 0 1 .955-.963l10.686-.052a.958.958 0 0 1 .973.981l-.012.518c-.009.542-.462.981-1.01.981Z",
    fill: "#FEFEFE"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.028,
    d: "m39.131 41.644-10.658-.006a.932.932 0 0 1-.928-.948l.003-.506a.96.96 0 0 1 .946-.953l10.686-.052a.95.95 0 0 1 .964.972l-.012.518a1 1 0 0 1-1.001.975Z",
    fill: "#FDFDFD"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.042,
    d: "m39.128 41.631-10.659-.006a.923.923 0 0 1-.918-.938l.003-.506a.95.95 0 0 1 .937-.945l10.685-.051a.942.942 0 0 1 .956.962l-.013.522a.99.99 0 0 1-.991.962Z",
    fill: "#FCFCFC"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.056,
    d: "m39.124 41.618-10.658-.006a.913.913 0 0 1-.91-.93l.004-.508a.94.94 0 0 1 .928-.936l10.685-.051a.93.93 0 0 1 .946.953l-.012.521a.981.981 0 0 1-.983.957Z",
    fill: "#FBFBFB"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "M39.121 41.607 28.463 41.6a.908.908 0 0 1-.903-.92l.003-.51a.93.93 0 0 1 .918-.926l10.686-.052c.53-.003.949.42.94.945l-.012.524a.973.973 0 0 1-.974.945Z",
    fill: "#FBFAFA"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.083,
    d: "m39.118 41.594-10.658-.006a.898.898 0 0 1-.895-.911l.003-.509a.919.919 0 0 1 .913-.917l10.686-.049a.919.919 0 0 1 .93.936l-.012.524a.967.967 0 0 1-.967.932Z",
    fill: "#FAF9F9"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.097,
    d: "m39.116 41.583-10.659-.003a.89.89 0 0 1-.885-.902l.003-.512a.916.916 0 0 1 .904-.911l10.685-.049c.52-.003.931.411.922.926l-.012.525a.958.958 0 0 1-.958.926Z",
    fill: "#F9F8F8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111,
    d: "m39.112 41.57-10.658-.004a.88.88 0 0 1-.876-.895l.003-.512a.908.908 0 0 1 .895-.902l10.685-.049a.9.9 0 0 1 .913.917l-.012.527a.95.95 0 0 1-.95.917Z",
    fill: "#F8F7F7"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.125,
    d: "m39.11 41.558-10.659-.003a.87.87 0 0 1-.867-.887l.003-.514a.896.896 0 0 1 .885-.893l10.686-.05a.892.892 0 0 1 .903.909l-.012.527a.94.94 0 0 1-.94.911Z",
    fill: "#F7F6F6"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "m39.106 41.545-10.658-.003a.862.862 0 0 1-.858-.878l.003-.515a.888.888 0 0 1 .876-.883l10.686-.05c.505-.002.906.4.894.9l-.012.53a.93.93 0 0 1-.931.899Z",
    fill: "#F6F5F5"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.153,
    d: "m39.103 41.533-10.659-.003a.856.856 0 0 1-.851-.868l.003-.518a.878.878 0 0 1 .867-.874l10.685-.05a.87.87 0 0 1 .886.89l-.012.53a.92.92 0 0 1-.92.893Z",
    fill: "#F5F4F4"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "m39.1 41.521-10.658-.003a.847.847 0 0 1-.842-.86l.003-.517a.87.87 0 0 1 .857-.866l10.686-.048a.862.862 0 0 1 .876.88l-.012.533a.907.907 0 0 1-.91.881Z",
    fill: "#F4F3F3"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.181,
    d: "m39.097 41.509-10.658-.004a.837.837 0 0 1-.834-.85l.003-.518a.858.858 0 0 1 .852-.856l10.686-.049c.49-.003.879.39.867.872l-.012.533a.904.904 0 0 1-.904.872Z",
    fill: "#F3F2F3"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.194,
    d: "m39.094 41.497-10.658-.003a.827.827 0 0 1-.825-.84l.003-.522a.85.85 0 0 1 .843-.847l10.686-.049A.843.843 0 0 1 40 40.1l-.013.533a.894.894 0 0 1-.894.865Z",
    fill: "#F3F1F2"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "m39.09 41.485-10.658-.003a.816.816 0 0 1-.815-.835l.003-.52a.847.847 0 0 1 .834-.842l10.685-.049c.481-.003.861.381.85.854l-.013.536a.883.883 0 0 1-.885.86Z",
    fill: "#F2F0F1"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222,
    d: "m39.088 41.472-10.659-.003a.813.813 0 0 1-.809-.826l.003-.524a.835.835 0 0 1 .825-.832l10.685-.049a.826.826 0 0 1 .84.847l-.012.537a.87.87 0 0 1-.873.85Z",
    fill: "#F1EFF0"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.236,
    d: "m39.085 41.463-10.658-.003a.803.803 0 0 1-.8-.816l.003-.524a.827.827 0 0 1 .815-.823l10.686-.049a.816.816 0 0 1 .83.838l-.012.54a.863.863 0 0 1-.864.837Z",
    fill: "#F0EEEF"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M39.082 41.45H28.424a.795.795 0 0 1-.791-.807l.003-.527a.817.817 0 0 1 .806-.813l10.686-.05a.807.807 0 0 1 .82.83l-.011.54a.855.855 0 0 1-.855.828Z",
    fill: "#EFEDEE"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.264,
    d: "M39.079 41.438H28.42a.786.786 0 0 1-.781-.798l.003-.527a.81.81 0 0 1 .797-.804l10.685-.05a.803.803 0 0 1 .816.82l-.013.543a.851.851 0 0 1-.848.816Z",
    fill: "#EEECED"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.278,
    d: "M39.076 41.426H28.417a.774.774 0 0 1-.772-.79l.003-.526a.8.8 0 0 1 .788-.796l10.685-.048a.794.794 0 0 1 .806.81l-.012.542a.84.84 0 0 1-.84.808Z",
    fill: "#EDEBEC"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "M39.072 41.415h-10.66a.77.77 0 0 1-.767-.78l.003-.53a.789.789 0 0 1 .781-.787l10.686-.048a.784.784 0 0 1 .797.8l-.012.543a.828.828 0 0 1-.828.802Z",
    fill: "#ECEAEB"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.306,
    d: "M39.07 41.402H28.41a.759.759 0 0 1-.758-.77l.003-.53a.781.781 0 0 1 .773-.778l10.686-.049a.776.776 0 0 1 .788.793l-.013.545a.82.82 0 0 1-.818.79Z",
    fill: "#EBE9EA"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "M39.067 41.39H28.405a.752.752 0 0 1-.748-.765l.006-.533a.77.77 0 0 1 .764-.768l10.685-.049a.766.766 0 0 1 .78.784l-.013.545a.813.813 0 0 1-.812.786Z",
    fill: "#EBE8E9"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M39.064 41.378H28.402a.742.742 0 0 1-.739-.756l.006-.533a.766.766 0 0 1 .755-.762l10.685-.049a.757.757 0 0 1 .77.774l-.012.549a.806.806 0 0 1-.803.777Z",
    fill: "#EAE7E8"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.347,
    d: "M39.06 41.365H28.4a.734.734 0 0 1-.73-.746l.006-.536a.756.756 0 0 1 .745-.753l10.686-.049a.749.749 0 0 1 .76.765l-.012.549a.798.798 0 0 1-.794.77Z",
    fill: "#E9E6E7"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "M39.057 41.354H28.396a.727.727 0 0 1-.724-.737l.006-.537a.746.746 0 0 1 .736-.743l10.686-.049a.74.74 0 0 1 .751.756l-.012.551a.781.781 0 0 1-.782.759Z",
    fill: "#E8E5E6"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.375,
    d: "M39.055 41.342H28.393a.717.717 0 0 1-.714-.729l.006-.536a.739.739 0 0 1 .727-.734l10.685-.049a.73.73 0 0 1 .743.747l-.012.551a.774.774 0 0 1-.773.75Z",
    fill: "#E7E4E5"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M39.052 41.328H28.39a.71.71 0 0 1-.705-.719l.006-.54a.73.73 0 0 1 .72-.724l10.686-.05a.722.722 0 0 1 .733.738l-.012.552a.769.769 0 0 1-.766.743Z",
    fill: "#E6E3E4"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.403,
    d: "m39.048 41.318-10.661.003c-.39 0-.7-.317-.697-.71l.006-.54a.72.72 0 0 1 .712-.716l10.686-.048a.714.714 0 0 1 .724.728l-.012.555a.758.758 0 0 1-.758.728Z",
    fill: "#E5E2E3"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.417,
    d: "m39.045 41.306-10.661.003a.69.69 0 0 1-.688-.704l.006-.543a.708.708 0 0 1 .703-.707l10.686-.048a.702.702 0 0 1 .715.719l-.013.554a.751.751 0 0 1-.748.726Z",
    fill: "#E4E1E2"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "m39.042 41.293-10.661.003a.68.68 0 0 1-.679-.695l.006-.542a.7.7 0 0 1 .694-.698l10.686-.048a.694.694 0 0 1 .705.71l-.012.557a.741.741 0 0 1-.74.713Z",
    fill: "#E3E0E1"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444,
    d: "m39.04 41.28-10.662.003a.676.676 0 0 1-.672-.686l.006-.542a.693.693 0 0 1 .685-.689l10.685-.049a.686.686 0 0 1 .697.701l-.012.558a.727.727 0 0 1-.727.704Z",
    fill: "#E3DFE0"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.458,
    d: "m39.036 41.267-10.661.004a.666.666 0 0 1-.663-.677l.006-.545a.685.685 0 0 1 .675-.683l10.686-.049a.68.68 0 0 1 .69.695l-.012.56a.724.724 0 0 1-.72.695Z",
    fill: "#E2DEDF"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.472,
    d: "m39.033 41.256-10.661.003a.656.656 0 0 1-.654-.667l.006-.546a.678.678 0 0 1 .666-.673l10.683-.049a.672.672 0 0 1 .681.686l-.012.56a.71.71 0 0 1-.709.686Z",
    fill: "#E1DDDE"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.486,
    d: "m39.03 41.244-10.662.003a.648.648 0 0 1-.644-.658l.006-.549a.668.668 0 0 1 .657-.664l10.682-.046a.664.664 0 0 1 .673.677l-.012.563a.699.699 0 0 1-.7.674Z",
    fill: "#E0DCDD"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m39.028 41.231-10.662.003a.637.637 0 0 1-.636-.649l.007-.548a.66.66 0 0 1 .65-.655l10.683-.046a.653.653 0 0 1 .663.667l-.012.564a.696.696 0 0 1-.693.664Z",
    fill: "#DFDCDD"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.514,
    d: "m39.025 41.219-10.662.003a.632.632 0 0 1-.63-.643l.006-.551a.647.647 0 0 1 .642-.646l10.683-.046a.645.645 0 0 1 .654.658l-.012.564a.68.68 0 0 1-.681.661Z",
    fill: "#DEDBDC"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.528,
    d: "m39.021 41.208-10.661.003a.622.622 0 0 1-.62-.634l.005-.552a.64.64 0 0 1 .633-.636l10.683-.046a.635.635 0 0 1 .645.649l-.013.567a.672.672 0 0 1-.672.649Z",
    fill: "#DDDADB"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.542,
    d: "m39.018 41.195-10.662.003a.615.615 0 0 1-.61-.624l.005-.552a.632.632 0 0 1 .624-.628l10.682-.045a.623.623 0 0 1 .636.64l-.012.566a.662.662 0 0 1-.663.64Z",
    fill: "#DCD9DA"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.556,
    d: "m39.015 41.183-10.662.006a.605.605 0 0 1-.602-.616l.006-.554a.62.62 0 0 1 .614-.619l10.683-.045a.616.616 0 0 1 .627.63l-.012.57a.652.652 0 0 1-.654.628Z",
    fill: "#DBD8D9"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "m39.012 41.17-10.661.006a.595.595 0 0 1-.593-.606l.006-.554a.612.612 0 0 1 .605-.61l10.683-.046a.606.606 0 0 1 .617.622l-.012.57a.644.644 0 0 1-.645.618Z",
    fill: "#DBD7D8"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.583,
    d: "m39.01 41.158-10.662.006a.592.592 0 0 1-.587-.597l.006-.558c.003-.332.27-.6.596-.603l10.683-.046a.598.598 0 0 1 .608.613l-.012.573a.63.63 0 0 1-.633.612Z",
    fill: "#DAD6D7"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.597,
    d: "m39.006 41.146-10.661.006a.58.58 0 0 1-.578-.588l.006-.558a.598.598 0 0 1 .59-.594l10.682-.046a.588.588 0 0 1 .6.604l-.012.572a.625.625 0 0 1-.627.604Z",
    fill: "#D9D5D6"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.611,
    d: "m39.003 41.134-10.665.007a.57.57 0 0 1-.568-.58l.006-.56a.59.59 0 0 1 .58-.585l10.683-.046c.335 0 .6.265.59.594l-.012.573a.613.613 0 0 1-.614.597Z",
    fill: "#D8D4D5"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.625,
    d: "m39 41.122-10.665.006a.562.562 0 0 1-.56-.573l.007-.56a.58.58 0 0 1 .571-.576l10.683-.046c.329 0 .59.262.581.585l-.012.576a.604.604 0 0 1-.605.588Z",
    fill: "#D7D3D4"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.639,
    d: "m38.996 41.113-10.664.006a.554.554 0 0 1-.55-.564l.005-.56a.57.57 0 0 1 .563-.567l10.683-.046c.322 0 .58.256.575.576l-.012.576a.6.6 0 0 1-.6.579Z",
    fill: "#D6D2D3"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.653,
    d: "m38.994 41.101-10.664.006a.546.546 0 0 1-.545-.554l.006-.564a.559.559 0 0 1 .554-.558l10.683-.045c.319 0 .571.253.565.566l-.012.58a.588.588 0 0 1-.587.57Z",
    fill: "#D5D1D2"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "m38.99 41.089-10.664.006a.537.537 0 0 1-.535-.545l.006-.564a.551.551 0 0 1 .545-.549l10.682-.045a.55.55 0 0 1 .557.557l-.012.58a.579.579 0 0 1-.578.56Z",
    fill: "#D4D0D1"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.681,
    d: "m38.988 41.077-10.665.006a.529.529 0 0 1-.526-.537l.006-.566a.541.541 0 0 1 .535-.54l10.683-.045a.54.54 0 0 1 .547.551l-.012.582a.568.568 0 0 1-.568.549Z",
    fill: "#D3CFD0"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.694,
    d: "m38.984 41.063-10.664.006a.519.519 0 0 1-.517-.527l.006-.567a.536.536 0 0 1 .526-.533l10.683-.045c.304 0 .544.24.538.542l-.012.582a.559.559 0 0 1-.56.542Z",
    fill: "#D3CECF"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "m38.982 41.052-10.664.009a.51.51 0 0 1-.508-.518l.006-.57a.529.529 0 0 1 .52-.524l10.683-.046c.298 0 .535.238.529.534l-.012.582a.556.556 0 0 1-.554.533Z",
    fill: "#D2CDCE"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.722,
    d: "m38.979 41.04-10.665.009a.5.5 0 0 1-.498-.512l.006-.57a.52.52 0 0 1 .51-.515l10.683-.046c.292 0 .526.232.52.524l-.012.585a.546.546 0 0 1-.544.524Z",
    fill: "#D1CCCD"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.736,
    d: "m38.976 41.027-10.665.01a.497.497 0 0 1-.493-.504l.006-.57a.512.512 0 0 1 .502-.505l10.683-.046c.289 0 .517.229.511.515l-.012.585a.532.532 0 0 1-.532.515Z",
    fill: "#D0CBCC"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "m38.972 41.016-10.664.009a.483.483 0 0 1-.484-.494l.006-.573a.498.498 0 0 1 .493-.496l10.683-.046c.283 0 .508.226.502.506l-.013.588a.524.524 0 0 1-.523.506Z",
    fill: "#CFCACB"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.764,
    d: "m38.97 41.003-10.665.01a.476.476 0 0 1-.475-.485l.006-.573a.49.49 0 0 1 .484-.487l10.682-.046c.277 0 .5.222.493.497l-.012.588a.514.514 0 0 1-.514.496Z",
    fill: "#CEC9CA"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.778,
    d: "M38.967 40.99 28.302 41a.468.468 0 0 1-.465-.476l.006-.576a.482.482 0 0 1 .474-.479L39 39.424c.274 0 .49.216.484.487l-.012.591a.505.505 0 0 1-.505.488Z",
    fill: "#CDC8C9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "m38.964 40.979-10.665.009a.458.458 0 0 1-.456-.466l.006-.576a.47.47 0 0 1 .465-.47l10.683-.045c.268 0 .48.213.474.478l-.012.591a.497.497 0 0 1-.495.479Z",
    fill: "#CCC7C8"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.806,
    d: "m38.96 40.966-10.664.01a.453.453 0 0 1-.45-.458l.006-.579a.463.463 0 0 1 .46-.46l10.682-.045a.46.46 0 0 1 .465.469l-.012.591a.488.488 0 0 1-.487.472Z",
    fill: "#CBC6C7"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.819,
    d: "m38.957 40.954-10.664.01a.441.441 0 0 1-.441-.449l.006-.579a.458.458 0 0 1 .45-.454l10.683-.045a.45.45 0 0 1 .456.46l-.012.594a.478.478 0 0 1-.478.463Z",
    fill: "#CBC5C6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "m38.954 40.942-10.665.009a.434.434 0 0 1-.431-.442l.005-.579a.448.448 0 0 1 .442-.445l10.682-.045c.253 0 .453.2.45.45l-.012.595a.475.475 0 0 1-.471.457Z",
    fill: "#CAC4C6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.847,
    d: "m38.952 40.93-10.665.01a.422.422 0 0 1-.423-.433l.006-.582a.438.438 0 0 1 .432-.436l10.683-.046c.25 0 .444.198.441.442l-.012.597a.463.463 0 0 1-.462.448Z",
    fill: "#C9C3C5"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.861,
    d: "m38.948 40.918-10.664.012a.415.415 0 0 1-.414-.424l.006-.582a.429.429 0 0 1 .423-.426l10.683-.046c.243 0 .435.192.432.433l-.013.597a.455.455 0 0 1-.453.436Z",
    fill: "#C8C2C4"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.875,
    d: "m38.945 40.906-10.664.012a.411.411 0 0 1-.408-.415l.006-.585a.421.421 0 0 1 .414-.417l10.682-.046c.238 0 .426.189.423.424l-.012.6a.44.44 0 0 1-.44.427Z",
    fill: "#C7C1C3"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.889,
    d: "m38.942 40.894-10.665.012a.402.402 0 0 1-.398-.405l.006-.585a.41.41 0 0 1 .404-.408l10.683-.043c.234 0 .417.186.414.414l-.012.6a.43.43 0 0 1-.432.415Z",
    fill: "#C6C0C2"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.903,
    d: "m38.939 40.88-10.665.013a.39.39 0 0 1-.39-.396l.007-.588c.003-.22.18-.4.395-.4l10.683-.042a.4.4 0 0 1 .405.405l-.013.6a.423.423 0 0 1-.422.409Z",
    fill: "#C5BFC1"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.917,
    d: "m38.936 40.87-10.664.011a.38.38 0 0 1-.38-.387l.006-.588a.392.392 0 0 1 .39-.39l10.682-.042c.222 0 .398.176.395.399l-.012.603a.417.417 0 0 1-.417.393Z",
    fill: "#C4BEC0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "m38.933 40.856-10.667.012a.373.373 0 0 1-.371-.38l.006-.589c.003-.21.17-.38.38-.38l10.683-.043a.38.38 0 0 1 .386.39l-.012.603a.403.403 0 0 1-.405.387Z",
    fill: "#C3BDBF"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.944,
    d: "m38.93 40.844-10.668.012a.366.366 0 0 1-.364-.372l.006-.591a.38.38 0 0 1 .37-.375l10.683-.042c.213 0 .384.17.377.38l-.012.607a.391.391 0 0 1-.392.38Z",
    fill: "#C3BCBE"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.958,
    d: "m38.927 40.832-10.668.012a.358.358 0 0 1-.356-.362l.006-.591a.37.37 0 0 1 .362-.366l10.683-.043c.207 0 .374.165.368.372l-.012.607a.38.38 0 0 1-.383.371Z",
    fill: "#C2BBBD"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.972,
    d: "m38.923 40.82-10.667.013a.35.35 0 0 1-.347-.353l.006-.594a.36.36 0 0 1 .353-.357l10.683-.043c.204 0 .365.162.359.363l-.012.61a.372.372 0 0 1-.375.362Z",
    fill: "#C1BABC"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "m38.921 40.809-10.667.012a.338.338 0 0 1-.338-.345l.006-.594a.348.348 0 0 1 .344-.347l10.683-.043c.197 0 .355.159.35.354l-.013.61a.364.364 0 0 1-.365.352Z",
    fill: "#C0B9BB"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "m38.918 40.795-10.668.012a.329.329 0 0 1-.328-.335l.006-.597a.34.34 0 0 1 .335-.338l10.682-.043c.192 0 .347.153.341.345l-.012.609a.353.353 0 0 1-.356.347Z",
    fill: "#BFB8BA"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "m38.857 41.043-10.576.01a.54.54 0 0 1-.539-.549l.006-.57a.56.56 0 0 1 .55-.554l10.598-.046c.317 0 .566.25.56.564l-.012.585a.587.587 0 0 1-.587.56Z",
    fill: "#B0B1BD"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "m38.842 41.031-10.564.01a.537.537 0 0 1-.536-.549l.006-.564a.554.554 0 0 1 .548-.551l10.585-.046a.55.55 0 0 1 .557.56l-.012.58a.586.586 0 0 1-.584.56Z",
    fill: "#B1B2BE"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "m38.83 41.02-10.555.008a.539.539 0 0 1-.536-.545l.006-.558a.551.551 0 0 1 .545-.548l10.573-.046c.313 0 .56.25.554.558l-.013.57a.576.576 0 0 1-.575.56Z",
    fill: "#B2B3BF"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "m38.814 41.007-10.542.009a.535.535 0 0 1-.533-.542l.006-.549a.548.548 0 0 1 .542-.545l10.56-.046c.311 0 .56.247.551.554l-.012.564a.572.572 0 0 1-.572.555Z",
    fill: "#B3B4C0"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 40.992 28.268 41a.53.53 0 0 1-.53-.54l.006-.542a.544.544 0 0 1 .539-.542l10.549-.046c.31 0 .556.247.55.552l-.012.554a.572.572 0 0 1-.572.555Z",
    fill: "#B4B5C1"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "m38.784 40.98-10.518.009a.529.529 0 0 1-.527-.537l.006-.533a.546.546 0 0 1 .536-.542l10.54-.046a.54.54 0 0 1 .547.552l-.012.548a.573.573 0 0 1-.572.549Z",
    fill: "#B4B6C2"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "m38.769 40.967-10.51.01a.524.524 0 0 1-.523-.534l.006-.527a.543.543 0 0 1 .536-.54l10.527-.045c.308 0 .55.244.545.548l-.012.543a.57.57 0 0 1-.57.545Z",
    fill: "#B5B7C3"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "m38.754 40.955-10.497.01a.521.521 0 0 1-.52-.534l.002-.52a.54.54 0 0 1 .533-.537l10.515-.046c.304 0 .548.244.541.545l-.012.534a.56.56 0 0 1-.562.548Z",
    fill: "#B6B8C3"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "m38.741 40.943-10.485.01a.524.524 0 0 1-.52-.531l.003-.512a.537.537 0 0 1 .53-.533l10.503-.046c.304 0 .544.24.538.542l-.012.528a.556.556 0 0 1-.557.542Z",
    fill: "#B7B9C4"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "m38.726 40.93-10.476.01a.517.517 0 0 1-.517-.527l.003-.506a.531.531 0 0 1 .527-.53l10.494-.046a.53.53 0 0 1 .535.54l-.012.517a.556.556 0 0 1-.554.543Z",
    fill: "#B8BAC5"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "m38.711 40.916-10.463.009a.516.516 0 0 1-.515-.524l.003-.497a.53.53 0 0 1 .524-.527l10.482-.046c.3 0 .538.238.532.536l-.012.512a.548.548 0 0 1-.55.537Z",
    fill: "#B9BBC6"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "m38.696 40.903-10.452.013a.513.513 0 0 1-.51-.521l.002-.491a.531.531 0 0 1 .52-.527l10.47-.046c.299 0 .539.238.533.533l-.01.503a.555.555 0 0 1-.553.536Z",
    fill: "#BABCC7"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "m38.68 40.891-10.439.012a.51.51 0 0 1-.508-.518l.003-.484a.529.529 0 0 1 .52-.524l10.458-.046c.298 0 .536.238.53.533l-.01.497a.554.554 0 0 1-.553.53Z",
    fill: "#BBBDC8"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "m38.665 40.879-10.43.012a.511.511 0 0 1-.508-.518l.003-.475a.526.526 0 0 1 .517-.521l10.448-.046a.52.52 0 0 1 .526.53l-.009.488a.546.546 0 0 1-.547.53Z",
    fill: "#BBBDC9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "m38.653 40.867-10.419.012a.508.508 0 0 1-.505-.515l.004-.47a.52.52 0 0 1 .514-.517l10.436-.046c.295 0 .53.235.523.527l-.009.482a.549.549 0 0 1-.544.527Z",
    fill: "#BCBECA"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "m38.637 40.852-10.406.012a.503.503 0 0 1-.502-.512l.004-.463a.517.517 0 0 1 .51-.515l10.425-.046c.292 0 .526.235.52.524l-.01.473a.542.542 0 0 1-.54.527Z",
    fill: "#BDBFCB"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "m38.622 40.84-10.397.011a.502.502 0 0 1-.498-.508l.003-.454a.514.514 0 0 1 .508-.512l10.412-.046a.51.51 0 0 1 .517.521l-.01.466a.534.534 0 0 1-.535.521Z",
    fill: "#BEC0CC"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "m38.607 40.827-10.385.012a.496.496 0 0 1-.495-.505l.003-.448a.51.51 0 0 1 .505-.51l10.4-.045c.288 0 .52.232.513.518l-.009.457a.53.53 0 0 1-.532.521Z",
    fill: "#BFC1CD"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "m38.592 40.815-10.373.012a.493.493 0 0 1-.492-.503l.003-.438a.513.513 0 0 1 .505-.51l10.39-.045c.29 0 .517.229.511.515l-.009.451a.535.535 0 0 1-.535.518Z",
    fill: "#C0C2CD"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "m38.577 40.803-10.36.012a.497.497 0 0 1-.493-.503l.003-.432a.51.51 0 0 1 .502-.506l10.378-.046c.286 0 .517.229.511.512l-.009.442a.533.533 0 0 1-.532.52Z",
    fill: "#C1C3CE"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "m38.565 40.79-10.352.013a.49.49 0 0 1-.49-.5l.004-.426a.504.504 0 0 1 .499-.503l10.366-.046c.286 0 .514.229.508.512l-.01.436a.532.532 0 0 1-.526.515Z",
    fill: "#C1C4CF"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "m38.55 40.776-10.34.012a.489.489 0 0 1-.486-.497l.003-.417a.503.503 0 0 1 .495-.5l10.355-.046c.286 0 .51.226.505.509l-.01.43a.525.525 0 0 1-.523.508Z",
    fill: "#C2C5D0"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "m38.534 40.763-10.327.015a.483.483 0 0 1-.483-.493l.003-.412a.498.498 0 0 1 .492-.496l10.346-.046c.282 0 .508.225.501.506l-.009.42a.524.524 0 0 1-.523.506Z",
    fill: "#C3C6D1"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "m38.519 40.75-10.318.016a.482.482 0 0 1-.48-.49l.003-.403a.496.496 0 0 1 .49-.493l10.332-.046a.49.49 0 0 1 .5.503l-.01.414a.515.515 0 0 1-.517.5Z",
    fill: "#C4C7D2"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "m38.504 40.739-10.306.015a.479.479 0 0 1-.477-.487l.003-.397a.498.498 0 0 1 .486-.493l10.321-.046a.49.49 0 0 1 .496.5l-.01.405a.513.513 0 0 1-.513.503Z",
    fill: "#C5C8D3"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.015,
    d: "M25.39 42.611c-1.47.135-2.939.132-4.39-.012-.58-.06-1.134-.612-1.198-1.191a20.204 20.204 0 0 1 .003-4.287c.067-.585.624-1.152 1.208-1.22a23.269 23.269 0 0 1 4.42-.054c.599.052 1.164.612 1.228 1.207a20.229 20.229 0 0 1-.033 4.354c-.073.588-.642 1.146-1.238 1.203Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M25.375 42.603a23.078 23.078 0 0 1-4.377-.012c-.58-.06-1.131-.612-1.195-1.191a20.318 20.318 0 0 1 .003-4.278c.067-.585.62-1.15 1.204-1.216a23.173 23.173 0 0 1 4.411-.055c.596.052 1.162.612 1.226 1.204a20.145 20.145 0 0 1-.034 4.345c-.073.588-.642 1.145-1.238 1.203Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.045,
    d: "M25.363 42.591a22.99 22.99 0 0 1-4.368-.012c-.578-.061-1.128-.613-1.192-1.188a20.26 20.26 0 0 1 .003-4.273c.067-.581.62-1.145 1.201-1.212a23.044 23.044 0 0 1 4.399-.055c.596.052 1.159.612 1.223 1.2.142 1.46.133 2.883-.034 4.337-.073.59-.642 1.145-1.232 1.203Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.061,
    d: "M25.348 42.582c-1.46.134-2.917.13-4.356-.013-.578-.06-1.125-.609-1.19-1.185a20.174 20.174 0 0 1 .004-4.263c.067-.582.617-1.145 1.198-1.21 1.451-.158 2.92-.176 4.39-.054.593.052 1.155.61 1.22 1.2.142 1.46.133 2.88-.034 4.33-.073.582-.642 1.137-1.232 1.195Z",
    fill: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.076,
    d: "M25.336 42.572a22.76 22.76 0 0 1-4.347-.012c-.575-.06-1.122-.61-1.186-1.182a20.116 20.116 0 0 1 .003-4.257c.067-.582.617-1.142 1.195-1.21a22.818 22.818 0 0 1 4.377-.054c.593.052 1.153.61 1.217 1.197a20.117 20.117 0 0 1-.033 4.321c-.073.585-.64 1.14-1.226 1.197Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.091,
    d: "M25.32 42.563c-1.45.134-2.904.13-4.334-.012-.575-.061-1.12-.61-1.183-1.183a20.03 20.03 0 0 1 .003-4.247c.067-.58.614-1.14 1.195-1.207a22.47 22.47 0 0 1 4.368-.052c.59.052 1.15.61 1.214 1.195.143 1.453.13 2.867-.034 4.311-.076.582-.641 1.137-1.228 1.195Z",
    fill: "#F9F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.106,
    d: "M25.307 42.551a22.53 22.53 0 0 1-4.325-.012c-.572-.06-1.116-.606-1.18-1.18-.15-1.42-.15-2.809.003-4.24.067-.58.614-1.14 1.192-1.204a22.854 22.854 0 0 1 4.356-.052c.59.052 1.15.606 1.21 1.194.144 1.45.132 2.862-.033 4.306-.076.579-.639 1.13-1.223 1.188Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.121,
    d: "M25.292 42.542c-1.445.134-2.89.128-4.313-.012-.572-.061-1.113-.607-1.18-1.176a19.887 19.887 0 0 1 .003-4.233c.067-.579.611-1.136 1.19-1.203a22.75 22.75 0 0 1 4.346-.052c.587.052 1.147.606 1.207 1.191.143 1.448.131 2.858-.033 4.297-.073.579-.636 1.13-1.22 1.188Z",
    fill: "#F7F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.136,
    d: "M25.28 42.533a22.559 22.559 0 0 1-4.304-.012c-.569-.058-1.11-.604-1.177-1.177-.15-1.413-.146-2.8.003-4.226.064-.576.611-1.133 1.186-1.2a22.623 22.623 0 0 1 4.335-.052c.587.052 1.143.603 1.204 1.188.143 1.444.13 2.852-.033 4.29-.073.58-.633 1.13-1.214 1.189Z",
    fill: "#F6F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.151,
    d: "M25.266 42.52a22.448 22.448 0 0 1-4.292-.013c-.57-.057-1.11-.603-1.174-1.173a20.144 20.144 0 0 1 .003-4.217c.063-.576.608-1.133 1.183-1.197a22.5 22.5 0 0 1 4.322-.052c.584.052 1.14.603 1.202 1.185.143 1.441.13 2.846-.034 4.281-.07.58-.63 1.13-1.21 1.186Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.167,
    d: "M25.25 42.511a22.353 22.353 0 0 1-4.282-.012c-.57-.058-1.108-.603-1.171-1.17a20.086 20.086 0 0 1 .003-4.211c.063-.576.608-1.13 1.18-1.195a22.413 22.413 0 0 1 4.313-.051c.584.051 1.138.603 1.199 1.185.142 1.438.13 2.84-.034 4.272-.07.576-.627 1.124-1.207 1.182Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.182,
    d: "M25.238 42.502c-1.43.134-2.859.128-4.27-.01-.566-.057-1.105-.6-1.168-1.166a20 20 0 0 1 .003-4.202c.063-.573.605-1.128 1.177-1.195a22.276 22.276 0 0 1 4.3-.051c.582.051 1.135.6 1.196 1.182.14 1.435.131 2.837-.033 4.266-.07.573-.627 1.118-1.205 1.176Z",
    fill: "#F3F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.197,
    d: "M25.223 42.493a22.618 22.618 0 0 1-4.261-.01c-.566-.057-1.102-.6-1.165-1.166a19.913 19.913 0 0 1 .003-4.193c.063-.573.605-1.125 1.174-1.192a22.182 22.182 0 0 1 4.292-.052c.58.052 1.131.6 1.192 1.18.14 1.435.13 2.83-.033 4.256-.07.573-.624 1.119-1.202 1.177Z",
    fill: "#F2F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.212,
    d: "M25.21 42.48a22.489 22.489 0 0 1-4.248-.009c-.563-.058-1.099-.6-1.162-1.164a19.854 19.854 0 0 1 .003-4.186c.063-.573.602-1.125 1.17-1.189a22.059 22.059 0 0 1 4.28-.052c.578.052 1.129.6 1.19 1.177.14 1.432.13 2.824-.034 4.247-.07.576-.623 1.122-1.198 1.176Z",
    fill: "#F1F1F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.227,
    d: "M25.196 42.472c-1.42.13-2.838.128-4.24-.01-.563-.057-1.096-.597-1.16-1.16a19.768 19.768 0 0 1 .004-4.178c.063-.57.602-1.121 1.168-1.185a22.201 22.201 0 0 1 4.27-.052c.578.052 1.126.597 1.187 1.176.14 1.43.13 2.819-.03 4.242-.074.566-.624 1.112-1.2 1.167Z",
    fill: "#F0F0F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.242,
    d: "M25.183 42.463a22.265 22.265 0 0 1-4.228-.01c-.56-.057-1.092-.597-1.155-1.16a19.712 19.712 0 0 1 .003-4.172c.063-.57.599-1.118 1.165-1.185a22.087 22.087 0 0 1 4.258-.052c.575.052 1.123.597 1.183 1.173.14 1.426.128 2.816-.03 4.233-.073.572-.624 1.115-1.196 1.173Z",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.258,
    d: "M25.168 42.453a22.177 22.177 0 0 1-4.218-.009c-.56-.058-1.09-.594-1.153-1.158a19.624 19.624 0 0 1 .003-4.162c.063-.57.599-1.118 1.162-1.182a22.232 22.232 0 0 1 4.249-.052c.575.052 1.12.594 1.18 1.17.14 1.423.128 2.81-.03 4.223-.07.57-.62 1.112-1.193 1.17Z",
    fill: "#EEEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.273,
    d: "M25.156 42.441a22.05 22.05 0 0 1-4.207-.009c-.557-.058-1.086-.594-1.15-1.155a19.774 19.774 0 0 1 .003-4.156c.064-.567.597-1.115 1.16-1.18 1.399-.152 2.82-.17 4.236-.051.575.052 1.117.594 1.178 1.17a19.94 19.94 0 0 1-.03 4.217c-.074.567-.621 1.11-1.19 1.164Z",
    fill: "#EDEEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.288,
    d: "M25.14 42.433c-1.405.13-2.81.128-4.197-.01-.557-.057-1.083-.594-1.147-1.151a19.89 19.89 0 0 1 .003-4.147c.064-.567.596-1.112 1.156-1.176a21.989 21.989 0 0 1 4.225-.052c.572.052 1.114.594 1.174 1.167.14 1.417.128 2.797-.03 4.208-.067.564-.615 1.106-1.183 1.16Z",
    fill: "#ECEDEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.303,
    d: "M25.125 42.422a21.82 21.82 0 0 1-4.185-.01c-.554-.057-1.083-.59-1.144-1.151a19.833 19.833 0 0 1 .003-4.141c.064-.564.593-1.112 1.153-1.176a21.891 21.891 0 0 1 4.216-.052c.572.052 1.11.591 1.171 1.164a19.79 19.79 0 0 1-.03 4.202c-.07.567-.615 1.106-1.184 1.164Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.318,
    d: "M25.113 42.411c-1.399.131-2.795.128-4.176-.009-.554-.058-1.08-.59-1.14-1.148a19.746 19.746 0 0 1 .002-4.132c.064-.564.593-1.11 1.15-1.173 1.39-.153 2.799-.171 4.204-.052.569.052 1.107.591 1.168 1.16.137 1.411.128 2.789-.03 4.194-.067.566-.612 1.106-1.178 1.16Z",
    fill: "#EAEBED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M25.098 42.401c-1.393.131-2.79.128-4.164-.009-.55-.058-1.077-.591-1.138-1.146a19.687 19.687 0 0 1 .003-4.125c.064-.564.59-1.106 1.147-1.17a21.658 21.658 0 0 1 4.195-.052c.569.052 1.104.59 1.165 1.16a19.83 19.83 0 0 1-.03 4.184c-.07.567-.612 1.103-1.178 1.158Z",
    fill: "#E9EAEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.348,
    d: "M25.086 42.392c-1.39.131-2.78.128-4.155-.01-.55-.057-1.074-.587-1.135-1.145a19.6 19.6 0 0 1 .003-4.116c.064-.561.59-1.106 1.144-1.17a21.534 21.534 0 0 1 4.182-.052c.566.052 1.102.588 1.162 1.158a19.767 19.767 0 0 1-.03 4.177c-.067.567-.608 1.103-1.171 1.158Z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.364,
    d: "M25.07 42.383a21.387 21.387 0 0 1-4.142-.009c-.55-.058-1.07-.588-1.132-1.142a19.513 19.513 0 0 1 .003-4.108c.064-.56.587-1.103 1.141-1.167a21.691 21.691 0 0 1 4.173-.052c.566.052 1.098.588 1.16 1.155a19.678 19.678 0 0 1-.031 4.168c-.07.564-.609 1.097-1.171 1.155Z",
    fill: "#E7E8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.379,
    d: "M25.059 42.371a21.533 21.533 0 0 1-4.134-.009c-.548-.058-1.068-.585-1.129-1.14a19.456 19.456 0 0 1 .003-4.1c.064-.562.587-1.1 1.138-1.165a21.568 21.568 0 0 1 4.161-.052c.563.052 1.098.588 1.156 1.152a19.6 19.6 0 0 1-.03 4.16c-.067.566-.606 1.1-1.165 1.154Z",
    fill: "#E6E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.394,
    d: "M25.043 42.362a21.414 21.414 0 0 1-4.121-.01c-.548-.057-1.065-.584-1.126-1.136a19.578 19.578 0 0 1 .003-4.092c.064-.558.584-1.1 1.135-1.161a21.463 21.463 0 0 1 4.152-.052c.563.052 1.095.585 1.153 1.152.136 1.399.124 2.76-.03 4.153-.07.558-.606 1.091-1.166 1.146Z",
    fill: "#E5E6E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.409,
    d: "M25.03 42.353a21.32 21.32 0 0 1-4.112-.009c-.544-.058-1.061-.585-1.122-1.136-.14-1.369-.14-2.71.003-4.087.064-.557.584-1.096 1.131-1.16a21.35 21.35 0 0 1 4.14-.05c.56.053 1.092.586 1.15 1.15a19.657 19.657 0 0 1-.03 4.144c-.067.56-.603 1.093-1.16 1.148Z",
    fill: "#E4E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.424,
    d: "M25.016 42.344a21.429 21.429 0 0 1-4.1-.01c-.545-.057-1.06-.581-1.123-1.133-.14-1.365-.14-2.703.003-4.077.06-.557.581-1.094 1.129-1.158 1.365-.149 2.75-.167 4.13-.048.56.051 1.09.582 1.147 1.145a19.593 19.593 0 0 1-.03 4.138c-.067.555-.6 1.085-1.156 1.143Z",
    fill: "#E3E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M25.004 42.332a21.333 21.333 0 0 1-4.092-.01c-.541-.057-1.055-.582-1.119-1.13a19.58 19.58 0 0 1 .003-4.07c.06-.555.581-1.092 1.126-1.156a21.13 21.13 0 0 1 4.118-.048c.557.051 1.086.582 1.144 1.145.137 1.39.124 2.746-.03 4.129-.064.555-.597 1.085-1.15 1.14Z",
    fill: "#E2E3E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.455,
    d: "M24.988 42.321a21.214 21.214 0 0 1-4.079-.009c-.541-.058-1.055-.582-1.116-1.13-.14-1.362-.14-2.694.003-4.062.06-.554.578-1.09 1.123-1.152a21.006 21.006 0 0 1 4.106-.049c.556.052 1.083.583 1.14 1.143a19.62 19.62 0 0 1-.03 4.12c-.064.554-.593 1.085-1.147 1.14Z",
    fill: "#E1E2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M24.973 42.312a21.12 21.12 0 0 1-4.07-.009c-.538-.058-1.052-.579-1.113-1.127-.14-1.36-.14-2.688.003-4.056.061-.554.578-1.088 1.12-1.152a20.91 20.91 0 0 1 4.097-.049c.553.052 1.08.58 1.137 1.14a19.577 19.577 0 0 1-.03 4.114c-.06.554-.59 1.084-1.144 1.14Z",
    fill: "#E0E1E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.485,
    d: "M24.961 42.305c-1.36.127-2.716.124-4.058-.01-.538-.058-1.05-.578-1.11-1.124-.14-1.356-.14-2.681.003-4.046.06-.552.575-1.085 1.12-1.15 1.35-.148 2.719-.164 4.084-.048.554.049 1.077.579 1.135 1.137.134 1.383.125 2.73-.03 4.104-.067.551-.593 1.082-1.144 1.137Z",
    fill: "#DFE0E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.946 42.292a20.9 20.9 0 0 1-4.049-.009c-.535-.058-1.046-.579-1.107-1.121-.14-1.353-.14-2.678.003-4.04.061-.552.575-1.085 1.117-1.146a20.929 20.929 0 0 1 4.075-.049c.551.049 1.074.579 1.132 1.137.134 1.38.125 2.724-.03 4.095-.064.554-.59 1.078-1.141 1.133Z",
    fill: "#DFDFE3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.515,
    d: "M24.933 42.283c-1.35.128-2.704.125-4.036-.009-.535-.055-1.043-.576-1.104-1.121-.14-1.35-.137-2.672.003-4.032.06-.551.572-1.081 1.113-1.145a20.805 20.805 0 0 1 4.064-.049c.55.049 1.07.576 1.129 1.134a19.345 19.345 0 0 1-.03 4.089c-.068.554-.591 1.078-1.139 1.133Z",
    fill: "#DEDEE2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M24.918 42.274a20.681 20.681 0 0 1-4.027-.01c-.535-.054-1.04-.575-1.101-1.118a19.534 19.534 0 0 1 .003-4.022c.06-.548.572-1.078 1.11-1.142a20.711 20.711 0 0 1 4.055-.05c.547.05 1.067.577 1.125 1.131a19.26 19.26 0 0 1-.03 4.08c-.064.552-.59 1.076-1.135 1.13Z",
    fill: "#DDDDE1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.545,
    d: "M24.906 42.262a20.556 20.556 0 0 1-4.015-.01c-.532-.054-1.037-.572-1.098-1.115a19.468 19.468 0 0 1 .003-4.016c.06-.548.569-1.078 1.107-1.14a20.822 20.822 0 0 1 4.043-.048c.547.049 1.064.573 1.122 1.127a19.172 19.172 0 0 1-.03 4.071c-.067.555-.59 1.079-1.132 1.13Z",
    fill: "#DCDCE0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M24.89 42.252c-1.34.128-2.679.125-4.005-.009-.533-.055-1.034-.573-1.095-1.115a19.386 19.386 0 0 1 .003-4.007c.06-.548.569-1.076 1.104-1.136a20.726 20.726 0 0 1 4.033-.05c.545.05 1.062.574 1.12 1.128a19.308 19.308 0 0 1-.03 4.065c-.065.548-.588 1.07-1.13 1.124Z",
    fill: "#DBDBDF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.576,
    d: "M24.878 42.243a20.34 20.34 0 0 1-3.993-.009c-.53-.055-1.032-.573-1.092-1.112a19.32 19.32 0 0 1 .003-4c.06-.546.566-1.073 1.1-1.137a20.604 20.604 0 0 1 4.022-.05c.545.05 1.059.574 1.116 1.125.131 1.365.122 2.697-.027 4.056-.07.551-.59 1.072-1.129 1.127Z",
    fill: "#DADADE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.591,
    d: "M24.863 42.234a20.208 20.208 0 0 1-3.981-.01c-.53-.054-1.029-.57-1.09-1.108a19.232 19.232 0 0 1 .004-3.992c.06-.546.566-1.073 1.098-1.134a20.483 20.483 0 0 1 4.009-.048c.541.048 1.055.57 1.113 1.121a19.59 19.59 0 0 1-.027 4.05c-.067.545-.587 1.066-1.126 1.12Z",
    fill: "#D9D9DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.606,
    d: "M24.848 42.222c-1.329.128-2.658.124-3.972-.007-.527-.054-1.028-.57-1.086-1.106a19.18 19.18 0 0 1 .003-3.985c.06-.543.563-1.07 1.095-1.13a20.387 20.387 0 0 1 4-.05c.541.05 1.052.57 1.11 1.122.13 1.362.122 2.688-.027 4.04-.067.543-.584 1.064-1.123 1.116Z",
    fill: "#D8D8DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.621,
    d: "M24.836 42.212a20.225 20.225 0 0 1-3.96-.006c-.527-.055-1.026-.57-1.083-1.106a19.088 19.088 0 0 1 .003-3.977c.06-.542.563-1.066 1.092-1.127a20.508 20.508 0 0 1 3.987-.049c.539.049 1.05.57 1.108 1.118.13 1.36.121 2.682-.028 4.032-.067.542-.584 1.06-1.119 1.115Z",
    fill: "#D7D7DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.636,
    d: "M24.82 42.203a20.383 20.383 0 0 1-3.95-.006c-.524-.055-1.022-.567-1.08-1.103a19.036 19.036 0 0 1 .003-3.97c.06-.543.56-1.064 1.089-1.128a20.408 20.408 0 0 1 3.978-.049c.539.049 1.047.567 1.105 1.115.13 1.356.121 2.676-.028 4.026-.067.542-.58 1.06-1.116 1.115Z",
    fill: "#D6D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M24.81 42.194c-1.32.125-2.638.122-3.94-.006-.523-.055-1.019-.566-1.076-1.1a19.162 19.162 0 0 1 .003-3.96c.06-.54.56-1.064 1.085-1.125a20.286 20.286 0 0 1 3.967-.049c.535.049 1.046.567 1.101 1.112.13 1.353.122 2.67-.027 4.016-.067.543-.581 1.058-1.114 1.112Z",
    fill: "#D5D5DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M24.794 42.182a20.401 20.401 0 0 1-3.93-.006c-.52-.055-1.016-.563-1.074-1.1a19.312 19.312 0 0 1 .004-3.955c.06-.54.556-1.06 1.082-1.121a20.194 20.194 0 0 1 3.958-.049c.535.049 1.043.567 1.098 1.112.13 1.35.121 2.663-.028 4.007-.067.546-.578 1.06-1.11 1.112Z",
    fill: "#D4D4D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.682,
    d: "M24.782 42.173a20.268 20.268 0 0 1-3.918-.006c-.52-.055-1.013-.564-1.07-1.097a19.217 19.217 0 0 1 .002-3.946c.061-.54.557-1.057 1.08-1.118a20.07 20.07 0 0 1 3.945-.049c.533.049 1.04.564 1.095 1.11a19.12 19.12 0 0 1-.027 4c-.067.54-.578 1.051-1.107 1.106Z",
    fill: "#D3D3D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.697,
    d: "M24.767 42.164a20.182 20.182 0 0 1-3.909-.006c-.517-.055-1.01-.564-1.068-1.094a19.135 19.135 0 0 1 .004-3.937c.06-.536.553-1.057 1.076-1.118a20.21 20.21 0 0 1 3.936-.049c.533.049 1.037.564 1.092 1.106.131 1.344.122 2.654-.027 3.992-.067.539-.575 1.05-1.104 1.106Z",
    fill: "#D2D2D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.712,
    d: "M24.755 42.155c-1.305.125-2.61.122-3.897-.006-.517-.055-1.007-.56-1.068-1.091a19.076 19.076 0 0 1 .004-3.93c.057-.537.553-1.055 1.073-1.116a19.858 19.858 0 0 1 3.924-.046c.53.05 1.034.561 1.09 1.103.127 1.341.118 2.648-.028 3.986-.064.533-.572 1.045-1.098 1.1Z",
    fill: "#D1D1D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.727,
    d: "M24.74 42.143a19.971 19.971 0 0 1-3.888-.006c-.517-.055-1.004-.561-1.064-1.091-.134-1.313-.134-2.6.003-3.922.057-.536.55-1.051 1.07-1.112a19.733 19.733 0 0 1 3.912-.046c.53.05 1.031.561 1.086 1.103a19.308 19.308 0 0 1-.028 3.977c-.06.533-.565 1.045-1.091 1.097Z",
    fill: "#D0D0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.742,
    d: "M24.724 42.133a19.831 19.831 0 0 1-3.875-.006c-.514-.055-1-.56-1.061-1.088a18.936 18.936 0 0 1 .003-3.915c.057-.533.55-1.051 1.067-1.112a19.877 19.877 0 0 1 3.903-.046c.526.049 1.028.56 1.083 1.1a19.216 19.216 0 0 1-.028 3.967c-.06.537-.566 1.045-1.092 1.1Z",
    fill: "#CFCFD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.758,
    d: "M24.712 42.124a19.754 19.754 0 0 1-3.866-.006c-.514-.055-1-.558-1.058-1.085a18.848 18.848 0 0 1 .003-3.906c.057-.534.547-1.048 1.064-1.11a19.74 19.74 0 0 1 3.89-.045c.527.049 1.026.558 1.08 1.097a19.153 19.153 0 0 1-.027 3.961c-.06.53-.563 1.04-1.086 1.094Z",
    fill: "#CECFD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.773,
    d: "M24.697 42.112c-1.29.125-2.58.122-3.854-.006-.511-.055-.998-.558-1.056-1.085a18.992 18.992 0 0 1 .003-3.9c.058-.533.548-1.045 1.062-1.106a19.661 19.661 0 0 1 3.881-.046c.523.049 1.022.558 1.077 1.097a19.064 19.064 0 0 1-.027 3.952c-.061.533-.563 1.042-1.086 1.094Z",
    fill: "#CDCED3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.788,
    d: "M24.684 42.102a19.53 19.53 0 0 1-3.844-.006c-.511-.054-.995-.554-1.053-1.081-.13-1.304-.13-2.581.003-3.891.058-.53.548-1.046 1.059-1.103a19.534 19.534 0 0 1 3.869-.046c.523.049 1.019.557 1.074 1.094a18.97 18.97 0 0 1-.028 3.943c-.06.53-.56 1.039-1.08 1.09Z",
    fill: "#CCCDD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.803,
    d: "M24.67 42.093a19.406 19.406 0 0 1-3.833-.006c-.508-.055-.992-.554-1.05-1.078-.13-1.301-.13-2.575.003-3.885.058-.53.545-1.043 1.056-1.103a19.442 19.442 0 0 1 3.86-.046c.523.049 1.016.554 1.07 1.09a18.918 18.918 0 0 1-.027 3.938c-.06.53-.56 1.039-1.08 1.09Z",
    fill: "#CBCCD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.818,
    d: "M24.657 42.085a19.315 19.315 0 0 1-3.823-.006c-.508-.055-.989-.555-1.047-1.079-.13-1.298-.13-2.568.003-3.876.058-.53.545-1.039 1.053-1.1a19.316 19.316 0 0 1 3.848-.045c.52.049 1.012.554 1.067 1.088a18.837 18.837 0 0 1-.027 3.927c-.061.534-.557 1.036-1.074 1.091Z",
    fill: "#CACBD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.833,
    d: "M24.642 42.073a19.191 19.191 0 0 1-3.811-.006c-.505-.055-.986-.552-1.044-1.076-.13-1.295-.13-2.563.003-3.867.058-.527.542-1.039 1.05-1.097a19.233 19.233 0 0 1 3.838-.045c.52.049 1.01.551 1.065 1.087a18.75 18.75 0 0 1-.027 3.919c-.061.53-.557 1.033-1.074 1.085Z",
    fill: "#C9CAD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.849,
    d: "M24.63 42.063a19.328 19.328 0 0 1-3.802-.007c-.505-.054-.983-.551-1.04-1.072-.132-1.292-.132-2.56.002-3.86.058-.528.542-1.037 1.047-1.095a19.329 19.329 0 0 1 3.826-.045c.517.048 1.007.551 1.062 1.084a18.9 18.9 0 0 1-.028 3.913c-.06.527-.553 1.03-1.067 1.081Z",
    fill: "#C8C9CF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.864,
    d: "M24.614 42.054a19.221 19.221 0 0 1-3.79-.006c-.502-.055-.979-.551-1.037-1.07-.13-1.291-.13-2.553.003-3.85.058-.528.539-1.034 1.044-1.095a19.21 19.21 0 0 1 3.814-.045c.517.048 1.004.551 1.058 1.081a19.019 19.019 0 0 1-.027 3.903c-.058.528-.55 1.03-1.064 1.082Z",
    fill: "#C7C8CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.879,
    d: "M24.602 42.045c-1.265.122-2.53.122-3.78-.006-.502-.055-.977-.549-1.035-1.07-.13-1.289-.13-2.547.003-3.845.058-.524.539-1.03 1.044-1.091 1.259-.14 2.533-.155 3.805-.046.514.049 1 .549 1.055 1.079a18.96 18.96 0 0 1-.027 3.897c-.064.527-.554 1.027-1.065 1.082Z",
    fill: "#C6C7CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.894,
    d: "M24.587 42.033a18.99 18.99 0 0 1-3.769-.006c-.498-.054-.976-.548-1.03-1.066a18.59 18.59 0 0 1 .002-3.836c.058-.524.536-1.03 1.04-1.088a19.231 19.231 0 0 1 3.794-.046c.514.049.997.549 1.052 1.079a18.88 18.88 0 0 1-.027 3.888c-.061.524-.55 1.024-1.062 1.075Z",
    fill: "#C5C6CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.909,
    d: "M24.572 42.023a19.143 19.143 0 0 1-3.76-.006c-.498-.052-.973-.548-1.027-1.063a18.958 18.958 0 0 1 0-3.83c.057-.521.535-1.027 1.037-1.085 1.25-.14 2.518-.156 3.784-.046.51.049.994.549 1.05 1.076a18.784 18.784 0 0 1-.028 3.879c-.058.524-.545 1.023-1.056 1.075Z",
    fill: "#C4C5CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.924,
    d: "M24.56 42.014c-1.253.122-2.51.119-3.748-.006-.499-.052-.97-.545-1.025-1.063a19.103 19.103 0 0 1 0-3.821c.058-.521.533-1.024 1.034-1.085a19.024 19.024 0 0 1 3.772-.046c.511.049.995.546 1.047 1.073a18.936 18.936 0 0 1-.025 3.872c-.06.525-.547 1.024-1.055 1.076Z",
    fill: "#C3C4CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    d: "M24.545 42.006c-1.25.122-2.5.119-3.739-.006-.495-.052-.967-.546-1.022-1.06a19.027 19.027 0 0 1 0-3.816c.058-.52.533-1.023 1.032-1.081a18.928 18.928 0 0 1 3.762-.046c.508.049.992.545 1.043 1.07a18.846 18.846 0 0 1-.024 3.863c-.06.524-.544 1.021-1.052 1.076Z",
    fill: "#C2C3C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.955,
    d: "M24.532 41.993a18.805 18.805 0 0 1-3.726-.007c-.496-.051-.964-.542-1.019-1.057a18.95 18.95 0 0 1 0-3.806c.058-.518.53-1.02 1.028-1.078a18.802 18.802 0 0 1 3.75-.046c.509.049.99.545 1.044 1.07a18.764 18.764 0 0 1-.024 3.854c-.064.521-.548 1.018-1.053 1.07Z",
    fill: "#C1C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M24.517 41.983a18.706 18.706 0 0 1-3.717-.006c-.492-.051-.961-.542-1.016-1.054a18.875 18.875 0 0 1 0-3.8c.058-.518.53-1.017 1.025-1.078a18.71 18.71 0 0 1 3.742-.046c.505.049.985.542 1.04 1.066a18.707 18.707 0 0 1-.024 3.849c-.064.524-.545 1.018-1.05 1.07Z",
    fill: "#C0C1C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    d: "M24.505 41.975a18.576 18.576 0 0 1-3.705-.006c-.493-.052-.958-.542-1.013-1.054a18.801 18.801 0 0 1 0-3.79c.055-.519.526-1.019 1.022-1.076a18.59 18.59 0 0 1 3.73-.046c.504.046.982.542 1.037 1.063a18.83 18.83 0 0 1-.025 3.84c-.063.524-.544 1.017-1.046 1.07Z",
    fill: "#BFC0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.49 41.962a18.484 18.484 0 0 1-3.696-.006c-.49-.051-.955-.539-1.01-1.05a18.696 18.696 0 0 1 0-3.782c.055-.515.527-1.015 1.02-1.073a18.936 18.936 0 0 1 3.716-.046c.502.046.98.54 1.035 1.064a18.771 18.771 0 0 1-.025 3.833c-.06.518-.541 1.009-1.04 1.06Z",
    fill: "#BEBFC6"
  }))), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M24.451 42.076a19.351 19.351 0 0 1-3.872-.006c-.514-.055-1-.57-1.059-1.106a19.806 19.806 0 0 1 0-3.983c.058-.542.55-1.07 1.068-1.13a19.609 19.609 0 0 1 3.9-.05c.526.05 1.028.57 1.082 1.119a19.871 19.871 0 0 1-.027 4.034c-.064.546-.569 1.067-1.092 1.122Z",
    fill: "#B3B5BC"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M24.436 42.063a19.23 19.23 0 0 1-3.86-.006c-.511-.055-.998-.566-1.056-1.103a19.746 19.746 0 0 1 0-3.976c.058-.542.548-1.067 1.065-1.128a19.49 19.49 0 0 1 3.887-.048c.526.048 1.025.566 1.08 1.115a19.797 19.797 0 0 1-.027 4.028c-.064.546-.566 1.064-1.09 1.118Z",
    fill: "#B4B6BD"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42 42.054a19.125 19.125 0 0 1-3.851-.006c-.511-.055-.995-.567-1.053-1.103a19.656 19.656 0 0 1 0-3.967c.058-.542.548-1.064 1.062-1.128 1.28-.146 2.58-.161 3.875-.048.523.048 1.022.566 1.077 1.115a19.75 19.75 0 0 1-.027 4.022c-.061.542-.56 1.06-1.083 1.115Z",
    fill: "#B5B7BE"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M24.408 42.042c-1.283.128-2.57.125-3.838-.006-.508-.055-.992-.567-1.05-1.1a19.596 19.596 0 0 1 0-3.961c.058-.54.545-1.064 1.059-1.125a19.275 19.275 0 0 1 3.866-.048c.523.048 1.019.566 1.074 1.112.127 1.353.118 2.67-.028 4.016-.067.542-.562 1.06-1.083 1.112Z",
    fill: "#B6B8BF"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M24.393 42.033a19.12 19.12 0 0 1-3.827-.006c-.508-.055-.988-.564-1.046-1.1-.13-1.326-.13-2.62 0-3.955.058-.54.544-1.06 1.056-1.122a19.154 19.154 0 0 1 3.853-.048c.52.048 1.016.566 1.071 1.112.128 1.35.119 2.666-.027 4.01-.064.54-.563 1.054-1.08 1.109Z",
    fill: "#B7B9C0"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M24.378 42.02a19.013 19.013 0 0 1-3.818-.005c-.505-.055-.988-.564-1.043-1.097a19.92 19.92 0 0 1 0-3.95c.058-.538.541-1.06 1.053-1.12a19.036 19.036 0 0 1 3.841-.05c.52.05 1.013.564 1.068 1.11.128 1.347.119 2.66-.027 4-.061.546-.557 1.061-1.074 1.113Z",
    fill: "#B8BAC1"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M24.362 42.012a18.907 18.907 0 0 1-3.806-.006c-.505-.055-.985-.564-1.04-1.094-.13-1.32-.13-2.615 0-3.943.058-.54.542-1.058 1.05-1.119a18.917 18.917 0 0 1 3.83-.048c.516.048 1.009.563 1.064 1.106a19.697 19.697 0 0 1-.025 3.995c-.063.542-.556 1.054-1.073 1.109Z",
    fill: "#B8BAC2"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M24.35 42.003c-1.268.125-2.54.125-3.793-.006-.505-.055-.982-.56-1.037-1.094-.13-1.32-.13-2.608 0-3.937.058-.536.538-1.057 1.046-1.118a18.825 18.825 0 0 1 3.82-.046c.518.05 1.008.564 1.062 1.106.125 1.344.119 2.651-.024 3.989-.067.54-.56 1.051-1.074 1.106Z",
    fill: "#B9BBC3"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M24.334 41.99a18.696 18.696 0 0 1-3.784-.005c-.502-.055-.98-.56-1.034-1.091a19.737 19.737 0 0 1 0-3.93c.058-.537.539-1.055 1.043-1.116a18.708 18.708 0 0 1 3.809-.046c.514.05 1.004.561 1.058 1.103.125 1.341.119 2.648-.024 3.983-.064.54-.557 1.051-1.068 1.103Z",
    fill: "#BABCC4"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M24.319 41.982a18.57 18.57 0 0 1-3.772-.006c-.502-.055-.976-.561-1.03-1.091-.132-1.313-.132-2.6 0-3.925.057-.536.534-1.051 1.04-1.112a18.588 18.588 0 0 1 3.796-.046c.513.05 1 .561 1.055 1.103a19.962 19.962 0 0 1-.024 3.977c-.064.533-.554 1.045-1.065 1.1Z",
    fill: "#BBBDC5"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M24.304 41.97c-1.26.124-2.519.121-3.76-.007-.499-.055-.973-.56-1.028-1.088a19.584 19.584 0 0 1 0-3.915c.058-.533.535-1.051 1.037-1.112a18.722 18.722 0 0 1 3.787-.046c.511.049.998.56 1.053 1.1a19.867 19.867 0 0 1-.025 3.967c-.066.537-.553 1.048-1.064 1.1Z",
    fill: "#BCBEC6"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M24.292 41.96c-1.254.125-2.51.122-3.75-.006-.5-.055-.971-.558-1.026-1.088-.13-1.31-.13-2.593 0-3.91.058-.532.532-1.047 1.034-1.108a18.6 18.6 0 0 1 3.775-.046c.511.049.995.558 1.05 1.097a19.814 19.814 0 0 1-.025 3.961c-.064.536-.55 1.045-1.058 1.1Z",
    fill: "#BDBFC7"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M24.277 41.95c-1.25.126-2.503.123-3.738-.005-.496-.055-.968-.558-1.022-1.085a19.933 19.933 0 0 1 0-3.903c.058-.534.532-1.048 1.03-1.106a18.475 18.475 0 0 1 3.764-.046c.508.049.991.558 1.046 1.097.125 1.331.116 2.63-.024 3.955-.064.53-.551 1.039-1.056 1.094Z",
    fill: "#BEC0C8"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M24.262 41.939a18.346 18.346 0 0 1-3.726-.006c-.496-.055-.965-.558-1.02-1.082a19.87 19.87 0 0 1 0-3.897c.059-.533.53-1.045 1.029-1.106a18.392 18.392 0 0 1 3.753-.046c.508.049.989.558 1.044 1.094a19.695 19.695 0 0 1-.025 3.949c-.067.533-.55 1.042-1.055 1.094Z",
    fill: "#BFC1C9"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M24.247 41.93a18.476 18.476 0 0 1-3.717-.004c-.493-.054-.962-.554-1.016-1.081a19.793 19.793 0 0 1 0-3.891c.058-.53.53-1.045 1.025-1.103a18.267 18.267 0 0 1 3.741-.046c.505.049.986.554 1.04 1.094.125 1.328.116 2.62-.024 3.94-.064.53-.544 1.036-1.05 1.09Z",
    fill: "#C0C2CA"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M24.235 41.917a18.355 18.355 0 0 1-3.705-.003c-.493-.054-.958-.554-1.016-1.078a19.731 19.731 0 0 1 0-3.885c.055-.53.526-1.042 1.022-1.103a18.157 18.157 0 0 1 3.729-.046c.505.049.982.555 1.037 1.09a19.534 19.534 0 0 1-.024 3.935c-.06.533-.541 1.039-1.043 1.09Z",
    fill: "#C1C3CB"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M24.22 41.908a18.234 18.234 0 0 1-3.693-.003c-.49-.055-.955-.554-1.013-1.078a19.67 19.67 0 0 1 0-3.88c.055-.53.523-1.038 1.019-1.1a18.038 18.038 0 0 1 3.717-.045c.502.049.98.555 1.034 1.088a19.704 19.704 0 0 1-.024 3.928c-.061.533-.542 1.035-1.04 1.09Z",
    fill: "#C2C4CC"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M24.203 41.899a18.152 18.152 0 0 1-3.683-.003c-.49-.055-.952-.552-1.01-1.076a19.578 19.578 0 0 1 0-3.87c.055-.527.523-1.039 1.016-1.096a17.94 17.94 0 0 1 3.708-.046c.502.049.976.554 1.03 1.088.123 1.32.117 2.605-.023 3.921-.061.524-.539 1.027-1.038 1.082Z",
    fill: "#C2C4CC"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M24.19 41.887a18.025 18.025 0 0 1-3.672-.003c-.487-.055-.95-.552-1.007-1.073a19.516 19.516 0 0 1 0-3.863c.055-.528.52-1.036 1.013-1.097a17.826 17.826 0 0 1 3.695-.046c.5.049.974.551 1.029 1.085.121 1.32.112 2.602-.025 3.915-.06.524-.535 1.03-1.034 1.082Z",
    fill: "#C3C5CD"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M24.177 41.878a17.936 17.936 0 0 1-3.662-.003c-.487-.055-.946-.552-1.004-1.073a19.455 19.455 0 0 1 0-3.858c.055-.527.52-1.036 1.01-1.093 1.22-.14 2.454-.159 3.683-.046.5.049.97.551 1.022 1.082.122 1.316.113 2.599-.024 3.906-.055.527-.53 1.03-1.025 1.085Z",
    fill: "#C4C6CE"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M24.161 41.865c-1.22.125-2.442.122-3.65-.003-.483-.055-.943-.548-1-1.07a19.873 19.873 0 0 1 0-3.85c.054-.525.517-1.034 1.006-1.095a18.056 18.056 0 0 1 3.675-.045c.496.048.967.551 1.019 1.081a19.663 19.663 0 0 1-.024 3.9c-.058.528-.533 1.03-1.026 1.082Z",
    fill: "#C5C7CF"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M24.146 41.856a17.92 17.92 0 0 1-3.638-.003c-.483-.052-.943-.548-.997-1.07a19.81 19.81 0 0 1 0-3.845c.054-.524.517-1.03 1.003-1.09 1.21-.14 2.44-.156 3.663-.046.495.048.964.548 1.015 1.078.122 1.31.113 2.59-.024 3.895-.058.527-.53 1.03-1.022 1.081Z",
    fill: "#C6C8D0"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M24.131 41.844a17.83 17.83 0 0 1-3.629-.003c-.48-.052-.94-.549-.994-1.066a19.748 19.748 0 0 1 0-3.84c.054-.524.514-1.03 1-1.088a17.82 17.82 0 0 1 3.65-.045c.493.048.962.548 1.013 1.078a19.54 19.54 0 0 1-.024 3.888c-.052.524-.523 1.024-1.016 1.076Z",
    fill: "#C7C9D1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M24.119 41.835c-1.21.122-2.421.122-3.617-.003-.48-.052-.937-.549-.991-1.064a19.685 19.685 0 0 1 0-3.833c.054-.524.514-1.027.997-1.088a17.73 17.73 0 0 1 3.641-.045c.493.048.958.548 1.01 1.075a19.48 19.48 0 0 1-.024 3.882c-.058.524-.527 1.024-1.016 1.076Z",
    fill: "#C8CAD2"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M24.104 41.826a17.6 17.6 0 0 1-3.605-.003c-.477-.052-.934-.546-.988-1.064a19.623 19.623 0 0 1 0-3.827c.054-.52.51-1.027.994-1.085a17.612 17.612 0 0 1 3.629-.045c.49.048.955.545 1.007 1.072a19.606 19.606 0 0 1-.024 3.873c-.058.527-.527 1.024-1.013 1.079Z",
    fill: "#C9CBD3"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M24.088 41.814a17.498 17.498 0 0 1-3.595-.004c-.477-.051-.93-.545-.985-1.06a19.53 19.53 0 0 1 0-3.818c.054-.52.51-1.024.991-1.085 1.196-.14 2.41-.155 3.617-.045.49.048.952.545 1.004 1.072a19.552 19.552 0 0 1-.025 3.867c-.054.524-.52 1.02-1.006 1.073Z",
    fill: "#CACCD4"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M24.073 41.804a17.387 17.387 0 0 1-3.583-.003c-.474-.051-.928-.545-.982-1.06a19.467 19.467 0 0 1 0-3.812c.054-.52.508-1.024.988-1.082 1.193-.14 2.4-.155 3.605-.045.486.048.949.545 1 1.07a19.5 19.5 0 0 1-.024 3.86c-.052.524-.517 1.02-1.004 1.072Z",
    fill: "#CBCDD5"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M24.061 41.792c-1.195.122-2.39.122-3.571-.003-.474-.052-.925-.542-.98-1.057a19.405 19.405 0 0 1 0-3.806c.055-.518.508-1.02.986-1.079 1.19-.14 2.394-.155 3.595-.045.487.048.946.542.998 1.07a19.423 19.423 0 0 1-.024 3.854c-.058.518-.52 1.014-1.004 1.066Z",
    fill: "#CCCED6"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M24.046 41.783c-1.19.122-2.382.122-3.562-.003-.472-.052-.922-.542-.977-1.054a19.818 19.818 0 0 1 0-3.8c.055-.518.505-1.018.983-1.079a17.173 17.173 0 0 1 3.583-.045c.484.048.943.542.995 1.066.118 1.295.11 2.557-.025 3.849-.055.518-.517 1.014-.997 1.066Z",
    fill: "#CCCED7"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M24.03 41.774a17.065 17.065 0 0 1-3.55-.003c-.47-.051-.918-.542-.973-1.054a19.754 19.754 0 0 1 0-3.794c.055-.517.505-1.017.98-1.075a16.852 16.852 0 0 1 3.57-.043c.484.049.94.543.992 1.064.119 1.292.11 2.553-.024 3.839-.055.518-.514 1.012-.995 1.066Z",
    fill: "#CDCFD8"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M24.015 41.762c-1.183.122-2.37.122-3.537-.003-.469-.052-.916-.54-.97-1.051a19.691 19.691 0 0 1 0-3.788c.054-.518.501-1.014.976-1.072a17.173 17.173 0 0 1 3.562-.043c.48.046.936.542.988 1.063.119 1.292.11 2.548-.024 3.834-.055.515-.514 1.008-.995 1.06Z",
    fill: "#CED0D9"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M24.003 41.753c-1.18.122-2.36.119-3.529-.003-.468-.052-.912-.54-.967-1.051a19.628 19.628 0 0 1 0-3.782c.055-.515.502-1.014.974-1.072a17.052 17.052 0 0 1 3.55-.043c.48.046.933.54.985 1.06.119 1.29.11 2.545-.024 3.828-.055.518-.511 1.011-.989 1.063Z",
    fill: "#CFD1DA"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M23.988 41.74a16.95 16.95 0 0 1-3.517-.003c-.465-.051-.909-.539-.964-1.048a19.534 19.534 0 0 1 0-3.772c.055-.515.5-1.011.97-1.07a16.945 16.945 0 0 1 3.538-.042c.478.046.93.54.983 1.06.115 1.286.11 2.538-.022 3.821-.057.512-.514 1.003-.988 1.055Z",
    fill: "#D0D2DB"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M23.973 41.731a16.833 16.833 0 0 1-3.505-.003c-.465-.051-.906-.536-.96-1.045a19.47 19.47 0 0 1 0-3.766c.051-.515.498-1.011.966-1.07a16.856 16.856 0 0 1 3.529-.042c.478.046.928.54.98 1.057.115 1.283.109 2.535-.022 3.815-.06.512-.514 1.003-.988 1.054Z",
    fill: "#D1D3DC"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M71.843 26.704a.743.743 0 0 0-.65-.738 26.78 26.78 0 0 0-6.61 0 .743.743 0 0 0-.651.738v4.582h7.914v-4.582h-.003Z",
    fill: "#F2919F"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M71.667 26.712a.735.735 0 0 0-.636-.734 25.252 25.252 0 0 0-3.315-.207 25.037 25.037 0 0 0-3.149.204.738.738 0 0 0-.635.737v4.568h7.738v-4.568h-.003Z",
    fill: "#F292A0"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M71.49 26.722a.731.731 0 0 0-.62-.731 23.17 23.17 0 0 0-3.24-.207c-1.125.003-2.16.082-3.078.2-.356.046-.62.366-.62.741v4.552h7.558v-4.555Z",
    fill: "#F293A0"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M71.314 26.73a.725.725 0 0 0-.608-.728 23.456 23.456 0 0 0-6.169-.012c-.347.046-.605.369-.605.74v4.538h7.382V26.73Z",
    fill: "#F394A1"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M71.138 26.74c0-.368-.256-.676-.594-.725a21.007 21.007 0 0 0-3.087-.21c-1.074.003-2.06.076-2.935.195-.338.046-.59.372-.59.74v4.525h7.206V26.74Z",
    fill: "#F395A2"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M70.958 26.75c0-.366-.25-.67-.578-.72a19.977 19.977 0 0 0-3.011-.213c-1.046.003-2.01.077-2.865.192-.332.046-.575.375-.575.74v4.51h7.03v-4.51Z",
    fill: "#F396A2"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M70.782 26.758c0-.366-.243-.668-.563-.716a18.616 18.616 0 0 0-2.935-.214 20.917 20.917 0 0 0-2.796.19c-.322.045-.56.374-.56.74v4.494h6.854v-4.494Z",
    fill: "#F397A3"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M70.605 26.767c0-.362-.237-.66-.547-.713-.849-.14-1.807-.219-2.86-.213a19.82 19.82 0 0 0-2.722.186c-.313.046-.544.378-.544.74v4.48h6.673v-4.48Z",
    fill: "#F398A4"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M70.429 26.777c0-.36-.231-.658-.535-.71-.825-.14-1.759-.22-2.784-.216a18.87 18.87 0 0 0-2.652.186c-.307.045-.53.38-.53.74v4.464h6.498v-4.464h.003Z",
    fill: "#F499A4"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M70.252 26.783c0-.36-.225-.655-.52-.707a14.954 14.954 0 0 0-2.707-.216c-.94.003-1.813.067-2.582.183-.298.045-.514.38-.514.74v4.452h6.32v-4.452h.004Z",
    fill: "#F49AA5"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M70.076 26.793c0-.357-.219-.65-.505-.704a14.11 14.11 0 0 0-2.63-.22c-.916.003-1.765.064-2.513.18-.29.046-.5.384-.5.74v4.437h6.145v-4.433h.003Z",
    fill: "#F49BA6"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M69.897 26.801c0-.356-.213-.646-.49-.698a13.327 13.327 0 0 0-2.555-.22 16.43 16.43 0 0 0-2.44.178c-.28.042-.483.387-.483.743v4.418h5.968v-4.421Z",
    fill: "#F49CA6"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M69.72 26.81c0-.354-.207-.643-.474-.695a12.296 12.296 0 0 0-2.476-.222c-.861.003-1.667.06-2.37.173-.274.043-.468.387-.468.744v4.406h5.791V26.81h-.003Z",
    fill: "#F49DA7"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M69.544 26.82c0-.35-.2-.637-.462-.692a11.568 11.568 0 0 0-2.4-.223c-.837.003-1.616.058-2.3.171-.265.043-.453.39-.453.744v4.39h5.612v-4.39h.003Z",
    fill: "#F59DA8"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M69.367 26.83c0-.351-.194-.634-.447-.69a10.47 10.47 0 0 0-2.324-.222c-.809.003-1.566.058-2.226.17-.256.044-.438.394-.438.744v4.379h5.435v-4.382Z",
    fill: "#F59EA9"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M69.19 26.838c0-.347-.188-.628-.431-.686-.666-.155-1.42-.228-2.248-.225-.782.003-1.518.055-2.157.167-.246.043-.42.397-.42.744V31.2h5.26v-4.363h-.003Z",
    fill: "#F59FA9"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M69.011 26.847c0-.348-.182-.625-.416-.683a8.993 8.993 0 0 0-2.172-.225c-.758.003-1.47.052-2.087.164-.24.043-.404.396-.404.744v4.348h5.082v-4.348h-.003Z",
    fill: "#F5A0AA"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M68.835 26.855c0-.344-.176-.621-.404-.676-.621-.159-1.324-.232-2.096-.229-.73.003-1.42.052-2.017.162-.231.042-.39.399-.39.743v4.333h4.907v-4.333Z",
    fill: "#F5A1AB"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M68.659 26.865c0-.341-.17-.616-.39-.673-.596-.162-1.274-.232-2.02-.229-.702.003-1.368.049-1.943.158-.222.043-.374.403-.374.744v4.318h4.727v-4.318Z",
    fill: "#F6A2AB"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M68.482 26.875c0-.342-.164-.613-.374-.67-.575-.162-1.226-.235-1.944-.232-.678.003-1.32.046-1.873.155-.213.043-.36.402-.36.744v4.305h4.551v-4.302Z",
    fill: "#F6A3AC"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M68.306 26.883c0-.338-.159-.61-.36-.667-.55-.165-1.18-.235-1.867-.232-.65.003-1.271.046-1.804.153-.207.043-.343.405-.343.746v4.29h4.374v-4.29Z",
    fill: "#F6A4AD"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M68.13 26.89c0-.339-.156-.604-.345-.665-.529-.165-1.131-.238-1.791-.235-.624.003-1.223.043-1.73.153-.199.042-.33.408-.33.746v4.275h4.198V26.89h-.003Z",
    fill: "#F6A5AD"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M67.95 26.898c0-.335-.15-.6-.332-.661-.505-.168-1.082-.238-1.715-.235-.6.003-1.174.043-1.661.15-.189.042-.313.41-.313.746v4.26h4.02v-4.26Z",
    fill: "#F6A6AE"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M67.773 26.908c0-.335-.142-.595-.316-.655-.483-.171-1.034-.241-1.64-.235-.571.003-1.122.04-1.59.146-.18.043-.298.412-.298.747v4.244h3.844v-4.247Z",
    fill: "#F7A7AF"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M67.597 26.917c0-.332-.137-.59-.301-.652-.46-.17-.986-.24-1.564-.238-.544.003-1.073.037-1.52.144-.174.04-.283.414-.283.746v4.23h3.665v-4.23h.003Z",
    fill: "#F7A8AF"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M67.42 26.926c0-.33-.13-.588-.285-.65-.438-.173-.937-.24-1.488-.237-.52.003-1.025.037-1.448.14-.164.04-.267.418-.267.747v4.217h3.489v-4.217Z",
    fill: "#F7A9B0"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M71.844 26.704a.743.743 0 0 0-.65-.738 26.78 26.78 0 0 0-6.61 0 .743.743 0 0 0-.651.738v4.582h7.914v-4.582h-.003Z",
    fill: "url(#c)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M71.859 30.565c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.015,
    d: "M71.859 30.568c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E8F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.023,
    d: "M71.859 30.572c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.031,
    d: "M71.859 30.574c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M71.859 30.578c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976a72.17 72.17 0 0 0-.018-1.158Z",
    fill: "#F4E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.046,
    d: "M71.859 30.578c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E7F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.054,
    d: "M71.859 30.581c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E7F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.062,
    d: "M71.859 30.584c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E7F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "M71.859 30.587c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F4E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.077,
    d: "M71.859 30.59c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F4E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.085,
    d: "M71.859 30.59c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E6EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.092,
    d: "M71.859 30.594c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F4E6EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M71.859 30.596c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E6ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.108,
    d: "M71.859 30.6c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.157Z",
    fill: "#F3E5EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.115,
    d: "M71.859 30.6c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.157Z",
    fill: "#F3E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.123,
    d: "M71.859 30.602c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.131,
    d: "M71.859 30.605c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "M71.859 30.608c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.146,
    d: "M71.859 30.611c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976a72.17 72.17 0 0 0-.018-1.158Z",
    fill: "#F3E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.154,
    d: "M71.859 30.611c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.162,
    d: "M71.859 30.614c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.169,
    d: "M71.859 30.617c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.177,
    d: "M71.859 30.621c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M71.859 30.623c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.771-.016 1.158h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M71.859 30.623c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.771-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E3E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.859 30.626c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E2E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "M71.859 30.63c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E2DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.215,
    d: "M71.859 30.633c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F3E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.223,
    d: "M71.859 30.633c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E2DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.231,
    d: "M71.859 30.636c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E1DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.238,
    d: "M71.859 30.639c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E1DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.246,
    d: "M71.859 30.642c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.386-.01-.773-.018-1.157Z",
    fill: "#F3E1DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.254,
    d: "M71.859 30.645c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.202-.007.387-.013.771-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F3E1D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.262,
    d: "M71.859 30.645c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.202-.007.387-.013.771-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E0D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.269,
    d: "M71.859 30.648c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.157Z",
    fill: "#F3E0D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.277,
    d: "M71.859 30.651c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F3E0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.285,
    d: "M71.859 30.653c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F3E0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "M71.859 30.657c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F3DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.859 30.657c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.308,
    d: "M71.859 30.66c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315,
    d: "M71.859 30.663c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DFD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.323,
    d: "M71.859 30.666c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F2DED0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.331,
    d: "M71.859 30.666c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DECF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.339,
    d: "M71.859 30.669c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.346,
    d: "M71.859 30.673c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DECD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.354,
    d: "M71.859 30.675c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DDCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "M71.859 30.679c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F2DDCB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.369,
    d: "M71.859 30.679c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.377,
    d: "M71.859 30.682c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DDC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.385,
    d: "M71.859 30.685c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DCC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.392,
    d: "M71.859 30.688c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.157Z",
    fill: "#F2DCC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.859 30.69c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F2DCC6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.408,
    d: "M71.859 30.69c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DCC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.415,
    d: "M71.859 30.693c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DBC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.423,
    d: "M71.859 30.696c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DBC3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M71.859 30.7c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F2DBC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M71.859 30.7c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DBC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.446,
    d: "M71.859 30.703c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.454,
    d: "M71.859 30.706c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DABF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.462,
    d: "M71.859 30.709c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2DABE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.469,
    d: "M71.859 30.71c-1.211.126-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976a72.17 72.17 0 0 0-.018-1.158Z",
    fill: "#F2DABD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.477,
    d: "M71.859 30.71c-1.211.126-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2D9BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.485,
    d: "M71.859 30.716c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2D9BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.492,
    d: "M71.859 30.718c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F2D9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.859 30.722c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F2D9B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.508,
    d: "M71.859 30.724c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.39-.01-.776-.018-1.157Z",
    fill: "#F1D8B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.515,
    d: "M71.859 30.724c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.387-.01-.773-.018-1.157Z",
    fill: "#F1D8B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.523,
    d: "M71.859 30.727c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.157Z",
    fill: "#F1D8B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.531,
    d: "M71.859 30.73c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D7B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.538,
    d: "M71.859 30.733c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F1D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.546,
    d: "M71.859 30.733c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D7B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.554,
    d: "M71.859 30.736c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D7B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M71.859 30.74c-1.211.124-2.552.203-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M71.859 30.742c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D6B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.577,
    d: "M71.859 30.745c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F1D6AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.585,
    d: "M71.859 30.745c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D6AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.592,
    d: "M71.859 30.748c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D5AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M71.859 30.752c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D5AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.608,
    d: "M71.859 30.755c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F1D5AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M71.859 30.758c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F1D5AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.623,
    d: "M71.859 30.758c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.631,
    d: "M71.859 30.76c-1.211.126-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D4A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.638,
    d: "M71.859 30.764c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D4A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.646,
    d: "M71.859 30.767c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.39-.01-.773-.018-1.157Z",
    fill: "#F1D4A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.654,
    d: "M71.859 30.767c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.386-.01-.773-.018-1.157Z",
    fill: "#F1D3A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.661,
    d: "M71.859 30.77c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.387-.01-.773-.018-1.157Z",
    fill: "#F1D3A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.669,
    d: "M71.859 30.773c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D3A3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    d: "M71.859 30.775c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.202-.007.387-.013.771-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D3A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.685,
    d: "M71.859 30.78c-1.211.124-2.552.203-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F1D2A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.692,
    d: "M71.859 30.78c-1.211.124-2.552.203-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D2A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.859 30.781c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F1D29F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "M71.859 30.785c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D29E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.715,
    d: "M71.859 30.788c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F0D19D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.723,
    d: "M71.859 30.791c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F0D19C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.731,
    d: "M71.859 30.791c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D19B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.739,
    d: "M71.859 30.794c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D19A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.746,
    d: "M71.859 30.797c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.754,
    d: "M71.859 30.8c-1.211.126-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F0D098"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    d: "M71.859 30.8c-1.211.126-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D097"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.769,
    d: "M71.859 30.803c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0D096"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.777,
    d: "M71.859 30.806c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.386-.01-.773-.018-1.157Z",
    fill: "#F0CF95"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.785,
    d: "M71.859 30.81c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CF94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "M71.859 30.813c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.157Z",
    fill: "#F0CF93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.859 30.813c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.387-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.157Z",
    fill: "#F0CF92"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M71.859 30.815c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CE91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M71.859 30.818c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CE90"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.823,
    d: "M71.859 30.821c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F0CE8F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.831,
    d: "M71.859 30.825c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#F0CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.839,
    d: "M71.859 30.825c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CD8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M71.859 30.827c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CD8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.854,
    d: "M71.859 30.831c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CD8B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.862,
    d: "M71.859 30.833c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F0CD8A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.869,
    d: "M71.859 30.833c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CC89"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.877,
    d: "M71.859 30.837c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CC88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.885,
    d: "M71.859 30.84c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CC87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.892,
    d: "M71.859 30.843c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#F0CC86"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M71.859 30.846c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#F0CB85"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.908,
    d: "M71.859 30.846c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFCB84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.915,
    d: "M71.859 30.849c-1.211.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFCB83"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.923,
    d: "M71.859 30.852c-1.211.125-2.552.205-4.006.202-1.427 0-2.744-.08-3.936-.201-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.773-.018-1.157Z",
    fill: "#EFCB82"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "M71.859 30.855c-1.211.124-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.157Z",
    fill: "#EFCA81"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    d: "M71.859 30.858c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.777-.018-1.158Z",
    fill: "#EFCA80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.946,
    d: "M71.859 30.858c-1.211.125-2.552.205-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFCA7F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    d: "M71.859 30.861c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFCA7E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.962,
    d: "M71.859 30.864c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFC97D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    d: "M71.859 30.867c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.39-.01-.774-.018-1.158Z",
    fill: "#EFC97C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    d: "M71.859 30.867c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFC97B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    d: "M71.859 30.87c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.079-3.936-.2-.007.386-.013.77-.016 1.157h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFC97A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    d: "M71.859 30.873c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.771-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFC879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.859 30.876c-1.211.125-2.552.204-4.006.201-1.427 0-2.744-.08-3.936-.201-.007.387-.013.77-.016 1.158h7.976c-.003-.387-.01-.774-.018-1.158Z",
    fill: "#EFC878"
  }))), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "m67.907 64.996-1.925-3.364-1.925-3.367v-.926H71.7v.926l-1.898 3.367-1.895 3.364Z",
    fill: "#F2CBCD"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.345h7.455v.892l-1.81 3.243c0 .018-.645 1.17-.654 1.185-.009.012-.608 1.06-.623 1.063-.016.003-.615 1.042-.63 1.036a116.05 116.05 0 0 1-1-1.715l-.898-1.57-1.837-3.242v-.892h-.003Z",
    fill: "#F2CCCE"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.348h7.263v.856l-1.724 3.12c.003.04-.618 1.152-.64 1.18-.017.024-.601 1.03-.632 1.038-.03.01-.617.997-.648.988-.03-.01-.973-1.634-.991-1.667l-.88-1.539-1.748-3.12v-.856Z",
    fill: "#F2CDCF"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.355H71.129v.822l-1.637 2.998c.003.058-.593 1.134-.62 1.17-.028.037-.6 1.003-.642 1.015-.046.012-.62.95-.666.936-.046-.016-.955-1.57-.983-1.618l-.86-1.506-1.661-2.998v-.82h-.003Z",
    fill: "#F3CED0"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.357h6.886v.787l-1.551 2.876c.003.076-.566 1.115-.605 1.164-.037.049-.594.975-.651.993-.058.019-.624.908-.685.887-.057-.021-.937-1.505-.976-1.572l-.843-1.472-1.575-2.876v-.787Z",
    fill: "#F3CFD1"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.362h6.695v.753l-1.466 2.755c.006.094-.542 1.096-.588 1.157-.048.064-.587.948-.663.97-.073.02-.626.862-.702.834-.073-.027-.919-1.441-.968-1.523l-.824-1.438-1.487-2.755v-.753h.003Z",
    fill: "#F3D0D2"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.366H70.566v.72l-1.378 2.632c.006.116-.514 1.079-.572 1.152-.058.076-.584.92-.672.944-.088.028-.63.817-.72.786-.092-.03-.904-1.377-.959-1.474l-.806-1.408-1.4-2.633v-.719h-.002Z",
    fill: "#F3D1D3"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.373h6.314v.683l-1.292 2.51c.006.134-.49 1.058-.557 1.146-.067.088-.578.89-.681.92-.104.03-.633.771-.736.735-.104-.037-.886-1.314-.953-1.43l-.784-1.374-1.311-2.51v-.68Z",
    fill: "#F4D2D4"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.375h6.129v.649l-1.208 2.389c.01.152-.462 1.039-.538 1.14-.076.1-.575.862-.69.898-.12.037-.636.726-.755.683-.119-.043-.867-1.25-.943-1.38l-.767-1.341-1.225-2.389v-.649h-.003Z",
    fill: "#F4D3D5"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.382h5.937v.612l-1.12 2.267c.01.17-.437 1.021-.522 1.134-.086.112-.57.835-.703.874-.134.04-.639.683-.773.634-.133-.049-.848-1.185-.934-1.331l-.748-1.308-1.137-2.267v-.615Z",
    fill: "#F4D4D6"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.384H69.809v.579l-1.035 2.142c.01.192-.41 1.002-.505 1.127-.094.125-.562.808-.711.85-.15.043-.642.637-.791.582-.15-.052-.834-1.118-.928-1.285l-.73-1.277-1.05-2.145v-.573h-.002Z",
    fill: "#F4D5D7"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.39h5.56v.546l-.949 2.02c.012.21-.386.984-.49 1.122-.103.137-.56.78-.72.825-.162.046-.645.591-.81.534-.161-.058-.815-1.055-.918-1.238l-.712-1.243-.961-2.02v-.545Z",
    fill: "#F4D6D8"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.394h5.368v.508l-.86 1.899c.012.228-.36.966-.472 1.115-.112.15-.553.75-.73.804-.176.052-.648.546-.827.482-.177-.064-.797-.99-.91-1.192l-.693-1.21-.876-1.898v-.508Z",
    fill: "#F5D6D8"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.397H69.24v.475l-.776 1.776c.015.247-.331.945-.456 1.11-.125.164-.55.721-.742.78-.192.057-.651.5-.843.432-.192-.07-.779-.926-.903-1.142l-.675-1.177-.788-1.776v-.478Z",
    fill: "#F5D7D9"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.403h4.991v.442l-.69 1.655c.015.268-.308.926-.441 1.103-.134.176-.545.694-.752.755-.207.061-.654.458-.86.381-.207-.073-.76-.862-.895-1.094l-.654-1.145-.7-1.655v-.442Z",
    fill: "#F5D8DA"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.405h4.806v.405l-.603 1.533c.016.287-.28.908-.422 1.097-.143.19-.539.667-.76.731-.223.068-.658.412-.88.333-.222-.08-.745-.799-.888-1.049l-.636-1.112-.611-1.533v-.405h-.006Z",
    fill: "#F5D9DB"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.412H68.668v.372l-.517 1.41c.018.305-.256.89-.408 1.091-.152.202-.535.64-.77.71-.237.07-.66.366-.897.28-.237-.084-.727-.734-.879-.999l-.614-1.081-.526-1.411v-.372Z",
    fill: "#F6DADC"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.415h4.425v.335l-.431 1.29c.018.322-.229.87-.39 1.08-.161.211-.53.61-.782.686-.252.074-.663.32-.915.232-.253-.091-.709-.67-.87-.95l-.6-1.046-.437-1.289v-.338Z",
    fill: "#F6DBDD"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.42h4.234v.303l-.344 1.167c.018.344-.204.85-.374 1.075-.17.226-.523.582-.79.661-.266.08-.667.275-.935.18-.264-.094-.69-.606-.864-.905l-.58-1.015-.35-1.167v-.298h.003Z",
    fill: "#F6DCDE"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.425h4.048v.268l-.258 1.045c.021.363-.177.832-.356 1.07-.18.237-.52.554-.8.636-.28.083-.67.232-.952.128-.28-.1-.675-.542-.855-.856l-.563-.981-.261-1.045v-.265h-.003Z",
    fill: "#F6DDDF"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.43H67.914v.232l-.174.924c.022.38-.152.813-.34 1.063-.189.25-.515.527-.81.612-.295.089-.672.186-.967.08-.295-.107-.657-.479-.846-.808l-.544-.947-.176-.924v-.231Z",
    fill: "#F7DEE0"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M64.057 57.434h3.665v.198l-.085.801c.021.402-.125.795-.326 1.057-.2.262-.51.497-.82.591-.311.092-.676.14-.986.028-.31-.113-.64-.415-.84-.762l-.523-.914-.088-.801v-.198h.003Z",
    fill: "#F7DFE1"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "m64.564 59.161-.504-.883v-.841h3.48v.84a1.55 1.55 0 0 1-.308 1.052c-.21.274-.505.469-.83.566a1.616 1.616 0 0 1-1.004-.02 1.538 1.538 0 0 1-.834-.714Z",
    fill: "#F7E0E2"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M67.57 58.265c-.195.076-.462.262-.834.356-.66.168-1.22.226-1.828.068a2.395 2.395 0 0 1-.851-.424V39.291h3.513v18.974Z",
    fill: "#FFD982"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M67.524 58.268c-.195.082-.456.256-.821.35-.651.168-1.205.22-1.804.061a2.372 2.372 0 0 1-.84-.42V39.29h3.468l-.003 18.977Z",
    fill: "#FFD983"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M67.479 58.274c-.198.085-.448.25-.81.344-.641.165-1.192.21-1.782.055a2.33 2.33 0 0 1-.83-.417V39.29h3.425l-.003 18.983Z",
    fill: "#FFD884"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M67.436 58.28c-.198.092-.441.244-.797.338-.636.165-1.177.202-1.761.05a2.255 2.255 0 0 1-.818-.415V39.29h3.379l-.003 18.99Z",
    fill: "#FFD885"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M67.39 58.286c-.197.095-.435.241-.787.332-.627.162-1.162.195-1.737.04a2.192 2.192 0 0 1-.81-.411V39.29h3.338l-.004 18.995Z",
    fill: "#FFD885"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M67.345 58.293c-.198.1-.426.234-.776.323-.617.161-1.147.185-1.715.033a2.17 2.17 0 0 1-.797-.408V39.288h3.29l-.002 19.005Z",
    fill: "#FFD886"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3 58.299c-.201.106-.42.228-.764.316-.609.162-1.132.177-1.695.028a2.184 2.184 0 0 1-.787-.402V39.29h3.245v19.008Z",
    fill: "#FFD787"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M67.257 58.304c-.201.11-.414.223-.752.311-.602.159-1.116.171-1.67.022a2.161 2.161 0 0 1-.775-.4V39.294h3.2l-.004 19.01Z",
    fill: "#FFD788"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M67.567 58.268c.192.082.487.192.864.277.508.116 1.153.262 1.859.019.188-.064.48-.192.797-.457-.003-6.271-.003-12.542-.006-18.816h-3.514v18.977Z",
    fill: "#FFD982"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M67.583 58.268c.192.082.487.192.858.277.505.116 1.147.262 1.85.018.188-.063.48-.191.793-.457-.003-6.27-.003-12.541-.006-18.812h-3.495v18.974Z",
    fill: "#FED881"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M67.595 58.265c.188.082.483.192.855.277.504.116 1.143.262 1.84.019a2.44 2.44 0 0 0 .79-.458c-.002-6.27-.002-12.541-.005-18.812h-3.48v18.974Z",
    fill: "#FDD781"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M67.61 58.265c.189.082.481.192.852.277.502.116 1.138.262 1.834.018.186-.064.475-.192.788-.457l-.006-18.81h-3.465v18.972h-.003Z",
    fill: "#FCD680"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M67.625 58.265c.189.082.478.192.846.277.498.116 1.131.262 1.825.018.185-.064.474-.192.784-.457l-.006-18.81h-3.449v18.972Z",
    fill: "#FBD580"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M67.638 58.265c.185.082.477.192.842.277.496.116 1.126.262 1.816.018a2.38 2.38 0 0 0 .779-.457l-.006-18.81h-3.434v18.972h.003Z",
    fill: "#FBD47F"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M67.653 58.265c.185.082.474.192.839.277.496.116 1.122.262 1.807.018.182-.064.468-.192.775-.457l-.006-18.806H67.65v18.968h.004Z",
    fill: "#FAD37F"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M67.668 58.265c.185.082.471.192.836.277.493.116 1.117.262 1.801.018.183-.064.469-.192.773-.457l-.006-18.806H67.67v18.968h-.003Z",
    fill: "#F9D27E"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M67.68 58.265c.185.082.468.192.83.277.49.116 1.11.262 1.792.018a2.36 2.36 0 0 0 .77-.457c-.004-6.27-.004-12.532-.007-18.806H67.68v18.968Z",
    fill: "#F8D17E"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M67.695 58.265c.183.082.469.192.828.277.486.116 1.107.262 1.782.018.183-.064.462-.192.767-.457L71.066 39.3h-3.37v18.965Z",
    fill: "#F7D17D"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M67.71 58.265c.183.082.466.192.824.277.487.116 1.101.262 1.774.018.18-.064.459-.192.76-.457L71.062 39.3h-3.355v18.965h.003Z",
    fill: "#F6D07C"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M67.726 58.262c.182.082.462.192.82.277.484.116 1.096.262 1.768.018.18-.064.46-.192.758-.457-.004-6.27-.004-12.53-.007-18.8h-3.34v18.962Z",
    fill: "#F5CF7C"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M67.737 58.262c.18.082.463.192.816.277.48.116 1.092.262 1.758.018.18-.064.456-.192.754-.457l-.006-18.8h-3.325v18.962h.003Z",
    fill: "#F4CE7B"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M67.753 58.262c.18.082.46.192.812.277.478.116 1.086.262 1.75.018.175-.064.452-.192.75-.457l-.006-18.8h-3.306v18.962Z",
    fill: "#F3CD7B"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M67.769 58.261c.179.083.456.192.809.278.477.116 1.08.262 1.743.018.176-.064.453-.192.748-.457l-.006-18.797h-3.291v18.959h-.003Z",
    fill: "#F3CC7A"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M67.78 58.261c.18.083.454.192.803.278.475.116 1.074.262 1.734.018.177-.064.45-.192.745-.457l-.006-18.797H67.78v18.959Z",
    fill: "#F2CB7A"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M67.795 58.262c.177.083.453.192.8.278.472.116 1.07.262 1.725.018.176-.064.447-.192.739-.457l-.006-18.794h-3.261v18.955h.003Z",
    fill: "#F1CA79"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M67.81 58.262c.177.083.45.192.798.278.468.116 1.064.262 1.715.018.174-.064.444-.192.736-.457l-.006-18.794h-3.245v18.955h.003Z",
    fill: "#F0C979"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M67.823 58.262c.177.083.447.192.794.278.469.116 1.059.262 1.71.018a2.22 2.22 0 0 0 .733-.457l-.006-18.794h-3.23v18.955Z",
    fill: "#EFC878"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.637.637 0 0 1-.165.021.763.763 0 0 1-.483-.18V39.296h.645v18.974h.003Z",
    fill: "#EFC878"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.631.631 0 0 1-.161.021.768.768 0 0 1-.48-.18V39.296h.638v18.974h.003Z",
    fill: "#EEC777"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.63.63 0 0 1-.161.021.74.74 0 0 1-.475-.18V39.296h.633v18.974h.003Z",
    fill: "#EDC677"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.625.625 0 0 1-.158.021.738.738 0 0 1-.472-.18V39.296h.627v18.974h.003Z",
    fill: "#EDC576"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.607.607 0 0 1-.159.021.718.718 0 0 1-.465-.18V39.296h.62v18.974h.004Z",
    fill: "#ECC475"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.601.601 0 0 1-.155.021.723.723 0 0 1-.462-.18V39.296h.614v18.974h.003Z",
    fill: "#EBC375"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.6.6 0 0 1-.155.021.697.697 0 0 1-.456-.18V39.296h.608v18.974h.003Z",
    fill: "#EAC274"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.558.558 0 0 1-.152.021.694.694 0 0 1-.453-.18V39.296h.602v18.974h.003Z",
    fill: "#E9C174"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.558.558 0 0 1-.152.021.683.683 0 0 1-.448-.18V39.296h.597v18.974h.003Z",
    fill: "#E9C073"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.553.553 0 0 1-.149.021.674.674 0 0 1-.444-.18V39.296h.59v18.974h.003Z",
    fill: "#E8BF72"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.535.535 0 0 1-.149.021.655.655 0 0 1-.438-.18V39.296h.584v18.974h.003Z",
    fill: "#E7BF72"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.53.53 0 0 1-.146.021.653.653 0 0 1-.435-.18V39.296h.578v18.974h.003Z",
    fill: "#E6BE71"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.529.529 0 0 1-.146.021.642.642 0 0 1-.43-.18V39.296h.573v18.974h.003Z",
    fill: "#E6BD70"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.507.507 0 0 1-.143.021.633.633 0 0 1-.426-.18V39.296h.566v18.974h.003Z",
    fill: "#E5BC70"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.49.49 0 0 1-.143.021.615.615 0 0 1-.42-.18V39.296h.56v18.974h.003Z",
    fill: "#E4BB6F"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.486.486 0 0 1-.14.021.613.613 0 0 1-.417-.18V39.296h.554v18.974h.003Z",
    fill: "#E3BA6F"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.469.469 0 0 1-.14.021.603.603 0 0 1-.41-.18V39.296h.547v18.974h.003Z",
    fill: "#E2B96E"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M71.707 58.269a.464.464 0 0 1-.137.021.594.594 0 0 1-.408-.18V39.296h.542v18.974h.003Z",
    fill: "#E2B86D"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.464.464 0 0 1-.136.021.577.577 0 0 1-.402-.18V39.296h.535v18.974h.003Z",
    fill: "#E1B76D"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M71.706 58.269a.442.442 0 0 1-.134.021c-.194.003-.337-.122-.398-.18V39.296h.53v18.974h.002Z",
    fill: "#E0B66C"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "m67.89 65-.639-1.115-.32-.558-.319-.557a3.92 3.92 0 0 0 1.272.207c.538 0 .973-.11 1.262-.204-.103.185-.21.371-.313.557l-.314.558c-.212.369-.422.74-.63 1.112Z",
    fill: "#585858"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M66.612 62.77a3.911 3.911 0 0 0 .706.164 3.975 3.975 0 0 0 1.776-.155c-.1.183-.2.365-.304.548-.1.183-.204.366-.304.549-.2.362-.408.74-.611 1.1l-.633-1.106-.316-.552-.314-.548Z",
    fill: "#595959"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M66.615 62.77a3.804 3.804 0 0 0 .694.161 3.971 3.971 0 0 0 1.74-.143c-.095.18-.192.36-.292.54-.098.179-.195.362-.295.541-.195.35-.396.738-.594 1.088l-.626-1.094-.314-.548-.313-.545Z",
    fill: "#5A5A5A"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M66.615 62.773a3.915 3.915 0 0 0 .682.159 3.916 3.916 0 0 0 1.7-.128c-.091.177-.186.353-.28.533-.094.177-.189.357-.286.533-.188.342-.383.732-.575 1.073l-.62-1.085-.31-.542-.31-.543Z",
    fill: "#5B5B5B"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M66.615 62.773a4.254 4.254 0 0 0 .67.159 3.868 3.868 0 0 0 1.66-.116c-.085.174-.176.348-.267.524-.092.174-.183.35-.277.524-.18.332-.371.729-.557 1.058l-.614-1.073-.308-.536-.307-.54Z",
    fill: "#5C5C5C"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M66.618 62.775a3.861 3.861 0 0 0 .657.156 3.72 3.72 0 0 0 1.621-.104c-.082.17-.167.342-.258.515-.088.17-.177.345-.268.518-.173.32-.359.725-.538 1.042l-.608-1.063-.305-.53-.3-.534Z",
    fill: "#5D5D5D"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M66.618 62.78a4.27 4.27 0 0 0 .645.152 3.711 3.711 0 0 0 1.585-.091c-.076.167-.158.334-.247.505-.085.168-.17.338-.258.509-.164.31-.347.722-.52 1.027l-.603-1.052-.3-.527-.302-.524Z",
    fill: "#5E5E5E"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M66.618 62.78c.134.042.295.088.48.121l.156.028a3.798 3.798 0 0 0 1.545-.08c-.073.165-.152.33-.234.497-.082.165-.161.335-.25.503-.158.298-.334.716-.501 1.011l-.597-1.042-.298-.52-.3-.519Z",
    fill: "#5F5F5F"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M66.621 62.781c.13.043.29.086.472.12l.152.026c.152.025.31.043.477.05.441.015.794-.059 1.025-.113-.067.161-.143.323-.222.49-.079.162-.155.33-.243.494-.152.29-.322.713-.484 1l-.59-1.03-.295-.516-.292-.52Z",
    fill: "#606060"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M66.621 62.781c.13.043.286.083.462.12l.15.026c.148.025.304.043.468.05.429.015.773-.05.998-.104a12.18 12.18 0 0 1-.21.481c-.076.159-.15.323-.235.485-.142.28-.313.71-.465.984l-.584-1.021-.292-.509-.292-.512Z",
    fill: "#616161"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M66.621 62.785c.128.04.28.082.453.116l.146.027c.146.025.302.043.46.052a3.63 3.63 0 0 0 .967-.091c-.058.152-.125.31-.2.472-.074.155-.144.317-.226.478-.137.269-.301.707-.447.97l-.578-1.01-.289-.505-.286-.509Z",
    fill: "#626262"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M66.624 62.785a4.254 4.254 0 0 0 .587.14 3.498 3.498 0 0 0 1.387-.027c-.052.15-.115.305-.189.463-.07.152-.136.31-.215.47-.131.258-.29.703-.43.953l-.571-1-.286-.5-.283-.499Z",
    fill: "#636363"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M66.624 62.788c.125.04.27.08.435.11l.14.027c.143.025.289.046.441.055.392.021.703-.03.906-.067-.048.146-.11.299-.176.454-.067.15-.128.308-.207.46-.121.247-.277.698-.41.939l-.566-.988-.283-.493-.28-.497Z",
    fill: "#646464"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M66.624 62.788c.122.04.268.076.426.11.046.009.091.018.137.024.14.025.283.046.432.055.38.024.681-.024.879-.058-.043.143-.1.293-.165.448-.06.146-.121.302-.197.454-.116.238-.265.695-.393.923l-.56-.978-.28-.487-.279-.49Z",
    fill: "#656565"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M66.628 62.791a4.36 4.36 0 0 0 .55.131c.137.024.277.046.423.055.368.024.66-.018.849-.046a3.84 3.84 0 0 1-.155.439c-.058.143-.116.296-.189.445-.11.225-.252.692-.374.91l-.553-.965-.277-.484-.274-.485Z",
    fill: "#666"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M66.628 62.791a4.4 4.4 0 0 0 .538.128c.134.024.271.046.414.058.356.027.636-.01.818-.034-.033.138-.082.28-.143.43-.054.14-.11.29-.18.436-.103.216-.24.688-.355.896l-.548-.957-.273-.479-.271-.478Z",
    fill: "#676767"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M66.628 62.795c.119.033.252.07.398.1a4.503 4.503 0 0 0 .53.082c.343.031.614-.002.79-.024a3.29 3.29 0 0 1-.13.42c-.052.138-.1.284-.17.43-.098.205-.229.683-.341.881l-.542-.947-.27-.473-.265-.47Z",
    fill: "#686868"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M66.63 62.795c.116.033.25.07.39.1a4.363 4.363 0 0 0 .517.085c.332.031.59.004.76-.011a2.667 2.667 0 0 1-.118.411c-.049.134-.094.277-.161.42-.088.196-.216.68-.323.866l-.535-.936-.268-.469-.261-.466Z",
    fill: "#696969"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M66.63 62.797a5.83 5.83 0 0 0 .506.122c.127.024.255.049.383.06.32.034.569.01.73 0a2.318 2.318 0 0 1-.11.406c-.045.131-.088.274-.151.411-.083.183-.204.677-.305.85l-.529-.926-.265-.463-.258-.46Z",
    fill: "#696969"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M66.63 62.797c.113.033.238.067.375.094.04.01.08.016.119.025.124.024.249.049.374.06.307.034.547.016.7.013a1.922 1.922 0 0 1-.098.396c-.043.128-.082.268-.143.405-.076.174-.192.674-.286.835l-.523-.914-.262-.457-.255-.457Z",
    fill: "#6A6A6A"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M66.634 62.8c.112.033.234.064.365.091.04.01.079.016.118.025.125.024.244.048.365.064.299.036.524.02.673.02-.01.123-.043.25-.085.388-.04.125-.073.262-.134.396-.07.162-.18.667-.268.823l-.517-.905-.259-.451-.258-.451Z",
    fill: "#6B6B6B"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M66.634 62.804c.11.033.228.06.356.088.036.01.076.015.115.024.122.025.237.05.356.064.286.037.502.03.642.034a1.654 1.654 0 0 1-.073.378c-.037.122-.067.256-.125.387-.064.15-.167.664-.25.807l-.51-.892-.256-.449-.255-.441Z",
    fill: "#6C6C6C"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M66.634 62.804c.106.033.225.06.347.088.036.01.073.015.112.024.119.025.234.05.347.068.274.04.477.036.611.045 0 .116-.024.238-.064.369-.033.119-.06.25-.115.38-.058.14-.155.662-.231.793l-.505-.884-.253-.441-.25-.442Z",
    fill: "#6D6D6D"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M66.634 62.806c.106.033.219.058.337.085.037.01.073.015.11.024.115.025.228.052.334.067.262.043.457.043.584.058.004.113-.018.232-.051.363-.03.116-.055.244-.107.372-.051.128-.146.658-.212.777l-.5-.872-.249-.436-.246-.438Z",
    fill: "#6E6E6E"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M66.637 62.806c.103.03.216.058.328.082.037.01.07.015.107.024.112.025.222.052.325.07.25.043.435.05.554.067.009.11-.01.226-.04.354-.027.113-.045.238-.097.363-.046.115-.134.652-.195.761l-.493-.862-.246-.43-.243-.43Z",
    fill: "#6F6F6F"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M66.637 62.81c.103.03.21.054.32.079.033.009.07.015.103.024.112.025.215.052.316.07.237.046.41.055.523.08.012.103 0 .219-.027.344-.025.11-.04.231-.088.356-.04.107-.122.65-.177.75l-.487-.85-.243-.427-.24-.426Z",
    fill: "#707070"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M66.637 62.81c.1.03.207.051.31.079.033.009.067.015.1.024.11.025.21.052.308.07.225.046.389.061.492.092.019.1.01.213-.015.335-.021.107-.033.228-.079.347-.036.095-.11.646-.158.735l-.48-.841-.241-.42-.237-.421Z",
    fill: "#717171"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M66.64 62.813c.1.03.2.051.3.076l.098.024c.107.024.207.052.298.073.213.049.365.07.466.104a.846.846 0 0 1-.007.326c-.018.103-.027.222-.07.341-.03.082-.097.643-.14.72l-.474-.83-.237-.414-.234-.42Z",
    fill: "#727272"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M66.64 62.813c.097.027.197.048.295.073.03.009.064.015.094.021.103.024.2.052.289.073.2.049.344.076.435.113a.746.746 0 0 1 .006.32c-.015.1-.018.216-.06.332-.025.07-.086.637-.123.704l-.468-.82-.234-.408-.234-.408Z",
    fill: "#737373"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M66.64 62.815c.097.028.191.05.286.07.03.007.06.016.09.022.104.027.195.052.28.076.19.049.323.082.405.125.03.091.034.195.019.31-.013.098-.034.205-.052.324-.03.055-.073.634-.104.688l-.462-.807-.231-.405-.231-.403Z",
    fill: "#747474"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M66.643 62.815c.094.028.188.046.276.068.03.006.058.015.089.02.1.028.188.053.267.077.177.052.298.088.377.137.037.088.04.186.03.302-.008.094-.026.198-.042.317-.024.042-.06.63-.085.673l-.456-.798-.228-.4-.228-.396Z",
    fill: "#757575"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M66.643 62.818c.094.022.182.046.267.067l.085.022c.098.027.183.055.259.079.164.052.277.094.347.15.042.085.048.179.04.292-.007.091-.022.192-.034.308-.018.033-.049.627-.067.66l-.45-.785-.225-.393-.222-.4Z",
    fill: "#767676"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M66.643 62.818c.09.022.179.043.258.064.028.006.055.016.082.022.094.027.177.054.25.079.152.055.252.1.316.158a.53.53 0 0 1 .052.284c-.003.088-.016.186-.025.298-.012.022-.036.625-.048.646l-.444-.777-.222-.387-.22-.387Z",
    fill: "#777"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "m66.645 62.821.25.061c.027.006.055.016.079.022.094.027.173.054.24.079.14.055.231.11.286.17.052.08.064.168.064.278 0 .085-.009.18-.015.292-.006.012-.024.619-.03.631l-.439-.765-.218-.384-.216-.384Z",
    fill: "#787878"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "m67.506 64.333-.431-.756-.432-.756c.121.028.225.055.316.08.091.027.167.054.231.082a.62.62 0 0 1 .259.183c.097.134.073.304.07.551l-.013.616Z",
    fill: "#797979"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M64.063 40.44c1.046.204 2.33.369 3.802.372 1.488 0 2.79-.165 3.842-.372.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E9F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.015,
    d: "M64.063 40.437a19.813 19.813 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E8F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.023,
    d: "M64.063 40.431a19.804 19.804 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E8F7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.031,
    d: "M64.063 40.427a19.83 19.83 0 0 0 7.644 0c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F4E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.038,
    d: "M64.063 40.422a19.839 19.839 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.046,
    d: "M64.063 40.419a19.838 19.838 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F4E7F4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.054,
    d: "M64.063 40.412a19.847 19.847 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F4E7F3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.062,
    d: "M64.063 40.41a19.838 19.838 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E7F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.069,
    d: "M64.063 40.404a19.847 19.847 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E7F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.077,
    d: "M64.063 40.4a19.847 19.847 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E6F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.085,
    d: "M64.063 40.394a19.839 19.839 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E6EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.092,
    d: "M64.063 40.391a19.897 19.897 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F4E6EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.063 40.384a19.896 19.896 0 0 0 7.644 0c.006-.386.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F3E6ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.108,
    d: "M64.063 40.383a19.897 19.897 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F3E5EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.115,
    d: "M64.063 40.377a19.897 19.897 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F3E5EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.123,
    d: "M64.063 40.373a19.897 19.897 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F3E5EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.131,
    d: "M64.063 40.367a19.838 19.838 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.139,
    d: "M64.063 40.364a19.862 19.862 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E4E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.146,
    d: "M64.063 40.358a19.605 19.605 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.154,
    d: "M64.063 40.354a19.605 19.605 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E4E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.162,
    d: "M64.063 40.348c1.046.208 2.333.372 3.808.375a19.84 19.84 0 0 0 3.836-.375c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.169,
    d: "M64.063 40.346c1.046.208 2.333.372 3.808.375a19.84 19.84 0 0 0 3.836-.375c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F3E3E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.177,
    d: "M64.063 40.34c1.046.207 2.333.371 3.808.374a19.84 19.84 0 0 0 3.836-.374c.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.185,
    d: "M64.063 40.337c1.046.207 2.333.371 3.808.374a19.84 19.84 0 0 0 3.836-.374c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E3E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M64.063 40.33c1.046.208 2.333.373 3.811.376 1.488 0 2.784-.168 3.836-.375.006-.387.012-.771.015-1.158h-7.677c.003.39.009.777.015 1.158Z",
    fill: "#F3E3E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.063 40.327c1.046.207 2.333.372 3.811.375 1.488 0 2.784-.168 3.836-.375.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F3E2E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.208,
    d: "M64.063 40.325c1.046.207 2.336.372 3.811.375 1.488 0 2.784-.168 3.833-.375.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E2DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.215,
    d: "M64.063 40.318a19.62 19.62 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E2DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.223,
    d: "M64.063 40.315a19.62 19.62 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E2DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.231,
    d: "M64.063 40.31a19.62 19.62 0 0 0 7.644 0c.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F3E1DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.238,
    d: "M64.063 40.306a19.62 19.62 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E1DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.246,
    d: "M64.063 40.3a19.62 19.62 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F3E1DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.254,
    d: "M64.063 40.297a19.622 19.622 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E1D9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.262,
    d: "M64.063 40.29a19.628 19.628 0 0 0 7.647 0c.006-.386.012-.77.015-1.157h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F3E0D8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.269,
    d: "M64.063 40.288a19.628 19.628 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F3E0D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.277,
    d: "M64.063 40.282a19.628 19.628 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E0D6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.285,
    d: "M64.063 40.279a19.628 19.628 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3E0D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.292,
    d: "M64.063 40.273a19.628 19.628 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F3DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M64.063 40.27a19.628 19.628 0 0 0 7.644 0c.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F2DFD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.308,
    d: "M64.063 40.263a19.63 19.63 0 0 0 7.644 0c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F2DFD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315,
    d: "M64.063 40.26a19.628 19.628 0 0 0 7.644 0c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F2DFD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.323,
    d: "M64.063 40.255a19.628 19.628 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DED0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.331,
    d: "M64.063 40.252a19.637 19.637 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F2DECF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.339,
    d: "M64.063 40.245a19.637 19.637 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F2DECE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.346,
    d: "M64.063 40.242a19.637 19.637 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DECD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.354,
    d: "M64.063 40.236a19.637 19.637 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DDCC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.361,
    d: "M64.063 40.232a19.637 19.637 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DDCB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.369,
    d: "M64.063 40.226a19.637 19.637 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.377,
    d: "M64.063 40.224a19.663 19.663 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DDC9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.385,
    d: "M64.063 40.218a19.663 19.663 0 0 0 7.644 0c.006-.388.012-.772.015-1.158h-7.677l.018 1.157Z",
    fill: "#F2DCC8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.392,
    d: "M64.063 40.215a19.663 19.663 0 0 0 7.644 0c.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F2DCC7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M64.063 40.212a19.484 19.484 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DCC6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.408,
    d: "M64.063 40.205a19.485 19.485 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F2DCC5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.415,
    d: "M64.063 40.203a19.477 19.477 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F2DBC4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.423,
    d: "M64.063 40.196c1.046.207 2.34.378 3.82.378 1.485 0 2.778-.168 3.824-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DBC3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M64.063 40.194c1.046.207 2.34.378 3.82.378 1.485 0 2.778-.168 3.824-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DBC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.439,
    d: "M64.063 40.187c1.046.207 2.34.378 3.82.378 1.485 0 2.778-.168 3.824-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DBC1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.446,
    d: "M64.063 40.183c1.046.208 2.34.378 3.82.378 1.485 0 2.778-.167 3.824-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.454,
    d: "M64.063 40.178c1.046.208 2.34.378 3.82.378 1.485 0 2.778-.167 3.824-.378.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F2DABF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.462,
    d: "M64.063 40.175c1.046.207 2.34.377 3.82.377 1.485 0 2.778-.167 3.824-.377.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F2DABE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.469,
    d: "M64.063 40.169c1.046.207 2.34.378 3.82.378 1.485 0 2.778-.168 3.824-.378.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2DABD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.477,
    d: "M64.063 40.166c1.046.207 2.34.378 3.824.378s2.777-.168 3.823-.378c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F2D9BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.485,
    d: "M64.063 40.16c1.046.207 2.34.378 3.824.378 1.48 0 2.777-.168 3.823-.378.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F2D9BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.492,
    d: "M64.063 40.157c1.046.207 2.34.378 3.824.378a19.41 19.41 0 0 0 3.82-.378c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2D9BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.063 40.151c1.046.207 2.34.378 3.824.378 1.481 0 2.774-.168 3.82-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F2D9B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.508,
    d: "M64.063 40.147c1.046.207 2.34.378 3.824.378 1.481 0 2.774-.17 3.82-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D8B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.515,
    d: "M64.063 40.141c1.046.21 2.34.378 3.824.378 1.481 0 2.774-.17 3.82-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D8B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.523,
    d: "M64.063 40.138c1.046.21 2.34.378 3.824.378 1.481 0 2.774-.17 3.82-.378.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F1D8B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.531,
    d: "M64.063 40.133c1.046.21 2.34.377 3.824.377 1.481 0 2.774-.17 3.82-.377.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F1D7B5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.538,
    d: "M64.063 40.13c1.046.21 2.34.377 3.824.377 1.481 0 2.774-.17 3.82-.377.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D7B4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.546,
    d: "M64.063 40.123c1.046.21 2.34.378 3.827.378 1.481 0 2.774-.171 3.82-.378.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F1D7B3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.554,
    d: "M64.063 40.12c1.046.21 2.342.378 3.827.378 1.481 0 2.774-.171 3.82-.378.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F1D7B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.561,
    d: "M64.063 40.114a19.45 19.45 0 0 0 3.827.378c1.481 0 2.774-.17 3.817-.378.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D6B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M64.063 40.111c1.046.21 2.342.378 3.827.378 1.481 0 2.774-.17 3.817-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D6B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.577,
    d: "M64.063 40.104a19.459 19.459 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D6AF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.585,
    d: "M64.063 40.102a19.45 19.45 0 0 0 3.827.378c1.481 0 2.774-.17 3.817-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D6AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.592,
    d: "M64.063 40.096a19.459 19.459 0 0 0 7.644 0c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#F1D5AD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M64.063 40.093a19.45 19.45 0 0 0 3.827.378c1.481 0 2.774-.17 3.817-.378.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D5AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.608,
    d: "M64.063 40.09a19.59 19.59 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F1D5AB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.615,
    d: "M64.063 40.084a19.617 19.617 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F1D5AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.623,
    d: "M64.063 40.08c1.046.211 2.342.382 3.83.379 1.481 0 2.77-.171 3.817-.378.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F1D4A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.631,
    d: "M64.063 40.074a19.557 19.557 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D4A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.638,
    d: "M64.063 40.072a19.556 19.556 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D4A7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.646,
    d: "M64.063 40.065c1.046.21 2.342.381 3.83.381 1.481 0 2.77-.17 3.814-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F1D4A6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.654,
    d: "M64.063 40.062a19.304 19.304 0 0 0 7.644 0c.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D3A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.661,
    d: "M64.063 40.056c1.046.21 2.342.381 3.83.381 1.481 0 2.77-.17 3.814-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F1D3A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.669,
    d: "M64.063 40.052c1.046.21 2.342.381 3.83.381 1.481 0 2.77-.17 3.814-.38.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F1D3A3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    d: "M64.063 40.047c1.046.21 2.342.38 3.83.38 1.481 0 2.77-.17 3.814-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D3A2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.685,
    d: "M64.063 40.045c1.046.21 2.342.38 3.83.38 1.481 0 2.77-.17 3.814-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F1D2A1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.692,
    d: "M64.063 40.038c1.046.21 2.342.38 3.833.38 1.481 0 2.77-.17 3.814-.38.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F1D2A0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.063 40.035c1.046.21 2.342.38 3.833.38 1.481 0 2.77-.17 3.814-.38.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F1D29F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.708,
    d: "M64.063 40.029c1.046.21 2.342.38 3.833.38 1.481 0 2.77-.17 3.811-.38.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0D29E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.715,
    d: "M64.063 40.025c1.046.21 2.342.381 3.833.381 1.481 0 2.77-.17 3.811-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0D19D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.723,
    d: "M64.063 40.02c1.046.21 2.342.38 3.833.38 1.481 0 2.77-.17 3.811-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0D19C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.731,
    d: "M64.063 40.016c1.046.21 2.345.381 3.833.381 1.481 0 2.768-.17 3.811-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0D19B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.739,
    d: "M64.063 40.01c1.046.21 2.345.381 3.833.381 1.478 0 2.768-.17 3.811-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0D19A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.746,
    d: "M64.063 40.008c1.046.21 2.345.38 3.833.38 1.478 0 2.768-.17 3.811-.38.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F0D099"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.754,
    d: "M64.063 40.002c1.046.21 2.345.38 3.833.38 1.478 0 2.768-.17 3.811-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0D098"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.761,
    d: "M64.063 39.998c1.046.21 2.345.38 3.836.38 1.478 0 2.768-.17 3.811-.38.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F0D097"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.769,
    d: "M64.063 39.993c1.046.21 2.345.38 3.836.38 1.478 0 2.768-.17 3.811-.38.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#F0D096"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.777,
    d: "M64.063 39.989c1.046.21 2.345.38 3.836.38 1.478 0 2.768-.17 3.808-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0CF95"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.785,
    d: "M64.063 39.982c1.046.21 2.345.381 3.836.381 1.478 0 2.768-.17 3.808-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CF94"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.792,
    d: "M64.063 39.98c1.046.21 2.345.381 3.836.381 1.478 0 2.768-.17 3.808-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CF93"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M64.063 39.974c1.046.21 2.345.381 3.836.381 1.478 0 2.768-.17 3.808-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CF92"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M64.063 39.97a19.26 19.26 0 0 0 3.836.381c1.478 0 2.768-.17 3.808-.38.006-.388.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F0CE91"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.815,
    d: "M64.063 39.968c1.046.21 2.345.383 3.836.38 1.478 0 2.768-.17 3.808-.38.006-.388.012-.772.015-1.158h-7.677l.018 1.157Z",
    fill: "#F0CE90"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.823,
    d: "M64.063 39.962a19.26 19.26 0 0 0 3.836.38c1.478 0 2.768-.17 3.808-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0CE8F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.831,
    d: "M64.063 39.959c1.046.21 2.345.384 3.839.38 1.478 0 2.768-.17 3.808-.38.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F0CE8E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.839,
    d: "M64.063 39.952c1.046.21 2.345.384 3.839.38 1.478 0 2.768-.17 3.808-.38.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#F0CD8D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.846,
    d: "M64.063 39.95a19.27 19.27 0 0 0 3.839.38c1.478 0 2.765-.17 3.805-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0CD8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.854,
    d: "M64.063 39.944c1.046.21 2.345.384 3.839.38 1.478 0 2.765-.17 3.805-.38.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0CD8B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.862,
    d: "M64.063 39.94c1.046.21 2.345.384 3.839.381 1.478 0 2.765-.174 3.805-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CD8A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.869,
    d: "M64.063 39.934c1.046.21 2.345.384 3.839.381 1.478 0 2.765-.174 3.805-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CC89"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.877,
    d: "M64.063 39.931c1.046.21 2.345.384 3.839.381 1.478 0 2.765-.173 3.805-.38.006-.388.012-.772.015-1.159h-7.677l.018 1.158Z",
    fill: "#F0CC88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.885,
    d: "M64.063 39.925a19.27 19.27 0 0 0 3.839.38c1.478 0 2.765-.173 3.805-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F0CC87"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.892,
    d: "M64.063 39.922c1.046.21 2.345.385 3.839.381 1.478 0 2.765-.173 3.805-.38.006-.387.012-.771.015-1.158h-7.677l.018 1.157Z",
    fill: "#F0CC86"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M64.063 39.917a19.183 19.183 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#F0CB85"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.908,
    d: "M64.063 39.913a19.185 19.185 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#EFCB84"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.915,
    d: "M64.063 39.907a19.178 19.178 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#EFCB83"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.923,
    d: "M64.063 39.904c1.046.21 2.348.384 3.842.384 1.478 0 2.765-.174 3.802-.384.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#EFCB82"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "M64.063 39.898c1.046.21 2.348.384 3.842.384 1.478 0 2.765-.174 3.802-.384.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#EFCA81"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.939,
    d: "M64.063 39.894c1.046.21 2.348.384 3.842.384 1.478 0 2.765-.173 3.802-.384.006-.387.012-.77.015-1.158h-7.677l.018 1.158Z",
    fill: "#EFCA80"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.946,
    d: "M64.063 39.888a19.28 19.28 0 0 0 3.842.384 19.36 19.36 0 0 0 3.802-.384c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#EFCA7F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.954,
    d: "M64.063 39.885a19.273 19.273 0 0 0 7.644 0c.006-.387.012-.77.015-1.157h-7.677l.018 1.157Z",
    fill: "#EFCA7E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.962,
    d: "M64.063 39.88a19.273 19.273 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#EFC97D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    d: "M64.063 39.877a19.272 19.272 0 0 0 7.644 0c.006-.387.012-.771.015-1.158h-7.677l.018 1.158Z",
    fill: "#EFC97C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    d: "M64.063 39.87a19.281 19.281 0 0 0 7.647 0c.006-.386.012-.77.015-1.157h-7.677c.003.39.009.774.015 1.158Z",
    fill: "#EFC97B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    d: "M64.063 39.867a19.281 19.281 0 0 0 7.647 0c.006-.387.012-.771.015-1.158h-7.677c.003.387.009.774.015 1.158Z",
    fill: "#EFC97A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    d: "M64.063 39.861c1.046.213 2.348.384 3.845.384a19.337 19.337 0 0 0 3.8-.384c.005-.387.011-.77.014-1.158h-7.677l.018 1.158Z",
    fill: "#EFC879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.063 39.858c1.046.213 2.348.384 3.845.384a19.345 19.345 0 0 0 3.8-.384c.005-.387.011-.77.014-1.158h-7.677l.018 1.158Z",
    fill: "#EFC878"
  }))), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M71.862 30.93c-1.21.126-2.552.205-4.006.202a38.71 38.71 0 0 1-3.936-.201c-.01.57-.016 1.136-.022 1.706 0 .064.061.128.061.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.064.1.067.174.003.094-.058.113-.055.207.015.622.033 1.322.055 1.944a18.85 18.85 0 0 0 3.726.402 19.07 19.07 0 0 0 4.046-.402c.024-.625.048-1.32.067-1.96.003-.09-.058-.121-.055-.212.003-.074.067-.116.067-.192.006-.217.009-.467.015-.683.024-1.27.033-2.52.027-3.748 0-.08-.064-.158-.064-.24 0-.052.061-.107.061-.159l-.027-1.703Z",
    fill: "#EBE4D9"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M63.92 30.935c-.01.57-.016 1.136-.022 1.706 0 .064.061.128.061.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.067.1.067.174.003.094-.058.113-.058.207.015.622.033 1.325.055 1.944a18.778 18.778 0 0 0 7.626.01c.027-.616.048-1.326.066-1.963.004-.092-.057-.122-.054-.213.003-.074.067-.116.07-.19v-.008c.006-.214.009-.46.015-.674.027-1.27.033-2.52.027-3.745 0-.03-.009-.058-.018-.088-.018-.052-.043-.1-.046-.152 0-.034.022-.064.04-.098a.123.123 0 0 0 .021-.06v-.126c-.006-.533-.012-1.054-.024-1.578a39.125 39.125 0 0 1-7.8-.012Z",
    fill: "#EBE5DA"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.935c-.009.57-.018 1.136-.02 1.706 0 .064.063.128.063.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.067.1.07.174.003.094-.061.113-.058.207.015.622.033 1.331.055 1.944.991.204 2.199.375 3.589.39 1.52.015 2.835-.158 3.897-.369.027-.603.051-1.328.07-1.965.002-.091-.058-.122-.055-.213.003-.073.067-.116.07-.19v-.008c.006-.214.009-.46.015-.674.027-1.27.033-2.517.027-3.742 0-.03-.009-.057-.018-.088-.018-.052-.043-.1-.046-.152 0-.034.019-.064.037-.098.009-.021.018-.04.021-.06 0-.043.003-.083.003-.126-.006-.533-.012-1.054-.024-1.578a38.989 38.989 0 0 1-7.669-.024Z",
    fill: "#ECE5DB"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.938c-.01.57-.019 1.136-.022 1.706 0 .064.064.128.064.192 0 .076-.067.15-.067.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.067.1.07.174.003.094-.061.112-.058.207.015.622.033 1.334.058 1.944.98.201 2.163.365 3.52.384a19.45 19.45 0 0 0 3.823-.35c.027-.592.051-1.332.07-1.972.003-.091-.061-.122-.058-.213.003-.073.067-.116.07-.19v-.008c.006-.214.009-.46.015-.674.027-1.267.037-2.514.027-3.738 0-.031-.009-.058-.018-.089-.018-.052-.042-.1-.045-.152-.004-.034.018-.064.033-.098.009-.021.018-.04.021-.06.003-.04.006-.083.006-.123a133.75 133.75 0 0 0-.024-1.575c-1.18.107-2.44.174-3.796.168a41.032 41.032 0 0 1-3.726-.207Z",
    fill: "#ECE6DC"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.94c-.01.57-.019 1.137-.022 1.707 0 .064.064.128.064.192 0 .076-.067.15-.067.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.07.1.07.174.003.094-.061.112-.058.207.015.621.036 1.34.058 1.944.97.195 2.123.36 3.452.375a19.21 19.21 0 0 0 3.75-.336c.028-.579.056-1.337.074-1.974.003-.091-.061-.122-.058-.213.003-.073.07-.116.07-.19v-.008c.006-.214.009-.46.015-.674.027-1.267.037-2.514.027-3.735a.229.229 0 0 0-.018-.089c-.015-.052-.042-.1-.045-.152-.004-.034.015-.064.03-.098.01-.021.018-.04.021-.06.003-.04.006-.083.006-.122-.006-.537-.012-1.049-.024-1.576-1.171.1-2.4.165-3.726.155a41.025 41.025 0 0 1-3.656-.2Z",
    fill: "#EDE6DD"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.94c-.01.57-.019 1.137-.022 1.707 0 .064.067.128.064.192 0 .076-.067.15-.067.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.07.1.073.174.003.094-.061.112-.061.207.015.621.036 1.344.058 1.944.961.192 2.087.35 3.382.368 1.409.019 2.64-.134 3.675-.316.03-.567.054-1.341.073-1.978.003-.091-.061-.122-.058-.213.003-.073.07-.116.073-.19v-.008a140.199 140.199 0 0 0 .046-4.409.3.3 0 0 0-.016-.089c-.015-.051-.042-.1-.045-.149-.003-.033.015-.064.03-.097.01-.022.018-.04.021-.061.003-.04.01-.083.01-.122-.007-.54-.016-1.045-.025-1.576a38.85 38.85 0 0 1-3.656.143 39.936 39.936 0 0 1-3.592-.2Z",
    fill: "#EDE7DE"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.943c-.01.57-.019 1.137-.022 1.707 0 .064.067.128.067.192 0 .076-.067.149-.07.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.07.1.073.174.003.094-.064.112-.061.207.015.621.036 1.35.058 1.944.949.189 2.05.344 3.315.362a20.016 20.016 0 0 0 3.602-.298c.03-.558.058-1.344.076-1.984.003-.091-.061-.122-.058-.213.003-.073.07-.116.073-.19v-.008a140.295 140.295 0 0 0 .046-4.406.296.296 0 0 0-.016-.089c-.015-.048-.042-.1-.048-.149-.003-.033.012-.064.027-.097.01-.022.018-.04.021-.061.006-.04.013-.08.013-.122-.007-.54-.016-1.042-.025-1.573a39.88 39.88 0 0 1-3.586.131 41.216 41.216 0 0 1-3.522-.2Z",
    fill: "#EDE8DF"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.943c-.01.57-.019 1.137-.022 1.707 0 .064.067.128.067.192 0 .076-.07.149-.07.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.073.1.073.174.003.094-.064.112-.061.207.015.621.036 1.353.06 1.944.94.186 2.014.335 3.25.356 1.335.022 2.512-.119 3.528-.283.03-.546.058-1.347.076-1.987.003-.091-.064-.122-.06-.213.002-.073.07-.116.072-.189v-.01a139.74 139.74 0 0 0 .046-4.403.3.3 0 0 0-.016-.087c-.015-.05-.042-.101-.048-.15a.193.193 0 0 1 .024-.097c.01-.022.018-.04.021-.061.007-.04.013-.08.013-.12a135.05 135.05 0 0 0-.028-1.571 39.861 39.861 0 0 1-3.516.119 40.05 40.05 0 0 1-3.446-.202Z",
    fill: "#EEE8E0"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.946c-.013.57-.019 1.137-.022 1.707 0 .064.067.128.067.192 0 .076-.07.149-.07.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.073.1.073.174.003.094-.064.112-.061.207.015.621.04 1.356.06 1.944.929.18 1.975.326 3.18.347 1.298.021 2.445-.11 3.452-.265.03-.533.058-1.353.079-1.99.003-.091-.064-.122-.06-.213.002-.073.07-.116.075-.189v-.01a139.513 139.513 0 0 0 .046-4.4.3.3 0 0 0-.015-.087c-.016-.05-.04-.101-.05-.15-.005-.033.01-.064.022-.097.01-.022.018-.04.021-.061.007-.04.016-.08.016-.119-.006-.542-.016-1.04-.028-1.572-1.128.079-2.248.125-3.446.106a40.228 40.228 0 0 1-3.376-.198Z",
    fill: "#EEE9E1"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.95c-.013.569-.019 1.136-.025 1.706 0 .064.07.127.07.191 0 .077-.07.15-.07.226a171.798 171.798 0 0 0 .04 4.449c.003.073.073.1.076.173.003.095-.064.113-.064.208.015.621.04 1.362.06 1.944.92.176 1.938.32 3.113.34 1.262.022 2.381-.1 3.379-.249.034-.521.06-1.356.082-1.993.003-.091-.064-.122-.06-.213.002-.073.072-.116.075-.189v-.01c.006-.215.013-.46.016-.675.027-1.262.04-2.505.03-3.721a.3.3 0 0 0-.015-.088c-.012-.05-.04-.1-.049-.15-.006-.033.006-.064.018-.097a.531.531 0 0 0 .04-.18c-.006-.542-.015-1.036-.027-1.57-1.12.077-2.212.117-3.377.095a41.695 41.695 0 0 1-3.312-.198Z",
    fill: "#EEEAE2"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M63.923 30.95c-.012.569-.019 1.136-.025 1.706 0 .064.07.127.07.191 0 .077-.073.15-.073.226a153.777 153.777 0 0 0 .043 4.449c.003.073.073.1.076.173.003.095-.067.113-.064.208.018.621.04 1.365.061 1.944.906.173 1.901.31 3.042.335 1.226.024 2.318-.095 3.306-.232.034-.509.061-1.359.082-1.999.003-.091-.064-.121-.06-.213.002-.073.072-.116.076-.186v-.009a127.635 127.635 0 0 0 .046-4.397c0-.03-.007-.058-.013-.088-.012-.049-.04-.1-.049-.15-.006-.033.006-.064.019-.097.006-.021.018-.04.02-.061.01-.04.02-.08.02-.119-.007-.545-.016-1.033-.028-1.569-1.107.07-2.172.104-3.307.082a39.225 39.225 0 0 1-3.242-.195Z",
    fill: "#EFEAE3"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.952c-.013.57-.019 1.137-.025 1.706 0 .064.07.128.07.192 0 .077-.073.15-.073.226a153.789 153.789 0 0 0 .043 4.449c.003.073.076.1.076.173.003.095-.067.113-.064.208.018.621.04 1.37.064 1.944.897.167 1.865.304 2.975.329 1.19.024 2.254-.086 3.233-.214.034-.5.064-1.362.085-2.002.003-.091-.067-.121-.064-.213.004-.073.074-.116.08-.186v-.009c.006-.216.012-.46.015-.676.03-1.262.04-2.499.03-3.718 0-.03-.006-.058-.012-.088-.012-.049-.04-.1-.049-.15a.184.184 0 0 1 .016-.097c.006-.021.018-.04.02-.06.01-.04.022-.08.022-.117-.006-.545-.015-1.03-.027-1.566a39.514 39.514 0 0 1-3.237.07 43.866 43.866 0 0 1-3.178-.2Z",
    fill: "#EFEBE4"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.955c-.013.57-.019 1.137-.025 1.706 0 .064.073.128.07.192 0 .077-.073.15-.073.226a153.78 153.78 0 0 0 .043 4.449c.003.073.076.1.079.173.003.095-.067.113-.064.207.018.622.04 1.375.064 1.944a17.8 17.8 0 0 0 2.905.32c1.153.025 2.187-.076 3.157-.198.034-.487.064-1.368.085-2.005.003-.091-.067-.122-.064-.213.004-.073.074-.116.08-.186v-.009l.018-.676c.03-1.259.04-2.499.03-3.715 0-.03-.006-.058-.012-.088-.012-.049-.04-.1-.049-.15a.182.182 0 0 1 .013-.097c.006-.021.018-.04.02-.06.01-.04.025-.077.025-.117-.006-.548-.015-1.027-.027-1.566a40.822 40.822 0 0 1-3.167.061 44.521 44.521 0 0 1-3.108-.198Z",
    fill: "#F0EBE5"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.955c-.013.57-.019 1.137-.025 1.706 0 .064.073.128.073.192 0 .077-.073.15-.076.226a153.78 153.78 0 0 0 .043 4.449c.003.073.076.1.079.173.003.095-.067.113-.067.207.018.622.043 1.378.064 1.944.876.162 1.788.287 2.838.314 1.116.028 2.123-.07 3.084-.18.034-.475.067-1.37.089-2.008.002-.09-.068-.121-.064-.213.003-.073.073-.115.079-.186v-.009l.018-.676c.03-1.259.04-2.496.033-3.712 0-.03-.006-.057-.012-.088-.012-.049-.04-.097-.051-.15a.214.214 0 0 1 .009-.097c.006-.018.015-.04.02-.058.013-.04.025-.076.025-.115-.006-.549-.015-1.027-.027-1.567-1.077.055-2.06.077-3.094.05a45.38 45.38 0 0 1-3.038-.202Z",
    fill: "#F0ECE6"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.958c-.013.57-.019 1.137-.025 1.706 0 .064.073.128.073.192 0 .076-.076.15-.076.226a153.78 153.78 0 0 0 .043 4.449c.003.073.079.1.079.173.003.095-.07.113-.067.207.018.622.043 1.384.064 1.944.867.156 1.752.28 2.771.308 1.077.028 2.06-.06 3.011-.161.037-.464.067-1.375.088-2.014.004-.092-.066-.122-.063-.214.003-.073.076-.116.079-.186v-.009l.018-.68c.03-1.258.04-2.492.033-3.708 0-.03-.006-.057-.012-.088-.009-.049-.04-.097-.051-.15a.179.179 0 0 1 .006-.097l.021-.058c.012-.04.027-.076.027-.115a86.347 86.347 0 0 0-.03-1.564c-1.068.05-2.02.067-3.024.037-.991-.03-1.919-.104-2.965-.198Z",
    fill: "#F0EDE7"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.958c-.013.57-.022 1.137-.025 1.706 0 .064.073.128.073.192 0 .076-.076.15-.076.226a153.78 153.78 0 0 0 .043 4.449c.003.073.079.1.082.173.003.095-.07.113-.067.207.018.622.043 1.387.067 1.944.855.153 1.716.272 2.701.302 1.04.028 1.992-.052 2.938-.146.037-.451.07-1.378.092-2.017.003-.092-.07-.122-.067-.214.003-.073.076-.115.082-.186v-.009l.018-.68c.03-1.255.04-2.492.034-3.704a.434.434 0 0 0-.01-.089c-.009-.049-.039-.097-.051-.146a.178.178 0 0 1 .006-.098l.021-.057c.012-.037.03-.077.03-.113a87.851 87.851 0 0 0-.03-1.563 40.123 40.123 0 0 1-2.953.024 49.981 49.981 0 0 1-2.908-.201Z",
    fill: "#F1EDE8"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.96c-.013.57-.022 1.137-.025 1.707 0 .064.076.128.073.192 0 .076-.076.15-.076.226a153.789 153.789 0 0 0 .043 4.448c.003.074.079.101.082.174.003.095-.07.113-.067.207.018.622.043 1.393.067 1.944.846.15 1.68.262 2.634.293 1.004.03 1.929-.043 2.862-.128.037-.442.07-1.384.092-2.02.003-.092-.07-.122-.067-.214.003-.073.076-.115.082-.186v-.009l.018-.68c.03-1.255.043-2.489.034-3.701a.435.435 0 0 0-.01-.089c-.009-.048-.036-.097-.051-.146a.178.178 0 0 1 .003-.097.476.476 0 0 1 .024-.058c.012-.037.03-.077.03-.113a87.463 87.463 0 0 0-.03-1.56 39.777 39.777 0 0 1-2.883.012c-.937-.037-1.81-.11-2.835-.201Z",
    fill: "#F1EEE8"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.96c-.013.57-.022 1.137-.025 1.707 0 .064.076.128.076.192 0 .076-.079.15-.079.226a153.789 153.789 0 0 0 .043 4.448c.003.074.082.101.082.174.003.095-.073.113-.07.207.018.622.046 1.396.067 1.944.833.144 1.64.256 2.564.287.968.03 1.865-.037 2.79-.11.036-.43.073-1.386.094-2.023.003-.092-.07-.122-.067-.214.003-.073.076-.115.082-.185v-.01l.018-.679c.03-1.255.043-2.486.034-3.7a.435.435 0 0 0-.01-.087c-.009-.05-.036-.098-.051-.147a.21.21 0 0 1 0-.097.46.46 0 0 1 .024-.058c.015-.037.034-.076.034-.113a87.519 87.519 0 0 0-.03-1.56 37.56 37.56 0 0 1-2.814 0c-.904-.037-1.746-.113-2.762-.201Z",
    fill: "#F2EEE9"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.965c-.013.57-.022 1.136-.025 1.706 0 .064.076.128.076.192 0 .076-.079.15-.079.226-.006 1.249.003 2.501.028 3.75.006.217.009.482.015.698.003.074.082.1.085.174.003.095-.073.113-.07.207.018.622.046 1.402.067 1.944.824.14 1.603.247 2.497.28.931.031 1.798-.027 2.717-.094.04-.417.073-1.39.097-2.03.003-.09-.07-.121-.067-.212.003-.074.08-.113.085-.186v-.01l.018-.679c.03-1.252.043-2.486.034-3.696a.435.435 0 0 0-.01-.088c-.008-.05-.036-.098-.05-.147a.21.21 0 0 1-.004-.097c.003-.018.015-.04.024-.058.016-.037.037-.073.037-.113-.006-.554-.018-1.011-.03-1.56a36.984 36.984 0 0 1-2.744-.012c-.88-.034-1.697-.11-2.701-.195Z",
    fill: "#F2EFEA"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 30.965c-.012.57-.022 1.136-.028 1.706 0 .064.076.128.076.192 0 .076-.079.15-.079.226-.006 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.074.082.1.085.174.003.095-.073.113-.07.207.018.622.046 1.405.07 1.944.815.137 1.567.241 2.428.274.894.034 1.733-.018 2.643-.076.04-.405.076-1.392.097-2.032.003-.091-.073-.122-.07-.213.003-.073.08-.113.085-.183v-.01l.019-.679c.03-1.252.042-2.483.033-3.693a.434.434 0 0 0-.01-.088c-.005-.049-.036-.098-.05-.146a.152.152 0 0 1-.004-.098c.003-.018.015-.04.025-.058.015-.036.036-.073.036-.11-.006-.557-.018-1.011-.03-1.557a38.063 38.063 0 0 1-2.674-.024c-.846-.046-1.634-.119-2.628-.204Z",
    fill: "#F2F0EB"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.967c-.013.57-.022 1.136-.028 1.706 0 .064.08.128.08.192 0 .076-.08.15-.083.226-.006 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.073.082.1.085.174.003.094-.073.113-.07.207.018.622.046 1.408.07 1.944.803.131 1.53.232 2.36.268.858.034 1.67-.009 2.568-.06.04-.394.076-1.4.1-2.036.003-.091-.073-.122-.07-.213.003-.07.08-.113.085-.183v-.01l.019-.679c.033-1.252.042-2.483.036-3.69 0-.03-.003-.058-.006-.088-.006-.049-.036-.098-.055-.146a.178.178 0 0 1-.006-.098c.003-.018.015-.04.025-.058.018-.036.039-.073.039-.11-.006-.557-.018-1.008-.03-1.557a39.258 39.258 0 0 1-2.604-.033c-.818-.049-1.579-.122-2.561-.204Z",
    fill: "#F3F0EC"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.967c-.013.57-.022 1.136-.028 1.706 0 .064.08.128.08.192 0 .076-.083.15-.083.226-.006 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.073.085.1.085.174.003.094-.076.113-.073.207.018.622.046 1.414.07 1.944.794.128 1.49.223 2.294.26.82.033 1.603-.004 2.494-.044.04-.383.079-1.401.1-2.038.003-.091-.073-.122-.07-.213.003-.07.08-.113.088-.183v-.01l.019-.679c.033-1.249.042-2.48.036-3.687 0-.03-.003-.058-.006-.088-.006-.049-.036-.098-.055-.146a.18.18 0 0 1-.009-.098c.003-.018.015-.04.025-.058.018-.036.042-.073.042-.11-.006-.56-.018-1.005-.03-1.556a36.28 36.28 0 0 1-2.534-.046c-.788-.046-1.521-.119-2.491-.201Z",
    fill: "#F3F1ED"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.967c-.012.57-.021 1.136-.028 1.706 0 .064.08.128.08.192 0 .076-.083.15-.083.226-.009 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.073.085.1.088.174.003.094-.076.113-.073.207.019.622.049 1.417.07 1.944.782.125 1.454.217 2.224.253.785.037 1.539.006 2.421-.024.043-.372.08-1.405.103-2.045.004-.091-.076-.122-.07-.213.004-.07.08-.113.089-.183v-.01l.018-.679c.034-1.249.043-2.477.037-3.684 0-.03-.004-.057-.007-.088-.006-.049-.036-.097-.054-.146-.013-.034-.016-.064-.013-.098.004-.018.016-.04.025-.058.018-.036.042-.073.042-.11a86.637 86.637 0 0 0-.033-1.553 35.127 35.127 0 0 1-2.464-.058c-.751-.049-1.457-.122-2.418-.201Z",
    fill: "#F4F1EE"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.97c-.012.57-.021 1.137-.027 1.707 0 .064.082.128.079.192 0 .076-.082.15-.085.225-.01 1.25.003 2.502.03 3.751.006.217.01.482.015.698.003.073.085.1.088.174.004.094-.076.113-.073.207.019.622.05 1.423.073 1.944.773.122 1.418.207 2.157.247.748.036 1.475.015 2.348-.01.043-.359.082-1.41.104-2.047.003-.091-.076-.122-.073-.213.003-.07.082-.113.088-.183v-.01l.018-.679c.034-1.249.046-2.477.037-3.68 0-.03-.003-.058-.006-.089-.007-.049-.037-.097-.055-.146a.22.22 0 0 1-.015-.098.16.16 0 0 1 .024-.057c.018-.037.046-.074.046-.107-.007-.564-.019-1-.034-1.554a35.62 35.62 0 0 1-2.394-.07c-.718-.052-1.393-.125-2.345-.201Z",
    fill: "#F4F2EF"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.967c-.012.57-.021 1.136-.028 1.706 0 .064.083.128.083.192 0 .076-.086.15-.086.226-.009 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.073.088.1.088.174.003.094-.076.113-.073.207.019.622.049 1.426.073 1.944.76.116 1.381.201 2.087.24.709.038 1.408.022 2.272.01.043-.347.082-1.414.107-2.05.003-.092-.076-.123-.073-.214.003-.07.082-.113.088-.183v-.009l.018-.682c.034-1.247.046-2.475.037-3.678 0-.03-.003-.058-.007-.089-.003-.048-.033-.097-.054-.146a.183.183 0 0 1-.015-.097.156.156 0 0 1 .024-.058c.021-.037.049-.07.049-.107-.007-.564-.019-1-.034-1.55a34.016 34.016 0 0 1-2.324-.083c-.687-.052-1.338-.125-2.278-.201Z",
    fill: "#F4F3F0"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.967c-.012.57-.021 1.136-.028 1.706 0 .064.083.128.083.192 0 .076-.086.15-.086.226-.009 1.249.003 2.501.03 3.75.007.217.01.482.016.698.003.073.088.1.091.174.003.094-.079.113-.076.207.022.622.049 1.432.073 1.944.752.113 1.345.192 2.02.232.672.036 1.344.03 2.2.027.042-.335.084-1.417.106-2.057.003-.091-.076-.121-.073-.213.003-.07.082-.113.091-.183v-.009c.006-.216.015-.463.018-.682.034-1.247.046-2.471.037-3.675 0-.03-.003-.058-.003-.089-.003-.048-.034-.097-.055-.143a.187.187 0 0 1-.018-.097.158.158 0 0 1 .024-.058c.021-.037.049-.07.049-.107-.006-.567-.019-.996-.034-1.55a30.325 30.325 0 0 1-2.254-.095c-.657-.052-1.28-.125-2.211-.198Z",
    fill: "#F5F3F1"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.965c-.012.57-.021 1.136-.028 1.706 0 .064.083.128.083.192 0 .076-.086.15-.086.226-.009 1.249.003 2.501.03 3.75.007.217.01.482.02.698.002.074.087.1.09.174.004.095-.079.113-.076.207.022.622.052 1.435.073 1.944.743.11 1.305.183 1.95.226.636.04 1.28.04 2.126.042.046-.326.085-1.42.11-2.06.003-.09-.08-.121-.073-.213.003-.07.082-.112.091-.182v-.01l.021-.682c.034-1.246.046-2.471.037-3.675 0-.03-.003-.058-.003-.088-.003-.05-.034-.098-.055-.143a.19.19 0 0 1-.021-.098.159.159 0 0 1 .024-.058c.021-.036.052-.07.052-.107-.006-.566-.018-.993-.034-1.55a28.488 28.488 0 0 1-2.184-.107c-.632-.049-1.225-.122-2.147-.192Z",
    fill: "#F5F4F2"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.955c-.012.57-.021 1.137-.028 1.706 0 .064.086.128.086.192 0 .077-.089.15-.089.226-.009 1.25.003 2.502.03 3.75l.02.699c.002.073.09.1.09.173.004.095-.079.113-.076.207.022.622.052 1.439.076 1.944.73.104 1.269.177 1.883.22.6.04 1.214.049 2.053.06.046-.313.089-1.425.113-2.062.003-.092-.08-.122-.076-.213.003-.07.082-.113.091-.183v-.01l.022-.682c.033-1.243.045-2.468.036-3.672 0-.03 0-.057-.003-.088-.003-.049-.033-.094-.058-.143a.231.231 0 0 1-.024-.098c0-.018.012-.04.024-.058.022-.033.055-.07.055-.103-.006-.567-.018-.99-.033-1.548a26.341 26.341 0 0 1-2.115-.119c-.599-.055-1.168-.128-2.077-.198Z",
    fill: "#F5F5F3"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M63.929 30.95c-.012.569-.024 1.136-.028 1.706 0 .064.086.127.086.191 0 .077-.089.15-.089.226-.009 1.25.003 2.502.03 3.75l.02.699c.002.073.09.1.093.173.004.095-.079.113-.076.208.022.621.052 1.444.076 1.944.721.1 1.232.167 1.813.213.563.04 1.15.055 1.978.076.045-.302.088-1.429.112-2.066.003-.091-.079-.122-.076-.213.003-.07.085-.113.094-.18v-.009c.006-.216.016-.463.022-.683.033-1.243.045-2.465.04-3.668 0-.03 0-.058-.004-.089-.003-.048-.033-.094-.058-.143a.193.193 0 0 1-.024-.097c0-.019.012-.04.024-.058.025-.034.055-.07.055-.104-.006-.57-.018-.987-.033-1.548a25.458 25.458 0 0 1-2.044-.13c-.572-.059-1.11-.132-2.011-.199Z",
    fill: "#F6F5F4"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M63.932 30.943c-.012.57-.025 1.137-.028 1.707 0 .064.086.128.086.192 0 .076-.089.149-.089.225-.009 1.25.003 2.502.034 3.751l.018.698c.003.073.091.1.094.174.003.094-.082.112-.079.207.022.621.052 1.447.076 1.944.71.097 1.196.161 1.746.204a44.86 44.86 0 0 0 1.904.094c.046-.29.089-1.432.116-2.072.003-.091-.079-.121-.076-.213.003-.07.085-.113.094-.18v-.009l.022-.682a99.24 99.24 0 0 0 .04-3.666c0-.03 0-.058-.004-.088-.003-.05-.033-.095-.058-.144-.015-.033-.03-.064-.027-.097 0-.018.012-.04.024-.058.025-.033.058-.07.058-.104-.006-.57-.018-.984-.036-1.544a23.271 23.271 0 0 1-1.974-.14c-.542-.061-1.053-.132-1.941-.199Z",
    fill: "#F6F6F5"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M63.932 30.938c-.012.57-.024 1.136-.03 1.706 0 .064.088.128.085.192 0 .076-.088.15-.092.225-.009 1.25.004 2.502.034 3.751l.018.698c.003.073.091.1.094.174.004.094-.082.112-.078.207.02.622.051 1.453.075 1.944.7.091 1.156.152 1.68.198.49.043 1.019.073 1.83.113.046-.278.092-1.435.116-2.075.003-.092-.082-.122-.076-.214.003-.07.085-.112.095-.18v-.009c.006-.216.015-.466.02-.682.037-1.24.05-2.462.04-3.663v-.088c0-.049-.033-.094-.057-.143a.202.202 0 0 1-.03-.098c0-.018.011-.036.023-.058.025-.033.061-.067.061-.103a63.76 63.76 0 0 0-.036-1.545 20.818 20.818 0 0 1-1.904-.152c-.508-.064-.992-.134-1.868-.198Z",
    fill: "#F7F6F6"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M67.567 31.293c-1.816-.085-1.926-.24-3.635-.362a106.7 106.7 0 0 0-.03 1.706c0 .064.088.128.088.192 0 .076-.092.15-.092.225-.009 1.25.003 2.502.034 3.751l.018.698c.003.073.094.1.094.174.004.094-.082.113-.079.207.022.622.055 1.456.08 1.944 1.326.17 1.697.22 3.367.32.048-.268.091-1.441.118-2.078.003-.092-.082-.122-.079-.213.003-.074.095-.116.098-.192a103.49 103.49 0 0 0 .06-4.43c0-.08-.09-.16-.09-.242 0-.051.087-.106.087-.158-.012-.57-.024-.978-.04-1.542Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 30,
    width: 9,
    height: 11
  }, _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M71.862 30.932c-1.21.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.01.57-.016 1.136-.022 1.706 0 .064.061.128.061.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.064.1.067.174.003.094-.058.113-.055.207.015.622.033 1.322.055 1.944a18.85 18.85 0 0 0 3.726.402 19.068 19.068 0 0 0 4.046-.402c.024-.625.048-1.32.067-1.96.003-.09-.058-.121-.055-.212.003-.074.067-.116.067-.192.006-.217.009-.467.015-.683.024-1.27.033-2.52.027-3.748 0-.08-.064-.158-.064-.24 0-.052.061-.107.061-.16l-.027-1.702Z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "M67.886 33.411h-.2a23.328 23.328 0 0 1-3.796-.347l.027-.314a23.112 23.112 0 0 0 7.948 0l.028.314c-1.32.231-2.668.347-4.007.347Z",
    fill: "#F6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.027,
    d: "M67.886 33.408h-.2a23.328 23.328 0 0 1-3.796-.347l.027-.311a23.112 23.112 0 0 0 7.948 0l.028.31c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F5EDF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.041,
    d: "M67.886 33.405h-.2a23.328 23.328 0 0 1-3.796-.347l.027-.305a23.112 23.112 0 0 0 7.948 0l.028.305c-1.32.231-2.668.347-4.007.347Z",
    fill: "#F5EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.055,
    d: "M67.886 33.406h-.2a23.328 23.328 0 0 1-3.796-.347l.027-.302a23.112 23.112 0 0 0 7.948 0l.028.302c-1.32.228-2.668.347-4.007.347Z",
    fill: "#F4ECF7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.068,
    d: "M67.886 33.403h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.298a23.112 23.112 0 0 0 7.948 0l.028.298c-1.32.229-2.668.348-4.007.348Z",
    fill: "#F4ECF6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    d: "M67.886 33.4h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.295a23.112 23.112 0 0 0 7.948 0l.028.295c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F4EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.096,
    d: "M67.886 33.397h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.292a23.112 23.112 0 0 0 7.948 0l.028.292c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F3EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M67.886 33.394h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.29c1.244.22 2.51.336 3.772.345a23.112 23.112 0 0 0 4.176-.344l.025.29a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F3EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.123,
    d: "M67.886 33.39h-.2a23.339 23.339 0 0 1-3.796-.347l.024-.286a23.112 23.112 0 0 0 7.948 0l.024.286a23.158 23.158 0 0 1-4 .348Z",
    fill: "#F3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.137,
    d: "M67.886 33.39h-.2a23.327 23.327 0 0 1-3.796-.348l.024-.283a23.112 23.112 0 0 0 7.948 0l.024.283a23.459 23.459 0 0 1-4 .347Z",
    fill: "#F2E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.151,
    d: "M67.886 33.387h-.2a23.316 23.316 0 0 1-3.796-.347l.024-.277a23.112 23.112 0 0 0 7.948 0l.024.277a23.459 23.459 0 0 1-4 .347Z",
    fill: "#F2E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.164,
    d: "M67.886 33.384h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.274a23.112 23.112 0 0 0 7.948 0l.024.274a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F1E9EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.178,
    d: "M67.886 33.381h-.2a23.316 23.316 0 0 1-3.796-.347l.024-.271a23.112 23.112 0 0 0 7.948 0l.024.27a23.148 23.148 0 0 1-4 .348Z",
    fill: "#F1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M67.886 33.378h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.268a23.112 23.112 0 0 0 7.948 0l.024.268a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F1E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.205,
    d: "M67.886 33.375h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.265a23.112 23.112 0 0 0 7.948 0l.024.265a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F0E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.219,
    d: "M67.886 33.374h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.262a23.112 23.112 0 0 0 7.948 0l.024.262a23.459 23.459 0 0 1-4 .347Z",
    fill: "#F0E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.233,
    d: "M67.886 33.371h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.26c1.247.22 2.506.336 3.772.345a23.112 23.112 0 0 0 4.176-.344l.025.259a23.449 23.449 0 0 1-4 .347Z",
    fill: "#EFE6EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.247,
    d: "M67.886 33.368h-.2a23.316 23.316 0 0 1-3.796-.348l.024-.252a23.112 23.112 0 0 0 7.948 0l.024.252a23.148 23.148 0 0 1-4 .348Z",
    fill: "#EFE6E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M67.886 33.365h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.25c1.247.22 2.506.336 3.772.345a23.169 23.169 0 0 0 4.18-.344l.023.25c-1.32.231-2.664.347-4.002.347Z",
    fill: "#EFE5E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.274,
    d: "M67.886 33.362h-.2a23.257 23.257 0 0 1-3.793-.348l.024-.246c1.247.219 2.506.335 3.772.344a23.167 23.167 0 0 0 4.18-.344l.023.246a23.27 23.27 0 0 1-4.006.348Z",
    fill: "#EEE5E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.288,
    d: "M67.886 33.359h-.2a23.257 23.257 0 0 1-3.793-.348l.02-.243a23.167 23.167 0 0 0 7.951 0l.022.243a23.146 23.146 0 0 1-4 .348Z",
    fill: "#EEE5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.301,
    d: "M67.886 33.36h-.2a23.257 23.257 0 0 1-3.793-.348l.02-.24a23.167 23.167 0 0 0 7.951 0l.022.24a23.457 23.457 0 0 1-4 .348Z",
    fill: "#EEE4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315,
    d: "M67.886 33.356h-.2a23.268 23.268 0 0 1-3.793-.347l.02-.237a23.167 23.167 0 0 0 7.951 0l.022.237a23.457 23.457 0 0 1-4 .347Z",
    fill: "#EDE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.329,
    d: "M67.886 33.353h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.234a23.167 23.167 0 0 0 7.951 0l.022.234a23.146 23.146 0 0 1-4 .347Z",
    fill: "#EDE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.343,
    d: "M67.886 33.35h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.229c1.251.22 2.507.336 3.773.345a23.167 23.167 0 0 0 4.179-.345l.021.229a23.146 23.146 0 0 1-4 .347Z",
    fill: "#ECE3E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.356,
    d: "M67.886 33.347h-.2A23.288 23.288 0 0 1 63.893 33l.02-.226c1.251.22 2.507.336 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.226c-1.32.231-2.664.347-4.003.347Z",
    fill: "#ECE2E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M67.886 33.344h-.2a23.299 23.299 0 0 1-3.793-.347l.02-.223c1.251.22 2.507.336 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.223c-1.32.231-2.664.347-4.003.347Z",
    fill: "#ECE2E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.384,
    d: "M67.886 33.344h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.22c1.251.22 2.507.335 3.776.345a23.158 23.158 0 0 0 4.18-.345l.02.22a23.51 23.51 0 0 1-4.003.347Z",
    fill: "#EBE1DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.397,
    d: "M67.886 33.341h-.2a23.277 23.277 0 0 1-3.793-.347l.02-.217c1.251.22 2.504.335 3.776.345a23.158 23.158 0 0 0 4.18-.345l.02.217a23.52 23.52 0 0 1-4.003.347Z",
    fill: "#EBE1DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.411,
    d: "M67.886 33.338h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.214c1.251.22 2.504.335 3.776.345a23.158 23.158 0 0 0 4.18-.345l.02.214c-1.32.231-2.664.347-4.003.347Z",
    fill: "#EAE0DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.425,
    d: "M67.886 33.335h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.21a23.158 23.158 0 0 0 7.954 0l.022.21c-1.32.231-2.664.347-4.003.347Z",
    fill: "#EAE0DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M67.886 33.332h-.2a23.288 23.288 0 0 1-3.793-.348l.02-.204c1.251.22 2.504.335 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.204c-1.32.232-2.664.348-4.003.348Z",
    fill: "#EAE0DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.452,
    d: "M67.886 33.329h-.2a23.277 23.277 0 0 1-3.793-.348l.02-.2a23.167 23.167 0 0 0 7.954 0l.022.2c-1.32.232-2.664.348-4.003.348Z",
    fill: "#E9DFDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.466,
    d: "M67.886 33.329h-.2a23.299 23.299 0 0 1-3.793-.348l.02-.198a23.167 23.167 0 0 0 7.954 0l.022.198a23.52 23.52 0 0 1-4.003.348Z",
    fill: "#E9DFD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.479,
    d: "M67.886 33.326h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.195a23.167 23.167 0 0 0 7.954 0l.018.195a23.395 23.395 0 0 1-3.997.348Z",
    fill: "#E9DED8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.493,
    d: "M67.886 33.322h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.192a23.144 23.144 0 0 0 7.954 0l.018.192a23.096 23.096 0 0 1-3.997.347Z",
    fill: "#E8DED7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.507,
    d: "M67.886 33.32h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.189a22.87 22.87 0 0 0 7.954 0l.018.19a23.086 23.086 0 0 1-3.997.346Z",
    fill: "#E8DDD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M67.886 33.316h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.186a22.87 22.87 0 0 0 7.954 0l.018.186a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E7DDD6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.534,
    d: "M67.886 33.313h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.18a22.87 22.87 0 0 0 7.954 0l.018.18a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E7DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.548,
    d: "M67.886 33.313h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.177a22.878 22.878 0 0 0 7.954 0l.018.177a23.395 23.395 0 0 1-3.997.347Z",
    fill: "#E7DCD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.562,
    d: "M67.886 33.31h-.2a23.299 23.299 0 0 1-3.793-.347l.018-.174a22.878 22.878 0 0 0 7.954 0l.018.174a23.395 23.395 0 0 1-3.997.347Z",
    fill: "#E6DBD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.575,
    d: "M67.886 33.307h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.17a22.878 22.878 0 0 0 7.954 0l.018.17a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E6DBD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.589,
    d: "M67.886 33.304h-.2a23.299 23.299 0 0 1-3.793-.347l.018-.168a22.878 22.878 0 0 0 7.954 0l.018.168a23.096 23.096 0 0 1-3.997.347Z",
    fill: "#E6DBD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.603,
    d: "M67.886 33.301h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.165a22.878 22.878 0 0 0 7.954 0l.018.165a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E5DAD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.616,
    d: "M67.886 33.298h-.2a23.299 23.299 0 0 1-3.793-.347l.018-.162a22.935 22.935 0 0 0 7.957 0l.018.162a23.156 23.156 0 0 1-4 .347Z",
    fill: "#E5DACF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M67.886 33.299h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.155a22.935 22.935 0 0 0 7.957 0l.018.155a23.457 23.457 0 0 1-4 .348Z",
    fill: "#E4D9CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.644,
    d: "M67.886 33.296h-.2a23.299 23.299 0 0 1-3.793-.348l.018-.152a22.935 22.935 0 0 0 7.957 0l.018.152a23.457 23.457 0 0 1-4 .348Z",
    fill: "#E4D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.657,
    d: "M67.886 33.293h-.2a23.288 23.288 0 0 1-3.793-.348l.015-.15a22.934 22.934 0 0 0 7.957 0l.015.15a23.053 23.053 0 0 1-3.994.348Z",
    fill: "#E4D8CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.671,
    d: "M67.886 33.29h-.2a23.232 23.232 0 0 1-3.79-.348l.015-.146a22.935 22.935 0 0 0 7.957 0l.015.146a23.123 23.123 0 0 1-3.997.347Z",
    fill: "#E3D8CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.685,
    d: "M67.886 33.286h-.2a23.22 23.22 0 0 1-3.79-.347l.015-.143a22.935 22.935 0 0 0 7.957 0l.015.143a23.113 23.113 0 0 1-3.997.347Z",
    fill: "#E3D7CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.699,
    d: "M67.886 33.283h-.2a23.232 23.232 0 0 1-3.79-.347l.015-.14a22.935 22.935 0 0 0 7.957 0l.015.14a23.123 23.123 0 0 1-3.997.347Z",
    fill: "#E2D7C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.712,
    d: "M67.886 33.283h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.137a22.926 22.926 0 0 0 7.957 0l.015.137a23.413 23.413 0 0 1-3.997.347Z",
    fill: "#E2D6C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.726,
    d: "M67.886 33.28h-.2a23.241 23.241 0 0 1-3.79-.347l.015-.131a22.935 22.935 0 0 0 7.957 0l.015.13a23.423 23.423 0 0 1-3.997.348Z",
    fill: "#E2D6C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M67.886 33.277h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.128a22.934 22.934 0 0 0 7.96 0l.015.128c-1.32.231-2.661.347-4 .347Z",
    fill: "#E1D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    d: "M67.886 33.274h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.125a22.934 22.934 0 0 0 7.96 0l.015.125c-1.32.231-2.661.347-4 .347Z",
    fill: "#E1D5C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.767,
    d: "M67.886 33.271h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.122a22.934 22.934 0 0 0 7.96 0l.015.122c-1.32.231-2.661.347-4 .347Z",
    fill: "#E1D5C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.781,
    d: "M67.886 33.268h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.12a22.934 22.934 0 0 0 7.96 0l.015.12c-1.32.231-2.661.347-4 .347Z",
    fill: "#E0D4C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.794,
    d: "M67.886 33.268h-.2a23.241 23.241 0 0 1-3.79-.348l.015-.115a22.934 22.934 0 0 0 7.96 0l.015.115c-1.32.229-2.661.348-4 .348Z",
    fill: "#E0D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M67.886 33.265h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.112a22.934 22.934 0 0 0 7.96 0l.015.112c-1.32.229-2.661.348-4 .348Z",
    fill: "#DFD3C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.822,
    d: "M67.886 33.262h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.106a22.925 22.925 0 0 0 7.96 0l.015.106c-1.32.232-2.661.348-4 .348Z",
    fill: "#DFD3C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.836,
    d: "M67.886 33.259h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.103a22.903 22.903 0 0 0 7.96 0l.015.103c-1.32.232-2.661.348-4 .348Z",
    fill: "#DFD2BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.849,
    d: "M67.886 33.255h-.2a23.252 23.252 0 0 1-3.79-.347l.012-.1a22.903 22.903 0 0 0 7.96 0l.012.1a23.06 23.06 0 0 1-3.994.347Z",
    fill: "#DED2BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.863,
    d: "M67.886 33.252h-.2a23.252 23.252 0 0 1-3.79-.347l.012-.097a22.903 22.903 0 0 0 7.96 0l.012.097a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DED2BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.877,
    d: "M67.886 33.252h-.2a23.252 23.252 0 0 1-3.79-.347l.012-.095a22.903 22.903 0 0 0 7.96 0l.012.095a23.36 23.36 0 0 1-3.994.347Z",
    fill: "#DDD1BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M67.886 33.25h-.2a23.263 23.263 0 0 1-3.79-.348l.012-.092a22.903 22.903 0 0 0 7.96 0l.012.092a23.36 23.36 0 0 1-3.994.347Z",
    fill: "#DDD1BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.904,
    d: "M67.886 33.246h-.2a23.284 23.284 0 0 1-3.79-.347l.012-.089a22.903 22.903 0 0 0 7.96 0l.012.089a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DDD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.918,
    d: "M67.886 33.244h-.2a23.284 23.284 0 0 1-3.79-.347l.012-.082a22.912 22.912 0 0 0 7.96 0l.012.082a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DCD0B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "M67.886 33.241h-.2a23.273 23.273 0 0 1-3.79-.347l.012-.08a22.912 22.912 0 0 0 7.96 0l.012.08a23.077 23.077 0 0 1-3.994.347Z",
    fill: "#DCCFB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.945,
    d: "M67.886 33.238h-.2a23.284 23.284 0 0 1-3.79-.347l.012-.076a22.912 22.912 0 0 0 7.96 0l.012.076a23.077 23.077 0 0 1-3.994.347Z",
    fill: "#DCCFB7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.959,
    d: "M67.886 33.237h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.073a22.958 22.958 0 0 0 7.963 0l.012.073a23.44 23.44 0 0 1-3.997.348Z",
    fill: "#DBCEB6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.973,
    d: "M67.886 33.234h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.07a22.958 22.958 0 0 0 7.963 0l.012.07a23.45 23.45 0 0 1-3.997.348Z",
    fill: "#DBCEB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "M67.886 33.23h-.2a23.284 23.284 0 0 1-3.79-.347l.012-.067a22.958 22.958 0 0 0 7.963 0l.012.067a23.14 23.14 0 0 1-3.997.348Z",
    fill: "#DACDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.886 33.228h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.064a22.958 22.958 0 0 0 7.963 0l.012.064a23.14 23.14 0 0 1-3.997.348Z",
    fill: "#DACDB3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 30,
    width: 9,
    height: 11
  }, _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M71.862 30.932c-1.21.125-2.552.204-4.006.2-1.427 0-2.744-.079-3.936-.2-.01.57-.016 1.136-.022 1.706 0 .064.061.128.061.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.064.1.067.174.003.094-.058.113-.055.207.015.622.033 1.322.055 1.944a18.85 18.85 0 0 0 3.726.402 19.068 19.068 0 0 0 4.046-.402c.024-.625.048-1.32.067-1.96.003-.09-.058-.121-.055-.212.003-.074.067-.116.067-.192.006-.217.009-.467.015-.683.024-1.27.033-2.52.027-3.748 0-.08-.064-.158-.064-.24 0-.052.061-.107.061-.16l-.027-1.702Z",
    fill: "#fff"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.014,
    d: "M67.886 38.21h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.314a23.112 23.112 0 0 0 7.948 0l.028.314c-1.32.228-2.668.347-4.007.347Z",
    fill: "#F6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.027,
    d: "M67.886 38.206h-.2a23.328 23.328 0 0 1-3.796-.347l.027-.311a23.112 23.112 0 0 0 7.948 0l.028.31c-1.32.23-2.668.348-4.007.348Z",
    fill: "#F5EDF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.041,
    d: "M67.886 38.203h-.2a23.316 23.316 0 0 1-3.796-.348l.027-.304a23.112 23.112 0 0 0 7.948 0l.028.304c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F5EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.055,
    d: "M67.886 38.2h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.301a23.112 23.112 0 0 0 7.948 0l.028.301c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F4ECF7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.068,
    d: "M67.886 38.197h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.298a23.112 23.112 0 0 0 7.948 0l.028.298c-1.32.232-2.668.348-4.007.348Z",
    fill: "#F4ECF6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.082,
    d: "M67.886 38.197h-.2a23.316 23.316 0 0 1-3.796-.348l.027-.295a23.112 23.112 0 0 0 7.948 0l.028.295c-1.32.229-2.668.348-4.007.348Z",
    fill: "#F4EBF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.096,
    d: "M67.886 38.194h-.2a23.328 23.328 0 0 1-3.796-.348l.027-.292a23.112 23.112 0 0 0 7.948 0l.028.292c-1.32.229-2.668.348-4.007.348Z",
    fill: "#F3EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M67.886 38.19h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.29a23.112 23.112 0 0 0 7.948 0l.024.29a23.459 23.459 0 0 1-4 .348Z",
    fill: "#F3EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.123,
    d: "M67.886 38.188h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.286a23.112 23.112 0 0 0 7.948 0l.024.286a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F3EAF2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.137,
    d: "M67.886 38.184h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.283a23.112 23.112 0 0 0 7.948 0l.024.283a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F2E9F1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.151,
    d: "M67.886 38.181h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.277a23.112 23.112 0 0 0 7.948 0l.024.277a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F2E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.164,
    d: "M67.886 38.182h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.275a23.103 23.103 0 0 0 7.948 0l.024.275a23.459 23.459 0 0 1-4 .347Z",
    fill: "#F1E9EF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.178,
    d: "M67.886 38.18h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.272a23.103 23.103 0 0 0 7.948 0l.024.272a23.449 23.449 0 0 1-4 .347Z",
    fill: "#F1E8EE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.192,
    d: "M67.886 38.176h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.269a23.103 23.103 0 0 0 7.948 0l.024.269a23.459 23.459 0 0 1-4 .347Z",
    fill: "#F1E8ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.205,
    d: "M67.886 38.173h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.266a23.103 23.103 0 0 0 7.948 0l.024.266a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F0E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.219,
    d: "M67.886 38.17h-.2a23.328 23.328 0 0 1-3.796-.347l.024-.263a23.103 23.103 0 0 0 7.948 0l.024.263a23.148 23.148 0 0 1-4 .347Z",
    fill: "#F0E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.233,
    d: "M67.886 38.167h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.259a23.103 23.103 0 0 0 7.948 0l.024.26a23.148 23.148 0 0 1-4 .347Z",
    fill: "#EFE6EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.247,
    d: "M67.886 38.167h-.2a23.328 23.328 0 0 1-3.796-.348l.024-.253a23.112 23.112 0 0 0 7.948 0l.024.253a23.459 23.459 0 0 1-4 .348Z",
    fill: "#EFE6E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M67.886 38.164h-.2a23.327 23.327 0 0 1-3.796-.348l.024-.25c1.247.22 2.506.336 3.772.345a23.169 23.169 0 0 0 4.18-.345l.023.25a23.52 23.52 0 0 1-4.002.348Z",
    fill: "#EFE5E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.274,
    d: "M67.886 38.16h-.2a23.257 23.257 0 0 1-3.793-.347l.024-.247c1.247.22 2.506.336 3.772.345a23.167 23.167 0 0 0 4.18-.345l.023.247a23.582 23.582 0 0 1-4.006.348Z",
    fill: "#EEE5E7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.288,
    d: "M67.886 38.157h-.2a23.257 23.257 0 0 1-3.793-.347l.02-.244c1.248.22 2.507.336 3.773.345a23.167 23.167 0 0 0 4.179-.345l.021.244a23.156 23.156 0 0 1-4 .347Z",
    fill: "#EEE5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.301,
    d: "M67.886 38.154h-.2a23.257 23.257 0 0 1-3.793-.347l.02-.24a23.167 23.167 0 0 0 7.951 0l.022.24a23.146 23.146 0 0 1-4 .347Z",
    fill: "#EEE4E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315,
    d: "M67.886 38.151h-.2a23.246 23.246 0 0 1-3.793-.347l.02-.238c1.251.22 2.507.336 3.773.345a23.167 23.167 0 0 0 4.179-.345l.021.238a23.156 23.156 0 0 1-4 .347Z",
    fill: "#EDE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.329,
    d: "M67.886 38.151h-.2a23.299 23.299 0 0 1-3.793-.347l.02-.235c1.251.22 2.507.335 3.773.345a23.167 23.167 0 0 0 4.179-.345l.021.235a23.457 23.457 0 0 1-4 .347Z",
    fill: "#EDE3E3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.343,
    d: "M67.886 38.148h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.229c1.251.22 2.507.335 3.773.345a23.167 23.167 0 0 0 4.179-.345l.021.229a23.457 23.457 0 0 1-4 .347Z",
    fill: "#ECE3E2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.356,
    d: "M67.886 38.145h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.226c1.251.22 2.507.335 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.226a23.51 23.51 0 0 1-4.003.347Z",
    fill: "#ECE2E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M67.886 38.142h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.223c1.251.22 2.507.335 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.223c-1.32.231-2.664.347-4.003.347Z",
    fill: "#ECE2E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.384,
    d: "M67.886 38.139h-.2a23.299 23.299 0 0 1-3.793-.347l.02-.22c1.251.22 2.507.335 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.22c-1.32.231-2.664.347-4.003.347Z",
    fill: "#EBE1DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.397,
    d: "M67.886 38.136h-.2a23.288 23.288 0 0 1-3.793-.347l.02-.217c1.251.22 2.504.335 3.776.345a23.167 23.167 0 0 0 4.18-.345l.02.217c-1.32.231-2.664.347-4.003.347Z",
    fill: "#EBE1DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.411,
    d: "M67.886 38.136h-.2a23.288 23.288 0 0 1-3.793-.348l.02-.213a23.167 23.167 0 0 0 7.954 0l.022.214a23.52 23.52 0 0 1-4.003.347Z",
    fill: "#EAE0DD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.425,
    d: "M67.886 38.133h-.2a23.288 23.288 0 0 1-3.793-.348l.02-.21a23.167 23.167 0 0 0 7.954 0l.022.21a23.51 23.51 0 0 1-4.003.348Z",
    fill: "#EAE0DC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.438,
    d: "M67.886 38.13h-.2a23.277 23.277 0 0 1-3.793-.348l.02-.204a23.167 23.167 0 0 0 7.954 0l.022.204a23.52 23.52 0 0 1-4.003.348Z",
    fill: "#EAE0DB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.452,
    d: "M67.886 38.127h-.2a23.288 23.288 0 0 1-3.793-.348l.02-.2a23.167 23.167 0 0 0 7.954 0l.022.2c-1.32.232-2.664.348-4.003.348Z",
    fill: "#E9DFDA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.466,
    d: "M67.886 38.123h-.2a23.277 23.277 0 0 1-3.793-.347l.02-.198a23.167 23.167 0 0 0 7.954 0l.022.198c-1.32.232-2.664.347-4.003.347Z",
    fill: "#E9DFD9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.479,
    d: "M67.886 38.12h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.195a23.167 23.167 0 0 0 7.954 0l.018.195a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E9DED8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.493,
    d: "M67.886 38.121h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.192a23.144 23.144 0 0 0 7.954 0l.018.192a23.395 23.395 0 0 1-3.997.347Z",
    fill: "#E8DED7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.507,
    d: "M67.886 38.118h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.189a22.87 22.87 0 0 0 7.954 0l.018.189a23.385 23.385 0 0 1-3.997.347Z",
    fill: "#E8DDD7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M67.886 38.115h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.186a22.87 22.87 0 0 0 7.954 0l.018.186a23.395 23.395 0 0 1-3.997.347Z",
    fill: "#E7DDD6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.534,
    d: "M67.886 38.111h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.18a22.887 22.887 0 0 0 7.954 0l.018.18a23.096 23.096 0 0 1-3.997.347Z",
    fill: "#E7DCD5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.548,
    d: "M67.886 38.108h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.177a22.887 22.887 0 0 0 7.954 0l.018.177a23.086 23.086 0 0 1-3.997.347Z",
    fill: "#E7DCD4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.562,
    d: "M67.886 38.105h-.2a23.288 23.288 0 0 1-3.793-.347l.018-.174a22.887 22.887 0 0 0 7.954 0l.018.174a23.096 23.096 0 0 1-3.997.347Z",
    fill: "#E6DBD3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.575,
    d: "M67.886 38.106h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.17a22.878 22.878 0 0 0 7.954 0l.018.17a23.385 23.385 0 0 1-3.997.348Z",
    fill: "#E6DBD2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.589,
    d: "M67.886 38.103h-.2a23.277 23.277 0 0 1-3.793-.348l.018-.167a22.878 22.878 0 0 0 7.954 0l.018.167a23.395 23.395 0 0 1-3.997.348Z",
    fill: "#E6DBD1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.603,
    d: "M67.886 38.1h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.164a22.878 22.878 0 0 0 7.954 0l.018.164a23.385 23.385 0 0 1-3.997.348Z",
    fill: "#E5DAD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.616,
    d: "M67.886 38.097h-.2a23.277 23.277 0 0 1-3.793-.348l.018-.161a22.935 22.935 0 0 0 7.957 0l.018.161a23.146 23.146 0 0 1-4 .348Z",
    fill: "#E5DACF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M67.886 38.094h-.2a23.288 23.288 0 0 1-3.793-.348l.018-.155a22.926 22.926 0 0 0 7.957 0l.018.155a23.146 23.146 0 0 1-4 .348Z",
    fill: "#E4D9CE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.644,
    d: "M67.886 38.09h-.2a23.277 23.277 0 0 1-3.793-.347l.018-.152a22.926 22.926 0 0 0 7.957 0l.018.152a23.156 23.156 0 0 1-4 .347Z",
    fill: "#E4D9CD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.657,
    d: "M67.886 38.09h-.2a23.277 23.277 0 0 1-3.793-.348l.015-.15a22.934 22.934 0 0 0 7.957 0l.015.15a23.361 23.361 0 0 1-3.994.347Z",
    fill: "#E4D8CC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.671,
    d: "M67.886 38.086h-.2a23.22 23.22 0 0 1-3.79-.347l.015-.146a22.935 22.935 0 0 0 7.957 0l.015.146a23.413 23.413 0 0 1-3.997.347Z",
    fill: "#E3D8CB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.685,
    d: "M67.886 38.083h-.2a23.22 23.22 0 0 1-3.79-.347l.015-.143a22.935 22.935 0 0 0 7.957 0l.015.143a23.423 23.423 0 0 1-3.997.347Z",
    fill: "#E3D7CA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.699,
    d: "M67.886 38.08h-.2a23.22 23.22 0 0 1-3.79-.347l.015-.14a22.935 22.935 0 0 0 7.957 0l.015.14a23.113 23.113 0 0 1-3.997.347Z",
    fill: "#E2D7C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.712,
    d: "M67.886 38.077h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.137a22.935 22.935 0 0 0 7.957 0l.015.137a23.113 23.113 0 0 1-3.997.347Z",
    fill: "#E2D6C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.726,
    d: "M67.886 38.075h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.131a22.935 22.935 0 0 0 7.957 0l.015.13a23.113 23.113 0 0 1-3.997.348Z",
    fill: "#E2D6C7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M67.886 38.075h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.128a22.925 22.925 0 0 0 7.96 0l.015.128c-1.32.228-2.661.347-4 .347Z",
    fill: "#E1D6C6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.753,
    d: "M67.886 38.072h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.124a22.925 22.925 0 0 0 7.96 0l.015.124c-1.32.23-2.661.348-4 .348Z",
    fill: "#E1D5C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.767,
    d: "M67.886 38.069h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.121a22.925 22.925 0 0 0 7.96 0l.015.121c-1.32.229-2.661.348-4 .348Z",
    fill: "#E1D5C4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.781,
    d: "M67.886 38.066h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.118a22.925 22.925 0 0 0 7.96 0l.015.118c-1.32.232-2.661.348-4 .348Z",
    fill: "#E0D4C3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.794,
    d: "M67.886 38.063h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.115a22.925 22.925 0 0 0 7.96 0l.015.115c-1.32.232-2.661.348-4 .348Z",
    fill: "#E0D4C2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.808,
    d: "M67.886 38.06h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.112a22.925 22.925 0 0 0 7.96 0l.015.112c-1.32.232-2.661.348-4 .348Z",
    fill: "#DFD3C1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.822,
    d: "M67.886 38.06h-.2a23.252 23.252 0 0 1-3.79-.348l.015-.107a22.934 22.934 0 0 0 7.96 0l.015.107c-1.32.229-2.661.347-4 .347Z",
    fill: "#DFD3C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.836,
    d: "M67.886 38.056h-.2a23.252 23.252 0 0 1-3.79-.347l.015-.104a22.912 22.912 0 0 0 7.96 0l.015.104c-1.32.229-2.661.347-4 .347Z",
    fill: "#DFD2BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.849,
    d: "M67.886 38.053h-.2a23.252 23.252 0 0 1-3.79-.347l.012-.1a22.912 22.912 0 0 0 7.96 0l.012.1a23.35 23.35 0 0 1-3.994.347Z",
    fill: "#DED2BE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.863,
    d: "M67.886 38.05h-.2a23.241 23.241 0 0 1-3.79-.347l.012-.098a22.912 22.912 0 0 0 7.96 0l.012.098a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DED2BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.877,
    d: "M67.886 38.047h-.2a23.252 23.252 0 0 1-3.79-.347l.012-.095a22.912 22.912 0 0 0 7.96 0l.012.095a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DDD1BC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.89,
    d: "M67.886 38.044h-.2a23.241 23.241 0 0 1-3.79-.347l.012-.092a22.912 22.912 0 0 0 7.96 0l.012.092a23.05 23.05 0 0 1-3.994.347Z",
    fill: "#DDD1BB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.904,
    d: "M67.886 38.044h-.2a23.295 23.295 0 0 1-3.79-.347l.012-.089a22.912 22.912 0 0 0 7.96 0l.012.089a23.36 23.36 0 0 1-3.994.347Z",
    fill: "#DDD0BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.918,
    d: "M67.886 38.042h-.2a23.284 23.284 0 0 1-3.79-.347l.012-.083a22.903 22.903 0 0 0 7.96 0l.012.083a23.36 23.36 0 0 1-3.994.347Z",
    fill: "#DCD0B9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.931,
    d: "M67.886 38.039h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.079a22.903 22.903 0 0 0 7.96 0l.012.08a23.377 23.377 0 0 1-3.994.347Z",
    fill: "#DCCFB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.945,
    d: "M67.886 38.036h-.2a23.273 23.273 0 0 1-3.79-.348l.012-.076a22.903 22.903 0 0 0 7.96 0l.012.076a23.077 23.077 0 0 1-3.994.348Z",
    fill: "#DCCFB7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.959,
    d: "M67.886 38.033h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.073a22.958 22.958 0 0 0 7.963 0l.012.073a23.14 23.14 0 0 1-3.997.348Z",
    fill: "#DBCEB6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.973,
    d: "M67.886 38.03h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.07a22.958 22.958 0 0 0 7.963 0l.012.07a23.14 23.14 0 0 1-3.997.348Z",
    fill: "#DBCEB5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    d: "M67.886 38.029h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.067a22.966 22.966 0 0 0 7.963 0l.012.067a23.45 23.45 0 0 1-3.997.348Z",
    fill: "#DACDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.886 38.026h-.2a23.284 23.284 0 0 1-3.79-.348l.012-.064a22.966 22.966 0 0 0 7.963 0l.012.064a23.44 23.44 0 0 1-3.997.348Z",
    fill: "#DACDB3"
  })))), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M71.863 30.93c-1.21.125-2.552.204-4.006.2-1.427 0-2.744-.078-3.936-.2-.01.57-.015 1.136-.022 1.706 0 .064.061.128.061.192 0 .076-.064.15-.064.225-.006 1.25.003 2.502.025 3.751l.012.698c.003.073.064.1.067.174.003.094-.058.113-.055.207.015.622.033 1.322.055 1.944a18.85 18.85 0 0 0 3.726.402 19.07 19.07 0 0 0 4.046-.402c.024-.625.048-1.32.066-1.96.004-.09-.057-.121-.054-.212.003-.074.067-.116.067-.192.006-.217.009-.467.015-.683.024-1.27.033-2.52.027-3.748 0-.08-.064-.158-.064-.24 0-.052.061-.107.061-.159l-.027-1.703Z",
    fill: "url(#f)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.525,
    y1: 47.399,
    x2: 20.937,
    y2: 59.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DEE0EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#D7D9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#C4C6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#BDBFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#9195AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 63.931,
    y1: 28.523,
    x2: 71.845,
    y2: 28.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#EAE3D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 63.897,
    y1: 35.581,
    x2: 71.891,
    y2: 35.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#EAE3D7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(55.5568 0 0 55.6534 23.449 4.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7B1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#929DE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplication);
export default __webpack_public_path__ + "static/media/icon-application.b02f61d68e9ebba7582e9e1b09bacd51.svg";
export { ForwardRef as ReactComponent };